export const UPDATES = [
    {
      id: 0,
      name: 'Walter Browne Interview',
      description: '\nSix years after forfeiting the 1975 World Championship, Bobby Fischer visited Browne at his home in Berkeley, California. \n\n'+

'"They had this article in Sports Illustrated in \'76 and evidently Bobby didn\'t like a few of the quotes I made. One I think he might have taken offense to was something like - I made some comment like, \'there\'s nothing in chess I don\'t understand\'." \n\n'+

'"A mutual friend of ours who lived in San Francisco contacted me one day, and says that Bobby wasn\'t happy [with me] but then suddenly out of the blue in 1981 he told me, \'say Bobby\'s in town and he\'d like to see you.\' I remember we talked first and then we set up the meet, and then he came to my house." \n\n'+

'"Basically we went over [my games] - I was very happy - because he wanted to go over my games from the US Championship, so I showed him a bunch of games. And he was complimentary, which for him was no easy deal. You know for him any compliment was the very- he didn\'t give them easily,  you know what I mean? His compliments were avoided. Well we looked at my games from the US Championship, and he basically was very complimentary - I mean always he had a criticism here or there. And then we went to my library. I do have a fair amount of chess books and he showed this book - I think it\'s either 600 or either 660 games by Kurt Richter (its 666 Kurzpartien, a book of miniatures, from the Richter of Richter-Rauzer fame -editor) and he liked the book. He was playing over some of the games. Well I\'m glad he found a book that he liked, because he\'d seen so many books you could bore him easily if you didn\'t have some special books in your library - he\'d get bored I\'m sure. Because he used to go to bookshops going through all the books looking for new material all the time. One time I did that, and down when we were walking in New York, and we went in a store, and at least an hour, or two hours, we were in that store and he was just - he\'d go through books and just start readin\' \'em while he was there and look and he\'d go through a bunch of pages. He might spend 15 or 20 minutes on one book and then go on to the next book."\n\n'+

'"I knew he did that a lot. I mean that\'s why he got so good. He did a tremendous amount of research, and of course he worked extremely hard. I loved his work ethic, I mean he just - its tremendous stuff - and it\'s a wonderful thing that he could take so much time to work on chess. There\'s very few of us who could do that. Even though I sooner or later had to succumb to the day-to-day paying-the-bills kind of thing." \n\n'+

'During Fischer\'s stay, Browne beat him at pool, and despite Fischer\'s competitive nature, he was unfazed. \n\n'+

'"I think the thing about Bobby is, he could appreciate if somebody is really good at something and appreciate it and I believe that\'s the kind of person he was. He wouldn\'t take offense or anything. He respected excellence, as I do. So I don\'t really like football, but say I\'m watching and I see two teams playing great, I would enjoy it. Or baseball - I don\'t watch any more but - two top teams or a great pitcher, you know I can enjoy it, I can enjoy excellence. I don\'t recall playing him a second game. He might have been upset in his own way, but he didn\'t show it. And I don\'t think he really had good reason to be upset there. It\'s just that he might have felt it was a mismatch. Because he thought maybe I\'m too good - and I wasn\'t really that good, I just had a good game." \n\n'+

'"He still kept up with chess and he still played. Very strange - you could tell by his analysis that his mind was still very sharp. It\'s just a shame that he had to wait twenty years to play another match. If he had played in say 82, he would have been much stronger than he was in the Spassky match." \n\n'+

'"He seemed upset with a bunch of things. He wasn\'t sure he was getting paid well for his book [My 60 Memorable Games]. He had some prejudices. We could take a walk and he was ranting and raving a bit, and he was obviously very perturbed by a bunch of things. That was about how it was I think. And it got worse, it definitely got worse, as far as his rationality." \n\n'+

'The visit ended on a sour note, after Browne took Fischer to task for spending six hours on his house phone. \n\n'+

'"He just normally would do that. He did that with other people too - he stayed at their house - he might have stayed weeks or months and he spent a lot of time on the phone. But they put it up with it. And I didn\'t want to put up with it. So I just told him it was too much. He probably talked to several different people, but the gist of it is he was tying up the phone, and I might be getting calls for a tournament or something. In those days I only have one phone number, and even only one phone, so I didn\'t want it tied up completely. He could have just said, "OK fair enough," and just hung up, or said, "look I\'ll only be on for a little longer," but he just took it the wrong way and didn\'t really say very much, and he left soon after. And I didn\'t see him any more, or hear from him.\n\n'+
'This is the only encounter between Fischer and Browne:\n',
diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkb1r/pppppppp/5n2/4P3/8/8/PPPP1PPP/RNBQKBNR',
4:'rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR',
5:'rnbqkb1r/pppppppp/8/3nP3/3P4/8/PPP2PPP/RNBQKBNR',
6:'rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR',
7:'rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R',
8:'rnbqkb1r/ppp1pp1p/3p2p1/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R',
9:'rnbqkb1r/ppp1pp1p/3p2p1/3nP3/3P4/5N2/PPP1BPPP/RNBQK2R',
10:'rnbqk2r/ppp1ppbp/3p2p1/3nP3/3P4/5N2/PPP1BPPP/RNBQK2R',
11:'rnbqk2r/ppp1ppbp/3p2p1/3nP3/2PP4/5N2/PP2BPPP/RNBQK2R',
12:'rnbqk2r/ppp1ppbp/1n1p2p1/4P3/2PP4/5N2/PP2BPPP/RNBQK2R',
13:'rnbqk2r/ppp1ppbp/1n1P2p1/8/2PP4/5N2/PP2BPPP/RNBQK2R',
14:'rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/5N2/PP2BPPP/RNBQK2R',
15:'rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2N2N2/PP2BPPP/R1BQK2R',
16:'rnbq1rk1/pp2ppbp/1n1p2p1/8/2PP4/2N2N2/PP2BPPP/R1BQK2R',
17:'rnbq1rk1/pp2ppbp/1n1p2p1/8/2PP4/2N2N2/PP2BPPP/R1BQ1RK1',
18:'r1bq1rk1/pp2ppbp/1nnp2p1/8/2PP4/2N2N2/PP2BPPP/R1BQ1RK1',
19:'r1bq1rk1/pp2ppbp/1nnp2p1/8/2PP4/2N1BN2/PP2BPPP/R2Q1RK1',
20:'r2q1rk1/pp2ppbp/1nnp2p1/8/2PP2b1/2N1BN2/PP2BPPP/R2Q1RK1',
21:'r2q1rk1/pp2ppbp/1nnp2p1/8/2PP2b1/1PN1BN2/P3BPPP/R2Q1RK1',
22:'r2q1rk1/pp2ppbp/1nn3p1/3p4/2PP2b1/1PN1BN2/P3BPPP/R2Q1RK1',
23:'r2q1rk1/pp2ppbp/1nn3p1/2Pp4/3P2b1/1PN1BN2/P3BPPP/R2Q1RK1',
24:'r1nq1rk1/pp2ppbp/2n3p1/2Pp4/3P2b1/1PN1BN2/P3BPPP/R2Q1RK1',
25:'r1nq1rk1/pp2ppbp/2n3p1/2Pp4/3P2b1/1PN1BN1P/P3BPP1/R2Q1RK1',
26:'r1nq1rk1/pp2ppbp/2n3p1/2Pp4/3P4/1PN1Bb1P/P3BPP1/R2Q1RK1',
27:'r1nq1rk1/pp2ppbp/2n3p1/2Pp4/3P4/1PN1BB1P/P4PP1/R2Q1RK1',
28:'r1nq1rk1/pp3pbp/2n1p1p1/2Pp4/3P4/1PN1BB1P/P4PP1/R2Q1RK1',
29:'r1nq1rk1/pp3pbp/2n1p1p1/2Pp4/3P4/1PN1BB1P/P2Q1PP1/R4RK1',
30:'r2q1rk1/pp2npbp/2n1p1p1/2Pp4/3P4/1PN1BB1P/P2Q1PP1/R4RK1',
31:'r2q1rk1/pp2npbp/2n1p1p1/1NPp4/3P4/1P2BB1P/P2Q1PP1/R4RK1',
32:'r2q1rk1/pp3pbp/2n1p1p1/1NPp1n2/3P4/1P2BB1P/P2Q1PP1/R4RK1',
33:'r2q1rk1/pp3pbp/2n1p1p1/1NPp1n2/3P2B1/1P2B2P/P2Q1PP1/R4RK1',
34:'r2q1rk1/1p3pbp/p1n1p1p1/1NPp1n2/3P2B1/1P2B2P/P2Q1PP1/R4RK1',
35:'r2q1rk1/1p3pbp/p1n1p1p1/1NPp1B2/3P4/1P2B2P/P2Q1PP1/R4RK1',
36:'r2q1rk1/1p3pbp/2n1p1p1/1pPp1B2/3P4/1P2B2P/P2Q1PP1/R4RK1',
37:'r2q1rk1/1p3pbp/2n1p1p1/1pPp4/3P4/1P2B2P/P1BQ1PP1/R4RK1',
38:'3q1rk1/1p3pbp/2n1p1p1/1pPp4/3P4/rP2B2P/P1BQ1PP1/R4RK1',
39:'3q1rk1/1p3pbp/2n1p1p1/1pPp4/1P1P4/r3B2P/P1BQ1PP1/R4RK1',
40:'3q1rk1/1p4bp/2n1p1p1/1pPp1p2/1P1P4/r3B2P/P1BQ1PP1/R4RK1',
41:'3q1rk1/1p4bp/2n1p1p1/1pPp1p2/1P1P4/rB2B2P/P2Q1PP1/R4RK1',
42:'5rk1/1p4bp/2n1pqp1/1pPp1p2/1P1P4/rB2B2P/P2Q1PP1/R4RK1',
43:'5rk1/1p4bp/2n1pqp1/1pPp1p2/1P1P4/rB1QB2P/P4PP1/R4RK1',
44:'5rk1/1p4bp/2n1pqp1/1pPp4/1P1P1p2/rB1QB2P/P4PP1/R4RK1',
45:'5rk1/1p4bp/2n1pqp1/1pPp4/1P1P1p2/rB1Q3P/P4PP1/R1B2RK1',
46:'5rk1/1p4bp/r1n1pqp1/1pPp4/1P1P1p2/1B1Q3P/P4PP1/R1B2RK1',
47:'5rk1/1p4bp/r1n1pqp1/1pPp4/1P1P1p2/1B1Q3P/PB3PP1/R4RK1',
48:'5rk1/1p4bp/r1n1pqp1/1pPp4/1P1P4/1B1Q1p1P/PB3PP1/R4RK1',
49:'5rk1/1p4bp/r1n1pqp1/1pPp4/1P1P4/1B1Q1pPP/PB3P2/R4RK1',
50:'5rk1/1p4bp/r1n1p1p1/1pPp1q2/1P1P4/1B1Q1pPP/PB3P2/R4RK1',
51:'5rk1/1p4bp/r1n1p1p1/1pPp1Q2/1P1P4/1B3pPP/PB3P2/R4RK1',
52:'5rk1/1p4bp/r1n1p3/1pPp1p2/1P1P4/1B3pPP/PB3P2/R4RK1',
53:'5rk1/1p4bp/r1n1p3/1pPp1p2/1P1P4/1B3pPP/PB3P2/3R1RK1',
54:'5rk1/1p4bp/r3p3/1pPp1p2/1n1P4/1B3pPP/PB3P2/3R1RK1',
55:'5rk1/1p4bp/r3p3/1pPp1p2/1n1P4/1B3pPP/PB3P2/3RR1K1',
56:'5rk1/1p4bp/r3p3/1pPp4/1n1P1p2/1B3pPP/PB3P2/3RR1K1',
57:'5rk1/1p4bp/r3p3/1pPp4/1n1P1p2/PB3pPP/1B3P2/3RR1K1',
58:'5rk1/1p4bp/r1n1p3/1pPp4/3P1p2/PB3pPP/1B3P2/3RR1K1',
59:'5rk1/1p4bp/r1n1R3/1pPp4/3P1p2/PB3pPP/1B3P2/3R2K1',
60:'5rk1/1p4bp/r1n1R3/1pPp4/3P4/PB3ppP/1B3P2/3R2K1',
61:'5rk1/1p4bp/r1n1R3/1pPB4/3P4/P4ppP/1B3P2/3R2K1',
62:'5rk1/1p4bp/r1n1R3/1pPB4/3P4/P4p1P/1B3p2/3R2K1',
63:'5rk1/1p4bp/r1n1R3/1pPB4/3P4/P4p1P/1B3K2/3R4',
64:'5r1k/1p4bp/r1n1R3/1pPB4/3P4/P4p1P/1B3K2/3R4',
65:'5r1k/1p4bp/r1n5/1pPB4/3P4/P3Rp1P/1B3K2/3R4',
66:'5r1k/1p4bp/r1n5/2PB4/1p1P4/P3Rp1P/1B3K2/3R4',
67:'5r1k/1p4bp/r1n5/2PB4/1P1P4/4Rp1P/1B3K2/3R4',
68:'5r1k/1p4bp/r7/2PB4/1n1P4/4Rp1P/1B3K2/3R4',
69:'5r1k/1p4bp/r7/2P5/1n1P4/4RB1P/1B3K2/3R4',
70:'5r1k/1p4bp/8/2P5/1n1P4/4RB1P/rB3K2/3R4',
71:'5r1k/1p4bp/8/2P5/1n1P4/1R3B1P/rB3K2/3R4',
72:'5r1k/1p4bp/2n5/2P5/3P4/1R3B1P/rB3K2/3R4',
73:'5r1k/1p4bp/2n5/2P5/3P4/1R3BKP/rB6/3R4',
74:'6rk/1p4bp/2n5/2P5/3P4/1R3BKP/rB6/3R4',
75:'6rk/1p4bp/2n5/2P5/3P1K2/1R3B1P/rB6/3R4',
76:'5r1k/1p4bp/2n5/2P5/3P1K2/1R3B1P/rB6/3R4',
77:'5r1k/1p4bp/2n5/2P5/3PK3/1R3B1P/rB6/3R4',
78:'7k/1p3rbp/2n5/2P5/3PK3/1R3B1P/rB6/3R4',
79:'7k/1p3rbp/2n5/2P5/3PK1B1/1R5P/rB6/3R4',
80:'7k/1p2r1bp/2n5/2P5/3PK1B1/1R5P/rB6/3R4',
81:'7k/1p2r1bp/2n5/2P5/3P2B1/1R1K3P/rB6/3R4',
82:'7k/1p2r1bp/2n5/2P5/r2P2B1/1R1K3P/1B6/3R4',
83:'7k/1p2r1bp/2n5/2P5/r2P2B1/1R1K3P/1B6/R7',
84:'7k/1p2r1bp/2n5/2P5/3r2B1/1R1K3P/1B6/R7',
85:'7k/1p2r1bp/2n5/2P5/3B2B1/1R1K3P/8/R7',
86:'7k/1p2r2p/2n5/2P5/3b2B1/1R1K3P/8/R7',
87:'R6k/1p2r2p/2n5/2P5/3b2B1/1R1K3P/8/8',
88:'R7/1p2r1kp/2n5/2P5/3b2B1/1R1K3P/8/8',
89:'R7/1p2r1kp/2n5/1RP5/3b2B1/3K3P/8/8',
90:'R7/1p2r1kp/2n5/1RP5/6B1/3K3P/5b2/8',
91:'R7/1p2r1kp/2n5/1RP2B2/8/3K3P/5b2/8',
92:'R7/1p2r1kp/8/1RP1nB2/8/3K3P/5b2/8',
93:'R7/1p2r1kp/8/1RP1nB2/8/2K4P/5b2/8',
94:'R7/1p2r1kp/8/1RP1nB2/8/2K4P/8/4b3',
95:'R7/1p2r1kp/8/1RP1nB2/3K4/7P/8/4b3',
96:'R7/1p2r1kp/2n5/1RP2B2/3K4/7P/8/4b3',
97:'R7/1p2r1kp/2n5/1RP2B2/2K5/7P/8/4b3',
98:'R7/1p2r1kp/2n5/1RP2B2/2K4b/7P/8/8',
99:'R1B5/1p2r1kp/2n5/1RP5/2K4b/7P/8/8',
100:'R1Bn4/1p2r1kp/8/1RP5/2K4b/7P/8/8',
101:'2Bn4/1p2r1kp/8/1RP5/2K4b/7P/R7/8',
102:'2Bn4/1pr3kp/8/1RP5/2K4b/7P/R7/8',
103:'3n4/1pr3kp/8/1RP5/2K3Bb/7P/R7/8',
104:'3n4/1pr1b1kp/8/1RP5/2K3B1/7P/R7/8',
105:'3n4/1pr1b1kp/8/1RPK4/6B1/7P/R7/8',
106:'8/1pr1b1kp/2n5/1RPK4/6B1/7P/R7/8',
107:'8/1pr1b1kp/2n5/1RPK4/6B1/7P/1R6/8',
108:'3n4/1pr1b1kp/8/1RPK4/6B1/7P/1R6/8',
109:'3n4/1pr1b1kp/8/1RPK4/6B1/7P/8/1R6',
110:'3n1b2/1pr3kp/8/1RPK4/6B1/7P/8/1R6',
111:'3n1b2/1pr3kp/8/1RPK4/6B1/7P/1R6/8',
112:'3n4/1pr1b1kp/8/1RPK4/6B1/7P/1R6/8',
113:'3n4/1pr1b1kp/8/1RPK4/6B1/7P/6R1/8',
114:'3n3k/1pr1b2p/8/1RPK4/6B1/7P/6R1/8',
115:'3n3k/1pr1b2p/8/1RPK4/6B1/7P/R7/8',
116:'3n4/1pr1b1kp/8/1RPK4/6B1/7P/R7/8',
117:'R2n4/1pr1b1kp/8/1RPK4/6B1/7P/8/8',
118:'R2n4/1pr3kp/8/1RPK4/6Bb/7P/8/8',
119:'1R1n4/1pr3kp/8/1RPK4/6Bb/7P/8/8',
120:'1R1n4/1p3rkp/8/1RPK4/6Bb/7P/8/8',
121:'1R1n4/1p3rkp/8/2PK4/6Bb/7P/1R6/8',
122:'1R1n4/1p3r1p/7k/2PK4/6Bb/7P/1R6/8',
123:'1R1n4/1p3r1p/1R5k/2PK4/6Bb/7P/8/8',
124:'1R1n4/1p3rkp/1R6/2PK4/6Bb/7P/8/8',
125:'1R1n4/1p3rkp/8/2PK4/6Bb/1R5P/8/8',
126:'1R1n4/1p3rk1/8/2PK3p/6Bb/1R5P/8/8',
127:'1RBn4/1p3rk1/8/2PK3p/7b/1R5P/8/8',
128:'1RBn4/1p2brk1/8/2PK3p/8/1R5P/8/8',
129:'1RBn4/1p2brk1/8/1RPK3p/8/7P/8/8',
130:'1RBn4/1p2b1k1/8/1RPK3p/8/5r1P/8/8',
131:'1R1n4/1B2b1k1/8/1RPK3p/8/5r1P/8/8',
132:'1R1n4/1B2b1k1/8/1RPK3p/8/7r/8/8',
133:'1R1n4/1B2b1k1/2P5/1R1K3p/8/7r/8/8',
134:'1R1n4/1B2b1k1/2P5/1R1K3p/8/2r5/8/8',
135:'R2n4/1B2b1k1/2P5/1R1K3p/8/2r5/8/8',
136:'R2n4/1B2b1k1/2P5/1R1K4/7p/2r5/8/8',
137:'3n4/1B2b1k1/2P5/1R1K4/R6p/2r5/8/8',
138:'3n4/1B2b1k1/2P5/1R1K4/R7/2r4p/8/8',
139:'3n4/1B2b1k1/2P5/1R1K4/2R5/2r4p/8/8',
140:'3n4/1B2b1k1/2P5/1R1K4/2R5/2r5/7p/8',
141:'3n4/1B2b1k1/2P5/3K4/2R5/2r5/7p/1R6',
142:'3n4/1B2b1k1/2P5/3K4/2r5/8/7p/1R6',
143:'3n4/1B2b1k1/2P5/8/2K5/8/7p/1R6',
144:'3n4/1B4k1/2Pb4/8/2K5/8/7p/1R6',
145:'3n4/1B4k1/2Pb4/3K4/8/8/7p/1R6',
146:'3n4/1B4k1/2P5/3K4/8/6b1/7p/1R6',
147:'2Bn4/6k1/2P5/3K4/8/6b1/7p/1R6',
148:'2Bn4/5k2/2P5/3K4/8/6b1/7p/1R6',
149:'3n4/5k2/2P5/3K4/8/6bB/7p/1R6',
150:'3n4/4k3/2P5/3K4/8/6bB/7p/1R6',
151:'3n4/4k3/2P5/3K4/8/6bB/7p/2R5',
152:'3n4/8/2P2k2/3K4/8/6bB/7p/2R5',
153:'3n4/8/2P2k2/3K4/8/6bB/7p/R7',
154:'3n4/4k3/2P5/3K4/8/6bB/7p/R7',
155:'3n4/4k3/2P5/3K4/8/6bB/7p/5R2',
156:'8/4kn2/2P5/3K4/8/6bB/7p/5R2',
157:'8/4kn2/2P5/3K4/8/6b1/6Bp/5R2',
158:'8/4k3/2P5/3K2n1/8/6b1/6Bp/5R2',
159:'8/4k3/2P5/2K3n1/8/6b1/6Bp/5R2',
160:'8/4k3/2P1n3/2K5/8/6b1/6Bp/5R2',
161:'8/4k3/1KP1n3/8/8/6b1/6Bp/5R2',
162:'8/2b1k3/1KP1n3/8/8/8/6Bp/5R2',
163:'8/1Kb1k3/2P1n3/8/8/8/6Bp/5R2',
164:'8/1K2k3/2Pbn3/8/8/8/6Bp/5R2',
165:'8/1K2k3/2Pbn3/3B4/8/8/7p/5R2',
166:'8/1K2k3/2Pb4/2nB4/8/8/7p/5R2',
167:'8/4k3/1KPb4/2nB4/8/8/7p/5R2',
168:'8/4k3/1KPb4/3B4/n7/8/7p/5R2',
169:'8/4k3/2Pb4/K2B4/n7/8/7p/5R2',
170:'8/4k3/2Pb4/K1nB4/8/8/7p/5R2',
171:'8/4k3/2Pb4/1KnB4/8/8/7p/5R2',
172:'3k4/8/2Pb4/1KnB4/8/8/7p/5R2',
173:'3k4/5R2/2Pb4/1KnB4/8/8/7p/8',
174:'2k5/5R2/2Pb4/1KnB4/8/8/7p/8',
175:'2k5/2P2R2/3b4/1KnB4/8/8/7p/8',
176:'2k5/2Pn1R2/3b4/1K1B4/8/8/7p/8',
177:'2k5/2Pn1R2/2Kb4/3B4/8/8/7p/8',
178:'2k5/2Pn1R2/2Kb4/3B4/8/8/8/7q',
179:'2k5/2Pn1R2/2Kb4/8/8/8/8/7B',
180:'2k5/2P2R2/2Kb4/4n3/8/8/8/7B',
181:'2k5/2P2R2/1K1b4/4n3/8/8/8/7B',
182:'2k5/2P2R2/1K6/2b1n3/8/8/8/7B',
183:'2k5/2P2R2/8/2K1n3/8/8/8/7B',
184:'2k5/2P2n2/8/2K5/8/8/8/7B',
185:'2k5/2P2n2/1K6/8/8/8/8/7B',
186:'2k5/2P5/1K1n4/8/8/8/8/7B',
187:'2k5/2P5/1K1n4/3B4/8/8/8/8',
188:'8/2Pk4/1K1n4/3B4/8/8/8/8',
189:'8/2Pk4/1KBn4/8/8/8/8/8',
190:'2k5/2P5/1KBn4/8/8/8/8/8',
191:'2k5/2P5/1K1n4/3B4/8/8/8/8',
192:'8/2Pk4/1K1n4/3B4/8/8/8/8',
193:'8/2Pk4/1K1n4/8/8/1B6/8/8',
194:'2n5/2Pk4/1K6/8/8/1B6/8/8',
195:'2n5/1KPk4/8/8/8/1B6/8/8',
196:'8/1KPkn3/8/8/8/1B6/8/8'
},
comments:{
0:'Walter Browne vs Robert Fischer, Rovinj/Zagreb (1970). Annotations by GM Karsten Mueller. Annotations by Fischer from Informant 10 as noted.',
1:'1.e4', 2:'1...Nf6', 3:'2.e5', 4:'2...Nd5', 5:'3.d4', 6:'3...d6', 7:'4.Nf3', 8:'4...g6', 9:'5.Be2 5.Bc4!? with a slight edge - Fischer', 10:'5...Bg7', 11:'6.c4', 12:'6...Nb6',
13:'7.exd6', 14:'7...cxd6', 15:'8.Nc3', 16:'8...O-O', 17:'9.O-O', 18:'9...Nc6', 19:'10.Be3', 20:'10...Bg4', 21:'11.b3', 22:'11...d5',
23:'12.c5', 24:'12...Nc8 With the idea of … e6, ..Nc8-e7-f5 - Fischer.', 25:'13.h3 13.b4! - Fischer. The other main line, 13.b4, is probably more critical.', 26:'13...Bxf3', 27:'14.Bxf3', 28:'14...e6', 29:'15.Qd2', 30:'15...N8e7', 31:'16.Nb5? Better is 16.Ne2 - Fischer. 16.Ne2 e5 17.g3 is more circumspect', 32:'16...Nf5',
33:'17.Bg4', 34:'17...a6', 35:'18.Bxf5', 36:'18...axb5', 37:'19.Bc2', 38:'19...Ra3 Better are 19...b4! or 19...Qa5! - Fischer.', 39:'20.b4', 40:'20...f5 This plan is not bad in itself - Black is better. But the alternative, 20...Qh4!, is far stronger because it activates Black\'s whole army, e.g., 21.Rfd1 Rfa8 22.Bb3 Nxd4 23.Bxd5 Nc6.', 41:'21.Bb3 Not 21.f4?? Rxe3! - Fischer.', 42:'21...Qf6',
43:'22.Qd3', 44:'22...f4', 45:'23.Bc1', 46:'23...Ra6 Correct is 23...Rxb3!! 24.axb3 (24.Qxb3 Nxd4 25.Qd3 f3) 24...Qxd4 25.Qxd4 Bxd4 26.Ra2 e5 - Fischer.', 47:'24.Bb2', 48:'24...f3 24...Qf5!? - Fischer.', 49:'25.g3', 50:'25...Qf5', 51:'26.Qxf5', 52:'26...gxf5 Better is 26...Rxf5 - Fischer.',
53:'27.Rad1', 54:'27...Nxb4', 55:'28.Rfe1', 56:'28...f4? Better is 28...Kf7 with a slight advantage - Fischer. Fischer takes completely unnecessary risks. 28...Kf7 is simple and strong.', 57:'29.a3', 58:'29...Nc6', 59:'30.Rxe6', 60:'30...fxg3', 61:'31.Bxd5 31.fxg3?! - Fischer.',
62:'31...gxf2+', 63:'32.Kxf2', 64:'32...Kh8', 65:'33.Re3?! 33.Rd6 is more active.', 66:'33...b4', 67: '34.axb4', 68: '34...Nxb4', 69:'35.Bxf3 Not 35.Bxb7? Ra2 36.Rb3 (36.Rd2? Bh6) 36...Nc2!- Fischer.', 70:'35...Ra2',
71:'36.Rb3', 72:'36...Nc6', 73:'37.Kg3', 74:'37...Rg8', 75:'38.Kf4', 76:'38...Rf8+', 77:'39.Ke4', 78:'39...Rf7', 79:'40.Bg4', 80:'40...Re7+',
81:'41.Kd3', 82:'41...Ra4', 83:'42.Ra1', 84:'42...Rxd4+!? An interesting decision! Fischer decides that he can defend tenaciously by giving up the exchange and is rewarded in the end.', 85:'43.Bxd4', 86:'43...Bxd4', 87:'44.Ra8+', 88:'44...Kg7', 89:'45.Rb5',
90:'45...Bf2', 91:'46.Bf5', 92:'46...Ne5+', 93:'47.Kc3', 94:'47...Be1+', 95:'48.Kd4', 96:'48...Nc6+', 97:'49.Kc4', 98:'49...Bh4', 99:'50.Bc8',
100:'50...Nd8', 101:'51.Ra2', 102:'51...Rc7', 103:'52.Bg4', 104:'52...Be7', 105:'53.Kd5', 106:'53...Nc6', 107:'54.Rab2', 108:'54...Nd8', 109:'55.Rb1',
110:'55...Bf8', 111:'56.R1b2', 112:'56...Be7', 113:'57.Rg2', 114:'57...Kh8', 115:'58.Ra2', 116:'58...Kg7', 117:'59.Ra8', 118:'59...Bh4', 119:'60.Rb8',
120:'60...Rf7', 121:'61.Rb2', 122:'61...Kh6', 123:'62.Rb6+', 124:'62...Kg7', 125:'63.Rb3', 126:'63...h5', 127:'64.Bc8', 128:'64...Be7', 129:'65.Rb5',
130:'65...Rf3', 131:'66.Bxb7', 132:'66...Rxh3', 133:'67.c6', 134:'67...Rc3', 135:'68.Ra8 Correct is 68.Rc8! Nf7 69.Rc7 Kf6 70.Rb1 - Fischer.', 136:'68...h4', 137:'69.Ra4', 138:'69...h3', 139:'70.Rc4', 140:'70...h2',
141:'71.Rb1', 142:'71...Rxc4', 143:'72.Kxc4', 144:'72...Bd6', 145:'73.Kd5', 146:'73...Bg3 73...Nxb7 74.cxb7 Bb8 75.Ke4 is winning for White.', 147:'74.Bc8', 148:'74...Kf7', 149:'75.Bh3', 150:'75...Ke7',
151:'76.Rc1', 152:'76...Kf6', 153:'77.Ra1', 154:'77...Ke7', 155:'78.Rf1', 156:'78...Nf7', 157:'79.Bg2', 158:'79...Ng5', 159:'80.Kc5', 160:'80...Ne6+',
161:'81.Kb6', 162:'81...Bc7+ Better is 81...Nc7! - Fischer.', 163:'82.Kb7', 164:'82...Bd6 82...Be5!? 83.Bd5 Nd8+ 84.Kc8 Nxc6!? 85.Bxc6 Bd4 - Fischer.', 165:'83.Bd5', 166:'83...Nc5+ Not 83...Nc7? 84.Rf7+ - Fischer.', 167:'84.Kb6', 168:'84...Na4+', 169:'85.Ka5', 170:'85...Nc5',
171:'86.Kb5', 172:'86...Kd8', 173:'87.Rf7', 174:'87...Kc8', 175:'88.c7? Correct is 88.Rh7! Nd3 89.Be6+ Kb8 (89...Kd8 90.Rd7+ Ke8 91.Bf7+ Kf8 92.Bd5) 90.Rb7+ Ka8 91.Bd7 - Fischer. Missing the easy win with 88.Rh7! Kd8 89.c7+ Bxc7 90.Kxc5.', 176:'88...Nd7 Black should draw - Fischer.', 177:'89.Kc6? 89.Be6 Be7!! 90.Rxe7 (90.Bxd7+ Kxd7 91.Rh7 h1Q!) 90...h1Q 91.Bxd7+ Kxc7 92.Bc6+ Kd6 93.Rd7+ Ke6; 89.Rh7 Kxc7 90.Bc6 h1Q! 91.Bxh1 Kd8! 92.Kc6 Nf6 - Fischer. Browne could still have won with 89.Rh7! Kxc7 90.Bc6! h1=Q 91.Bxh1 (Sullivan) as this pawnless endgame is won as a rule with opposite-colored bishops. (Editors – The Nalimov Tables were not available in 1970. We now know White has chances to win the pawnless ending with rook and light-squared bishop versus knight and dark-squared bishop although it can often take more than 50 moves with best play by both sides.)', 178:'89...h1=Q Not 89...Ne5+?? 90.Kb6!! (90.Kxd6?? Nxf7+ 91.Bxf7 h1Q 92.Be6+ Kb7 93.c8Q+ Ka7 94.Qc5+ Kb8 95.Qc7+ Ka8 96.Bd5+ Qxd5+!) 90...Bc5+ 91.Kxc5 Nxf7 92.Kb6 Nd8 93.Be4 Kd7 94.Bf3 Ne6 95.Bc6+ - Fischer.', 179:'90.Bxh1', 180:'90...Ne5+',
181:'91.Kb6', 182:'91...Bc5+', 183:'92.Kxc5', 184:'92...Nxf7', 185:'93.Kb6', 186:'93...Nd6', 187:'94.Bd5', 188:'94...Kd7', 189:'95.Bc6+',
190:'95...Kc8', 191:'96.Bd5', 192:'96...Kd7', 193:'97.Bb3', 194:'97...Nc8+', 195:'98.Kb7', 196:'98...Ne7 Draw'
}
    },
    {
    id: 1,
      name: 'Eliot Hearst annotates his two Games with Bobby Fischer',
      description: '\nThe late Eliot Hearst (1932–2018) played two tournament games with Bobby Fischer, but had never annotated them until asked to do so by noted chess historian Nikolai Bruno of Honolulu in 2010, for a book he is writing on Fischer. \n\n'+

'We are grateful to Mr. Brunni for allowing us to present these two games with Hearst’s annotations. \n\n'+

'I had been playing Bobby for two or three years before the following game took place. This was our first tournament game, as our prior games at the Marshall Chess Club and Columbia University Chess Club were all contested at very fast speeds. I believe I was able to give him rook odds in our initial games, but it soon became apparent that he was a chess genius and that someday in the near future I would no longer be able to hold my own against him. It is not well known that he used to appear occasionally at the Columbia Club after his high school classes were over for the day (or he might have failed to attend school that day at all!); Columbia’s was the only club in New York where some strong players were usually available to play on weekday afternoons. At any rate, at the Rosenwald Tourney Bobby had beaten Donald Byrne a few days before in what became known as the “Game of the Century”, and I was not at all sure that I should be considered the favorite in this game against a 13-year-old (I was 24 at the time, had been playing in tournaments since I was 13, and had gained a master’s rating).\n',
diagrams:{0:'rnbqkbnr/pppppppp/8/8/0/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
6:'r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQK2R',
7:'r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQ1RK1',
8:'r1bqk1nr/pppp1ppp/8/1Bb1p3/3nP3/5N2/PPPP1PPP/RNBQ1RK1',
9:'r1bqk1nr/pppp1ppp/8/1Bb1p3/3NP3/8/PPPP1PPP/RNBQ1RK1',
10:'r1bqk1nr/pppp1ppp/8/1B2p3/3bP3/8/PPPP1PPP/RNBQ1RK1',
11:'r1bqk1nr/pppp1ppp/8/1B2p3/3bP3/2P5/PP1P1PPP/RNBQ1RK1',
12:'r1bqk1nr/pppp1ppp/1b6/1B2p3/4P3/2P5/PP1P1PPP/RNBQ1RK1',
13:'r1bqk1nr/pppp1ppp/1b6/1B2p3/3PP3/2P5/PP3PPP/RNBQ1RK1',
14:'r1bqk1nr/pp1p1ppp/1bp5/1B2p3/3PP3/2P5/PP3PPP/RNBQ1RK1',
15:'r1bqk1nr/pp1p1ppp/1bp5/4p3/B2PP3/2P5/PP3PPP/RNBQ1RK1',
16:'r1bqk1nr/pp3ppp/1bpp4/4p3/B2PP3/2P5/PP3PPP/RNBQ1RK1',
17:'r1bqk1nr/pp3ppp/1bpp4/4p3/B2PP3/N1P5/PP3PPP/R1BQ1RK1',
18:'r1bqk2r/pp3ppp/1bpp1n2/4p3/B2PP3/N1P5/PP3PPP/R1BQ1RK1',
19:'r1bqk2r/pp3ppp/1bpp1n2/4p3/B2PP3/N1P5/PP3PPP/R1BQR1K1',
20:'r1b1k2r/pp2qppp/1bpp1n2/4p3/B2PP3/N1P5/PP3PPP/R1BQR1K1',
21:'r1b1k2r/pp2qppp/1bpp1n2/4p1B1/B2PP3/N1P5/PP3PPP/R2QR1K1',
22:'r1b1k2r/pp2qpp1/1bpp1n1p/4p1B1/B2PP3/N1P5/PP3PPP/R2QR1K1',
23:'r1b1k2r/pp2qpp1/1bpp1n1p/4p3/B2PP2B/N1P5/PP3PPP/R2QR1K1',
24:'r1b1k2r/pp2qp2/1bpp1n1p/4p1p1/B2PP2B/N1P5/PP3PPP/R2QR1K1',
25:'r1b1k2r/pp2qp2/1bpp1n1p/4p1p1/B2PP3/N1P3B1/PP3PPP/R2QR1K1',
26:'r1b1k2r/pp2qp2/1bpp1n2/4p1pp/B2PP3/N1P3B1/PP3PPP/R2QR1K1',
27:'r1b1k2r/pp2qp2/1bpp1n2/4p1pp/B2PP3/N1P2PB1/PP4PP/R2QR1K1',
28:'r1b1k2r/pp2qp2/1bpp1n2/4p1p1/B2PP2p/N1P2PB1/PP4PP/R2QR1K1',
29:'r1b1k2r/pp2qp2/1bpp1n2/4p1p1/B2PP2p/N1P2P2/PP3BPP/R2QR1K1',
30:'r1b1k2r/pp2qp2/1bpp1n2/4p3/B2PP1pp/N1P2P2/PP3BPP/R2QR1K1',
31:'r1b1k2r/pp2qp2/1bpp1n2/4p3/B1NPP1pp/2P2P2/PP3BPP/R2QR1K1',
32:'r1b1k2r/pp2qp2/1bpp1n2/4p3/B1NPP2p/2P2Pp1/PP3BPP/R2QR1K1',
33:'r1b1k2r/pp2qp2/1bpp1n2/4p3/B1NPP2p/2P2PP1/PP3BP1/R2QR1K1',
34:'r1b1k2r/pp2qp2/1bpp1n2/4p3/B1NPP3/2P2Pp1/PP3BP1/R2QR1K1',
35:'r1b1k2r/pp2qp2/1bpp1n2/4p3/B1NPP3/2P2PB1/PP4P1/R2QR1K1',
36:'r1b1k2r/pp2qp2/1bpp4/4p2n/B1NPP3/2P2PB1/PP4P1/R2QR1K1',
37:'r1b1k2r/pp2qp2/1bpp4/4p2n/B1NPP3/2P2P2/PP4PB/R2QR1K1',
38:'r1b1k2r/ppb1qp2/2pp4/4p2n/B1NPP3/2P2P2/PP4PB/R2QR1K1',
39:'r1b1k2r/ppb1qp2/2pp4/4p2n/B2PP3/2P1NP2/PP4PB/R2QR1K1',
40:'r1b1k2r/ppb2p2/2pp4/4p2n/B2PP2q/2P1NP2/PP4PB/R2QR1K1',
41:'r1b1k2r/ppb2p2/2pp4/4p2n/B2PP2q/2P1NP2/PP1Q2PB/R3R1K1',
42:'r3k2r/ppbb1p2/2pp4/4p2n/B2PP2q/2P1NP2/PP1Q2PB/R3R1K1',
43:'r3k2r/ppbb1p2/2pp4/4p2n/3PP2q/1BP1NP2/PP1Q2PB/R3R1K1',
44:'r3k3/ppbb1p1r/2pp4/4p2n/3PP2q/1BP1NP2/PP1Q2PB/R3R1K1',
45:'r3k3/ppbb1p1r/2pp4/4p2n/3PP2q/1BP1NP2/PP3QPB/R3R1K1',
46:'r3k3/ppbb1p1r/2pp4/4p1qn/3PP3/1BP1NP2/PP3QPB/R3R1K1',
47:'r3k3/ppbb1p1r/2pp4/4p1qn/3PP3/1BP1NP2/PP3QPB/3RR1K1',
48:'r3k3/ppbb1p1r/2pp4/4p1q1/3PPn2/1BP1NP2/PP3QPB/3RR1K1',
49:'r3k3/ppbb1p1r/2pp4/4p1q1/3PPB2/1BP1NP2/PP3QP1/3RR1K1',
50:'r3k3/ppbb1p1r/2pp4/6q1/3PPp2/1BP1NP2/PP3QP1/3RR1K1',
51:'r3k3/ppbb1p1r/2pp4/5Nq1/3PPp2/1BP2P2/PP3QP1/3RR1K1',
52:'2kr4/ppbb1p1r/2pp4/5Nq1/3PPp2/1BP2P2/PP3QP1/3RR1K1',
53:'2kr4/ppbb1p1r/2pp4/5Nq1/3PPp2/1BP2P2/PP3QP1/3RRK2',
54:'2kr4/ppbb1p2/2pp4/5Nq1/3PPp2/1BP2P2/PP3QPr/3RRK2',
55:'2kr4/ppbb1B2/2pp4/5Nq1/3PPp2/2P2P2/PP3QPr/3RRK2',
56:'2kr4/ppbb1B2/2p5/3p1Nq1/3PPp2/2P2P2/PP3QPr/3RRK2',
57:'2kr4/ppbb1B2/2p5/3p1Nq1/3PPp2/2P2P2/PP1R1QPr/4RK2',
58:'2k2r2/ppbb1B2/2p5/3p1Nq1/3PPp2/2P2P2/PP1R1QPr/4RK2',
59:'2k2r2/ppbb1B2/2p5/3p1Nq1/3PPp2/2P2P2/PP1R2Pr/4RKQ1',
60:'2k2r2/ppbb1B1r/2p5/3p1Nq1/3PPp2/2P2P2/PP1R2P1/4RKQ1',
61:'2k2r2/ppbb1B1r/2p5/3P1Nq1/3P1p2/2P2P2/PP1R2P1/4RKQ1',
62:'2k2r2/ppbb1r2/2p5/3P1Nq1/3P1p2/2P2P2/PP1R2P1/4RKQ1',
63:'2k2r2/ppbb1r2/2P5/5Nq1/3P1p2/2P2P2/PP1R2P1/4RKQ1',
64:'2k2r2/ppb2r2/2b5/5Nq1/3P1p2/2P2P2/PP1R2P1/4RKQ1',
65:'2k2r2/ppb2r2/2b5/3P1Nq1/5p2/2P2P2/PP1R2P1/4RKQ1',
66:'2k2r2/ppb2r2/8/1b1P1Nq1/5p2/2P2P2/PP1R2P1/4RKQ1',
67:'2k2r2/ppb2r2/8/1b1P1Nq1/5p2/2P2P2/PP1RR1P1/5KQ1',
68:'2k2r2/ppb5/8/1b1P1rq1/5p2/2P2P2/PP1RR1P1/5KQ1',
69:'2k2r2/Qpb5/8/1b1P1rq1/5p2/2P2P2/PP1RR1P1/5K2',
70:'2k2r2/Qpb5/8/1b1r2q1/5p2/2P2P2/PP1RR1P1/5K2',
71:'2k2r2/Qpb5/8/1b1r2q1/2P2p2/5P2/PP1RR1P1/5K2',
72:'2k2r2/Qpb5/8/3r2q1/2b2p2/5P2/PP1RR1P1/5K2',
73:'Q1k2r2/1pb5/8/3r2q1/2b2p2/5P2/PP1RR1P1/5K2',
74:'Qbk2r2/1p6/8/3r2q1/2b2p2/5P2/PP1RR1P1/5K2',
75:'Qbk2r2/1p6/8/3r2q1/2b2p2/5P2/PPR1R1P1/5K2',
76:'Qbk2r2/1p6/8/2r3q1/2b2p2/5P2/PPR1R1P1/5K2',
77:'Qbk2r2/1p6/8/2r3q1/2b2p2/5P2/PPR1R1P1/4K3',
78:'Qbk2r2/1p6/8/2r3q1/5p2/5P2/PPR1b1P1/4K3',
79:'1bk2r2/1p6/8/Q1r3q1/5p2/5P2/PPR1b1P1/4K3',
80:'1bk2r2/1p6/8/Q1r5/5p2/5Pq1/PPR1b1P1/4K3',
81:'rnbqkbnr/pppppppp/8/8/0/8/PPPPPPPP/RNBQKBNR',
82:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
83:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',
84:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
85:'rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
86:'rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',
87:'rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R',
88:'rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R',
89:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R',
90:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
91:'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
92:'rnbqkb1r/1p2pppp/p2p1n2/8/3NPP2/2N5/PPP3PP/R1BQKB1R',
93:'rnbqkb1r/1p3ppp/p2p1n2/4p3/3NPP2/2N5/PPP3PP/R1BQKB1R',
94:'rnbqkb1r/1p3ppp/p2p1n2/4p3/4PP2/2N2N2/PPP3PP/R1BQKB1R',
95:'rnb1kb1r/1pq2ppp/p2p1n2/4p3/4PP2/2N2N2/PPP3PP/R1BQKB1R',
96:'rnb1kb1r/1pq2ppp/p2p1n2/4p3/4PP2/2NB1N2/PPP3PP/R1BQK2R',
97:'r1b1kb1r/1pqn1ppp/p2p1n2/4p3/4PP2/2NB1N2/PPP3PP/R1BQK2R',
98:'r1b1kb1r/1pqn1ppp/p2p1n2/4p3/4PP2/2NB1N2/PPP3PP/R1BQ1RK1',
99:'r1b1kb1r/2qn1ppp/p2p1n2/1p2p3/4PP2/2NB1N2/PPP3PP/R1BQ1RK1',
100:'r1b1kb1r/2qn1ppp/p2p1n2/1p2p3/4PP2/P1NB1N2/1PP3PP/R1BQ1RK1',
101:'r3kb1r/1bqn1ppp/p2p1n2/1p2p3/4PP2/P1NB1N2/1PP3PP/R1BQ1RK1',
102:'r3kb1r/1bqn1ppp/p2p1n2/1p2p3/4PP2/P1NB1N2/1PP3PP/R1BQ1R1K',
103:'r3kb1r/1bqn1p1p/p2p1np1/1p2p3/4PP2/P1NB1N2/1PP3PP/R1BQ1R1K',
104:'r3kb1r/1bqn1p1p/p2p1np1/1p2p3/4PP2/P1NBBN2/1PP3PP/R2Q1R1K',
105:'r3kb1r/1bqn1p1p/p2p2p1/1p2p3/4PPn1/P1NBBN2/1PP3PP/R2Q1R1K',
106:'r3kb1r/1bqn1p1p/p2p2p1/1p2p3/4PPn1/P1NB1N2/1PPB2PP/R2Q1R1K',
107:'r3k2r/1bqn1pbp/p2p2p1/1p2p3/4PPn1/P1NB1N2/1PPB2PP/R2Q1R1K',
108:'r3k2r/1bqn1pbp/p2p2p1/1p2pP2/4P1n1/P1NB1N2/1PPB2PP/R2Q1R1K',
109:'r3k2r/1bqn1pbp/p2p1np1/1p2pP2/4P3/P1NB1N2/1PPB2PP/R2Q1R1K',
110:'r3k2r/1bqn1pbp/p2p1np1/1p2pPN1/4P3/P1NB4/1PPB2PP/R2Q1R1K',
111:'r3k2r/1bqn1pb1/p2p1npp/1p2pPN1/4P3/P1NB4/1PPB2PP/R2Q1R1K',
112:'r3k2r/1bqn1pb1/p2p1npp/1p2pP2/4P3/P1NB3N/1PPB2PP/R2Q1R1K',
113:'r3k2r/1bqn1pb1/p2p1n1p/1p2pPp1/4P3/P1NB3N/1PPB2PP/R2Q1R1K',
114:'r3k2r/1bqn1pb1/p2p1n1p/1p2pPp1/4P3/P1NB4/1PPB1NPP/R2Q1R1K',
115:'r3k2r/1bq2pb1/p2p1n1p/1pn1pPp1/4P3/P1NB4/1PPB1NPP/R2Q1R1K',
116:'r3k2r/1bq2pb1/p2p1n1p/1pn1pPp1/1P2P3/P1NB4/2PB1NPP/R2Q1R1K',
117:'r3k2r/1bq2pb1/p2p1n1p/1p2pPp1/1P2P3/P1Nn4/2PB1NPP/R2Q1R1K',
118:'r3k2r/1bq2pb1/p2p1n1p/1p2pPp1/1P2P3/P1NP4/3B1NPP/R2Q1R1K',
119:'r3k2r/1b1q1pb1/p2p1n1p/1p2pPp1/1P2P3/P1NP4/3B1NPP/R2Q1R1K',
120:'r3k2r/1b1q1pb1/p2p1n1p/1p2pPp1/1P2P3/P1NP4/3BQNPP/R4R1K',
121:'2r1k2r/1b1q1pb1/p2p1n1p/1p2pPp1/1P2P3/P1NP4/3BQNPP/R4R1K',
122:'2r1k2r/1b1q1pb1/p2p1n1p/1p2pPp1/PP2P3/2NP4/3BQNPP/R4R1K',
123:'2r2rk1/1b1q1pb1/p2p1n1p/1p2pPp1/PP2P3/2NP4/3BQNPP/R4R1K',
124:'2r2rk1/1b1q1pb1/p2p1n1p/1P2pPp1/1P2P3/2NP4/3BQNPP/R4R1K',
125:'2r2rk1/1b1q1pb1/3p1n1p/1p2pPp1/1P2P3/2NP4/3BQNPP/R4R1K',
126:'2r2rk1/1b1q1pb1/3p1n1p/Rp2pPp1/1P2P3/2NP4/3BQNPP/5R1K',
127:'2r2rk1/1b1q1pb1/5n1p/Rp1ppPp1/1P2P3/2NP4/3BQNPP/5R1K',
128:'2r2rk1/1b1q1pb1/5n1p/Rp1PpPp1/1P6/2NP4/3BQNPP/5R1K',
129:'2r2rk1/1b1q1pb1/7p/Rp1npPp1/1P6/2NP4/3BQNPP/5R1K',
130:'2r2rk1/1b1q1pb1/7p/Rp1NpPp1/1P6/3P4/3BQNPP/5R1K',
131:'2r2rk1/1b3pb1/7p/Rp1qpPp1/1P6/3P4/3BQNPP/5R1K',
132:'2r2rk1/1b3pb1/7p/Rp1qpPp1/1P2N3/3P4/3BQ1PP/5R1K',
133:'2rr2k1/1b3pb1/7p/Rp1qpPp1/1P2N3/3P4/3BQ1PP/5R1K',
134:'2rr2k1/1b3pb1/7p/Rp1qpPp1/1P2N3/3P4/4Q1PP/4BR1K',
135:'2rr2k1/1b3pb1/7p/Rp2pPp1/1P2N3/3q4/4Q1PP/4BR1K',
136:'2rr2k1/1b3pb1/7p/Rp2pPp1/1P2N3/3Q4/6PP/4BR1K',
137:'2r3k1/1b3pb1/7p/Rp2pPp1/1P2N3/3r4/6PP/4BR1K',
138:'2r3k1/1b3pb1/7p/RpN1pPp1/1P6/3r4/6PP/4BR1K',
139:'2r3k1/1b3pb1/7p/RpN1pPp1/1P6/8/6PP/3rBR1K',
140:'2r3k1/1N3pb1/7p/Rp2pPp1/1P6/8/6PP/3rBR1K',
141:'6k1/1N3pb1/7p/Rp2pPp1/1P6/8/6PP/2rrBR1K',
142:'6k1/1N3pb1/7p/Rp2pPp1/1P6/8/6PP/2rrBRK1',
143:'6k1/1N3pb1/7p/Rp2pPp1/1P6/8/6PP/2r1rRK1',
144:'6k1/1N3pb1/7p/Rp2pPp1/1P6/8/6PP/2r1R1K1',
145:'6k1/1N3pb1/7p/Rp2pPp1/1P6/8/6PP/4r1K1',
146:'6k1/1N3pb1/7p/Rp2pPp1/1P6/8/5KPP/4r3',
147:'6k1/1N3pb1/7p/Rp2pPp1/1P2r3/8/5KPP/8',
148:'6k1/1N3pb1/7p/1R2pPp1/1P2r3/8/5KPP/8',
149:'5bk1/1N3p2/7p/1R2pPp1/1P2r3/8/5KPP/8',
150:'5bk1/5p2/7p/1RN1pPp1/1P2r3/8/5KPP/8',
151:'5bk1/5p2/7p/1RN1pPp1/1r6/8/5KPP/8',
152:'5bk1/5p2/7p/R1N1pPp1/1r6/8/5KPP/8',
153:'6k1/5p2/7p/R1b1pPp1/1r6/8/5KPP/8',
154:'6k1/5p2/7p/2R1pPp1/1r6/8/5KPP/8',
155:'6k1/5p2/7p/2R1pPp1/5r2/8/5KPP/8',
156:'6k1/5p2/7p/2R1pPp1/5r2/4K3/6PP/8',
157:'6k1/5p2/7p/2R1prp1/8/4K3/6PP/8',
158:'6k1/5p2/7p/2R1prp1/6P1/4K3/7P/8',
159:'6k1/5p2/7p/2R1p1p1/5rP1/4K3/7P/8',
160:'6k1/5p2/7p/2R1p1p1/5rP1/4K2P/8/8',
161:'6k1/5p2/7p/2R3p1/4prP1/4K2P/8/8',
162:'6k1/5p2/7p/6p1/2R1prP1/4K2P/8/8',
163:'6k1/5p2/7p/6p1/2R1p1P1/4Kr1P/8/8',
164:'6k1/5p2/7p/6p1/2R1K1P1/5r1P/8/8',
165:'6k1/5p2/7p/6p1/2R1K1P1/7r/8/8',
166:'6k1/5p2/7p/4K1p1/2R3P1/7r/8/8',
167:'6k1/5p2/7p/4K1p1/2R3P1/4r3/8/8',
168:'6k1/5p2/5K1p/6p1/2R3P1/4r3/8/8',
169:'6k1/5p2/5K1p/6p1/2R3P1/5r2/8/8',
170:'6k1/5p2/7p/4K1p1/2R3P1/5r2/8/8',
171:'8/5pk1/7p/4K1p1/2R3P1/5r2/8/8',
172:'8/5pk1/7p/3K2p1/2R3P1/5r2/8/8',
173:'8/5p2/6kp/3K2p1/2R3P1/5r2/8/8',
174:'8/5p2/6kp/3K2p1/6P1/5r2/8/2R5',
175:'8/5p2/6kp/3K2p1/5rP1/8/8/2R5',
176:'8/5p2/6kp/3K2p1/5rP1/8/8/6R1',
177:'8/8/6kp/3K1pp1/5rP1/8/8/6R1',
178:'8/8/6kp/3K1Pp1/5r2/8/8/6R1',
179:'8/8/7p/3K1kp1/5r2/8/8/6R1',
180:'8/8/7p/3K1kp1/5r2/8/8/7R',
181:'8/8/6kp/3K2p1/5r2/8/8/7R',
182:'8/8/6kp/4K1p1/5r2/8/8/7R',
183:'8/8/6k1/4K1pp/5r2/8/8/7R',
184:'8/8/6k1/4K1pp/5r2/8/8/3R4',
185:'8/8/6k1/4K1p1/5r1p/8/8/3R4',
186:'8/8/6k1/4K1p1/5r1p/8/8/6R1',
187:'8/8/8/4K1pk/5r1p/8/8/6R1',
188:'8/8/8/4K1pk/5r1p/8/8/7R',
189:'5r2/8/8/4K1pk/7p/8/8/7R',
190:'5r2/8/8/4K1pk/7p/8/8/3R4',
191:'5r2/8/8/4K1pk/8/7p/8/3R4',
192:'5r2/8/8/6pk/4K3/7p/8/3R4',
193:'5r2/8/8/6p1/4K2k/7p/8/3R4',
194:'5r2/3R4/8/6p1/4K2k/7p/8/8',
195:'8/3R4/8/6p1/4K2k/7p/8/5r2',
196:'8/8/8/6p1/4K2k/7p/3R4/5r2',
197:'8/8/8/8/4K1pk/7p/3R4/5r2',
198:'3R4/8/8/8/4K1pk/7p/8/5r2',
199:'3R4/8/8/8/4K1pk/8/7p/5r2'
},
comments:{0:'Bobby had already established himself as someone who would virtually always open with the Ruy Lopez if his opponent permitted it. I decided beforehand to permit [it], but not to meet the opening with one of the most common defenses against it.', 1:'1.e4', 2:'1...e5', 3:'2.Nf3', 4:'2...Nc6', 5:'3.Bb5', 6:'3...Bc5 The relatively unusual Classical or Cordel Defense to the Ruy Lopez.', 7:'4.O-O Most common here is 4.c3, aiming for an early d4.', 8:'4...Nd4', 9:'5.Nxd4', 10:'5...Bxd4', 11:'6.c3',
12:'6...Bb6 ', 13:'7.d4', 14:'7...c6', 15:'8.Ba4', 16:'8...d6', 17:'9.Na3', 18:'9...Nf6', 19:'10.Re1', 20:'10...Qe7', 21:'11.Bg5', 22:'11...h6 Up to here the play has more or less followed some previously played grandmaster games.',
23:'12.Bh4 This is a mistake, in my opinion. Since Black can still castle queenside, he does not fear initiating a pawn storm on the kingside; he has no intention of castling on that side of the board.', 24:'12...g5', 25:'13.Bg3', 26:'13...h5', 27:'14.f3', 28:'14...h4', 29:'15.Bf2', 30:'15...g4', 31:'16.Nc4', 32:'16...g3 The opening of lines to White’s king seemed to justify this pawn sacrifice.', 33:'17.hxg3',
34:'17...hxg3', 35:'18.Bxg3', 36:'18...Nh5', 37:'19.Bh2', 38:'19...Bc7 With the minor threat of …b5, but the major purpose of saving this bishop for later use against White’s king.', 39:'20.Ne3', 40:'20...Qh4', 41:'21.Qd2', 42:'21...Bd7', 43:'22.Bb3',
44:'22...Rh7', 45:'23.Qf2', 46:'23...Qg5', 47:'24.Rad1', 48:'25...Nf4 Of course threating a disastrous fork with …Nh3+.', 49:'25.Bxf4 The move 25.Qg3 gives Black much more trouble. (A follow-up e-mail from Dr. Hearst he relates that he was in a bookstore looking at Karsten Mueller\'s book Bobby Fischer: The Career and Complete Games of the American World Chess Champion, and saw Muller’s note: "25.Qg3 leads to a more or less forced draw: 25…Qh5 26.dxe5 dxe5 27.Qg8+ Ke7 28.Qxa8 Qxh2+ 29.Kf2 Qh4."', 50:'25...exf4', 51:'26.Nf5 Appears aggressive but leaves the knight out on a limb. Nc4 was much better. Now Black gains a definite advantage.', 52:'26...O-O-O Black is fully mobilized for his attack against White’s king. Recalling the game about 30 years later, Bobby told me "you gotta terrific ??? in that game!" ',
53:'27.Kf1', 54:'27...Rh2', 55:'28.Bxf7 Losing a piece eventually but it is hard to suggest a better defense.', 56:'28...d5! Trapping the bishop or at least giving White major defensive problems.', 57:'29.Rd2', 58:'29...Rf8', 59:'30.Qg1 If instead 30.Bg6 (hoping for 30…Qxg6 31.Ne7+) then Black simply replies 30…Kb8 and the bishop still has nowhere to go.', 60:'30...Rh7', 61:'31.exd5', 62:'31...Rhxf7',
63:'32.dxc6', 64:'32...Bxc6 Now White’s knight is trapped, too. Against a grandmaster opponent Bobby would probably have resigned here. But we were both in tremendous time pressure to reach the 40th move.', 65:'33.d5', 66:'33...Bb5+', 67:'34.Ree2', 68:'34...Rxf5', 69:'35.Qxa7', 70:'35...Rxd5', 71:'36.c4',
72:'36...Bxc4', 73:'37.Qa8+', 74:'37...Bb8', 75:'38.Rc2', 76:'38...Rc5?? I was merely trying to play safe moves so that I could avoid a loss on time. Were I looking for an immediate tactical win I might have seen 38…Rd1+ 39.Kf2 Qg3 mate. As soon as the game was over everyone in the crowd surrounding our game (allowed in those days) pointed out this checkmate to me. I was abashed but so happy to win that I was able to laugh at my blunder.', 77:'39.Ke1', 78:'39...Bxe2', 79:'40.Qa5 In a totally lost position and extreme time pressure Bobby found this tricky move. Somehow I am impressed by this last-gasp try, even though it can be refuted in numerous ways. ', 80:'40...Qg3+ 0-1 Now that I have reached the time control without overstepping the time limit, my recollection is that Bobby resigned right now. However, some collections of Bobby\'s games continue with the following moves, which I do not believe occurred: 41.Kd2 Rd8+ 42.Qxd8+ Kxd8 43.Rxc5 Qxg2. I consider this game one of the five best games I ever played, regardless of whether it was played against a future world champion. My only regret about it was missing the forced mate on move 38. ',
81:'My second tournament game with Bobby came about seven months after the first. I no longer lived in New York but had been drafted into the U.S. Army and was stationed in Washington, D.C. Even so, I drove to New York on most weekends to see friends and to play occasionally for the Marshall Chess Club in the Metropolitan League matches, held on Saturday nights in the early part of each year. Almost always the Marshall and Manhattan Chess Clubs had won all their previous matches and were paired in the final round. I believe the Manhattan club won virtually all these title-deciding matches; they had a stronger group of players to select from than did the Marshall club and rumor has it that they paid some members of their team to play in what was not really an important national or international event. It had relatively little interest outside New York City, except for the fact that some of the nation’s top players participated. Seven months after my first game with Bobby he had improved by leaps and bounds and later in 1957, after this game, he won both the U.S. Open and regular U.S. Championships at the age of 14. He played the following game without any real errors and I was pleased to hold my own, losing a contest that I could probably have drawn with better play on my part at the crucial stages. ',
82:'1.e4',
83:'1...c5',
84:'2.Nf3',
85:'2...d6',
86:'3.d4 ',
87:'3...cxd4 ',
88:'4.Nxd4 ',
89:'4...Nf6 ',
90:'5.Nc3 ',
91:'5...a6 The Najdorf Variation, one of Bobby’s favorites throughout his career. It has been one of the most analyzed openings of the past 50–60 years.',
92:'6.f4 This rather uncommon move was always my favorite; I knew it well and was happy to avoid the more frequent continuations, such as Bg5 and one of Bobby’s favorites, Bc4.',
93:'6...e5',
94:'7.Nf3 ',
95:'7...Qc7 ',
96:'8.Bd3 ',
97:'8...Nbd7 ',
98:'9.O-O ',
99:'9...b5 ',
100:'10.a3 ',
101:'10...Bb7 ',
102:'11.Kh1 ',
103:'11...g6 ',
104:'12.Be3 Perhaps 12.Qe1, intending to place the queen on h4 was better.',
105:'12...Ng4 ',
106:'13.Bd2 ',
107:'13...Bg7 ',
108:'14.f5 ',
109:'14...Ngf6 Getting ready to play …d5.',
110:'15.Ng5 ',
111:'15...h6 ',
112:'16.Nh3 ',
113:'16...g5 ',
114:'17.Nf2 ',
115:'17...Nc5',
116:'18.b4 Weakening White’s queenside. 18.Qf3 with Ng4 in mind was a better alternative. ',
117:'18...Nxd3 ',
118:'19.cxd3 ',
119:'19...Qd7 ',
120:'20.Qe2',
121:'20...Rc8 ',
122:'21.a4 ',
123:'21...O-O ',
124:'22.axb5 ',
125:'22...axb5',
126:'23.Ra5 ',
127:'23...d5 ',
128:'24.exd5 Obviously not Rxb5 because of the reply …d4.',
129:'24...Nxd5 ',
130:'25.Nxd5 25.Nce4 was a superior move and gives White attacking chances on the kingside and queenside.',
131:'25...Qxd5 ',
132:'26.Ne4 ',
133:'26...Rfd8 ',
134:'27.Be1 Partly to prevent …Rc2 and I thought Black could not capture my d-pawn because of the fork 29.Nc5, as follows. But Bobby saw further ahead than I did! 27.Nc5 was better and seems to retain an equal game.',
135:'27...Qxd3! ',
136:'28.Qxd3 ',
137:'28...Rxd3 ',
138:'29.Nc5 ',
139:'29...Rd1 ',
140:'30.Nxb7 ',
141:'30...Rcc1 ',
142:'31.Kg1 ',
143:'31...Rxe1',
144:'32.Rxe1 ',
145:'32...Rxe1+ ',
146:'33.Kf2 ',
147:'33...Re4 ',
148:'34.Rxb5 White has other moves that are more likely to gain a draw: 34.Ra8+ Kh7 36.Nd6.',
149:'34...Bf8 ',
150:'35.Nc5?? A time-pressure blunder that ensures Black’s win. Other moves such as Nd8, Kf3, or g3 still left White with drawing chances.',
151:'35...Rxb4 ',
152:'36.Ra5',
153:'36...Bxc5+ ',
154:'37.Rxc5 ',
155:'37...Rf4+ ',
156:'38.Ke3 ',
157:'38...Rxf5 ',
158:'39.g4 ',
159:'39...Rf4 ',
160:'40.h3 ',
161:'40...e4 ',
162:'41.Rc4',
163:'41...Rf3+ ',
164:'42.Kxe4 ',
165:'42...Rxh3 ',
166:'43.Ke5 ',
167:'43...Re3+ ',
168:'44.Kf6 ',
169:'44...Rf3+ ',
170:'45.Ke5 ',
171:'45...Kg7',
172:'46.Kd5 ',
173:'46...Kg6 ',
174:'47.Rc1 ',
175:'47...Rf4 ',
176:'48.Rg1 ',
177:'48...f5 ',
178:'49.gxf5+ ',
179:'49...Kxf5 ',
180:'50.Rh1 ',
181:'50...Kg6',
182:'51.Ke5 ',
183:'51...h5 ',
184:'52.Rd1 ',
185:'52...h4 ',
186:'53.Rg1 ',
187:'53...Kh5 ',
188:'54.Rh1 ',
189:'54...Rf8 ',
190:'55.Rd1 ',
191:'55...h3',
192:'56.Ke4 ',
193:'56...Kh4 ',
194:'57.Rd7 ',
195:'57...Rf1 ',
196:'58.Rd2 ',
197:'58...g4 ',
198:'59.Rd8 ',
199:'59...h2 0-1 I should have resigned earlier but thought maybe a 14-year-old wasn’t as good in the endgame as in the opening and middlegame. He was. '
}
},
{
    id: 2,
      name: 'Duncan Suttles Interview',
      description: '\nInterview with GM Duncan Suttles\n\n'+
'by Bruce Harper\n\n'+
'(From the book No Regrets, 1992)\n\n'+
'\n\n'+
'What would be your assessment of the level of play in the match?\n\n'+

'Suttles – I would say Spassky would be, maybe 2650. I don’t know how you determine Fischer’s performance from that number. It depends on how you count the draws. Not counting draws, maybe 2800...\n\n'+

'Really?\n\n'+

'Suttles – Why not? He beat him two to one, didn’t he? What does that mean? I would say somewhere between 2750 and 2800. What’s Kasparov’s rating? About 2780? Let’s just say Fischer’s within about 25 points of Kasparov...plus or minus.\n\n'+

'How do you think Fischer would fare in a match against one of the top players in the world, such as Anand, Ivanchuk, Short or Timman?\n\n'+

'Suttles – I think he would be favored against any one of them. Mind you, someone who plays as fast as Anand might pose a little bit of a problem.\n\n'+

'How would Fischer do against Kasparov?\n\n'+

'Suttles – Well, I think right now it would be pretty close, but if Fischer plays himself back in form, I think he would beat him.\n\n'+

'Kasparov has said that Fischer isn’t playing “modern chess.”  Do you think chess has changed since Fischer last played?\n\n'+

'Suttles – I didn’t see what wasn’t “modern” about his chess in the match.\n\n'+

'Is there such a thing as “modern chess?” I think Kasparov was referring to a better understanding of the dynamic possibilities inherent in the game.\n\n'+

'Suttles – I think Fischer tries to seek the truth in the position. Seeking the truth in the position and playing what might practically be the best line are not necessarily the same thing. If they mean by modern chess trying practically to beat the opponent over the board by not playing the best move but by posing a problem for him, then maybe Fischer doesn’t exactly go for that. I would say, on the other hand, whether or not what’s referred to as “modern chess” has uncovered some new truth behind the game, I sort of doubt it. To figure this out would probably require computers to figure out whether Fischer’s strategies in fact work.\n\n'+

'I saw some games in which Fischer plays what be considered from the “modern chess” point of view to be risky positions, in that they were cramped and his opponent had a space advantage or might have had a temporary plus in mobility. However, it’s difficult to say whether, objectively, those were bad positions for him.  They might have been good.\n\n'+

'So Kasparov tries to win and Fischer seeks the truth.\n\n'+
'Suttles – Well, they both try to win, but Fischer tries to win by playing the best move, while Kasparov tries to win by finding the weakness in his opponent’s psychology. I think that’s the difference between the so-called “modern chess” and Fischer’s style of chess. Fischer’s style is more related to the truth in the position – or what he perceives to be truth. Fischer seeks a deeper understanding of the actual position on the board, not just the dynamics of the particular opponent.\n\n'+

'Are we approaching the “death of chess?”\n\n'+

'Suttles – In what sense? Computers will be unbeatable in a few years, but I don’t know if that will matter. It depends on human chess players. One of the problems will be that computers will add more and more to opening theory, which will make the problem of people being booked up greater and greater.\n\n'+

'Is it becoming increasingly difficult for a good player to show that he’s good?\n\n'+

'Well, a player who can memorize key lines from an extended computer analysis will be difficult  to beat in the opening and will always achieve a decent position going into the middlegame. So in that sense the game might be played out. I can see some problems developing similar to what happened to checkers, where openings have to be drawn by lot. In chess wins could become less and less frequent. I think computer analysis will significantly increase the margin of draw in chess. As in the match, as opposed to playing with bishop against knight only twice. Does this mean anything? In the 1972 match Fischer traded knights for bishops just about as often as he traded bishops for knights.\n\n'+

'In this match a significant number of positions were relatively closed. In blocked or semi-blocked positions knights are usually better than bishops.\n\n'+

'So Fischer seemed to playing for closed positions?\n\n'+

'Suttles – (Laughs) Maybe they both were. There were clearly quite a few closed positions. I think Fischer may have been doing it to create a larger number of long-range strategic possibilities, as opposed to violent tactics which would clarify things. Presumably to give himself a chance to outplay his opponent.\n\n'+

'So the knights against bishops is only the result of the type of position Fischer was playing. I think the games also show that Fischer was playing for structural advantages, generally speaking. Again, I think this might signify a shift in style. Perhaps Fischer has come to the conclusion that defense offers more possibilities than had been previously thought.\n\n'+

'Does this make a Fischer-Kasparov match even more interesting?\n\n'+

'Suttles – I think so, because you would have a clash between a style which attempts to strive for activity and dynamic chances, so to speak, versus an attempt to exploit structural advantages through long-term strategy. Especially if Fischer goes for long-term advantages and goes on the edge to do it – for that to work against Kasparov, he has to play himself into the best possible technical form too, obviously, because you can’t afford any slips when you’re using that strategy.\n\n'+

'That’s for sure. I guess I don’t have to ask which side you’d be cheering for stylistically?\n\n'+

'Suttles – (Laughs) Of course, I’m more inclined towards the structural.\n\n'+

'Any other comments?\n\n'+

'I think generally...the problem coming back after twenty years is one of getting your technique to be even, but I have the feeling he has evolved in his understanding of the game. In other words, he showed a lot of finesse in this match – there was a lot under the surface. Some of the criticisms of his play have looked too much at the result of the games. You have to be careful - there’s a tendency to push forwards the moves of the winner and push back the moves of the loser...I don’t think Fischer panicked with his king walk [game 8]-I think he was just trying to win the game.'+
'\n\n'+
'\n\n'+
'This is the first encounter between Fischer and Suttles:\n',
diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppppp1p/6p1/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppppp1p/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR',
4:'rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR',
5:'rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR',
6:'rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR',
7:'rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N1B3/PPP2PPP/R2QKBNR',
8:'rnbqk1nr/pp2ppbp/2pp2p1/8/3PP3/2N1B3/PPP2PPP/R2QKBNR',
9:'rnbqk1nr/pp2ppbp/2pp2p1/8/3PP3/2N1B3/PPPQ1PPP/R3KBNR',
10:'r1bqk1nr/pp1nppbp/2pp2p1/8/3PP3/2N1B3/PPPQ1PPP/R3KBNR',
11:'r1bqk1nr/pp1nppbp/2pp2p1/8/3PPP2/2N1B3/PPPQ2PP/R3KBNR',
12:'r1bqk2r/pp1nppbp/2pp1np1/8/3PPP2/2N1B3/PPPQ2PP/R3KBNR',
13:'r1bqk2r/pp1nppbp/2pp1np1/8/3PPP2/2N1BN2/PPPQ2PP/R3KB1R',
14:'r1bq1rk1/pp1nppbp/2pp1np1/8/3PPP2/2N1BN2/PPPQ2PP/R3KB1R',
15:'r1bq1rk1/pp1nppbp/2pp1np1/8/3PPP2/2N1BN1P/PPPQ2P1/R3KB1R',
16:'r1bq1rk1/p2nppbp/2pp1np1/1p6/3PPP2/2N1BN1P/PPPQ2P1/R3KB1R',
17:'r1bq1rk1/p2nppbp/2pp1np1/1p6/3PPP2/2NBBN1P/PPPQ2P1/R3K2R',
18:'r1bq1rk1/p3ppbp/1npp1np1/1p6/3PPP2/2NBBN1P/PPPQ2P1/R3K2R',
19:'r1bq1rk1/p3ppbp/1npp1np1/1p6/3PPP2/1PNBBN1P/P1PQ2P1/R3K2R',
20:'r1bq1rk1/4ppbp/1npp1np1/pp6/3PPP2/1PNBBN1P/P1PQ2P1/R3K2R',
21:'r1bq1rk1/4ppbp/1npp1np1/pp6/3PPP2/1PNBBN1P/P1PQ2P1/R4RK1',
22:'r1bq1rk1/4ppbp/1npp1np1/p7/1p1PPP2/1PNBBN1P/P1PQ2P1/R4RK1',
23:'r1bq1rk1/4ppbp/1npp1np1/p7/1p1PPP2/1P1BBN1P/P1PQN1P1/R4RK1',
24:'r1bq1rk1/4ppbp/1np2np1/p2p4/1p1PPP2/1P1BBN1P/P1PQN1P1/R4RK1',
25:'r1bq1rk1/4ppbp/1np2np1/p2pP3/1p1P1P2/1P1BBN1P/P1PQN1P1/R4RK1',
26:'r1bq1rk1/4ppbp/1np3p1/p2pP3/1p1PnP2/1P1BBN1P/P1PQN1P1/R4RK1',
27:'r1bq1rk1/4ppbp/1np3p1/p2pP3/1p1PnP2/1P1BBN1P/P1P1N1P1/R3QRK1',
28:'r1bq1rk1/4p1bp/1np3p1/p2pPp2/1p1PnP2/1P1BBN1P/P1P1N1P1/R3QRK1',
29:'r1bq1rk1/4p1bp/1np3p1/p2pPp2/1p1PnP2/PP1BBN1P/2P1N1P1/R3QRK1',
30:'r1bq1rk1/4p1bp/1np3p1/p2pPp2/3PnP2/pP1BBN1P/2P1N1P1/R3QRK1',
31:'r1bq1rk1/4p1bp/1np3p1/p2pPp2/3PnP2/RP1BBN1P/2P1N1P1/4QRK1',
32:'r1bq1rk1/4p1bp/1np3p1/3pPp2/p2PnP2/RP1BBN1P/2P1N1P1/4QRK1',
33:'r1bq1rk1/4p1bp/1np3p1/3pPp2/p2PnP2/RP1BBN1P/2P1N1P1/Q4RK1',
34:'r2q1rk1/4p1bp/bnp3p1/3pPp2/p2PnP2/RP1BBN1P/2P1N1P1/Q4RK1',
35:'r2q1rk1/4p1bp/Bnp3p1/3pPp2/p2PnP2/RP2BN1P/2P1N1P1/Q4RK1',
36:'3q1rk1/4p1bp/rnp3p1/3pPp2/p2PnP2/RP2BN1P/2P1N1P1/Q4RK1',
37:'3q1rk1/4p1bp/rnp3p1/3pPp2/p2PnP2/RPN1BN1P/2P3P1/Q4RK1',
38:'5rk1/2q1p1bp/rnp3p1/3pPp2/p2PnP2/RPN1BN1P/2P3P1/Q4RK1',
39:'5rk1/2q1p1bp/rnp3p1/3pPp2/p2PnP2/RPN1B2P/2P3P1/Q3NRK1',
40:'r5k1/2q1p1bp/rnp3p1/3pPp2/p2PnP2/RPN1B2P/2P3P1/Q3NRK1',
41:'r5k1/2q1p1bp/rnp3p1/3pPp2/p2PnP2/RPNNB2P/2P3P1/Q4RK1',
42:'r5k1/r1q1p1bp/1np3p1/3pPp2/p2PnP2/RPNNB2P/2P3P1/Q4RK1',
43:'r5k1/r1q1p1bp/1np3p1/3pPp2/p2PnP2/RPNNB2P/1QP3P1/5RK1',
44:'r5k1/r1q3bp/1np1p1p1/3pPp2/p2PnP2/RPNNB2P/1QP3P1/5RK1',
45:'r5k1/r1q3bp/1np1p1p1/2NpPp2/p2PnP2/RPN1B2P/1QP3P1/5RK1',
46:'r4bk1/r1q4p/1np1p1p1/2NpPp2/p2PnP2/RPN1B2P/1QP3P1/5RK1',
47:'r4bk1/r1q4p/1np1p1p1/2NpPp2/p2PnP2/RPN1B2P/1QP3P1/R5K1',
48:'r4b2/r1q2k1p/1np1p1p1/2NpPp2/p2PnP2/RPN1B2P/1QP3P1/R5K1',
49:'r4b2/r1q2k1p/1np1p1p1/2NpPp2/N2PnP2/RP2B2P/1QP3P1/R5K1',
50:'r4b2/r1q2k1p/2p1p1p1/2NpPp2/n2PnP2/RP2B2P/1QP3P1/R5K1',
51:'r4b2/r1q2k1p/2p1p1p1/2NpPp2/P2PnP2/R3B2P/1QP3P1/R5K1',
52:'r7/r1q2k1p/2p1p1p1/2bpPp2/P2PnP2/R3B2P/1QP3P1/R5K1',
53:'r7/r1q2k1p/2p1p1p1/2PpPp2/P3nP2/R3B2P/1QP3P1/R5K1',
54:'r5k1/r1q4p/2p1p1p1/2PpPp2/P3nP2/R3B2P/1QP3P1/R5K1',
55:'r5k1/r1q4p/2p1p1p1/2PpPp2/P3nP2/1R2B2P/1QP3P1/R5K1',
56:'r5k1/r6p/2p1p1p1/q1PpPp2/P3nP2/1R2B2P/1QP3P1/R5K1',
57:'r5k1/r6p/2p1p1p1/q1PpPp2/P3nP2/1R2B2P/1QP3PK/R7',
58:'r5k1/r7/2p1p1p1/q1PpPp1p/P3nP2/1R2B2P/1QP3PK/R7',
59:'rR4k1/r7/2p1p1p1/q1PpPp1p/P3nP2/4B2P/1QP3PK/R7',
60:'1r4k1/r7/2p1p1p1/q1PpPp1p/P3nP2/4B2P/1QP3PK/R7',
61:'1Q4k1/r7/2p1p1p1/q1PpPp1p/P3nP2/4B2P/2P3PK/R7',
62:'1Q6/r6k/2p1p1p1/q1PpPp1p/P3nP2/4B2P/2P3PK/R7',
63:'1Q6/r6k/2p1p1p1/q1PpPp1p/P3nP2/4B2P/2P3PK/1R6',
64:'1Q6/r6k/2p1p1p1/2PpPp1p/q3nP2/4B2P/2P3PK/1R6',
65:'5Q2/r6k/2p1p1p1/2PpPp1p/q3nP2/4B2P/2P3PK/1R6',
66:'5Q2/6rk/2p1p1p1/2PpPp1p/q3nP2/4B2P/2P3PK/1R6',
67:'1R3Q2/6rk/2p1p1p1/2PpPp1p/q3nP2/4B2P/2P3PK/8',
68:'1R3Q2/6rk/2p1p3/2PpPppp/q3nP2/4B2P/2P3PK/8',
69:'1R5Q/6rk/2p1p3/2PpPppp/q3nP2/4B2P/2P3PK/8',
70:'1R5Q/6r1/2p1p1k1/2PpPppp/q3nP2/4B2P/2P3PK/8',
71:'1R2Q3/6r1/2p1p1k1/2PpPppp/q3nP2/4B2P/2P3PK/8',
72:'1R2Q3/5r2/2p1p1k1/2PpPppp/q3nP2/4B2P/2P3PK/8',
73:'4Q3/1R3r2/2p1p1k1/2PpPppp/q3nP2/4B2P/2P3PK/8'
},
comments:{
0:'Robert James Fischer vs Duncan Suttles, USA championship New York 1965. Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...g6', 3:'2.d4', 4:'2...Bg7', 5:'3.Nc3', 6:'3...d6', 7:'4.Be3', 8:'4...c6', 9:'5.Qd2', 10:'5...Nd7', 11:'6.f4', 12:'6...Ngf6',
13:'7.Nf3', 14:'7...O-O', 15:'8.h3  8.e5 and 8.O-O-O are the main lines.', 16:'8...b5', 17:'9.Bd3', 18:'9...Nb6', 19:'10.b3', 20:'10...a5', 21:'11.O-O', 22:'11...b4', 23:'12.Ne2', 24:'12...d5',
25:'13.e5', 26:'13...Ne4', 27:'14.Qe1', 28:'14...f5', 29:'15.a3!  A typical undermining move.', 30:'15...bxa3', 31:'16.Rxa3', 32:'16...a4', 33:'17.Qa1', 34:'17...Ba6',
35:'18.Bxa6?!  This exchange helps Black develop. White should just develop with 18.Rb1', 36:'18...Rxa6', 37:'19.Nc3', 38:'19...Qc7', 39:'20.Ne1', 40:'20...Rfa8', 41:'21.Nd3', 42:'21...R6a7', 43:'22.Qb2?!  It is better to simply take the pawn with 22.Nxa4 Nxa4 23.bxa4.', 44:'22...e6',
45:'23.Nc5', 46:'23...Bf8!', 47:'24.Rfa1  24.Nxe6? Bxa3 25.Qxa3 Qe7 wins.', 48:'24...Kf7?  It is not necessary to give up the pawn. After 24...Qb8! Black has good play.', 49:'25.N3xa4', 50:'25...Nxa4', 51:'26.bxa4', 52:'26...Bxc5', 53:'27.dxc5',
54:'27...Kg8?!  27...Ra5 28.Rb3 R8a7 is a more active setup.', 55:'28.Rb3', 56:'28...Qa5', 57:'29.Kh2!  Such prophylactic king moves are a hallmark of a strong player. White\'s forces will invade on the queenside anyway.', 58:'29...h5?  Black should take measures against the coming invasion of White\'s major pieces, but his position is difficult in any case, e.g., 29...Rc7 30.Rb7 Rxb7 31.Qxb7 Rf8 32.Rb1 Qc3 33.Qb3.', 59:'30.Rb8+', 60:'30...Rxb8', 61:'31.Qxb8+', 62:'31...Kh7?  31...Kg7 is better, as it prepares for an ensuing endgame, while controlling f8.', 63:'32.Rb1',
64:'32...Qxa4?  This greedy move runs directly into a mating attack. 32...Qc7 33.Qe8 Qd7 34.Qxd7+ Rxd7 35.Rb6 is forced, but White will win in the long run.', 65:'33.Qf8!', 66:'33...Rg7', 67:'34.Rb8', 68:'34...g5', 69:'35.Qh8+', 70:'35...Kg6', 71:'36.Qe8+', 72:'36...Rf7', 73:'37.Rb7 Black Resigns'
}
   },
{
    id: 3,
      name: 'Michener on Fischer',
      description: '\nExcerpt from the book Talking with Michener \n\n'+

'You’ve met and worked with a lot of extremely intelligent people. Have any of them been touched with genius? \n\n'+

'In my lifetime I have met only two geniuses, a word that ought to be used with great care because genius is extremely rare. Genius implies a certain intensity and an intellectual gear that is different from what most have. \n\n'+

'One was Bobby Fischer, the chess player, and the other was Tennessee Williams, who simply looked at life and drama and the human condition differently from the way I do and then anybody else I know does. Both men found that to be the vessel housing genius was an intolerable condition, and each was destroyed by that burden. \n\n'+

'Which of them do you hold in greater esteem? \n\n'+

'As a writer, Williams has to take preeminence. He used words and human situations more brilliantly than any of us. I had dinner with him in Rome or Spain. We had a long night together. He was just geared into something in a way I wasn’t at all. Very impressive. \n\n'+

'But Bobby Fischer is quite compelling. My encounter with him was instructive. Television hosts like David Frost earn huge salaries by enlisting guests whom they pay nothing, the pay-off is the publicity bestowed by the telly. Frost, being a generous soul, decided to show his appreciation by renting a Boeing 747 and flying some sixty or eighty of his guests from New York to Bermuda for lunch. \n\n'+

'The roster was sparkling – politicians, media stars, actors, musicians – and when it came to seat us Frost asked me: “You ever heard of Bobby Fischer?” and I told him “I followed his great triumph in South America against Petrosian.” \n\n'+

'So I was seated with Fischer, and within a few minutes it became obvious that he had never heard of me, nor Senator Javits, nor anyone else aboard the plane. But when he found that I had followed his great duel in South America, he adopted me: “What do you do?” \n\n'+

'"I\'m a writer." With delight he told me that he was, too, and from a bag which he kept with him always he produced four stout books on the playing of chess. I asked him if he thought I could learn, and he studied me with professional care: “If you were bright enough,” and the way he said this betrayed his snap judgment that I would not be. \n\n'+

'During the flight to Bermuda he spoke only of himself: “By the eighth grade I knew more than any of my teachers, so I quit. I could play Karpov anytime, anywhere, and beat him.” He found my conversation so limited that in the midst of it he took out a magnetic chessboard, arranged the pieces, and ran through several games while still speaking of himself. \n\n'+

'When he reached Bermuda he disappeared, rented a bicycle, and pedaled like mad while the rest of us had drinks. When he returned to ask if he could sit with me at lunch, since he already knew me, he stopped dead, pointed out a beautiful woman member of our group, and cried: “I saw her on television. Four years ago." It was Kitty Carlisle, recent widow of Moss Hart, and he ran to her, telling her in the most minute detail of her performance that night, what she wore, what she said, how she laughed, everything. It was an amazing performance and when I asked her about it, she said: “I’d forgotten everything, it was so long ago. But he had everything right."\n\n'+

'On the way home I told him who all the passengers were, but he recognized none of them. He told me: “You have an interesting mind, but not quick. I don’t think you’d make it in chess.” \n\n'+

'Not long afterward he shocked the chess world by insolently throwing away the first game – or was it two? - and then creaming his Russian opponent, Boris Spassky, for the world’s undisputed championship. I am not sure he knew what country he was in. I sent him a note. It came back – he didn’t know who I was, never heard of me. Very insulting, like I was just another tourist who imposed on him. And I had sat and talked with him for maybe ten hours. Sometime after that he fell apart on religious matters, surrendering his crown by default. '+
'\n\n'+
'\n\n'+
'This was the final game of Fischer\'s match with Petrosian:\n',
diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR',
4:'rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR',
5:'rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR',
6:'r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR',
7:'r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/2N2N2/PPP2PPP/R1BQKB1R',
8:'r1bqkb1r/ppp2ppp/2n1pn2/3p4/3PP3/2N2N2/PPP2PPP/R1BQKB1R',
9:'r1bqkb1r/ppp2ppp/2n1pn2/3P4/3P4/2N2N2/PPP2PPP/R1BQKB1R',
10:'r1bqkb1r/ppp2ppp/2n2n2/3p4/3P4/2N2N2/PPP2PPP/R1BQKB1R',
11:'r1bqkb1r/ppp2ppp/2n2n2/1B1p4/3P4/2N2N2/PPP2PPP/R1BQK2R',
12:'r2qkb1r/ppp2ppp/2n2n2/1B1p4/3P2b1/2N2N2/PPP2PPP/R1BQK2R',
13:'r2qkb1r/ppp2ppp/2n2n2/1B1p4/3P2b1/2N2N1P/PPP2PP1/R1BQK2R',
14:'r2qkb1r/ppp2ppp/2n2n2/1B1p4/3P4/2N2b1P/PPP2PP1/R1BQK2R',
15:'r2qkb1r/ppp2ppp/2n2n2/1B1p4/3P4/2N2Q1P/PPP2PP1/R1B1K2R',
16:'r2qk2r/ppp1bppp/2n2n2/1B1p4/3P4/2N2Q1P/PPP2PP1/R1B1K2R',
17:'r2qk2r/ppp1bppp/2n2n2/1B1p2B1/3P4/2N2Q1P/PPP2PP1/R3K2R',
18:'r2qk2r/1pp1bppp/p1n2n2/1B1p2B1/3P4/2N2Q1P/PPP2PP1/R3K2R',
19:'r2qk2r/1pp1bppp/p1B2n2/3p2B1/3P4/2N2Q1P/PPP2PP1/R3K2R',
20:'r2qk2r/2p1bppp/p1p2n2/3p2B1/3P4/2N2Q1P/PPP2PP1/R3K2R',
21:'r2qk2r/2p1bppp/p1p2n2/3p2B1/3P4/2N2Q1P/PPP2PP1/R4RK1',
22:'r2q1rk1/2p1bppp/p1p2n2/3p2B1/3P4/2N2Q1P/PPP2PP1/R4RK1',
23:'r2q1rk1/2p1bppp/p1p2n2/3p2B1/3P4/2N2Q1P/PPP2PP1/R3R1K1',
24:'r2q1rk1/2p1bpp1/p1p2n1p/3p2B1/3P4/2N2Q1P/PPP2PP1/R3R1K1',
25:'r2q1rk1/2p1bpp1/p1p2n1p/3p4/3P3B/2N2Q1P/PPP2PP1/R3R1K1',
26:'r4rk1/2pqbpp1/p1p2n1p/3p4/3P3B/2N2Q1P/PPP2PP1/R3R1K1',
27:'r4rk1/2pqbpp1/p1p2n1p/3p4/3P3B/2N2Q1P/PPP1RPP1/R5K1',
28:'r4rk1/2pqbpp1/2p2n1p/p2p4/3P3B/2N2Q1P/PPP1RPP1/R5K1',
29:'r4rk1/2pqbpp1/2p2n1p/p2p4/3P3B/2N2Q1P/PPP1RPP1/4R1K1',
30:'r2b1rk1/2pq1pp1/2p2n1p/p2p4/3P3B/2N2Q1P/PPP1RPP1/4R1K1',
31:'r2b1rk1/2pq1pp1/2p2n1p/p2p4/3P3B/1PN2Q1P/P1P1RPP1/4R1K1',
32:'1r1b1rk1/2pq1pp1/2p2n1p/p2p4/3P3B/1PN2Q1P/P1P1RPP1/4R1K1',
33:'1r1b1rk1/2pq1pp1/2p2n1p/p2p4/N2P3B/1P3Q1P/P1P1RPP1/4R1K1',
34:'1r1b1rk1/2pq1pp1/2p4p/p2p4/N2Pn2B/1P3Q1P/P1P1RPP1/4R1K1',
35:'1r1B1rk1/2pq1pp1/2p4p/p2p4/N2Pn3/1P3Q1P/P1P1RPP1/4R1K1',
36:'3r1rk1/2pq1pp1/2p4p/p2p4/N2Pn3/1P3Q1P/P1P1RPP1/4R1K1',
37:'3r1rk1/2pq1pp1/2p4p/p2p4/N2PnQ2/1P5P/P1P1RPP1/4R1K1',
38:'3r1rk1/2p2pp1/2pq3p/p2p4/N2PnQ2/1P5P/P1P1RPP1/4R1K1',
39:'3r1rk1/2p2pp1/2pQ3p/p2p4/N2Pn3/1P5P/P1P1RPP1/4R1K1',
40:'3r1rk1/5pp1/2pp3p/p2p4/N2Pn3/1P5P/P1P1RPP1/4R1K1',
41:'3r1rk1/5pp1/2pp3p/p2p4/N1PPn3/1P5P/P3RPP1/4R1K1',
42:'3r1rk1/5pp1/2pp1n1p/p2p4/N1PP4/1P5P/P3RPP1/4R1K1',
43:'3r1rk1/5pp1/2pp1n1p/p2p4/N1PP4/1P5P/P3RPP1/2R3K1',
44:'1r3rk1/5pp1/2pp1n1p/p2p4/N1PP4/1P5P/P3RPP1/2R3K1',
45:'1r3rk1/5pp1/2pp1n1p/p2P4/N2P4/1P5P/P3RPP1/2R3K1',
46:'1r3rk1/5pp1/3p1n1p/p2p4/N2P4/1P5P/P3RPP1/2R3K1',
47:'1r3rk1/5pp1/3p1n1p/p2p4/N2P4/1P3P1P/P3R1P1/2R3K1',
48:'1r3rk1/5pp1/3p3p/p2p3n/N2P4/1P3P1P/P3R1P1/2R3K1',
49:'1r3rk1/5pp1/2Rp3p/p2p3n/N2P4/1P3P1P/P3R1P1/6K1',
50:'1r3rk1/5pp1/2Rp3p/p2p4/N2P1n2/1P3P1P/P3R1P1/6K1',
51:'1r3rk1/5pp1/2Rp3p/p2p4/N2P1n2/1P3P1P/P2R2P1/6K1',
52:'1r2r1k1/5pp1/2Rp3p/p2p4/N2P1n2/1P3P1P/P2R2P1/6K1',
53:'1r2r1k1/5pp1/3R3p/p2p4/N2P1n2/1P3P1P/P2R2P1/6K1',
54:'1r4k1/5pp1/3R3p/p2p4/N2P1n2/1P3P1P/P2R2P1/4r1K1',
55:'1r4k1/5pp1/3R3p/p2p4/N2P1n2/1P3P1P/P2R1KP1/4r3',
56:'1r4k1/5pp1/3R3p/p2p4/N2P1n2/1P3P1P/P2R1KP1/7r',
57:'1r4k1/5pp1/3R3p/p2p4/N2P1n2/1P3PKP/P2R2P1/7r',
58:'1r4k1/5pp1/3R3p/p2p3n/N2P4/1P3PKP/P2R2P1/7r',
59:'1r4k1/5pp1/3R3p/p2p3n/N2P3K/1P3P1P/P2R2P1/7r',
60:'1r4k1/5p2/3R2pp/p2p3n/N2P3K/1P3P1P/P2R2P1/7r',
61:'1r4k1/5p2/6pp/p2R3n/N2P3K/1P3P1P/P2R2P1/7r',
62:'4r1k1/5p2/6pp/p2R3n/N2P3K/1P3P1P/P2R2P1/7r',
63:'4r1k1/5p2/6pp/R6n/N2P3K/1P3P1P/P2R2P1/7r',
64:'6k1/5p2/6pp/R6n/N2P3K/1P3P1P/P2R2P1/4r2r',
65:'6k1/5p2/6pp/R6n/3P3K/1PN2P1P/P2R2P1/4r2r',
66:'6k1/5p2/6pp/R7/3P1n1K/1PN2P1P/P2R2P1/4r2r',
67:'6k1/5p2/6pp/R7/3P1nK1/1PN2P1P/P2R2P1/4r2r',
68:'6k1/5p2/4n1pp/R7/3P2K1/1PN2P1P/P2R2P1/4r2r',
69:'6k1/5p2/4n1pp/4R3/3P2K1/1PN2P1P/P2R2P1/4r2r',
70:'6k1/8/4n1pp/4Rp2/3P2K1/1PN2P1P/P2R2P1/4r2r',
71:'6k1/8/4n1pp/4Rp2/3P4/1PN2PKP/P2R2P1/4r2r',
72:'6k1/8/4n1pp/4R3/3P1p2/1PN2PKP/P2R2P1/4r2r',
73:'6k1/8/4n1pp/4R3/3P1p1K/1PN2P1P/P2R2P1/4r2r',
74:'8/7k/4n1pp/4R3/3P1p1K/1PN2P1P/P2R2P1/4r2r',
75:'8/7k/4n1pp/4R3/3PNp1K/1P3P1P/P2R2P1/4r2r',
76:'8/7k/4n2p/4R1p1/3PNp1K/1P3P1P/P2R2P1/4r2r',
77:'8/7k/4n2p/4R1p1/3PNpK1/1P3P1P/P2R2P1/4r2r',
78:'8/6nk/7p/4R1p1/3PNpK1/1P3P1P/P2R2P1/4r2r',
79:'8/6nk/7p/4R1N1/3P1pK1/1P3P1P/P2R2P1/4r2r',
80:'8/6nk/8/4R1p1/3P1pK1/1P3P1P/P2R2P1/4r2r',
81:'8/6nk/8/6p1/3P1pK1/1P3P1P/P2R2P1/4R2r',
82:'8/6nk/8/6p1/3P1pK1/1P3P1P/P2R2P1/4r3',
83:'8/6nk/8/6K1/3P1p2/1P3P1P/P2R2P1/4r3',
84:'8/7k/4n3/6K1/3P1p2/1P3P1P/P2R2P1/4r3',
85:'8/7k/4n3/5K2/3P1p2/1P3P1P/P2R2P1/4r3',
86:'8/7k/4n3/5K2/3P1p2/1P3P1P/P2Rr1P1/8',
87:'8/7k/4n3/5K2/3P1p2/1P3P1P/P3R1P1/8',
88:'8/7k/8/5K2/3n1p2/1P3P1P/P3R1P1/8',
89:'8/7k/8/4K3/3n1p2/1P3P1P/P3R1P1/8',
90:'8/7k/8/4K3/5p2/1P3P1P/P3n1P1/8',
91:'8/7k/8/4K3/P4p2/1P3P1P/4n1P1/8'
},
comments:{
0:'Robert James Fischer vs Tigran Petrosian, World Championship Candidates Buenos Aires 1971. Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...e6', 3:'2.d4', 4:'2...d5', 5:'3.Nc3', 6:'3...Nc6', 7:'4.Nf3', 8:'4...Nf6', 9:'5.exd5', 10:'5...exd5', 11:'6.Bb5',
12:'6...Bg4', 13:'7.h3', 14:'7...Bxf3', 15:'8.Qxf3', 16:'8...Be7', 17:'9.Bg5', 18:'9...a6?!  9...O-O is the main line', 19:'10.Bxc6+', 20:'10...bxc6', 21:'11.O-O',
22:'11...O-O', 23:'12.Rfe1', 24:'12...h6', 25:'13.Bh4', 26:'13...Qd7', 27:'14.Re2', 28:'14...a5', 29:'15.Rae1', 30:'15...Bd8', 31:'16.b3', 32:'16...Rb8',
33:'17.Na4', 34:'17...Ne4', 35:'18.Bxd8', 36:'18...Rbxd8', 37:'19.Qf4', 38:'19...Qd6', 39:'20.Qxd6', 40:'20...cxd6', 41:'21.c4',
42:'21...Nf6', 43:'22.Rc1', 44:'22...Rb8', 45:'23.cxd5',46: '23...cxd5', 47:'24.f3!?  Fischer excels in this type of endgame, one with and only after a slight strategic initiative. 24.Rc6?! is answered by 24...Rfc8 25.Rxd6 Rb4, with some counterplay.', 48:'24...Nh5?  The coming counterattack is too slow. 24...Rfc8! and only after 25.Rc3, then 25...Nh5 is the right way to implement Petrosian\'s idea.', 49:'25.Rc6', 50:'25...Nf4', 51:'26.Rd2',
52:'26...Rfe8  26...h5 27.h4 and 26...Rfd8 27.Kh2 g6 28.Ra6 Ra8 29.Rxa8 Rxa8 30.g3 Ne6 31.Nb6 both lead to large advantages for White.', 53:'27.Rxd6', 54:'27...Re1+', 55:'28.Kf2', 56:'28...Rh1', 57:'29.Kg3', 58:'29...Nh5+', 59:'30.Kh4', 60:'30...g6',
61:'31.Rxd5', 62:'31...Re8', 63:'32.Rxa5', 64:'32...Ree1', 65:'33.Nc3', 66:'33...Nf4', 67:'34.Kg4  White\'s King is remarably safe.', 68:'34...Ne6', 69:'35.Re5', 70:'35...f5+',
71:'36.Kg3', 72:'36...f4+', 73:'37.Kh4', 74:'37...Kh7', 75:'38.Ne4', 76:'38...g5+', 77:'39.Kg4', 78:'39...Ng7', 79:'40.Nxg5+', 80:'40...hxg5',
81:'41.Rxe1', 82:'41...Rxe1', 83:'42.Kxg5', 84:'42...Ne6+', 85:'43.Kf5', 86:'43...Re2', 87:'44.Rxe2', 88:'44...Nxd4+', 89:'45.Ke5',
90:'45...Nxe2', 91:'46.a4 Black Resigns'
}
},
{
    id: 4,
      name: 'John Collins on Fischer',
      description: '\nThe Ideal Tutor\n\n'+

'By Steven A. Fondiller \n\n'+

'(from the Manuscripts Department, Lilly Library, Indiana University, Bloomington, Indiana)\n\n'+

'John (Jack) William Collins is a unique teacher, honored for dedication and goodwill nationally and internationally. A CLFer for more than two decades, he owns many books about religion. His library of chess books, some written by himself and his students, is much larger, numbering nearly 800. Mr. Collins founded Collins Kids, Inc in 1977 to help 7 – 17 year old chess players.\n\n'+

'He and his sister Ethel have an apartment in New York City. Here, surrounded by many trophies and awards, the Life Master tutors. Dozens of photographs of his past students and other famous chess players inspire present day boys and girls. \n\n'+

'Mr. Collins was cited by Dr. David Feldman, a child psychologist at Tufts University, in a recent book about geniuses. Mr. Collins supports Dr. Feldman’s theory of genius, and summarized it: “Four things that produce a genius. One is genetic endowment. Another is environment. Third is the era he is born into. Fourth, is his teacher.” \n\n'+

'The most famous student Mr. Collins ever taught, former World Champion Robert J. Fischer, is considered a genius and the greatest chess player in the history of chess in the United States. “If God were to construct the ideal chess player, it would come out like Fischer. He did have – it is all in the past now – total recall. He was completely devoted to it. He would read and study ten to twelve hours a day. He was very competitive and very aggressive in his play. He had great stamina. He was completely composed and cool. He left all his idiosyncrasies when he reached the board and picked them up again when he finished the game.” \n\n'+

'Mr. Collins speaks of Mr. Fischer with warmth, sorrow and joy: “Bobby Fischer was a nice kid. We both lived in Flatbush, Brooklyn. He went to school near where I lived. He would come in for an hour at lunchtime. He would come in at three and stay until nine. He ate meals with us. We had birthday parties, Christmas, New Year’s Thanksgiving together. Ethel and I were like a second family to him. His father left when he was a baby. He never got along with his mother too well. \n\n'+

'He belonged to the World Wide Church of God starting in his late teens. He used to come here and listen to Herbert W. Armstrong. He became a Biblical reader, but I don’t know if you would call him a student. He carried the Bible around, even to a cocktail party. He would hand the Bible to me and say, ‘Open it up, and read something, and I’ll tell you where it is from.’ He had almost total recall. \n\n'+

'He has great ideas, but he carries them to extremes. He never wanted anyone’s approval on anything. Bobby was always his own man. He’s willing to talk about things, but he’s very difficult to convince or persuade about anything. \n\n'+

'He talked to me a lot about religion. He talked mostly about the Old Testament. He was mostly interested in Plain Truth. The articles in there impressed him a great deal and (so did) the sermons of Herbert W. Armstrong. Then he broke away from them totally or substantially (in the late 1970’s). \n\n'+

'I thought it (Bobby’s joining the World Wide Church of God) was a mistake. I never argued with him about it. I tried to keep on subjects we both enjoyed talking about and avoid the other parts that we disagreed on. \n\n'+

'In later years he became terribly anti-Semitic. I have so many friends that are Semitic that I broke up (with him) over this. He is so fanatical on this subject. He doesn’t believe there was a Holocaust. He doesn’t like blacks. So we finally broke apart four years. \n\n'+

'(In the 1972 World Championship match Mr. Fischer stunned the Soviet World Champion Boris Spassky and the chess world by easily capturing the title.) I thought Fischer would win. Spassky had a good record against Fischer up to that point. But Fischer was so good at that time that I felt he could defeat anyone. (Mr. Collins was concerned that Mr. Fischer, who was unhappy with the rules and conditions set by the sponsors and the FIDE, the international chess federation, might lose by default.)\n\n'+

'I was one of those who helped persuade him to play. He was very reluctant to play. Various people were urging him to come up and play Spassky. One of them was (Henry) Kissinger. Another one was me.'+
'\n\n'+
'\n\n'+
'This was the first game ever published of Fischer\'s:\n',
diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R',
2:'rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R',
3:'rnbqkb1r/pppppppp/5n2/8/8/5NP1/PPPPPP1P/RNBQKB1R',
4:'rnbqkb1r/ppp1pppp/5n2/3p4/8/5NP1/PPPPPP1P/RNBQKB1R',
5:'rnbqkb1r/ppp1pppp/5n2/3p4/8/5NP1/PPPPPPBP/RNBQK2R',
6:'rn1qkb1r/ppp1pppp/5n2/3p1b2/8/5NP1/PPPPPPBP/RNBQK2R',
7:'rn1qkb1r/ppp1pppp/5n2/3p1b2/8/5NP1/PPPPPPBP/RNBQ1RK1',
8:'rn1qkb1r/ppp2ppp/4pn2/3p1b2/8/5NP1/PPPPPPBP/RNBQ1RK1',
9:'rn1qkb1r/ppp2ppp/4pn2/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1',
10:'rn1qkb1r/pp3ppp/2p1pn2/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1',
11:'rn1qkb1r/pp3ppp/2p1pn2/3p1b2/8/3P1NP1/PPPNPPBP/R1BQ1RK1',
12:'r2qkb1r/pp3ppp/n1p1pn2/3p1b2/8/3P1NP1/PPPNPPBP/R1BQ1RK1',
13:'r2qkb1r/pp3ppp/n1p1pn2/3p1b2/8/P2P1NP1/1PPNPPBP/R1BQ1RK1',
14:'r2qkb1r/pp3ppp/2p1pn2/2np1b2/8/P2P1NP1/1PPNPPBP/R1BQ1RK1',
15:'r2qkb1r/pp3ppp/2p1pn2/2np1b2/2P5/P2P1NP1/1P1NPPBP/R1BQ1RK1',
16:'r2qkb1r/p4ppp/2p1pn2/1pnp1b2/2P5/P2P1NP1/1P1NPPBP/R1BQ1RK1',
17:'r2qkb1r/p4ppp/2p1pn2/1pnp1b2/2PN4/P2P2P1/1P1NPPBP/R1BQ1RK1',
18:'r3kb1r/p2q1ppp/2p1pn2/1pnp1b2/2PN4/P2P2P1/1P1NPPBP/R1BQ1RK1',
19:'r3kb1r/p2q1ppp/2p1pn2/1pnp1N2/2P5/P2P2P1/1P1NPPBP/R1BQ1RK1',
20:'r3kb1r/p2q1ppp/2p2n2/1pnp1p2/2P5/P2P2P1/1P1NPPBP/R1BQ1RK1',
21:'r3kb1r/p2q1ppp/2p2n2/1pnp1p2/2P5/PN1P2P1/1P2PPBP/R1BQ1RK1',
22:'r3kb1r/p2q1pp1/2p2n1p/1pnp1p2/2P5/PN1P2P1/1P2PPBP/R1BQ1RK1',
23:'r3kb1r/p2q1pp1/2p2n1p/1pnp1p2/2P5/PN1PB1P1/1P2PPBP/R2Q1RK1',
24:'r3kb1r/p2q1pp1/2p1nn1p/1p1p1p2/2P5/PN1PB1P1/1P2PPBP/R2Q1RK1',
25:'r3kb1r/p2q1pp1/2p1nn1p/1p1p1p2/2PN4/P2PB1P1/1P2PPBP/R2Q1RK1',
26:'r3kb1r/p2q1p2/2p1nnpp/1p1p1p2/2PN4/P2PB1P1/1P2PPBP/R2Q1RK1',
27:'r3kb1r/p2q1p2/2p1nnpp/1p1p1p2/2PN4/PQ1PB1P1/1P2PPBP/R4RK1',
28:'1r2kb1r/p2q1p2/2p1nnpp/1p1p1p2/2PN4/PQ1PB1P1/1P2PPBP/R4RK1',
29:'1r2kb1r/p2q1p2/2N1nnpp/1p1p1p2/2P5/PQ1PB1P1/1P2PPBP/R4RK1',
30:'1r2kb1r/p4p2/2q1nnpp/1p1p1p2/2P5/PQ1PB1P1/1P2PPBP/R4RK1',
31:'1r2kb1r/p4p2/2q1nnpp/1p1P1p2/8/PQ1PB1P1/1P2PPBP/R4RK1',
32:'1r2kb1r/p4p2/2q2npp/1pnP1p2/8/PQ1PB1P1/1P2PPBP/R4RK1',
33:'1r2kb1r/p4p2/2q2npp/1pnP1p2/8/P1QPB1P1/1P2PPBP/R4RK1',
34:'1r2kb1r/p4p2/3q1npp/1pnP1p2/8/P1QPB1P1/1P2PPBP/R4RK1',
35:'1r2kb1r/p4p2/3q1npp/1pBP1p2/8/P1QP2P1/1P2PPBP/R4RK1',
36:'1r2kb1r/p4p2/5npp/1pqP1p2/8/P1QP2P1/1P2PPBP/R4RK1',
37:'1r2kb1r/p4p2/5Qpp/1pqP1p2/8/P2P2P1/1P2PPBP/R4RK1'
},
comments:{
0:'Robert Fischer vs Peter Lapiken, 57th US Open, Oklahoma City, rd 4, July 19, 1956. Annotations by Fred Reinfeld.',
1:'1.Nf3', 2:'1...Nf6', 3:'2.g3', 4:'2...d5', 5:'3.Bg2', 6:'3...Bf5', 7:'4.O-O', 8:'4...e6', 9:'5.d3', 10:'5...c6', 11:'6.Nbd2', 12:'6...Na6',
13:'7.a3', 14:'7...Nc5', 15:'8.c4 The key move of Reti\'s system. The pressure on Black\'s center is strengthened by this flank thrust.', 16:'8...b5? A massive positional blunder. By undermining his c-pawn, Black undermines his hold on the long diagonal.', 17:'9.Nd4! Excellent. He gains time by attacking the weakened c-pawn. Meanwhile his hitherto passive King\'s Bishop suddenly takes on a menacing role.', 18:'9...Qd7', 19:'10.Nxf5', 20:'10...exf5 The exchange has further weakened Black\'s position.', 21:'11.Nb3! Now White threatens 12.Bg5, with the further threat of inflicting a tripled isolated f-pawn on Black and at the same time undermining the support of his d-pawn and still further thought the removal of Black\'s protective Knight. Black has nothing to hope for from 11...dxc4 12.dxc4 bxc4 13.Na5, with a winning positional advantage for White. 11...h6 12.Be3 Ne6 The alternative 12...Nxb3 13.Qxb3 d4 is refuted by 14.cxb5!. This is a good example of White\'s power along the long diagonal.', 22:'11...h6', 23:'12.Be3',
24:'12...Ne6', 25:'13.Nd4', 26:'13...g6 The alternative 12...Nxd4 13.Bxd4 Be7 15.cxb5 cxb5 16.Qb3 (threatening to win a Pawn) Rd8 17.Rac1 leaves White with all the play.', 27:'14.Qb3! Very strong. As Black cannot go in for 14...dxc4 15.exd4 Nxd4 16.Bxd4 Qxd4 17.Bxa8, he must give his b-pawn additional protection. But this gives Fischer the opportunity for a neat combination.', 28:'14...Rb8', 29:'15.Nxc6! What makes this sacrifice particularly delectable is that it validates the basic theme: pressure on the long diagonal.', 30:'15...Qxc6', 31:'16.cxd5', 32:'16...Nc5 Black wriggles.', 33:'17.Qc3!',
34:'17...Qd6 A neat variation is 17...Qb6 18.b4 Na4 19.Qe5+ winning Black\'s Queen.>', 35:'18.Bxc5', 36:'18...Qxc5', 37:'19.Qxf6 Black Resigns. An amusing finish. If Black moves his attacked Rook, White wins the other one with 20.Qe5+. (0:10 – 1:20)'
}

   },
{
    id: 5,
      name: 'Letter from Regina Fischer',
      description: '\nPlight of the U.S. Chess Champion. Letter from Regina Fischer to the NY Herald Tribune, 1958 \n\n'+

'I am wondering if there is anything you could do on an emergency basis to let people know about the situation of my son, Bobby Fischer, sixteen, the United States chess champion. Although official United States representatives to the coming Candidates Tournament, to be held in Yugoslavia Sept. 6 to Oct.31, he has not yet been provided with any funds at all to cover his expenses. He already poured his own prize winning, and my money, into essential preparations for this tournament. With another $2,000, half for his expense, half to pay for a second, Bobby could be sure of being able to take part in this event. Winner of this eight-man competition will become the new challenger in 1960 for the world championship title held by Russia’s Mikhail Botvinnik. \n\n'+

'The worst of it is that the International Chess Federation (F.I.D.E., Federation Internationale des Echecs, Stockholm, Sweden) has notified the United States Chess Federation that each competitor qualified to play must present formal guarantee that he will play. If not, it is F.I.D.E.’s duty to notify the candidate of the next country in line to replace him. F.I.D.E. directed substitutes to send formal notice of availability by Aug. 5. \n\n'+

'Four of the eight candidates are Russians, well provided with seconds, physical trainers, money and every moral and financial backing. Bobby must rely entirely on his own efforts and winnings, and actually pays for the privilege of representing the United States. He is the only American who has played abroad at all this year. From March to June he represented the United States at strong international events in Argentina, Chile and Switzerland, winning a total of under $500. Chess players abroad were much surprised to see Bobby’s financial struggles for themselves and learn that he gets no financial assistance from any American organization or individual. Their players, many of them substantial professional men, all receive their expenses as a matter of course. Last year, even after winning the United States Championship for 1958 and thus qualifying to represent the United States at the Interzonal Tournament scheduled for summer 1958 in Yugoslavia, Bobby was unable to raise the fare there in three months of trying. He only got it through a lucky break when Gary Moore gave him his tickets on the “I’ve got a Secret” show March 26. \n\n'+

'The situation has become steadily worse and Bobby’s finances and mine cannot stand up under this terrific drain. Bobby is sacrificing his schooling trying to compete and at the same time earn his own financial backing. The indifference to this plight and the constant suspense, not knowing whether he will or won’t have the funds to be able to compete each time are having a terrible effect on him. Bobby wants to win for the United States and has been doing it, but the effort of doing it singlehanded is ruinous. \n\n'+

 'I wish something could be done to assure his participation in this coming tournament and also in the other top-flight events in which he hopes to play and win for the United States in the future. The continual uncertainty and trying to raise funds somewhere, somehow from one tournament to the next is killing. Bobby is devoted to chess. He has bought the United States back to the top in international chess, where it belongs. He really needs and deserves some support and he needs it badly now. Anything you can do to let people know of this situation will be greatly appreciated. If anybody wants to contribute anything (I am sorry it will not be tax exempt) it can be sent directly to Bobby Fischer, in care of the U.S. Chess Federation, 80 E. 11th St., New York 3, N.Y. Every penny will be acknowledged and strictly publicly accounted for. Their telephone number is Gramercy 5-1270. \n\n'+

'Mrs. Regina Fischer, Brooklyn '+
'\n\n'+
'\n\n'+
'This was one Fischer\'s games at the 1958 Interzonal.\n\n'+
'Bronstein wrote the following about the game in his book \'200 Open Games\': What struck me even then was Fischer playing simple endgames. He conducted the defense irreproachably: 43.g3! and 58.Bd1! -- one can not fault him there; but what also had to be seen was what finesses he demonstrated as we analysed together when the game was over.\n',
diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
6:'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
7:'r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
8:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
9:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
10:'r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
11:'r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQR1K1',
12:'r1bqk2r/2ppbppp/p1n2n2/1p2p3/B3P3/5N2/PPPP1PPP/RNBQR1K1',
13:'r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1',
14:'r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1',
15:'r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1',
16:'r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1',
17:'r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1',
18:'r1bq1rk1/2pnbppp/p1np4/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1',
19:'r1bq1rk1/2pnbppp/p1np4/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1',
20:'r1bq1rk1/2p1bppp/pnnp4/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1',
21:'r1bq1rk1/2p1bppp/pnnp4/1p2p3/3PP3/1BP1BN1P/PP3PP1/RN1QR1K1',
22:'1rbq1rk1/2p1bppp/pnnp4/1p2p3/3PP3/1BP1BN1P/PP3PP1/RN1QR1K1',
23:'1rbq1rk1/2p1bppp/pnnp4/1p2p3/3PP3/1BP1BN1P/PP1N1PP1/R2QR1K1',
24:'1rbq1rk1/2p2ppp/pnnp1b2/1p2p3/3PP3/1BP1BN1P/PP1N1PP1/R2QR1K1',
25:'1rbq1rk1/2p2ppp/pnnp1b2/1p1Pp3/4P3/1BP1BN1P/PP1N1PP1/R2QR1K1',
26:'1rbq1rk1/2p2ppp/pn1p1b2/np1Pp3/4P3/1BP1BN1P/PP1N1PP1/R2QR1K1',
27:'1rbq1rk1/2p2ppp/pn1p1b2/np1Pp3/4P3/2P1BN1P/PPBN1PP1/R2QR1K1',
28:'1rbq1rk1/2p2ppp/pn1p1b2/1p1Pp3/2n1P3/2P1BN1P/PPBN1PP1/R2QR1K1',
29:'1rbq1rk1/2p2ppp/pn1p1b2/1p1Pp3/2N1P3/2P1BN1P/PPB2PP1/R2QR1K1',
30:'1rbq1rk1/2p2ppp/p2p1b2/1p1Pp3/2n1P3/2P1BN1P/PPB2PP1/R2QR1K1',
31:'1rbq1rk1/2p2ppp/p2p1b2/1p1Pp3/2n1P3/2P2N1P/PPB2PP1/R1BQR1K1',
32:'1rbq1rk1/5ppp/p1pp1b2/1p1Pp3/2n1P3/2P2N1P/PPB2PP1/R1BQR1K1',
33:'1rbq1rk1/5ppp/p1Pp1b2/1p2p3/2n1P3/2P2N1P/PPB2PP1/R1BQR1K1',
34:'1rb2rk1/2q2ppp/p1Pp1b2/1p2p3/2n1P3/2P2N1P/PPB2PP1/R1BQR1K1',
35:'1rb2rk1/2q2ppp/p1Pp1b2/1p2p3/2n1P3/2P4P/PPB2PPN/R1BQR1K1',
36:'1rb2rk1/5ppp/p1qp1b2/1p2p3/2n1P3/2P4P/PPB2PPN/R1BQR1K1',
37:'1rb2rk1/5ppp/p1qp1b2/1p2p3/2n1P1N1/2P4P/PPB2PP1/R1BQR1K1',
38:'1rb2rk1/4bppp/p1qp4/1p2p3/2n1P1N1/2P4P/PPB2PP1/R1BQR1K1',
39:'1rb2rk1/4bppp/p1qp4/1p2p3/2n1P3/2P1N2P/PPB2PP1/R1BQR1K1',
40:'1r3rk1/4bppp/p1qpb3/1p2p3/2n1P3/2P1N2P/PPB2PP1/R1BQR1K1',
41:'1r3rk1/4bppp/p1qpb3/1p2p3/2n1P3/2P1N2P/PPB1QPP1/R1B1R1K1',
42:'1r1r2k1/4bppp/p1qpb3/1p2p3/2n1P3/2P1N2P/PPB1QPP1/R1B1R1K1',
43:'1r1r2k1/4bppp/p1qpb3/1p2p3/2n1P3/2P1N2P/PPB1QPP1/R1BR2K1',
44:'1r1r2k1/4bppp/p1qpb3/1p2p3/4P3/2P1n2P/PPB1QPP1/R1BR2K1',
45:'1r1r2k1/4bppp/p1qpb3/1p2p3/4P3/2P1B2P/PPB1QPP1/R2R2K1',
46:'1r1r2k1/4bppp/2qpb3/pp2p3/4P3/2P1B2P/PPB1QPP1/R2R2K1',
47:'1r1r2k1/4bppp/2qpb3/pp2p3/4P3/2PBB2P/PP2QPP1/R2R2K1',
48:'1r1r2k1/4bppp/2qpb3/1p2p3/p3P3/2PBB2P/PP2QPP1/R2R2K1',
49:'1r1r2k1/4bppp/2qpb3/1p2p3/p3P3/P1PBB2P/1P2QPP1/R2R2K1',
50:'1r1r2k1/5ppp/2qpbb2/1p2p3/p3P3/P1PBB2P/1P2QPP1/R2R2K1',
51:'1r1r2k1/5ppp/2qpbb2/1p2p3/p3P3/P1P1B2P/1PB1QPP1/R2R2K1',
52:'1r1r2k1/5ppp/2q1bb2/1p1pp3/p3P3/P1P1B2P/1PB1QPP1/R2R2K1',
53:'1r1r2k1/5ppp/2q1bb2/1p1Pp3/p7/P1P1B2P/1PB1QPP1/R2R2K1',
54:'1r1r2k1/5ppp/2q2b2/1p1bp3/p7/P1P1B2P/1PB1QPP1/R2R2K1',
55:'1r1r2k1/5ppp/2q2b2/1p1bp3/p5Q1/P1P1B2P/1PB2PP1/R2R2K1',
56:'1r1r2k1/5ppp/2q1bb2/1p2p3/p5Q1/P1P1B2P/1PB2PP1/R2R2K1',
57:'1r1r2k1/5ppp/2q1bb2/1p2p3/p7/P1P1B1QP/1PB2PP1/R2R2K1',
58:'1r1r2k1/5ppp/2q2b2/1p2p3/p1b5/P1P1B1QP/1PB2PP1/R2R2K1',
59:'1r1r2k1/5ppp/2q2b2/1p2p1B1/p1b5/P1P3QP/1PB2PP1/R2R2K1',
60:'1r2r1k1/5ppp/2q2b2/1p2p1B1/p1b5/P1P3QP/1PB2PP1/R2R2K1',
61:'1r2r1k1/5ppp/2q2B2/1p2p3/p1b5/P1P3QP/1PB2PP1/R2R2K1',
62:'1r2r1k1/5ppp/5q2/1p2p3/p1b5/P1P3QP/1PB2PP1/R2R2K1',
63:'1r2r1k1/5ppp/5q2/1p2p3/p1b5/P1P3QP/1PBR1PP1/R5K1',
64:'3rr1k1/5ppp/5q2/1p2p3/p1b5/P1P3QP/1PBR1PP1/R5K1',
65:'3rr1k1/5ppp/5q2/1p2p3/p1b5/P1P3QP/1PBR1PP1/3R2K1',
66:'4r1k1/5ppp/5q2/1p2p3/p1b5/P1P3QP/1PBr1PP1/3R2K1',
67:'4r1k1/5ppp/5q2/1p2p3/p1b5/P1P3QP/1PBR1PP1/6K1',
68:'4r1k1/5pp1/5q2/1p2p2p/p1b5/P1P3QP/1PBR1PP1/6K1',
69:'4r1k1/5pp1/5q2/1p2p2p/p1b5/P1P1Q2P/1PBR1PP1/6K1',
70:'4r1k1/5pp1/8/1p2p2p/p1b2q2/P1P1Q2P/1PBR1PP1/6K1',
71:'4r1k1/5pp1/8/1p2p2p/p1b2q2/P1P4P/1PBR1PP1/4Q1K1',
72:'4r1k1/5pp1/8/1p2p3/p1b2q1p/P1P4P/1PBR1PP1/4Q1K1',
73:'4r1k1/5pp1/8/1p2p3/p1bR1q1p/P1P4P/1PB2PP1/4Q1K1',
74:'4r1k1/5pp1/5q2/1p2p3/p1bR3p/P1P4P/1PB2PP1/4Q1K1',
75:'4r1k1/5pp1/5q2/1p2p3/p1bRQ2p/P1P4P/1PB2PP1/6K1',
76:'4r1k1/5p2/5qp1/1p2p3/p1bRQ2p/P1P4P/1PB2PP1/6K1',
77:'4r1k1/5p2/5qp1/1p2p3/p1b1Q2p/P1P4P/1PBR1PP1/6K1',
78:'4r1k1/5p2/6p1/1p2p3/p1b1Qq1p/P1P4P/1PBR1PP1/6K1',
79:'4r1k1/5p2/6p1/1p2p3/p1b1Qq1p/P1P4P/1PB2PP1/3R2K1',
80:'4r1k1/5p2/6p1/1p2p3/p1b1q2p/P1P4P/1PB2PP1/3R2K1',
81:'4r1k1/5p2/6p1/1p2p3/p1b1B2p/P1P4P/1P3PP1/3R2K1',
82:'4rk2/5p2/6p1/1p2p3/p1b1B2p/P1P4P/1P3PP1/3R2K1',
83:'4rk2/3R1p2/6p1/1p2p3/p1b1B2p/P1P4P/1P3PP1/6K1',
84:'1r3k2/3R1p2/6p1/1p2p3/p1b1B2p/P1P4P/1P3PP1/6K1',
85:'1r3k2/3R1p2/6p1/1p2p3/p1b1B2p/P1P3PP/1P3P2/6K1',
86:'1r3k2/3R1p2/6p1/1p2p3/p1b1B3/P1P3pP/1P3P2/6K1',
87:'1r3k2/3R1p2/6p1/1p2p3/p1b1B3/P1P3PP/1P6/6K1',
88:'1r3k2/3R1p2/4b1p1/1p2p3/p3B3/P1P3PP/1P6/6K1',
89:'1r3k2/5p2/4b1p1/1p2p3/p3B3/P1P3PP/1P1R4/6K1',
90:'1r6/4kp2/4b1p1/1p2p3/p3B3/P1P3PP/1P1R4/6K1',
91:'1r6/4kp2/4b1p1/1p2p3/p3B2P/P1P3P1/1P1R4/6K1',
92:'1r6/4k3/4b1p1/1p2pp2/p3B2P/P1P3P1/1P1R4/6K1',
93:'1r6/4k3/4b1p1/1p2pp2/p6P/P1P3P1/1PBR4/6K1',
94:'7r/4k3/4b1p1/1p2pp2/p6P/P1P3P1/1PBR4/6K1',
95:'7r/4k3/4b1p1/1p2pp2/p6P/P1P3P1/1PBR1K2/8',
96:'7r/4k3/6p1/1p2pp2/p1b4P/P1P3P1/1PBR1K2/8',
97:'7r/4k3/6p1/1p2pp2/p1b4P/P1P1K1P1/1PBR4/8',
98:'7r/8/4k1p1/1p2pp2/p1b4P/P1P1K1P1/1PBR4/8',
99:'7r/8/4k1p1/1p2pp2/p1b4P/P1P1K1P1/1PB2R2/8',
100:'7r/8/3k2p1/1p2pp2/p1b4P/P1P1K1P1/1PB2R2/8',
101:'7r/8/3k2p1/1p2pp2/p1b4P/P1P1K1P1/1PBR4/8',
102:'7r/4k3/6p1/1p2pp2/p1b4P/P1P1K1P1/1PBR4/8',
103:'7r/4k3/6p1/1p2pp2/p1b4P/P1P1K1P1/1PB2R2/8',
104:'7r/8/4k1p1/1p2pp2/p1b4P/P1P1K1P1/1PB2R2/8',
105:'7r/8/4k1p1/1p2pp2/p1b4P/P1P1K1P1/1PBR4/8',
106:'7r/8/4k3/1p2ppp1/p1b4P/P1P1K1P1/1PBR4/8',
107:'7r/8/4k3/1p2ppP1/p1b5/P1P1K1P1/1PBR4/8',
108:'8/8/4k3/1p2ppP1/p1b5/P1P1K1Pr/1PBR4/8',
109:'8/8/4k3/1p2ppP1/p1b5/P1P3Pr/1PBR1K2/8',
110:'8/8/4k3/1p2ppP1/p1b5/P1P3P1/1PBR1K1r/8',
111:'8/8/4k3/1p2ppP1/p1b5/P1P3P1/1PBR3r/4K3',
112:'8/8/4k3/1p2ppP1/p1b5/P1P3P1/1PBR4/4K2r',
113:'8/8/4k3/1p2ppP1/p1b5/P1P3P1/1PBR1K2/7r',
114:'8/8/4k3/1p3pP1/p1b1p3/P1P3P1/1PBR1K2/7r',
115:'8/8/4k3/1p3pP1/p1b1p3/P1P3P1/1P1R1K2/3B3r',
116:'8/8/4k3/1p3pP1/p1b1p3/P1P3P1/1P1R1K2/3B1r2',
117:'8/8/4k3/1p3pP1/p1b1p3/P1P1K1P1/1P1R4/3B1r2',
118:'8/8/4k3/1p3pP1/p1b1p3/P1P1K1P1/1P1R4/3Br3',
119:'8/8/4k3/1p3pP1/p1b1p3/P1P3P1/1P1R1K2/3Br3',
120:'8/8/4k3/1p3pP1/p1b1p3/P1P3P1/1P1R1K2/3B1r2',
121:'8/8/4k3/1p3pP1/p1b1p3/P1P1K1P1/1P1R4/3B1r2',
122:'8/8/4k3/1p3pP1/p1b1p3/P1P1K1P1/1P1R4/3Br3',
123:'8/8/4k3/1p3pP1/p1b1p3/P1P3P1/1P1R1K2/3Br3'
},
comments:{
0:'Robert Fischer - David Bronstein, Portoroz Interzonal 1958. Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...e5', 3:'2.Nf3', 4:'2...Nc6', 5:'3.Bb5', 6:'3...a6', 7:'4.Ba4', 8:'4...Nf6', 9:'5.O-O', 10:'5...Be7', 11:'6.Re1', 12:'6...b5',
13:'7.Bb3', 14:'7...d6', 15:'8.c3', 16:'8...O-O', 17:'9.h3', 18:'9...Nd7', 19:'10.d4', 20:'10...Nb6', 21:'11.Be3', 22:'11...Rb8', 23:'12.Nbd2',
24:'12...Bf6', 25:'13.d5 13.Bc2 and 13.Nf1 are the main lines.', 26:'13...Na5', 27:'14.Bc2', 28:'14...Nac4', 29:'15.Nxc4', 30:'15...Nxc4', 31:'16.Bc1', 32:'16...c6!? A typical way to fight against White\'s center.', 33:'17.dxc6',
34:'17...Qc7', 35:'18.Nh2 Quite slow. 18.a4!? is critical, e.g., 18...bxa4 19.bxa4 Nxb2 20.Bxb2 Rxb2 21.Rb1.', 36:'18...Qxc6', 37:'19.Ng4', 38:'19...Be7', 39:'20.Ne3', 40:'20...Be6', 41:'21.Qe2', 42:'21...Rfd8', 43:'22.Rd1',
44:'22...Nxe3', 45:'23.Bxe3', 46:'23...a5', 47:'24.Bd3', 48:'24...a4', 49:'25.a3', 50:'25...Bf6', 51:'26.Bc2', 52:'26...d5', 53:'27.exd5',
54:'27...Bxd5', 55:'28.Qg4', 56:'28...Be6', 57:'29.Qg3', 58:'29...Bc4', 59:'30.Bg5', 60:'30...Re8?! A bit too refined. 30...Bxg5 31.Qxg5 f6 is more natural and slightly better for Black.', 61:'31.Bxf6', 62:'31...Qxf6', 63:'32.Rd2',
64:'32...Rbd8', 65:'33.Rad1', 66:'33...Rxd2', 67:'34.Rxd2', 68:'34...h5', 69:'35.Qe3', 70:'35...Qf4', 71:'36.Qe1', 72:'36...h4', 73:'37.Rd4',
74:'37...Qf6', 75:'38.Qe4?! Pseudo-active. 38.Rg4 is call for.', 76:'38...g6', 77:'39.Rd2 39.Qxh4?! Qxh4 40.Rxh4 Rd8 41.Bxa4 f5 is risky because of White\'s offside rook.', 78:'39...Qf4', 79:'40.Rd1', 80:'40...Qxe4', 81:'41.Bxe4', 82:'41...Kf8', 83:'42.Rd7',
84:'42...Rb8', 85:'43.g3', 86:'43...hxg3', 87:'44.fxg3', 88:'44...Be6', 89:'45.Rd2', 90:'45...Ke7 45...Bxh3?! 46.Rh2 Bc8 47.Rh8+ Ke7 48.g4 is equal.', 91:'46.h4', 92:'46...f5', 93:'47.Bc2', 94:'47...Rh8',
95:'48.Kf2', 96:'48...Bc4', 97:'49.Ke3', 98:'49...Ke6', 99:'50.Rf2', 100:'50...Kd6!? The start of a triangulation to create some sort of zugzwang.', 101:'51.Rd2+', 102:'51...Ke7', 103:'52.Rf2', 104:'52...Ke6',
105:'53.Rd2', 106:'53...g5!? A creative winning try.', 107:'54.hxg5', 108:'54...Rh3', 109:'55.Kf2', 110:'55...Rh2+', 111:'56.Ke1 Of course not 56.Ke3?? f4+ winning.', 112:'56...Rh1+', 113:'57.Kf2', 114:'57...e4',
115:'58.Bd1', 116:'58...Rf1+?! 58...Kf7 is more dangerous, but White should be able to hold, e.g., 59.Ke3 Kg6 60.g4 Kxg5 61.gxf5 Kxf5 62.Rf2+ Ke5 63.Bg4 Re1+ 64.Kd2 Rg1 65.Rf5+ (65.Be2? Rg3 winnning) 65...Kd6 66.Rf6+.', 117:'59.Ke3', 118:'59...Re1+', 119:'60.Kf2', 120:'60...Rf2+', 121:'61.Ke3', 122:'61...Re1+', 123:'62.Kf2 Draw'
}


   },
{
    id: 6,
      name: 'Fischer and Benko at Portoroz',
      description:
'\nFrom the book: My Life, Games and Compositions by Pal Benko'+
'\n\n'+
'I became acquainted with Fischer at the picturesque town of Portoroz, situated along the Yugoslavian coast. He was just a teenager at that time, a nice kid. Sometimes he would cry if he lost a game, and I quickly became quite fond of him, almost protective. Once I asked him what he wanted to be, and he said, "I want to be an international playboy, just like Benko!" Unfortunately, he was always very shy and never learned how to communicate with women. '+
'\n\n'+
'Though I had seen Fischer\'s gentler side, I was always aware that he was an opponent to be reckoned with: He was only fifteen and was already U.S. Champion and world famous. In fact, he was considered to be virtually unbeatable on his home soil, so I was really looking forward to seeing his stuff. We were paired in the fourth round with me having White. His performance in the event thus far hadn\'t been spectacular, since he had played three of the weaker participants and had only scored one win and two draws. He clearly didn\'t possess the kind of experience that only years of international competition produces, and this made him vulnerable.'+
'\n\n'+
'In his win (as Black) against the Hungarian-Canadian Fuester (yes, the same Fuester that played such an important role in my arrest!), I spotted an improvement for White. Hoping that his self confidence would lull him into a false sense of security, thereby preventing him from analyzing this game, I decided to use this same opening, positive that he would play his favorite King\'s Indian Defense. I intended to test my new idea and drag him into unknown territory, forcing him to solve difficult problems on his own. The following game was my first of three career victories over Fischer.\n',
diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
2:'rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR',
3:'rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR',
4:'rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR',
5:'rnbqkb1r/pppppp1p/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR',
6:'rnbqk2r/ppppppbp/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR',
7:'rnbqk2r/ppppppbp/5np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR',
8:'rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR',
9:'rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR',
10:'rnbqk2r/ppp2pbp/3p1np1/4p3/2PPP3/2N2P2/PP4PP/R1BQKBNR',
11:'rnbqk2r/ppp2pbp/3p1np1/4p3/2PPP3/2N2P2/PP2N1PP/R1BQKB1R',
12:'rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2P2/PP2N1PP/R1BQKB1R',
13:'rnbq1rk1/ppp2pbp/3p1np1/4p1B1/2PPP3/2N2P2/PP2N1PP/R2QKB1R',
14:'rnbq1rk1/ppp2pbp/3p1np1/6B1/2PpP3/2N2P2/PP2N1PP/R2QKB1R',
15:'rnbq1rk1/ppp2pbp/3p1np1/6B1/2PNP3/2N2P2/PP4PP/R2QKB1R',
16:'r1bq1rk1/ppp2pbp/2np1np1/6B1/2PNP3/2N2P2/PP4PP/R2QKB1R',
17:'r1bq1rk1/ppp2pbp/2np1np1/6B1/2P1P3/2N2P2/PPN3PP/R2QKB1R',
18:'r2q1rk1/ppp2pbp/2npbnp1/6B1/2P1P3/2N2P2/PPN3PP/R2QKB1R',
19:'r2q1rk1/ppp2pbp/2npbnp1/6B1/2P1P3/2N2P2/PPN1B1PP/R2QK2R',
20:'r2q1rk1/ppp2pb1/2npbnpp/6B1/2P1P3/2N2P2/PPN1B1PP/R2QK2R',
21:'r2q1rk1/ppp2pb1/2npbnpp/8/2P1P2B/2N2P2/PPN1B1PP/R2QK2R',
22:'r2q1rk1/ppp2pb1/2npbn1p/6p1/2P1P2B/2N2P2/PPN1B1PP/R2QK2R',
23:'r2q1rk1/ppp2pb1/2npbn1p/6p1/2P1P3/2N2P2/PPN1BBPP/R2QK2R',
24:'r2q1rk1/ppp2pb1/3pbn1p/4n1p1/2P1P3/2N2P2/PPN1BBPP/R2QK2R',
25:'r2q1rk1/ppp2pb1/3pbn1p/4n1p1/2P1P3/2N1NP2/PP2BBPP/R2QK2R',
26:'r2q1rk1/pp3pb1/2ppbn1p/4n1p1/2P1P3/2N1NP2/PP2BBPP/R2QK2R',
27:'r2q1rk1/pp3pb1/2ppbn1p/4n1p1/2P1P3/2N1NP2/PP2BBPP/R2Q1RK1',
28:'r4rk1/pp3pb1/2ppbn1p/q3n1p1/2P1P3/2N1NP2/PP2BBPP/R2Q1RK1',
29:'r4rk1/pp3pb1/2ppbn1p/q3n1p1/2P1P3/2N1NP2/PP1QBBPP/R4RK1',
30:'r2r2k1/pp3pb1/2ppbn1p/q3n1p1/2P1P3/2N1NP2/PP1QBBPP/R4RK1',
31:'r2r2k1/pp3pb1/2ppbn1p/q3n1p1/2P1P3/2N1NP2/PP1QBBPP/R2R2K1',
32:'r2r2k1/1p3pb1/p1ppbn1p/q3n1p1/2P1P3/2N1NP2/PP1QBBPP/R2R2K1',
33:'r2r2k1/1p3pb1/p1ppbn1p/q3n1p1/P1P1P3/2N1NP2/1P1QBBPP/R2R2K1',
34:'r2r2k1/1pq2pb1/p1ppbn1p/4n1p1/P1P1P3/2N1NP2/1P1QBBPP/R2R2K1',
35:'r2r2k1/1pq2pb1/p1ppbn1p/P3n1p1/2P1P3/2N1NP2/1P1QBBPP/R2R2K1',
36:'r2r2k1/1pq2pb1/p2pbn1p/P1p1n1p1/2P1P3/2N1NP2/1P1QBBPP/R2R2K1',
37:'r2r2k1/1pq2pb1/p2pbn1p/P1p1n1p1/2P1P2P/2N1NP2/1P1QBBP1/R2R2K1',
38:'r2r2k1/1p2qpb1/p2pbn1p/P1p1n1p1/2P1P2P/2N1NP2/1P1QBBP1/R2R2K1',
39:'r2r2k1/1p2qpb1/p2pbn1p/P1p1n1P1/2P1P3/2N1NP2/1P1QBBP1/R2R2K1',
40:'r2r2k1/1p2qpb1/p2pbn2/P1p1n1p1/2P1P3/2N1NP2/1P1QBBP1/R2R2K1',
41:'r2r2k1/1p2qpb1/p2pbn2/P1p1nNp1/2P1P3/2N2P2/1P1QBBP1/R2R2K1',
42:'r2r2k1/1p2qpb1/p2p1n2/P1p1nbp1/2P1P3/2N2P2/1P1QBBP1/R2R2K1',
43:'r2r2k1/1p2qpb1/p2p1n2/P1p1nPp1/2P5/2N2P2/1P1QBBP1/R2R2K1',
44:'r2r2k1/1p2qpb1/p2p1n2/P1p1nP2/2P3p1/2N2P2/1P1QBBP1/R2R2K1',
45:'r2r2k1/1p2qpb1/p2p1n2/P1p1nP2/2P3pB/2N2P2/1P1QB1P1/R2R2K1',
46:'r2r1qk1/1p3pb1/p2p1n2/P1p1nP2/2P3pB/2N2P2/1P1QB1P1/R2R2K1',
47:'r2r1qk1/1p3pb1/p2p1n2/P1p1nP2/2P3PB/2N5/1P1QB1P1/R2R2K1',
48:'r2r1qk1/1p3pb1/p2p1n2/P1p2P2/2P3nB/2N5/1P1QB1P1/R2R2K1',
49:'r2r1qk1/1p3pb1/p2p1n2/P1p2P2/2P3BB/2N5/1P1Q2P1/R2R2K1',
50:'r2r1qk1/1p3pb1/p2p4/P1p2P2/2P3nB/2N5/1P1Q2P1/R2R2K1',
51:'r2r1qk1/1p3pb1/p2p4/P1p2PQ1/2P3nB/2N5/1P4P1/R2R2K1',
52:'r2r1qk1/1p3pb1/p2p1n2/P1p2PQ1/2P4B/2N5/1P4P1/R2R2K1',
53:'r2r1qk1/1p3pb1/p2p1n2/P1p2PQ1/2P4B/2NR4/1P4P1/R5K1',
54:'r2r1qk1/1p3pbn/p2p4/P1p2PQ1/2P4B/2NR4/1P4P1/R5K1',
55:'r2r1qk1/1p3pbn/p2p4/P1p2P2/2P3QB/2NR4/1P4P1/R5K1',
56:'r2r1qk1/1p4bn/p2p1p2/P1p2P2/2P3QB/2NR4/1P4P1/R5K1',
57:'r2r1qk1/1p4bn/p2p1p2/P1pN1P2/2P3QB/3R4/1P4P1/R5K1',
58:'r2r2k1/1p3qbn/p2p1p2/P1pN1P2/2P3QB/3R4/1P4P1/R5K1',
59:'r2r2k1/1p3qbn/p2p1p2/P1pN1P2/2P3QB/3R4/1P4P1/4R1K1',
60:'r3r1k1/1p3qbn/p2p1p2/P1pN1P2/2P3QB/3R4/1P4P1/4R1K1',
61:'r3r1k1/1p3qbn/p2p1p2/P1pN1P2/2P3QB/4R3/1P4P1/4R1K1',
62:'r5k1/1p3qbn/p2p1p2/P1pNrP2/2P3QB/4R3/1P4P1/4R1K1',
63:'r5k1/1p3qbn/p2p1p2/P1pNrP2/2P3Q1/4R1B1/1P4P1/4R1K1',
64:'r5k1/1p3qbn/p2p1p2/P1pN1P2/2P3Q1/4r1B1/1P4P1/4R1K1',
65:'r5k1/1p3qbn/p2p1p2/P1pN1P2/2P3Q1/4R1B1/1P4P1/6K1',
66:'4r1k1/1p3qbn/p2p1p2/P1pN1P2/2P3Q1/4R1B1/1P4P1/6K1',
67:'4r1k1/1p3qbn/p2pRp2/P1pN1P2/2P3Q1/6B1/1P4P1/6K1',
68:'4r1k1/1p3qb1/p2pRp2/P1pN1Pn1/2P3Q1/6B1/1P4P1/6K1',
69:'4r1k1/1p3qb1/p2R1p2/P1pN1Pn1/2P3Q1/6B1/1P4P1/6K1',
70:'6k1/1p3qb1/p2R1p2/P1pN1Pn1/2P1r1Q1/6B1/1P4P1/6K1',
71:'3R2k1/1p3qb1/p4p2/P1pN1Pn1/2P1r1Q1/6B1/1P4P1/6K1',
72:'3R4/1p3qbk/p4p2/P1pN1Pn1/2P1r1Q1/6B1/1P4P1/6K1',
73:'3R4/1p3qbk/p4p2/P1pN1Pn1/2P1rBQ1/8/1P4P1/6K1',
74:'3R4/1p3q1k/p4p1b/P1pN1Pn1/2P1rBQ1/8/1P4P1/6K1',
75:'8/1p1R1q1k/p4p1b/P1pN1Pn1/2P1rBQ1/8/1P4P1/6K1',
76:'8/1p1R1q1k/p4p1b/P1pN1Pn1/2P2BQ1/8/1P4P1/4r1K1',
77:'8/1p1R1q1k/p4p1b/P1pN1Pn1/2P2BQ1/8/1P3KP1/4r3',
78:'8/1p1R1q1k/p4p1b/P1pN1P2/2P1nBQ1/8/1P3KP1/4r3',
79:'8/1p1R1q1k/p4p1b/P1pN1P2/2P1nBQ1/8/1P4P1/4K3',
80:'8/1p1q3k/p4p1b/P1pN1P2/2P1nBQ1/8/1P4P1/4K3',
81:'8/1p1q3k/p4pQb/P1pN1P2/2P1nB2/8/1P4P1/4K3'
},
comments:{
0:'Pal Benko vs Robert Fischer, Portoroz Interzonal 1958, Annotations by Benko',
1:'1.d4', 2:'1...Nf6', 3:'2.c4', 4:'2...g6', 5:'3.Nc3', 6:'3...Bg7', 7:'4.e4', 8:'4...d6', 9:'5.f3', 10:'5...e5', 11:'6.Nge2 White would gain nothing by taking on e5 and trading queens, since the hole on d4 would guarantee Black good long-term chances. ', 12:'6...O-O',
13:'7.Bg5 Fuster played 7.Be3, but this pin of the f6-knight caught my eye immediately. Now 7...h6 8.Be3 allows White to gain a tempo with a subsequent Qd2, hitting h6.', 14:'7...exd4 My surprise move did its work, and Bobby gives up his hold on the center. He is hoping to exploit the absence of my dark-squared bishop from e3, but this doesn’t lead to the desired result. More interesting would have been 7...Nc6 8.d5 and now 8...Nd4!? 9. Nxd4 exd4 10. Qxd4 h6 11.Bxf6 Bxf6 leaves Black with some compensation for his pawn miner in the form of an active bishop and firm control over the dark-squares.', 15:'8.Nxd4', 16:'8...Nc6', 17:'9.Nc2 Getting off the dangerous h8-a1 diagonal, the knight eventually hopes to jump to e3 and d5. Worse was 9.Be2?! Nxd4 10.Qxd4 Nxe4! when the resulting exchanges would lead to an equal game. By avoiding trades, White leaves Black with a cramped position.', 18:'9...Be6', 19:'10.Be2 It’s important to point out that 10.Qd2 wouldn’t stop Black from playing 10... h6 since 11.Bxh6 Nxe4 12.Nxe4 Qh4+ would make the second player quite happy.', 20:'10...h6', 21:'11.Bh4 Moving the bishop back to e3 would be illogical, since that square is reserved for the c2-knight.', 22:'11...g5 The impatience of youth! Here Bobby couldn’t stand the pin on his f6-knight any longer, and breaks it at a huge cost: his f5-square is now seriously weakened. An experienced tournament player would think twice before making such a move. Though f5 can’t be exploited right away, it is bound to lead to further concessions in the long run. I will say that finding good plans in cramped positions is never easy, and a player of that age rarely has the defensive technique necessary for such a daunting task.',
23:'12.Bf2', 24:'12...Ne5', 25:'13.Ne3', 26:'13...c6 Defending d5 but weakening d6.', 27:'14.O-O', 28:'14...Qa5 A surprise. This offers a pawn sacrifice: 15.Qxd6 Rfd8 16.Qa3 Qxa3 17.bxa3, when my queenside is in shambles. However, the natural 15.Qc2 Rfd8 lets him force the freeing ...d6-d5 with good play. So this position proved to be full of tricks, and I began to appreciate the skills of my young opponent.', 29:'15.Qd2 Crossing Black’s plans and taking aim at g5.', 30:'15...Rfd8', 31:'16.Rfd1 Still clamping down on the d5-square. The other rook stays on the queenside in order to curtail Black’s play in that sector.', 32:'16...a6',
33:'17.a4', 34:'17...Qc7 The more active 17...Qb4 isn’t wise, since after 18.a5, Black couldn’t capture on c4 due to 19.Ra4.', 35:'18.a5 This nails down Black’s queenside pawns and threatens a timely Bb6.', 36:'18...c5 Defending the b6-square, but at the cost of weakening d5. The progressive weakening of Black’s position now compelled me to start my attack, while Bobby’s central probe and queenside play has failed.', 37:'19.h4', 38:'19...Qe7', 39:'20.hxg5', 40:'20...hxg5', 41:'21.Nf5 Finally occupying the hole on f5.', 42:'21...Bxf5',
43:'22.exf5', 44:'22...g4', 45:'23.Bh4 The annoying bishop is back on the h4-d8 diagonal! Now the obvious threat of Nd5 forces Fischer to take preventive measures.', 46:'23...Qf8 Black steps out of the pin and creates possibilities of ...Bh6. Here I refrained from 24.Bxf6 Bxf6 since, even though I win a pawn, the resulting bishops of opposite colors would give Black good defensive chances.', 47:'24.fxg4', 48:'24...Nexg4', 49:'25.Bxg4', 50:'25...Nxg4 Black appears to be getting some activity, since ...Bd4+ might prove troublesome.', 51:'26.Qg5 A complete answer. Now g4 is hanging and the g7-bishop is pinned.',
52:'26...Nf6', 53:'27.Rd3 This isn’t subtle, but the threat of swinging the rook over to the kingside (g3 and/or h3) is devastating.', 54:'27...Nh7 Even worse is 27...Kh7 since White can employ an obvious but decisive queen sacrifice: 28.Qxf6 Bxf6 29.Bxf6 when the threat of Rh3 ends the game.', 55:'28.Qg4', 56: '28...f6 Sad but forced. Clearly Bobby has lost the strategic fight. Now all White has to do is occupy some of the holes, when Black’s game will implode positionally and/or tactically.', 57:'29.Nd5', 58:'29...Qf7', 59:'30.Re1', 60:'30...Re8', 61:'31.Rde3',
62:'31...Re5', 63:'32.Bg3', 64:'32...Rxe3', 65:'33.Rxe3', 66:'33...Re8', 67:'34.Re6 Black’s d6-pawn is lost with or without the exchange of rooks.', 68:'34...Ng5', 69:'35.Rxd6', 70:'35...Re4',
71:'36.Rd8+', 72:'36...Kh7', 73:'37.Bf4 Black’s position is, of course, quite lost.', 74:'37...Bh6', 75:'38.Rd7 This wins the Black queen since 38...Qxd7 allows 39.Nxf6+', 76:'38...Re1+', 77:'39.Kf2', 78:'39...Ne4+ This defends the f6-square and allows Fischer to save his queen. Fortunately for me, it doesn’t change the result of the game.', 79:'40.Kxe1',
80:'40...Qxd7', 81:'41.Qg6+ 1-0. In this game we saw the effect an opening surprise can have, even on a very strong player. '
}
},
{
    id: 7,
      name: 'Karpov on Fischer',
      description:
'\nKarpov interviewed in Gibraltar by Tania Sachdev in January 2020'+
'\n\n'+
'The most exciting is all the world championship matches that you have played, and I want to start with the 1975 match with Fischer, which did not happen. Do you remember the first time you heard about Bobby Fischer? What was your feeling about it then?'+
'\n\n'+
'Of course I knew his name and his games when I was very young, because I followed the Candidates Tournament in Yugoslavia. At that time, it was a very long competition, 28 games with adjournments, so it was like 45 days, it was very difficult to play [Ed. The tournament ran from September 7th to October 31st, 1959]. Fischer played this Candidates Tournament, and he qualified when he was 15, and at that time he became a grandmaster at the age of 14, very young, the youngest...not in history, but of course the weight of the grandmaster title was much more important than nowadays.'+
'\n\n'+
'When Fischer was going to the 1972 match with Boris Spassky, how did you feel the match would turn out? What were your predictions of the match?'+
'\n\n'+
'Fischer achieved fantastic results in Candidates matches: against Taimanov and Larsen, 6:0 and 6:0, and then against Petrosian with a four-point advantage, which was a great sportive result. Of course, everybody was impressed with those results, as Fischer dominated. He had a very strong personality, and these players I think mostly missed the psychological factor during these games. '+
'\n\n'+
'When I had to play Fischer, I prepared [a lot], and I think I had chances. I can\'t say I had better chances [than him] — I considered it would be a tough match.'+
'\n\n'+
'Was that a bit disappointing for you after Fischer\'s demands were not met and the match did not take place? Was it bittersweet to be world champion without a match?'+
'\n\n'+
'No, I prepared for the match, I was ready to play, but of course I could not force Fischer to play. If he didn\'t appear, he didn\'t appear. I wanted to play and to defeat Bobby. It was my personal aim to win that match, but the leaders of my country didn\'t like the idea. They said, you are world champion, why to take the risk to play Fischer, you are world champion, what else do you want? I said, I want to play the strongest player of the time, I want to beat him, I have chances. And then they asked, are you sure you can win? I said, I have good chances, but it\'s a sport, how can you be sure that you\'ll win?'+
'\n\n'+
'That\'s why I had problems to negotiate. They said, if you guarantee [a win]. I said, are you crazy? I cannot guarantee I\'ll win, but I have good chances to beat Fischer.'+
'\n\n'+
'Talking about good chances, there were a lot of mixed views. Kasparov felt that you probably would have won that match, considering that you were very active — you were at your toughest, you were peaking, while Fischer hadn\'t actually played for three years, after 1972. On the other hand, Spassky said that maybe Fischer would have won that match, but you would come back and win the next cycle.'+
'\n\n'+
'Fischer had a big supporter in Spassky. Probably because of this admiration Spassky missed his chances to play more successfully against Fischer in the match. If you analyse that match, Fischer won with a big gap, but in the middle of the match they both lost energy, so they were playing like boxers fighting in the last round of the battle. From game 11 or 12, I think for six games both sides could win, so the match could have continued in a different direction. In game 13, Spassky was winning almost by force, and he missed it, in the middle of the game. Actually, I got a lot of respect among our top players, when I showed — during the game — Petrosian and Keres how Spassky could win the game.'+
'\n\n'+
'Were you at the venue at that time?'+
'\n\n'+
'No, we were preparing for the Chess Olympiad in Skopje. We were together, and I just analysed and showed that Spassky missed a clear advantage, almost winning. And then he lost that game. It was an Alekhine Defence. He missed chances and lost opportunities to win.'+
'\n\n'+
'\n\n'+

'Here is the 13th game that Karpov referred to.'+
'\n\n'+
'Lombardy noted the shock that Spassky was in after he resigned:'+
'\n\n'+
'While Fischer dashed for his car, Spassky remained glued to his seat. A sympathetic Lothar Schmid came over, and the two shifted the pieces about with Boris demonstrating his careless mistakes. The two were left wondering how Bobby could have squeezed a win from a position which a night of competent analysis by a renowned Soviet team had showed to be a guaranteed draw.'+
'\n\n'+
'David Bronstein said, "Of all the games from the match, the 13th appeals to me most of all. When I play through the game I still cannot grasp the innermost motive behind this or that plan or even individual move. Like an enigma, it still teases my imagination."'+
'\n\n'+
'Former World Champion Mikhail Botvinnik said this game made a particularly strong impression on him. He called it "the highest creative achievement of Fischer". He resolved a drawish opposite-colored bishops endgame by sacrificing his bishop and trapping his own rook. "Then five passed pawns struggled with the white rook. Nothing similar had been seen before in chess".\n',


diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkb1r/pppppppp/5n2/4P3/8/8/PPPP1PPP/RNBQKBNR',
4:'rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR',
5:'rnbqkb1r/pppppppp/8/3nP3/3P4/8/PPP2PPP/RNBQKBNR',
6:'rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR',
7:'rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R',
8:'rnbqkb1r/ppp1pp1p/3p2p1/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R',
9:'rnbqkb1r/ppp1pp1p/3p2p1/3nP3/2BP4/5N2/PPP2PPP/RNBQK2R',
10:'rnbqkb1r/ppp1pp1p/1n1p2p1/4P3/2BP4/5N2/PPP2PPP/RNBQK2R',
11:'rnbqkb1r/ppp1pp1p/1n1p2p1/4P3/3P4/1B3N2/PPP2PPP/RNBQK2R',
12:'rnbqk2r/ppp1ppbp/1n1p2p1/4P3/3P4/1B3N2/PPP2PPP/RNBQK2R',
13:'rnbqk2r/ppp1ppbp/1n1p2p1/4P3/3P4/1B3N2/PPPN1PPP/R1BQK2R',
14:'rnbq1rk1/ppp1ppbp/1n1p2p1/4P3/3P4/1B3N2/PPPN1PPP/R1BQK2R',
15:'rnbq1rk1/ppp1ppbp/1n1p2p1/4P3/3P4/1B3N1P/PPPN1PP1/R1BQK2R',
16:'rnbq1rk1/1pp1ppbp/1n1p2p1/p3P3/3P4/1B3N1P/PPPN1PP1/R1BQK2R',
17:'rnbq1rk1/1pp1ppbp/1n1p2p1/p3P3/P2P4/1B3N1P/1PPN1PP1/R1BQK2R',
18:'rnbq1rk1/1pp1ppbp/1n4p1/p3p3/P2P4/1B3N1P/1PPN1PP1/R1BQK2R',
19:'rnbq1rk1/1pp1ppbp/1n4p1/p3P3/P7/1B3N1P/1PPN1PP1/R1BQK2R',
20:'r1bq1rk1/1pp1ppbp/nn4p1/p3P3/P7/1B3N1P/1PPN1PP1/R1BQK2R',
21:'r1bq1rk1/1pp1ppbp/nn4p1/p3P3/P7/1B3N1P/1PPN1PP1/R1BQ1RK1',
22:'r1bq1rk1/1pp1ppbp/1n4p1/p1n1P3/P7/1B3N1P/1PPN1PP1/R1BQ1RK1',
23:'r1bq1rk1/1pp1ppbp/1n4p1/p1n1P3/P7/1B3N1P/1PPNQPP1/R1B2RK1',
24:'r1b1qrk1/1pp1ppbp/1n4p1/p1n1P3/P7/1B3N1P/1PPNQPP1/R1B2RK1',
25:'r1b1qrk1/1pp1ppbp/1n4p1/p1n1P3/P3N3/1B3N1P/1PP1QPP1/R1B2RK1',
26:'r1b1qrk1/1pp1ppbp/6p1/p1n1P3/n3N3/1B3N1P/1PP1QPP1/R1B2RK1',
27:'r1b1qrk1/1pp1ppbp/6p1/p1n1P3/B3N3/5N1P/1PP1QPP1/R1B2RK1',
28:'r1b1qrk1/1pp1ppbp/6p1/p3P3/n3N3/5N1P/1PP1QPP1/R1B2RK1',
29:'r1b1qrk1/1pp1ppbp/6p1/p3P3/n3N3/5N1P/1PP1QPP1/R1B1R1K1',
30:'r1b1qrk1/1pp1ppbp/1n4p1/p3P3/4N3/5N1P/1PP1QPP1/R1B1R1K1',
31:'r1b1qrk1/1pp1ppbp/1n4p1/p3P3/4N3/5N1P/1PPBQPP1/R3R1K1',
32:'r1b1qrk1/1pp1ppbp/1n4p1/4P3/p3N3/5N1P/1PPBQPP1/R3R1K1',
33:'r1b1qrk1/1pp1ppbp/1n4p1/4P1B1/p3N3/5N1P/1PP1QPP1/R3R1K1',
34:'r1b1qrk1/1pp1ppb1/1n4pp/4P1B1/p3N3/5N1P/1PP1QPP1/R3R1K1',
35:'r1b1qrk1/1pp1ppb1/1n4pp/4P3/p3N2B/5N1P/1PP1QPP1/R3R1K1',
36:'r3qrk1/1pp1ppb1/1n4pp/4Pb2/p3N2B/5N1P/1PP1QPP1/R3R1K1',
37:'r3qrk1/1pp1ppb1/1n4pp/4Pb2/p3N1PB/5N1P/1PP1QP2/R3R1K1',
38:'r3qrk1/1pp1ppb1/1n2b1pp/4P3/p3N1PB/5N1P/1PP1QP2/R3R1K1',
39:'r3qrk1/1pp1ppb1/1n2b1pp/4P3/p2NN1PB/7P/1PP1QP2/R3R1K1',
40:'r3qrk1/1pp1ppb1/1n4pp/4P3/p1bNN1PB/7P/1PP1QP2/R3R1K1',
41:'r3qrk1/1pp1ppb1/1n4pp/4P3/p1bNN1PB/7P/1PPQ1P2/R3R1K1',
42:'r4rk1/1ppqppb1/1n4pp/4P3/p1bNN1PB/7P/1PPQ1P2/R3R1K1',
43:'r4rk1/1ppqppb1/1n4pp/4P3/p1bNN1PB/7P/1PPQ1P2/3RR1K1',
44:'r3r1k1/1ppqppb1/1n4pp/4P3/p1bNN1PB/7P/1PPQ1P2/3RR1K1',
45:'r3r1k1/1ppqppb1/1n4pp/4P3/p1bNNPPB/7P/1PPQ4/3RR1K1',
46:'r3r1k1/1ppqppb1/1n4pp/3bP3/p2NNPPB/7P/1PPQ4/3RR1K1',
47:'r3r1k1/1ppqppb1/1n4pp/2NbP3/p2N1PPB/7P/1PPQ4/3RR1K1',
48:'r1q1r1k1/1pp1ppb1/1n4pp/2NbP3/p2N1PPB/7P/1PPQ4/3RR1K1',
49:'r1q1r1k1/1pp1ppb1/1n4pp/2NbP3/p2N1PPB/2Q4P/1PP5/3RR1K1',
50:'r1q1r1k1/1pp2pb1/1n2p1pp/2NbP3/p2N1PPB/2Q4P/1PP5/3RR1K1',
51:'r1q1r1k1/1pp2pb1/1n2p1pp/2NbP3/p2N1PPB/2Q4P/1PP4K/3RR3',
52:'r1q1r1k1/1ppn1pb1/4p1pp/2NbP3/p2N1PPB/2Q4P/1PP4K/3RR3',
53:'r1q1r1k1/1ppn1pb1/4p1pp/3bP3/p2N1PPB/2QN3P/1PP4K/3RR3',
54:'r1q1r1k1/1p1n1pb1/4p1pp/2pbP3/p2N1PPB/2QN3P/1PP4K/3RR3',
55:'r1q1r1k1/1p1n1pb1/4p1pp/1NpbP3/p4PPB/2QN3P/1PP4K/3RR3',
56:'r3r1k1/1p1n1pb1/2q1p1pp/1NpbP3/p4PPB/2QN3P/1PP4K/3RR3',
57:'r3r1k1/1p1n1pb1/2qNp1pp/2pbP3/p4PPB/2QN3P/1PP4K/3RR3',
58:'r3r1k1/1p1n1pb1/3qp1pp/2pbP3/p4PPB/2QN3P/1PP4K/3RR3',
59:'r3r1k1/1p1n1pb1/3Pp1pp/2pb4/p4PPB/2QN3P/1PP4K/3RR3',
60:'r3r1k1/1p1n1p2/3Pp1pp/2pb4/p4PPB/2bN3P/1PP4K/3RR3',
61:'r3r1k1/1p1n1p2/3Pp1pp/2pb4/p4PPB/2PN3P/2P4K/3RR3',
62:'r3r1k1/1p1n4/3Ppppp/2pb4/p4PPB/2PN3P/2P4K/3RR3',
63:'r3r1k1/1p1n4/3Ppppp/2pb2P1/p4P1B/2PN3P/2P4K/3RR3',
64:'r3r1k1/1p1n4/3Pppp1/2pb2p1/p4P1B/2PN3P/2P4K/3RR3',
65:'r3r1k1/1p1n4/3Pppp1/2pb2P1/p6B/2PN3P/2P4K/3RR3',
66:'r3r1k1/1p1n4/3Pp1p1/2pb1pP1/p6B/2PN3P/2P4K/3RR3',
67:'r3r1k1/1p1n4/3Pp1p1/2pb1pP1/p7/2PN2BP/2P4K/3RR3',
68:'r3r3/1p1n1k2/3Pp1p1/2pb1pP1/p7/2PN2BP/2P4K/3RR3',
69:'r3r3/1p1n1k2/3Pp1p1/2pbNpP1/p7/2P3BP/2P4K/3RR3',
70:'r3r3/1p3k2/3Pp1p1/2pbnpP1/p7/2P3BP/2P4K/3RR3',
71:'r3r3/1p3k2/3Pp1p1/2pbBpP1/p7/2P4P/2P4K/3RR3',
72:'r3r3/5k2/3Pp1p1/1ppbBpP1/p7/2P4P/2P4K/3RR3',
73:'r3r3/5k2/3Pp1p1/1ppbBpP1/p7/2P4P/2P4K/3R1R2',
74:'r6r/5k2/3Pp1p1/1ppbBpP1/p7/2P4P/2P4K/3R1R2',
75:'r6r/5k2/3PpBp1/1ppb1pP1/p7/2P4P/2P4K/3R1R2',
76:'r6r/5k2/3PpBp1/1ppb1pP1/8/p1P4P/2P4K/3R1R2',
77:'r6r/5k2/3PpBp1/1ppb1pP1/5R2/p1P4P/2P4K/3R4',
78:'r6r/5k2/3PpBp1/1ppb1pP1/5R2/2P4P/p1P4K/3R4',
79:'r6r/5k2/3PpBp1/1ppb1pP1/2P2R2/7P/p1P4K/3R4',
80:'r6r/5k2/3PpBp1/1pp2pP1/2b2R2/7P/p1P4K/3R4',
81:'r6r/3P1k2/4pBp1/1pp2pP1/2b2R2/7P/p1P4K/3R4',
82:'r6r/3P1k2/4pBp1/1ppb1pP1/5R2/7P/p1P4K/3R4',
83:'r6r/3P1k2/4pBp1/1ppb1pP1/5R2/6KP/p1P5/3R4',
84:'7r/3P1k2/4pBp1/1ppb1pP1/5R2/r5KP/p1P5/3R4',
85:'7r/3P1k2/4pBp1/1ppb1pP1/5R2/r1P3KP/p7/3R4',
86:'r7/3P1k2/4pBp1/1ppb1pP1/5R2/r1P3KP/p7/3R4',
87:'r7/3P1k2/4pBp1/1ppb1pP1/7R/r1P3KP/p7/3R4',
88:'r7/3P1k2/5Bp1/1ppbppP1/7R/r1P3KP/p7/3R4',
89:'r7/3P1k1R/5Bp1/1ppbppP1/8/r1P3KP/p7/3R4',
90:'r7/3P3R/4kBp1/1ppbppP1/8/r1P3KP/p7/3R4',
91:'r7/3PR3/4kBp1/1ppbppP1/8/r1P3KP/p7/3R4',
92:'r7/3PR3/3k1Bp1/1ppbppP1/8/r1P3KP/p7/3R4',
93:'r7/3P4/3k1Bp1/1ppbRpP1/8/r1P3KP/p7/3R4',
94:'r7/3P4/3k1Bp1/1ppbRpP1/8/2r3KP/p7/3R4',
95:'r7/3P4/3k1Bp1/1ppbRpP1/8/2r4P/p4K2/3R4',
96:'r7/3P4/3k1Bp1/1ppbRpP1/8/7P/p1r2K2/3R4',
97:'r7/3P4/3k1Bp1/1ppbRpP1/8/7P/p1r5/3RK3',
98:'r7/3k4/5Bp1/1ppbRpP1/8/7P/p1r5/3RK3',
99:'r7/3k4/5Bp1/1ppR1pP1/8/7P/p1r5/3RK3',
100:'r7/8/2k2Bp1/1ppR1pP1/8/7P/p1r5/3RK3',
101:'r7/8/2kR1Bp1/1pp2pP1/8/7P/p1r5/3RK3',
102:'r7/1k6/3R1Bp1/1pp2pP1/8/7P/p1r5/3RK3',
103:'r7/1k1R4/5Bp1/1pp2pP1/8/7P/p1r5/3RK3',
104:'r7/3R4/k4Bp1/1pp2pP1/8/7P/p1r5/3RK3',
105:'r7/8/k4Bp1/1pp2pP1/8/7P/p1rR4/3RK3',
106:'r7/8/k4Bp1/1pp2pP1/8/7P/p2r4/3RK3',
107:'r7/8/k4Bp1/1pp2pP1/8/7P/p2K4/3R4',
108:'r7/8/k4Bp1/2p2pP1/1p6/7P/p2K4/3R4',
109:'r7/8/k4Bp1/2p2pP1/1p5P/8/p2K4/3R4',
110:'r7/8/5Bp1/1kp2pP1/1p5P/8/p2K4/3R4',
111:'r7/8/5Bp1/1kp2pPP/1p6/8/p2K4/3R4',
112:'r7/8/5Bp1/1k3pPP/1pp5/8/p2K4/3R4',
113:'r7/8/5Bp1/1k3pPP/1pp5/8/p2K4/R7',
114:'r7/8/5B2/1k3pPp/1pp5/8/p2K4/R7',
115:'r7/8/5BP1/1k3p1p/1pp5/8/p2K4/R7',
116:'r7/8/5BP1/1k3p2/1pp4p/8/p2K4/R7',
117:'r7/6P1/5B2/1k3p2/1pp4p/8/p2K4/R7',
118:'r7/6P1/5B2/1k3p2/1pp5/7p/p2K4/R7',
119:'r7/4B1P1/8/1k3p2/1pp5/7p/p2K4/R7',
120:'6r1/4B1P1/8/1k3p2/1pp5/7p/p2K4/R7',
121:'5Br1/6P1/8/1k3p2/1pp5/7p/p2K4/R7',
122:'5Br1/6P1/8/1k3p2/1pp5/8/p2K3p/R7',
123:'5Br1/6P1/8/1k3p2/1pp5/8/p1K4p/R7',
124:'5Br1/6P1/2k5/5p2/1pp5/8/p1K4p/R7',
125:'5Br1/6P1/2k5/5p2/1pp5/8/p1K4p/3R4',
126:'5Br1/6P1/2k5/5p2/2p5/1p6/p1K4p/3R4',
127:'5Br1/6P1/2k5/5p2/2p5/1pK5/p6p/3R4',
128:'5Br1/6P1/2k5/5p2/2p5/1pK5/p7/3R3q',
129:'5Br1/6P1/2k5/5p2/2p5/1pK5/p7/7R',
130:'5Br1/6P1/8/3k1p2/2p5/1pK5/p7/7R',
131:'5Br1/6P1/8/3k1p2/2p5/1p6/pK6/7R',
132:'5Br1/6P1/8/3k4/2p2p2/1p6/pK6/7R',
133:'5Br1/6P1/8/3k4/2p2p2/1p6/pK6/3R4',
134:'5Br1/6P1/8/8/2p1kp2/1p6/pK6/3R4',
135:'5Br1/6P1/8/8/2p1kp2/1p6/pK6/2R5',
136:'5Br1/6P1/8/8/2p2p2/1p1k4/pK6/2R5',
137:'5Br1/6P1/8/8/2p2p2/1p1k4/pK6/3R4',
138:'5Br1/6P1/8/8/2p2p2/1p6/pK2k3/3R4',
139:'5Br1/6P1/8/8/2p2p2/1p6/pK2k3/2R5',
140:'5Br1/6P1/8/8/2p5/1p3p2/pK2k3/2R5',
141:'6r1/6P1/8/2B5/2p5/1p3p2/pK2k3/2R5',
142:'8/6r1/8/2B5/2p5/1p3p2/pK2k3/2R5',
143:'8/6r1/8/2B5/2R5/1p3p2/pK2k3/8',
144:'8/3r4/8/2B5/2R5/1p3p2/pK2k3/8',
145:'8/3r4/8/2B5/4R3/1p3p2/pK2k3/8',
146:'8/3r4/8/2B5/4R3/1p3p2/pK6/5k2',
147:'8/3r4/8/8/3BR3/1p3p2/pK6/5k2',
148:'8/3r4/8/8/3BR3/1p6/pK3p2/5k2',
},
comments:{
0:'Boris Spassky – Bobby Fischer, World Championship 1972, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...Nf6', 3:'2.e5', 4:'2...Nd5', 5:'3.d4', 6:'3...d6', 7:'4.Nf3', 8:'4...g6', 9:'5.Bc4', 10:'5...Nb6', 11:'6.Bb3', 12:'6...Bg7',
13:'7.Nbd2?! This passive move is a serious inaccuracy. Spassky was obviously not prepared for this line of the Alekhine Defense. 7.Ng5 is played most often. But White has many more active options.', 14:'7...O-O', 15:'8.h3?!', 16:'8...a5', 17:'9.a4?!', 18:'9...dxe5', 19:'10.dxe5', 20:'10...Na6', 21:'11.O-O', 22:'11...Nc5',
23:'12.Qe2', 24:'12...Qe8!', 25:'13.Ne4', 26:'13...Nbxa4', 27:'14.Bxa4', 28:'14...Nxa4', 29:'15.Re1', 30:'15...Nb6', 31:'16.Bd2', 32:'16...a4',
33:'17.Bg5', 34:'17...h6', 35:'18.Bh4', 36:'18...Bf5', 37:'19.g4?! 19.Nd4 B×e4 20.Q×e4 (Smyslov) 20...c5 (Timman) 21.Nf3 (Kasparov) is less weakening.', 38:'19...Be6', 39:'20.Nd4', 40:'20...Bc4', 41:'21.Qd2', 42:'21...Qd7!? 21...B×e5 is also perfectly playable, e.g., 22.Nc5 B×d4 23.Q×d4 g5 24.Bg3 Rd8 25.Qe4 Qb5 (Kasparov).',
43:'22.Rad1', 44:'22...Rfe8? 22...B×e5 23.Q×h6 Bg7 opens more lines for Black.', 45:'23.f4', 46:'23...Bd5', 47:'24.Nc5', 48:'24...Qc8', 49:'25.Qc3? 25.e6!, to meet 25...Nc4 26.Qe2 N×b2 with the shot 27.Nf5!! (Smyslov), is much more dangerous and should be anticipated by 25.e6! a3 (Prins) 26.b×a3 R×a3 27.Qh2, with sharp play (Kasparov).', 50:'25...e6', 51:'26.Kh2', 52:'26...Nd7?! 26...c6 27.Ne4 B×e4 28.R×e4 Nd5 29.Qd2 b5 (Kasparov) is more precise.',
53:'27.Nd3? 27.N×d7 Q×d7 28.Qd3 offered better counterchances as 28...b6? can be met by 29.N×e6 (Kasparov).', 54:'27...c5', 55:'28.Nb5', 56:'28...Qc6', 57:'29.Nd6', 58:'29...Qxd6!', 59:'30.exd6', 60:'30...Bxc3', 61:'31.bxc3', 62:'31...f6',
63:'32.g5', 64:'32...hxg5 32...c4 33.Nb4 h×g5 34.f×g5 f5-+ (Smyslov) is the alternative.', 65:'33.fxg5', 66:'33...f5', 67:'34.Bg3', 68:'34...Kf7 34...a3!?', 69:'35.Ne5+', 70:'35...Nxe5', 71:'36.Bxe5', 72:'36...b5?! Fischer underestimates White’s counterattack. After the prophylactic 36...Red8 37.Rf1 Ke8-+, his play on the queenside comes first.',
73:'37.Rf1', 74:'37...Rh8', 75:'38.Bf6', 76:'38...a3', 77:'39.Rf4', 78:'39...a2', 79:'40.c4', 80:'40...Bxc4', 81:'41.d7 It was good that Spassky did not seal this move to force Fischer to make the next difficult decision over the board.', 82:'41...Bd5? 41...e5 42.B×e5 Rhd8 43.Bf6 Be2 44.Re1 R×d7 45.R×e2 a1Q 46.B×a1 R×a1 47.Rh4 Kg7-+ (Kasparov).',
83:'42.Kg3! The sealed move, to enable Rh4.', 84:'42...Ra3+ 42...e5 43.B×e5 Ke6 44.B×h8 R×h8 (Geller). 45.Rff1 Rd8 46.Rfe1± (Kasparov).', 85:'43.c3', 86:'43...Rha8!! Fischer has calculated very deeply, determining that he gets winning chances after the following forced sequence; if 43...a1Q? 44.R×a1 R×a1 45.Rh4= (Smyslov).', 87:'44.Rh4', 88:'44...e5', 89:'45.Rh7+', 90:'45...Ke6', 91:'46.Re7+', 92:'46...Kd6',
93:'47.Rxe5', 94:'47...Rxc3+', 95:'48.Kf2', 96:'48...Rc2+', 97:'49.Ke1', 98:'49...Kxd7', 99:'50.Rexd5+', 100:'50...Kc6',
101:'51.Rd6+', 102:'51...Kb7', 103:'52.Rd7+', 104:'52...Ka6', 105:'53.R7d2', 106:'53...Rxd2', 107:'54.Kxd2', 108:'54...b4 A truly fascinating ending has arisen, which White can just hold by creating counterplay on the kingside. ', 109:'55.h4', 110:'55...Kb5',
111:'56.h5!', 112:'56...c4', 113:'57.Ra1', 114:'57...gxh5', 115:'58.g6', 116:'58...h4', 117:'59.g7!', 118:'59...h3', 119:'60.Be7', 120:'60...Rg8', 121:'61.Bf8! It is necessary to incarcerate the rook, as after 61.Bf6?, Black wins quickly: 61...h2 62.Kc2 Re8-+ (Kasparov).',
122:'61...h2', 123:'62.Kc2', 124:'62...Kc6', 125:'63.Rd1', 126:'63...b3+', 127:'64.Kc3', 128:'64...h1=Q!? Otherwise Black’s king cannot invade.', 129:'65.Rxh1', 130:'65...Kd5', 131:'66.Kb2',
132:'66...f4', 133:'67.Rd1+', 134:'67...Ke4', 135:'68.Rc1', 136:'68...Kd3', 137:'69.Rd1+? Spassky cracks under the pressure. The other check saves him: 69.Rc3+ Kd4 70.Rf3 c3+ 71.Ka1 c2 72.R×f4+ Kc3 73.Rf3+ Kd2 74.Ba3= (Gligoric).', 138:'69...Ke2', 139:'70.Rc1', 140:'70...f3', 141:'71.Bc5',
142:'71...Rxg7', 143:'72.Rxc4', 144:'72...Rd7', 145:'73.Re4+', 146:'73...Kf1', 147:'74.Bd4', 148:'74...f2 and Spassky resigned in view of 75.Rf4 R×d4 76.R×d4 Ke2 77.Re4+ Kf3-+.'
}
},
{
    id: 8,
      name: 'Fischer on Russian Cheating',
      description:
      '\nAfter the Curacao Candidates tournament of 1962, Fischer accused the Soviet players of cheating. Here is that article from the magazine Sports Illustrated:'+
      '\n\n'+
      '"The international Candidates\' Chess Tournament that ended June 28 in Curacao left me with one conviction: Russian control of chess has reached a point where there can be no honest competition for the world championship. The system set up by the Federation International des Echecs, the governing body of world chess, insures that there will always be a Russian world champion because only a Russian can win the preliminary tournament that determines his challenger. The Russians arranged it that way. As far as I am concerned, they can keep it that way. I will never again play in one of these tournaments.'+
      '\n\n'+

      '"I\'ve been told that is a hard decision to make, because it means giving up any hope of ever winning the title. The truth is that as long as the present system exists neither I nor anyone else from any Western country can win the title. So the decision isn\'t a hard one to make, but it is hard to explain. The reason why it is hard is that anything I say about Russian domination of this part of chess - or anything that any western player says - is bound to look like an alibi for not having beaten the Russians in the Curacao tournament. Any loser explaining why we can\'t win the world championship or arguing that the setup makes it impossible for us to compete with the Russians on equal terms seems to be suffering from sour grapes; it\'s said there is nothing in the Russian controlled international chess that a few victories by others wouldn\'t fix.'+
      '\n\n'+

      '"Well, I know better. And if these reasons sound like sour grapes, I hope a statement of the facts will change that impression. I began playing chess 11 years ago when I was 8 years old. In 1959 I qualified for the candidates tournament held that year in Yugoslavia. The winner would meet Botvinnik for the world championship. There were eight players in the tournament, four of whom were Russians. I finished in a tie for fifth place, right behind the four Russians. In the three years before the next Candidates\' Tournament rolled around, I played against the Russians at every opportunity I was offered. In these interim tournaments I defeated all the Russians I faced in Yugoslavia (and would face again at Curacao) or I came out ahead of them in tournaments in which we were entered - in Stockholm, for example, where I won the tournament by 2 1/2 points,  or in Bled Yugoslavia, where I beat the Russian entries 3 1/2 to 1/2. That is, I won three and drew one of my four games with the Russians in that tournament.'+
      '\n\n'+

      '"But between 1959 and 1962, the Russians dominance of the Candidates\' Tournament became much more open than it had been before. At Curacao it was flagrant. There was open collusion between the Russian players. They agreed ahead of time to draw the games they played against each other. Each time they drew they gave each other half a point. The tournament winner Petrosian got 5 1/2 points of his 17 1/2 total this way. They consulted during the games. If I was playing a Russian opponent, the other Russians watched my games and commented on my moves in my hearing. Then they ridiculed my protests to officials. They worked as a team.'+
      '\n\n'+

      '"The present trouble in international chess goes back to the end of the war. In March 1946 Alexander Alekhine, who had been the world champion, was found dead in Lisbon, and there was no clear-cut procedure for choosing his successor. In the old days, champions themselves decided whom they would play for the title and there was some unfairness about it, because a champion could refuse for years to play a strong challenger. Generally the trouble had something to do with money: if you couldn\'t put up enough money, you couldn\'t get a match. It may have been unjust at times, but at least it was logical. Now you can\'t get a match if you put up money or anything else.'+
      '\n\n'+

      '"The Russians have substituted propaganda for money as the incentive for holding onto the title, and the system they have worked out makes no sense whatever. I personally would be willing to play a match with Botvinnik at any time, letting him decide the minimum and maximum stakes we would play for, and the time and place. I would go so far as to spot him the advantage of two points in a match of 24 points. It isn\'t conceit that leads me to say that I could come out the victor with ease in such a competition: it is simply that Botvinnik has been world champion too long, his reign perpetuated by the system that selects his opponents, and he is no longer a chess master of championship caliber.'+
      '\n\n'+

      '"The tournament to pick Alekhine‘s successor was held in Moscow in 1948. There were five players, three of them Russian. Botvinnik won the tournament and became the new champion, but he did not win by a very big margin - certainly not enough to suggest that he and the other Russians outstripped all other competition thereafter, for all time. Botvinnik\'s margin would have been even less (possibly even nonexistent) except that another Russian, Paul Keres, lost all his games to him. So right at the start there was a question of whether the Russian numerical superiority in these Candidates\' tournaments might not be decisive. But there wasn\'t so much criticism at first.'+
      '\n\n'+

      '"By 1953, when I was beginning to play chess seriously, everybody was talking about the unfair way of selecting Botvinnik\'s opponents. And there were charges that the Russians were rigging international tournaments to keep the world championship in Russian hands. For example, the Chess Review wrote about the Candidates\' tournament of 1953: “There has been undeniable collusion by the Russians to freeze out western competition.” The main argument was this: nothing could prevent one of the Russian players\' winning the Candidates\' tournament if, at a critical stage: “it became expedient to throw collective support to the Russian candidate whose prospects had crystallize above those of his fellow Russians.” Nothing could prevent it because the Russian team could draw all their games with each other if they were in the lead, or throw their games to the strongest Russian contender if they were threatened by a player from another country. In an editorial  New York Times said that the system for picking the challenger for the world championship lead “to possible collusion between Soviet players to help one win a tourney, as against a non-Soviet opponent.”'+
      '\n\n'+

      '"That was nine years ago, when I was 10 years old, so I don\'t think I can be guilty of sour grapes in quoting it. In the intervening years Russian mastery of this system of keeping in the lead has grown more skillful. At Curacao there were five Russians out of the eight contenders. Michael Tal, however, the former world champion, had recently recovered From a kidney operation, became ill during the tournament and withdrew to enter a hospital, having no part in the general Soviet team effort thereafter. The other four Russians swam in the afternoon, dressed, came to the start of the games in the chess room at the Hotel Intercontinental, dawdled at the chessboards for half an hour or so, made a few quick moves, traded off as many pieces as possible and then offered a draw.'+
      '\n\n'+

      '"“Niche?” one would ask, “Niche,” his opponent would reply. They would sign their scorecards, go through the formalities of turning them into the officials and then have dinner or change their clothes and go back to the pool. We played four games a week. Two other days were given over to finishing adjourned games. I played on every day set aside for tournaments. In effect, I was playing at regular schedule of six days a week. But when the Russians drew with each other, they drew early, before the time of adjournment. They thus played only four days a week. In the weeks when all four Russians happen to be playing each other and drew all their games they really played only two days that week.'+
      '\n\n'+

      '"Geller and Petrosian drew their first game in 21 moves. They met again in the 10th round. That game lasted 18 moves. Their next game went only 16 moves. In their last meeting they drew in 18 moves.'+
      '\n\n'+

      '"Keres and Petrosian drew in 17 moves the first time they played each other, 21 moves the second, 22 moves the third and 14 moves the last time they met. In this last game they overdid it, and while they drew, Petrosian clearly would\'ve won if they had gone on.'+
      '\n\n'+

      '"As shown on page 19, (Editor: see the website: https://www.chessgames.com/perl/chessgame?gid=1072968) white\'s king is permanently trapped in the center of the board. White\'s queen wing is hopelessly weakened. As a matter fact, black wins in a few moves.  But when black had certainly won, and another move or so would make it obvious, they drew.'+
      '\n\n'+

      '"Or take Geller and Keres. They drew their first game in 27 moves, the next in 17, the third in 22 and the last game in 15 moves.'+
      '\n\n'+

      '"The record of Victor Korchnoi, the fourth member of the Soviet team, is more complex. In the first half of the tournament he, too, drew every game he played with the other Russians. At the midpoint of the tournament there was a five-day rest period; we all went to the the island of St. Martin. The four Russians were almost tied in points for first place, and the talk was that when they came back to start the second half, one of the four was certain to begin losing to the others. Whatever happened in the Russians\' consultation at St. Martin, Korchnoi\'s game certainly collapsed abruptly afterwards. He lost three games in quick succession, first to Geller, then to Petrosian and then to Keres. Then, in the last time around, he drew quickly with Geller, drew with Keres and lost again to Petrosian. Anyone could draw his own conclusions from this sequence of events but, in any event, it revealed the advantage the Russian team had over Western individual players.'+
      '\n\n'+

      'The Noisy Kibitzers'+
      '\n\n'+

      '"Sometimes, after their quick draws with each other, the Russians wouldn\'t go back to the swimming pool. They would openly analyze my game while I was still playing it. It is strictly against the rules for a player to discuss a game in progress, or even to speak with another player during a game—or, for that matter, with anyone. I studied Russian enough to be able to read their chess books, and I could easily understand what they were saying. They would say this move is good, or that move is good—in Russian, of course. My Russian isn\'t the greatest but, believe me, they weren\'t talking about the weather. If I was playing against a Russian, and one of these debates was going on right in front of us, my opponent might get up and join the discussion after he had made his move. Even if the advice they gave each other was bad—and too many chess cooks can spoil a game—it was annoying. It made me mad that they thought they could get away with it. I protested to the officials. I learned that they could get away with it. I complained a few more times, but their lead had increased to the point where they were unworried, and they then gradually stopped doing it.'+
      '\n\n'+

      '"Somebody asked me, "What did you learn at the tournament?" I said, "I learned not to play in any more of them." It is a waste of time for any Western player. The present arrangement for selecting a challenger for the championship is bad for chess, bad for the players taking part in it and bad for any real standard of the world championship. The general public long ago lost interest in any title gained in this fashion. Maybe chess players are losing interest in it also. I have, permanently."'+
      '\n\n'+'\n\n'+
'The following is a game that Fischer lost to Geller from that tournament:\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',
6:'rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R',
7:'rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R',
8:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R',
9:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
10:'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
11:'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R',
12:'rnbqkb1r/1p3ppp/p2p1n2/4p3/3NP3/2N5/PPP1BPPP/R1BQK2R',
13:'rnbqkb1r/1p3ppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R',
14:'rnbqk2r/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R',
15:'rnbqk2r/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQ1RK1',
16:'rnbq1rk1/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQ1RK1',
17:'rnbq1rk1/1p2bppp/p2p1n2/4p3/4P3/1NN1B3/PPP1BPPP/R2Q1RK1',
18:'rnb2rk1/1pq1bppp/p2p1n2/4p3/4P3/1NN1B3/PPP1BPPP/R2Q1RK1',
19:'rnb2rk1/1pq1bppp/p2p1n2/4p3/P3P3/1NN1B3/1PP1BPPP/R2Q1RK1',
20:'rn3rk1/1pq1bppp/p2pbn2/4p3/P3P3/1NN1B3/1PP1BPPP/R2Q1RK1',
21:'rn3rk1/1pq1bppp/p2pbn2/P3p3/4P3/1NN1B3/1PP1BPPP/R2Q1RK1',
22:'r4rk1/1pqnbppp/p2pbn2/P3p3/4P3/1NN1B3/1PP1BPPP/R2Q1RK1',
23:'r4rk1/1pqnbppp/p2pbn2/P2Np3/4P3/1N2B3/1PP1BPPP/R2Q1RK1',
24:'r4rk1/1pqnbppp/p2pb3/P2np3/4P3/1N2B3/1PP1BPPP/R2Q1RK1',
25:'r4rk1/1pqnbppp/p2pb3/P2Pp3/8/1N2B3/1PP1BPPP/R2Q1RK1',
26:'r4rk1/1pqnbppp/p2p4/P2Ppb2/8/1N2B3/1PP1BPPP/R2Q1RK1',
27:'r4rk1/1pqnbppp/p2p4/P2Ppb2/2P5/1N2B3/1P2BPPP/R2Q1RK1',
28:'r4rk1/1pqnbppp/p2p2b1/P2Pp3/2P5/1N2B3/1P2BPPP/R2Q1RK1',
29:'r4rk1/1pqnbppp/p2p2b1/P2Pp3/2P5/1N2B3/1P2BPPP/2RQ1RK1',
30:'r4rk1/1pq1bppp/p2p2b1/P1nPp3/2P5/1N2B3/1P2BPPP/2RQ1RK1',
31:'r4rk1/1pq1bppp/p2p2b1/P1NPp3/2P5/4B3/1P2BPPP/2RQ1RK1',
32:'r4rk1/1pq1bppp/p5b1/P1pPp3/2P5/4B3/1P2BPPP/2RQ1RK1',
33:'r4rk1/1pq1bppp/p5b1/P1pPp3/1PP5/4B3/4BPPP/2RQ1RK1',
34:'2r2rk1/1pq1bppp/p5b1/P1pPp3/1PP5/4B3/4BPPP/2RQ1RK1',
35:'2r2rk1/1pq1bppp/p5b1/P1pPp3/1PP5/1Q2B3/4BPPP/2R2RK1',
36:'2r2rk1/1pq2ppp/p2b2b1/P1pPp3/1PP5/1Q2B3/4BPPP/2R2RK1',
37:'2r2rk1/1pq2ppp/p2b2b1/P1pPp3/1PP5/1Q2B3/4BPPP/2RR2K1',
38:'2r2rk1/1p2qppp/p2b2b1/P1pPp3/1PP5/1Q2B3/4BPPP/2RR2K1',
39:'2r2rk1/1p2qppp/p2b2b1/P1PPp3/2P5/1Q2B3/4BPPP/2RR2K1',
40:'2r2rk1/1p2qppp/p5b1/P1bPp3/2P5/1Q2B3/4BPPP/2RR2K1',
41:'2r2rk1/1p2qppp/p5b1/P1BPp3/2P5/1Q6/4BPPP/2RR2K1',
42:'5rk1/1p2qppp/p5b1/P1rPp3/2P5/1Q6/4BPPP/2RR2K1',
43:'5rk1/1p2qppp/p5b1/P1rPp3/2P5/1Q6/4BPPP/R2R2K1',
44:'3r2k1/1p2qppp/p5b1/P1rPp3/2P5/1Q6/4BPPP/R2R2K1',
45:'3r2k1/1p2qppp/p5b1/P1rPp3/R1P5/1Q6/4BPPP/3R2K1',
46:'3r2k1/1p2qppp/p7/P1rPpb2/R1P5/1Q6/4BPPP/3R2K1',
47:'3r2k1/1p2qppp/p7/P1rPpb2/1RP5/1Q6/4BPPP/3R2K1',
48:'2br2k1/1p2qppp/p7/P1rPp3/1RP5/1Q6/4BPPP/3R2K1',
49:'2br2k1/1p2qppp/pR6/P1rPp3/2P5/1Q6/4BPPP/3R2K1',
50:'2b3k1/1p2qppp/pR1r4/P1rPp3/2P5/1Q6/4BPPP/3R2K1',
51:'2b3k1/1p2qppp/pR1r4/P1rPp3/1QP5/8/4BPPP/3R2K1',
52:'2b3k1/1pq2ppp/pR1r4/P1rPp3/1QP5/8/4BPPP/3R2K1',
53:'2b3k1/1pq2ppp/p2R4/P1rPp3/1QP5/8/4BPPP/3R2K1',
54:'2b3k1/1p3ppp/p2q4/P1rPp3/1QP5/8/4BPPP/3R2K1',
55:'2b3k1/1p3ppp/p2q4/P1rPp3/1QP5/8/4BPPP/1R4K1',
56:'2b3k1/1pq2ppp/p7/P1rPp3/1QP5/8/4BPPP/1R4K1',
57:'2b3k1/1pq2ppp/p7/P1rPp3/Q1P5/8/4BPPP/1R4K1',
58:'6k1/1pqb1ppp/p7/P1rPp3/Q1P5/8/4BPPP/1R4K1',
59:'6k1/1pqb1ppp/p7/P1rPp3/2P5/Q7/4BPPP/1R4K1',
60:'6k1/1pqb1ppp/p7/r2Pp3/2P5/Q7/4BPPP/1R4K1',
61:'6k1/1Rqb1ppp/p7/r2Pp3/2P5/Q7/4BPPP/6K1',
62:'6k1/1q1b1ppp/p7/r2Pp3/2P5/Q7/4BPPP/6K1',
63:'6k1/1q1b1ppp/p7/Q2Pp3/2P5/8/4BPPP/6K1',
64:'6k1/1q1b1p1p/p5p1/Q2Pp3/2P5/8/4BPPP/6K1',
65:'6k1/1q1b1p1p/p5p1/Q2Pp3/2P5/7P/4BPP1/6K1',
66:'6k1/3b1p1p/p5p1/Q2Pp3/2P5/7P/4BPP1/1q4K1',
67:'6k1/3b1p1p/p5p1/Q2Pp3/2P5/7P/4BPPK/1q6',
68:'6k1/5p1p/p5p1/Q2Ppb2/2P5/7P/4BPPK/1q6',
69:'6k1/5p1p/p5p1/3Ppb2/2P5/2Q4P/4BPPK/1q6',
70:'6k1/5p1p/p5p1/3Ppb2/2P1q3/2Q4P/4BPPK/8',
71:'6k1/5p1p/p5p1/3Ppb2/2P1q3/2Q2B1P/5PPK/8',
72:'6k1/5p1p/p5p1/3Ppb2/2Pq4/2Q2B1P/5PPK/8',
73:'6k1/5p1p/p5p1/3Ppb2/2PQ4/5B1P/5PPK/8',
74:'6k1/5p1p/p5p1/3P1b2/2Pp4/5B1P/5PPK/8',
75:'6k1/5p1p/p5p1/3P1b2/2Pp2P1/5B1P/5P1K/8',
76:'2b3k1/5p1p/p5p1/3P4/2Pp2P1/5B1P/5P1K/8',
77:'2b3k1/5p1p/p5p1/2PP4/3p2P1/5B1P/5P1K/8',
78:'2b3k1/5p1p/6p1/p1PP4/3p2P1/5B1P/5P1K/8',
79:'2b3k1/5p1p/2P3p1/p2P4/3p2P1/5B1P/5P1K/8',
80:'2b2k2/5p1p/2P3p1/p2P4/3p2P1/5B1P/5P1K/8',
},
comments:{
0:'Efim Geller – Bobby Fischer, Curacao Candidates 1962, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...c5', 3:'2.Nf3', 4:'2...d6', 5:'3.d4', 6:'3...cxd4', 7:'4.Nxd4', 8:'4...Nf6', 9:'5.Nc3', 10:'5...a6', 11:'6.Be2', 12:'6...e5',
13:'7.Nb3', 14:'7...Be7', 15:'8.O-O', 16:'8...O-O', 17:'9.Be3', 18:'9...Qc7', 19:'10.a4', 20:'10...Be6', 21:'11.a5', 22:'11...Nbd7',
23:'12.Nd5', 24:'12...Nxd5?! 12...B×d5 13.e×d5 b5 is the main line.', 25:'13.exd5', 26:'13...Bf5', 27:'14.c4', 28:'14...Bg6', 29:'15.Rc1', 30:'15...Nc5?!', 31:'16.Nxc5', 32:'16...dxc5',
33:'17.b4! Geller shatters the blockade.', 34:'17...Rac8 17...c×b4 18.Bb6 Qd7 19.Qb3 with a large advantage.', 35:'18.Qb3', 36:'18...Bd6 18...c×b4 19.Bb6 Qd7 20.c5 e4 21.Rfd1 with a large advantage', 37:'19.Rfd1', 38:'19...Qe7', 39:'20.bxc5', 40:'20...Bxc5', 41:'21.Bxc5',
42:'21...Rxc5', 43:'22.Ra1', 44:'22...Rd8', 45:'23.Ra4', 46:'23...Bf5', 47:'24.Rb4', 48:'24...Bc8', 49:'25.Rb6', 50:'25...Rd6 25...R×a5 26.d6 Qe8 27.Qc3 with a large advantage.', 51:'26.Qb4', 52:'26...Qc7', 53:'27.Rxd6', 54:'27...Qxd6', 55:'28.Rb1', 56: '28...Qc7?!', 57:'29.Qa4', 58:'29...Bd7', 59:'30.Qa3', 60:'30...Rxa5',
61:'31.Rxb7', 62:'31...Qxb7? The defense 31...R×a3 32.R×c7 Ra1+ 33.Bf1 Bf5 34.f3 h5 is more difficult to break down.', 63:'32.Qxa5', 64:'32...g6', 65:'33.h3', 66:'33...Qb1+', 67:'34.Kh2? 34.Bf1 wins.', 68:'34...Bf5? Pseudo-active. After 34...Qc2, Black draws: 35.Qd8+ Kg7 36.Q×d7 Q×e2 37.Qd6 a5 38.Qc5 Qd2 39.d6 Kf6=.', 69:'35.Qc3', 70:'35...Qe4',
71:'36.Bf3', 72:'36...Qd4', 73:'37.Qxd4', 74:'37...exd4', 75:'38.g4', 76:'38...Bc8', 77:'39.c5', 78:'39...a5', 79:'40.c6', 80:'40...Kf8 1-0',
}
},
{
    id: 9,
      name: 'Timman on Fischer',
      description:
'\nJan Timman in his book Timman’s Titans (p. 230)' +
'\n\n' +
'Seven years after Fischer’s death, Ljubomir Ljubojevic told me an interesting story. During the second Fischer-Spassky match in 1992, Quinteros stayed with a woman friend in a luxury hotel in Belgrade; not as Fischer’s second, but just as a friend. Quinteros was in the habit of conducting long intercontinental telephone conversations from his hotel room, and he probably also drank many a good wine. After more than two months, the bill amounted to 327,000 dollars. Fischer paid the sum without blinking an eye.'+
'\n\n' +
'How many remember the gem Guimard–Fischer, Buenos Aires 1960? The tournament was arguably the worst of Bobby’s career, but did produce one magnificent moment against the Argentine grandmaster. '+
'\n\n'+
'Here\'s how Timman describes the move 25...Rc6!!'+
'\n\n'+
'"The fantastic point of Black\'s play. He allows the white rook to take one more time, because after the capture on c2, he will win back all the material with interest."\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
2:'rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR',
3:'rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R',
4:'rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R',
5:'rnbqkb1r/pppppp1p/5np1/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R',
6:'rnbqk2r/ppppppbp/5np1/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R',
7:'rnbqk2r/ppppppbp/5np1/6B1/3P4/5N2/PPPNPPPP/R2QKB1R',
8:'rnbqk2r/ppp1ppbp/3p1np1/6B1/3P4/5N2/PPPNPPPP/R2QKB1R',
9:'rnbqk2r/ppp1ppbp/3p1np1/6B1/3PP3/5N2/PPPN1PPP/R2QKB1R',
10:'rnbqk2r/ppp1ppb1/3p1npp/6B1/3PP3/5N2/PPPN1PPP/R2QKB1R',
11:'rnbqk2r/ppp1ppb1/3p1Bpp/8/3PP3/5N2/PPPN1PPP/R2QKB1R',
12:'rnbqk2r/ppp1pp2/3p1bpp/8/3PP3/5N2/PPPN1PPP/R2QKB1R',
13:'rnbqk2r/ppp1pp2/3p1bpp/1B6/3PP3/5N2/PPPN1PPP/R2QK2R',
14:'rnbqk2r/pp2pp2/2pp1bpp/1B6/3PP3/5N2/PPPN1PPP/R2QK2R',
15:'rnbqk2r/pp2pp2/2pp1bpp/8/3PP3/3B1N2/PPPN1PPP/R2QK2R',
16:'rnbq1rk1/pp2pp2/2pp1bpp/8/3PP3/3B1N2/PPPN1PPP/R2QK2R',
17:'rnbq1rk1/pp2pp2/2pp1bpp/4P3/3P4/3B1N2/PPPN1PPP/R2QK2R',
18:'rnbq1rk1/pp2ppb1/2pp2pp/4P3/3P4/3B1N2/PPPN1PPP/R2QK2R',
19:'rnbq1rk1/pp2ppb1/2pp2pp/4P3/3P4/3B1N2/PPPNQPPP/R3K2R',
20:'rnbq1rk1/pp2ppb1/3p2pp/2p1P3/3P4/3B1N2/PPPNQPPP/R3K2R',
21:'rnbq1rk1/pp2ppb1/3p2pp/2p1P3/3P3P/3B1N2/PPPNQPP1/R3K2R',
22:'rnbq1rk1/pp2ppb1/3p2pp/4P3/3p3P/3B1N2/PPPNQPP1/R3K2R',
23:'rnbq1rk1/pp2ppb1/3p2pp/4P2P/3p4/3B1N2/PPPNQPP1/R3K2R',
24:'rnbq1rk1/pp2ppb1/3p3p/4P1pP/3p4/3B1N2/PPPNQPP1/R3K2R',
25:'rnbq1rk1/pp2ppb1/3p3p/4P1pP/3pQ3/3B1N2/PPPN1PP1/R3K2R',
26:'rnbq1rk1/pp2p1b1/3p3p/4PppP/3pQ3/3B1N2/PPPN1PP1/R3K2R',
27:'rnbq1rk1/pp2p1b1/3p1P1p/6pP/3pQ3/3B1N2/PPPN1PP1/R3K2R',
28:'rnbq2k1/pp2p1b1/3p1r1p/6pP/3pQ3/3B1N2/PPPN1PP1/R3K2R',
29:'rnbq2k1/pp2p1b1/3p1r1p/6NP/3pQ3/3B4/PPPN1PP1/R3K2R',
30:'rnbq2k1/pp2p1b1/5r1p/3p2NP/3pQ3/3B4/PPPN1PP1/R3K2R',
31:'rnbq2k1/pp2p1bQ/5r1p/3p2NP/3p4/3B4/PPPN1PP1/R3K2R',
32:'rnbq1k2/pp2p1bQ/5r1p/3p2NP/3p4/3B4/PPPN1PP1/R3K2R',
33:'rnbq1k2/pp2p1bQ/5r1p/3p2NP/3p4/3B4/PPPN1PP1/2KR3R',
34:'r1bq1k2/pp2p1bQ/2n2r1p/3p2NP/3p4/3B4/PPPN1PP1/2KR3R',
35:'r1bq1k2/pp2p1bQ/2n2r1p/3p2NP/3p1P2/3B4/PPPN2P1/2KR3R',
36:'r1bq1k2/pp2p1bQ/5r1p/3p2NP/1n1p1P2/3B4/PPPN2P1/2KR3R',
37:'r1bq1k2/pp2p1bQ/5r1p/3p2NP/1n1p1P2/P2B4/1PPN2P1/2KR3R',
38:'r1bq1k2/pp2p1bQ/5r1p/3p2NP/3p1P2/P2n4/1PPN2P1/2KR3R',
39:'r1bq1k2/pp2p1b1/5r1p/3p2NP/3p1P2/P2Q4/1PPN2P1/2KR3R',
40:'r1bq1k2/pp2p1b1/5r2/3p2pP/3p1P2/P2Q4/1PPN2P1/2KR3R',
41:'r1bq1k2/pp2p1b1/5r1P/3p2p1/3p1P2/P2Q4/1PPN2P1/2KR3R',
42:'r1bq1k2/pp2p3/5r1b/3p2p1/3p1P2/P2Q4/1PPN2P1/2KR3R',
43:'r1bq1k2/pp2p3/5r1b/3p2P1/3p4/P2Q4/1PPN2P1/2KR3R',
44:'r2q1k2/pp2p3/5r1b/3p1bP1/3p4/P2Q4/1PPN2P1/2KR3R',
45:'r2q1k2/pp2p3/5r1R/3p1bP1/3p4/P2Q4/1PPN2P1/2KR4',
46:'r2q1k2/pp2p3/5r1R/3p2P1/3p4/P2b4/1PPN2P1/2KR4',
47:'r2q1k1R/pp2p3/5r2/3p2P1/3p4/P2b4/1PPN2P1/2KR4',
48:'r2q3R/pp2p1k1/5r2/3p2P1/3p4/P2b4/1PPN2P1/2KR4',
49:'r2R4/pp2p1k1/5r2/3p2P1/3p4/P2b4/1PPN2P1/2KR4',
50:'r2R4/pp2p1k1/2r5/3p2P1/3p4/P2b4/1PPN2P1/2KR4',
51:'R7/pp2p1k1/2r5/3p2P1/3p4/P2b4/1PPN2P1/2KR4',
52:'R7/pp2p1k1/8/3p2P1/3p4/P2b4/1PrN2P1/2KR4',
53:'R7/pp2p1k1/8/3p2P1/3p4/P2b4/1PrN2P1/1K1R4',
54:'R7/pp2p1k1/8/3p2P1/3p4/P2b4/1P1r2P1/1K1R4',
55:'R7/pp2p1k1/8/3p2P1/3p4/P2b4/1P1r2P1/2KR4',
56:'R7/pp2p1k1/8/3p2P1/3p4/P2b4/1Pr3P1/2KR4',
57:'R7/pp2p1k1/8/3p2P1/3p4/P2b4/1Pr3P1/1K1R4',
58:'R1r5/pp2p1k1/8/3p2P1/3p4/P2b4/1P4P1/1K1R4',
59:'R1r5/pp2p1k1/8/3p2P1/3p4/P2R4/1P4P1/1K6',
60:'r7/pp2p1k1/8/3p2P1/3p4/P2R4/1P4P1/1K6',
61:'r7/pp2p1k1/8/3p2P1/3R4/P7/1P4P1/1K6',
62:'3r4/pp2p1k1/8/3p2P1/3R4/P7/1P4P1/1K6',
63:'3r4/pp2p1k1/8/3p2P1/3R4/P7/1PK3P1/8',
64:'3r4/pp2p3/6k1/3p2P1/3R4/P7/1PK3P1/8',
65:'3r4/pp2p3/6k1/3p2P1/5R2/P7/1PK3P1/8',
66:'3r4/pp2p3/8/3p2k1/5R2/P7/1PK3P1/8',
67:'3r4/pp2pR2/8/3p2k1/8/P7/1PK3P1/8',
68:'8/pp1rpR2/8/3p2k1/8/P7/1PK3P1/8',
69:'8/pp1rpR2/8/3p2k1/8/P2K4/1P4P1/8',
70:'8/pp1rpR2/6k1/3p4/8/P2K4/1P4P1/8',
71:'5R2/pp1rp3/6k1/3p4/8/P2K4/1P4P1/8',
72:'5R2/pp1rp1k1/8/3p4/8/P2K4/1P4P1/8',
73:'R7/pp1rp1k1/8/3p4/8/P2K4/1P4P1/8',
74:'R7/p2rp1k1/1p6/3p4/8/P2K4/1P4P1/8',
75:'R7/p2rp1k1/1p6/3p4/3K4/P7/1P4P1/8',
76:'R7/p2rp3/1p3k2/3p4/3K4/P7/1P4P1/8',
77:'5R2/p2rp3/1p3k2/3p4/3K4/P7/1P4P1/8',
78:'5R2/p2rp3/1p2k3/3p4/3K4/P7/1P4P1/8',
79:'6R1/p2rp3/1p2k3/3p4/3K4/P7/1P4P1/8',
80:'6R1/p2rp3/1p1k4/3p4/3K4/P7/1P4P1/8',
81:'6R1/p2rp3/1p1k4/3p4/3K2P1/P7/1P6/8',
82:'6R1/p2r4/1p1k4/3pp3/3K2P1/P7/1P6/8',
83:'6R1/p2r4/1p1k4/3pp3/6P1/P2K4/1P6/8',
84:'6R1/p6r/1p1k4/3pp3/6P1/P2K4/1P6/8',
85:'6R1/p6r/1p1k4/3pp1P1/8/P2K4/1P6/8',
86:'6R1/p6r/1p2k3/3pp1P1/8/P2K4/1P6/8',
87:'6R1/p6r/1p2k1P1/3pp3/8/P2K4/1P6/8',
88:'6R1/p7/1p2k1P1/3pp3/8/P2K3r/1P6/8',
89:'6R1/p7/1p2k1P1/3pp3/8/P6r/1PK5/8',
90:'6R1/p7/1p2k1P1/3pp3/8/P7/1PK4r/8',
91:'6R1/p7/1p2k1P1/3pp3/8/PK6/1P5r/8',
92:'6R1/p7/1p2k1P1/3pp3/8/PK6/1P4r1/8',
93:'6R1/p5P1/1p2k3/3pp3/8/PK6/1P4r1/8',
94:'6R1/p5P1/1p3k2/3pp3/8/PK6/1P4r1/8',
95:'3R4/p5P1/1p3k2/3pp3/8/PK6/1P4r1/8',
96:'3R4/p5r1/1p3k2/3pp3/8/PK6/1P6/8',
97:'8/p5r1/1p3k2/3Rp3/8/PK6/1P6/8',
98:'8/p1r5/1p3k2/3Rp3/8/PK6/1P6/8',
99:'8/p1r5/1p3k2/3Rp3/P7/1K6/1P6/8',
100:'8/p1r5/1p3k2/3R4/P3p3/1K6/1P6/8',
101:'8/p1r5/1p3k2/7R/P3p3/1K6/1P6/8',
102:'8/p1r5/1p3k2/7R/P7/1K2p3/1P6/8',
103:'8/p1r5/1p3k2/8/P7/1K2p2R/1P6/8',
104:'8/p3r3/1p3k2/8/P7/1K2p2R/1P6/8',
105:'8/p3r3/1p3k2/8/P7/1K2p3/1P6/7R',
106:'8/p3r3/1p3k2/8/P7/1K6/1P2p3/7R',
107:'8/p3r3/1p3k2/8/P7/1K6/1P2p3/4R3',
108:'8/p3r3/1p6/5k2/P7/1K6/1P2p3/4R3',
109:'8/p3r3/1p6/5k2/P7/2K5/1P2p3/4R3',
110:'8/p3r3/1p6/8/P4k2/2K5/1P2p3/4R3',
111:'8/p3r3/1p6/8/P4k2/8/1P1Kp3/4R3',
112:'8/p3r3/1p6/8/P7/5k2/1P1Kp3/4R3',
113:'8/p3r3/1p6/8/P7/5k2/1P1Kp3/7R',
114:'8/p2r4/1p6/8/P7/5k2/1P1Kp3/7R',
115:'8/p2r4/1p6/8/P7/5k2/1PK1p3/7R',
116:'8/p2r4/1p6/8/P7/8/1PK1p1k1/7R',
},
comments:{
0:'Carlos Guimard – Bobby Fischer, Argentina 1959, Annotations by GM Karsten Mueller.',
1:'1.d4', 2:'1...Nf6', 3:'2.Nf3', 4:'2...g6', 5:'3.Bg5', 6:'3...Bg7', 7:'4.Nbd2', 8:'4...d6', 9:'5.e4', 10:'5...h6', 11:'6.Bxf6',
12:'6...Bxf6', 13:'7.Bb5+', 14:'7...c6', 15:'8.Bd3', 16:'8...O-O', 17:'9.e5', 18:'9...Bg7', 19:'10.Qe2', 20:'10...c5', 21:'11.h4', 22:'11...cxd4',
23:'12.h5', 24:'12...g5', 25:'13.Qe4', 26:'13...f5', 27:'14.exf6', 28:'14...Rxf6', 29:'15.Nxg5!', 30:'15...d5! 15...h×g5? 16.Qh7+ Kf7 17.Bg6+ +-', 31:'16.Qh7+', 32:'16...Kf8',
33:'17.O-O-O', 34:'17...Nc6', 35:'18.f4', 36:'18...Nb4', 37:'19.a3', 38:'19...Nxd3+', 39:'20.Qxd3', 40:'20...hxg5', 41:'21.h6',
42:'21...Bxh6?! Very bold and risky; 21...R×h6 22.R×h6 B×h6 23.Qh7 Qb6 24.f×g5 B×g5 25.Qh8+ Kf7 26.Qh7+=.', 43:'22.fxg5', 44:'22...Bf5', 45:'23.Rxh6? A miscalculation. 23.Q×d4 Rc8 24.c3 R×c3+ 25.b×c3 Qd6 26.Qb4 Q×b4 27.a×b4 B×g5 is more or less forced. White is not worse.', 46:'23...Bxd3', 47:'24.Rh8+', 48:'24...Kg7? 24...Kf7! 25.R×d8 R×d8 26.g×f6 Rc8-+', 49:'25.Rxd8', 50:'25...Rc6',
51:'26.Rxa8', 52:'26...Rxc2+', 53:'27.Kb1', 54:'27...Rxd2+?! It is probably better to keep the minor pieces on the board with 27...Rc8+ 28.Ka2 R×a8 29.Nf3 Be4 30.N×d4 Kg6, as rook and bishop usually cooperate well.', 55:'28.Kc1', 56:'28...Rc2+', 57:'29.Kb1', 58:'29...Rc8+',
59:'30.Rxd3', 60:'30...Rxa8', 61:'31.Rxd4', 62:'31...Rd8', 63:'32.Kc2? Now it is very difficult to deal with Black’s strong connected passed pawns. 32.Ra4 a6 33.Rb4 b5 34.Rh4 Rh8 35.Rd4 e6 36.Rd3 is called for.', 64:'32...Kg6', 65:'33.Rf4', 66:'33...Kxg5', 67:'34.Rf7',
68:'34...Rd7', 69:'35.Kd3', 70:'35...Kg6', 71:'36.Rf8', 72:'36...Kg7', 73:'37.Ra8', 74:'37...b6', 75:'38.Kd4', 76:'38...Kf6', 77:'39.Rf8+',
78:'39...Ke6', 79:'40.Rg8', 80:'40...Kd6', 81:'41.g4', 82:'41...e5+', 83:'42.Kd3', 84:'42...Rh7', 85:'43.g5', 86: '43...Ke6', 87:'44.g6', 88:'44...Rh3+',
89:'45.Kc2', 90:'45...Rh2+? 45...Rg3 46.g7 Kf7 47.Ra8 K×g7 48.R×a7+ Kf6 is necessary.', 91:'46.Kb3? 46.Kd1 is the last chance to offer resistance, as White gets one of Black’s center pawns. ', 92:'46...Rg2', 93:'47.g7', 94:'47...Kf6', 95:'48.Rd8', 96:'48...Rxg7', 97:'49.Rxd5', 98:'49...Rc7',
99:'50.a4', 100:'50...e4', 101:'51.Rh5', 102:'51...e3', 103:'52.Rh3', 104:'52...Re7', 105:'53.Rh1', 106:'53...e2', 107:'54.Re1', 108:'54...Kf5',
109:'55.Kc3', 110:'55...Kf4', 111:'56.Kd2', 112:'56...Kf3', 113:'57.Rh1', 114:'57...Rd7+', 115:'58.Kc2', 116:'58...Kg2 White Resigns',
}
},
{
    id: 10,
      name: 'Fischer Interview 1970',
      description:
'\nThis interview was conducted during the USSR versus Rest of the World match in 1970.' +
'\n\n' +
'What is chess for you? What attracts you to this game more than anything else?' +
'\n\n' +
'Bobby Fischer: The thing that attracts me the most in chess is the ability to travel, money, and chess atmosphere. I can earn money with chess more easily than with any other occupation. Chess is indisputably an art, but I haven\'t been thinking much about that. I love chess very much, but I\'m interested in many other things as well - music, sports, politics. Chess professionals can live a full life. In chess, I\'ve achieved things I would never have achieved in any other area. I quit school, and I\'m not sure if I needed the education. I haven\'t been playing in tournaments for some time, but I earn a living with chess. I got $10,000 for Bobby Fischer Teaches Chess, and about a half of that sum for My 60 Memorable Games. I also earn $300 a month writing chess columns for a youth magazine. There are rumours spread about me, for instance, that I use ghostwriters, demand a fee for interviews, hate photo reporters, set unacceptable terms. They are wrong. I\'m working constantly, I\'m trying to be amicable, I\'m not doing everything for money, but I earn my living with chess...' +
'\n\n' +
'What\'s your evaluation of sporting and creative results of this match?' +
'\n\n' +
'Bobby Fischer: The Belgrade match is truly a match of the century. I was attracted by the idea of playing in this event. The organization was very good, I\'m completely satisfied. In America, we don\'t have such great organizers devoted to chess as in Yugoslavia. The result of the match is good for the Rest of the World team. I think if there are more boards, the world team might even have winning chances. I haven\'t looked through all other games yet. I\'m happy with my first two games; in the third one, I played poorly in the opening, but Petrosian, despite a better position, had no clear win. I\'m going to return to tournament practice, even though I know that many are against me. I hope to become a world champion soon, because this match made me sure that I was again stronger than everyone. I ceded the first board to Larsen myself because I saw that the team was demoralized; I also thought that it would be easier for me to face Petrosian.' +
'\n\n' +
'What\'s your opinion on the current world championship system?' +
'\n\n' +
'The Candidates\' Match system doesn\'t bother me, but the matches themselves should be longer - for instance, for six wins, draws not counting. I\'m not afraid of anyone in a match. We have to hold World Championship matches every other year. Larsen and Korchnoi have the best chances of reaching Spassky in the current cycle. Of course, I would like to see a Fischer - Spassky match, but...\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR',
4:'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR',
5:'rnbqkbnr/pp2pppp/2p5/3P4/3P4/8/PPP2PPP/RNBQKBNR',
6:'rnbqkbnr/pp2pppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR',
7:'rnbqkbnr/pp2pppp/8/3p4/3P4/3B4/PPP2PPP/RNBQK1NR',
8:'r1bqkbnr/pp2pppp/2n5/3p4/3P4/3B4/PPP2PPP/RNBQK1NR',
9:'r1bqkbnr/pp2pppp/2n5/3p4/3P4/2PB4/PP3PPP/RNBQK1NR',
10:'r1bqkb1r/pp2pppp/2n2n2/3p4/3P4/2PB4/PP3PPP/RNBQK1NR',
11:'r1bqkb1r/pp2pppp/2n2n2/3p4/3P1B2/2PB4/PP3PPP/RN1QK1NR',
12:'r2qkb1r/pp2pppp/2n2n2/3p4/3P1Bb1/2PB4/PP3PPP/RN1QK1NR',
13:'r2qkb1r/pp2pppp/2n2n2/3p4/3P1Bb1/1QPB4/PP3PPP/RN2K1NR',
14:'r2qkb1r/pp2pppp/5n2/n2p4/3P1Bb1/1QPB4/PP3PPP/RN2K1NR',
15:'r2qkb1r/pp2pppp/5n2/n2p4/Q2P1Bb1/2PB4/PP3PPP/RN2K1NR',
16:'r2qkb1r/pp1bpppp/5n2/n2p4/Q2P1B2/2PB4/PP3PPP/RN2K1NR',
17:'r2qkb1r/pp1bpppp/5n2/n2p4/3P1B2/2PB4/PPQ2PPP/RN2K1NR',
18:'r2qkb1r/pp1b1ppp/4pn2/n2p4/3P1B2/2PB4/PPQ2PPP/RN2K1NR',
19:'r2qkb1r/pp1b1ppp/4pn2/n2p4/3P1B2/2PB1N2/PPQ2PPP/RN2K2R',
20:'r3kb1r/pp1b1ppp/1q2pn2/n2p4/3P1B2/2PB1N2/PPQ2PPP/RN2K2R',
21:'r3kb1r/pp1b1ppp/1q2pn2/n2p4/P2P1B2/2PB1N2/1PQ2PPP/RN2K2R',
22:'2r1kb1r/pp1b1ppp/1q2pn2/n2p4/P2P1B2/2PB1N2/1PQ2PPP/RN2K2R',
23:'2r1kb1r/pp1b1ppp/1q2pn2/n2p4/P2P1B2/2PB1N2/1PQN1PPP/R3K2R',
24:'2r1kb1r/pp1b1ppp/1qn1pn2/3p4/P2P1B2/2PB1N2/1PQN1PPP/R3K2R',
25:'2r1kb1r/pp1b1ppp/1qn1pn2/3p4/P2P1B2/2PB1N2/1P1N1PPP/RQ2K2R',
26:'2r1kb1r/pp1b1ppp/1qn1p3/3p3n/P2P1B2/2PB1N2/1P1N1PPP/RQ2K2R',
27:'2r1kb1r/pp1b1ppp/1qn1p3/3p3n/P2P4/2PBBN2/1P1N1PPP/RQ2K2R',
28:'2r1kb1r/pp1b1pp1/1qn1p2p/3p3n/P2P4/2PBBN2/1P1N1PPP/RQ2K2R',
29:'2r1kb1r/pp1b1pp1/1qn1p2p/3pN2n/P2P4/2PBB3/1P1N1PPP/RQ2K2R',
30:'2r1kb1r/pp1b1pp1/1qn1pn1p/3pN3/P2P4/2PBB3/1P1N1PPP/RQ2K2R',
31:'2r1kb1r/pp1b1pp1/1qn1pn1p/3pN3/P2P4/2PBB2P/1P1N1PP1/RQ2K2R',
32:'2r1k2r/pp1b1pp1/1qnbpn1p/3pN3/P2P4/2PBB2P/1P1N1PP1/RQ2K2R',
33:'2r1k2r/pp1b1pp1/1qnbpn1p/3pN3/P2P4/2PBB2P/1P1N1PP1/RQ3RK1',
34:'2r2k1r/pp1b1pp1/1qnbpn1p/3pN3/P2P4/2PBB2P/1P1N1PP1/RQ3RK1',
35:'2r2k1r/pp1b1pp1/1qnbpn1p/3pN3/P2P1P2/2PBB2P/1P1N2P1/RQ3RK1',
36:'2r1bk1r/pp3pp1/1qnbpn1p/3pN3/P2P1P2/2PBB2P/1P1N2P1/RQ3RK1',
37:'2r1bk1r/pp3pp1/1qnbpn1p/3pN3/P2P1P2/2PB3P/1P1N1BP1/RQ3RK1',
38:'2r1bk1r/ppq2pp1/2nbpn1p/3pN3/P2P1P2/2PB3P/1P1N1BP1/RQ3RK1',
39:'2r1bk1r/ppq2pp1/2nbpn1p/3pN3/P2P1P1B/2PB3P/1P1N2P1/RQ3RK1',
40:'2r1bknr/ppq2pp1/2nbp2p/3pN3/P2P1P1B/2PB3P/1P1N2P1/RQ3RK1',
41:'2r1bknr/ppq2pp1/2nbp2p/3pNP2/P2P3B/2PB3P/1P1N2P1/RQ3RK1',
42:'2r1bknr/ppq2pp1/3bp2p/3pnP2/P2P3B/2PB3P/1P1N2P1/RQ3RK1',
43:'2r1bknr/ppq2pp1/3bp2p/3pPP2/P6B/2PB3P/1P1N2P1/RQ3RK1',
44:'2r1bknr/ppq2pp1/4p2p/3pbP2/P6B/2PB3P/1P1N2P1/RQ3RK1',
45:'2r1bknr/ppq2pp1/4P2p/3pb3/P6B/2PB3P/1P1N2P1/RQ3RK1',
46:'2r1bknr/ppq2pp1/4Pb1p/3p4/P6B/2PB3P/1P1N2P1/RQ3RK1',
47:'2r1bknr/ppq2Pp1/5b1p/3p4/P6B/2PB3P/1P1N2P1/RQ3RK1',
48:'2r2knr/ppq2bp1/5b1p/3p4/P6B/2PB3P/1P1N2P1/RQ3RK1',
49:'2r2knr/ppq2bp1/5b1p/3p4/P6B/2PB1N1P/1P4P1/RQ3RK1',
50:'2r2knr/ppq2bp1/7p/3p4/P6b/2PB1N1P/1P4P1/RQ3RK1',
51:'2r2knr/ppq2bp1/7p/3p4/P6N/2PB3P/1P4P1/RQ3RK1',
52:'2r2k1r/ppq2bp1/5n1p/3p4/P6N/2PB3P/1P4P1/RQ3RK1',
53:'2r2k1r/ppq2bp1/5nNp/3p4/P7/2PB3P/1P4P1/RQ3RK1',
54:'2r2k1r/ppq3p1/5nbp/3p4/P7/2PB3P/1P4P1/RQ3RK1',
55:'2r2k1r/ppq3p1/5nBp/3p4/P7/2P4P/1P4P1/RQ3RK1',
56:'2r4r/ppq1k1p1/5nBp/3p4/P7/2P4P/1P4P1/RQ3RK1',
57:'2r4r/ppq1k1p1/5nBp/3p1Q2/P7/2P4P/1P4P1/R4RK1',
58:'2rk3r/ppq3p1/5nBp/3p1Q2/P7/2P4P/1P4P1/R4RK1',
59:'2rk3r/ppq3p1/5nBp/3p1Q2/P7/2P4P/1P4P1/4RRK1',
60:'2rk3r/pp4p1/5nBp/2qp1Q2/P7/2P4P/1P4P1/4RRK1',
61:'2rk3r/pp4p1/5nBp/2qp1Q2/P7/2P4P/1P4P1/4RR1K',
62:'2rk1r2/pp4p1/5nBp/2qp1Q2/P7/2P4P/1P4P1/4RR1K',
63:'2rk1r2/pp4p1/5nBp/2qpQ3/P7/2P4P/1P4P1/4RR1K',
64:'3k1r2/ppr3p1/5nBp/2qpQ3/P7/2P4P/1P4P1/4RR1K',
65:'3k1r2/ppr3p1/5nBp/2qpQ3/PP6/2P4P/6P1/4RR1K',
66:'3k1r2/ppr3p1/2q2nBp/3pQ3/PP6/2P4P/6P1/4RR1K',
67:'3k1r2/ppr3p1/2q2nBp/3pQ3/PPP5/7P/6P1/4RR1K',
68:'3k1r2/ppr3p1/2q2nBp/4Q3/PPp5/7P/6P1/4RR1K',
69:'3k1r2/ppr3p1/2q2n1p/4QB2/PPp5/7P/6P1/4RR1K',
70:'3k4/ppr2rp1/2q2n1p/4QB2/PPp5/7P/6P1/4RR1K',
71:'3k4/ppr2rp1/2q2n1p/4QB2/PPp5/7P/6P1/3R1R1K',
72:'3k4/pprr2p1/2q2n1p/4QB2/PPp5/7P/6P1/3R1R1K',
73:'3k4/pprB2p1/2q2n1p/4Q3/PPp5/7P/6P1/3R1R1K',
74:'3k4/pp1r2p1/2q2n1p/4Q3/PPp5/7P/6P1/3R1R1K',
75:'1Q1k4/pp1r2p1/2q2n1p/8/PPp5/7P/6P1/3R1R1K',
76:'1Q6/pp1rk1p1/2q2n1p/8/PPp5/7P/6P1/3R1R1K',
77:'1Q6/pp1rk1p1/2q2n1p/8/PPp5/7P/6P1/4RR1K',
},
comments:{
0:'Robert Fischer vs Tigran Petrosian, USSR vs. Rest of the World, Belgrade, 1970, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...c6', 3:'2.d4', 4:'2...d5', 5:'3.exd5', 6:'3...cxd5', 7:'4.Bd3', 8:'4...Nc6', 9:'5.c3', 10:'5...Nf6', 11:'6.Bf4', 12:'6...Bg4',
13:'7.Qb3', 14:'7...Na5', 15:'8.Qa4+', 16:'8...Bd7? The following setup is not in the spirit of the Caro-Kann defense. Kasparov gives 8...Nc6 from Müller-Agdestein, Bundesliga 1998, with equality.', 17:'9.Qc2', 18:'9...e6', 19:'10.Nf3', 20:'10...Qb6', 21:'11.a4! It is very important to prevent the exchange of light-squared bishops as White’s attacking potential would be quite reduced. The weakening of the b3-square on the other hand is not important, as Black cannot really exploit it.', 22:'11...Rc8',
23:'12.Nbd2', 24:'12...Nc6', 25:'13.Qb1', 26:'13...Nh5', 27:'14.Be3', 28:'14...h6', 29:'15.Ne5', 30:'15...Nf6', 31:'16.h3', 32:'16...Bd6',
33:'17.O-O', 34:'17...Kf8?! Fischer prefers 17...0-0, but White’s attack is then also dangerous.', 35:'18.f4', 36:'18...Be8', 37:'19.Bf2', 38:'19...Qc7 19...g6 can be met by the direct 20.B×g6 f×g6 21.N×g6+ Kg7 22.N×h8 K×h8 23.f5 Bf4 24.Qe1± (Kasparov).', 39:'20.Bh4', 40:'20...Ng8', 41:'21.f5! Opening the position to exploit Black’s insecure king.', 42:'21...Nxe5',
43:'22.dxe5', 44:'22...Bxe5', 45:'23.fxe6', 46:'23...Bf6', 47:'24.exf7', 48:'24...Bxf7', 49:'25.Nf3', 50:'25...Bxh4', 51:'26.Nxh4',
52:'26...Nf6', 53:'27.Ng6+! Fischer exchanges the enemy bishop to remain with his favorite combination of pieces, his strong light-squared bishop against a knight.', 54:'27...Bxg6', 55:'28.Bxg6', 56:'28...Ke7', 57:'29.Qf5', 58:'29...Kd8', 59:'30.Rae1', 60:'30...Qc5+',
61:'31.Kh1', 62:'31...Rf8?!', 63:'32.Qe5', 64:'32...Rc7', 65:'33.b4', 66:'33...Qc6', 67:'34.c4!! This beautiful opening of the position decides the matter.', 68:'34...dxc4', 69:'35.Bf5! Cutting off the king’s escape route.', 70:'35...Rff7',
71:'36.Rd1+', 72:'36...Rfd7', 73:'37.Bxd7', 74:'37...Rxd7', 75:'38.Qb8+', 76:'38...Ke7', 77:'39.Rde1+ Black Resigns',
}
},
{
    id: 11,
      name: 'Fischer the Singer',
      description:
'\nExcerpt from Checkmate! The Love Story of Mikhail Tal and Sally Landau by Sally Landau' +
'\n\n' +
'Bobby had only gained a limited schooling, and when I asked him why he’d never graduated from school, he replied: “Because school got in the way of my chess.” He was an amusing guy. A local millionaire invited us to a little restaurant on the other side of the island. Fischer sat in the car next to me and turned the radio on. He found a channel where some guy was singing and suddenly began to sing loudly alongside him. He was tone-deaf! A truly awful voice! And then he said to me in total seriousness: “If I weren’t a great chess player I would have become a great singer.” ...One day, a very young Fischer showed up at the excellent baritone Smyslov’s hotel room during a rest period and started to hum something. Vasily Vasilevich, who was by nature a very gentle person, told him: “Bobby! You are really talented!” These words put wind in the American grandmaster’s sails. Two years later, there was Fischer telling everybody what a great singer he was. During the tournament in Bled [the 1959 candidates tournament] we played a little trick on him. One evening, we all gathered in a bar where an orchestra was playing, accompanying a singer. Somebody had a word with the compere and we heard him announce: “Ladies and gentlemen! We are now going to be treated to a performance by the amazing American chess player and singer Robert James Fischer!” Fischer got all shy but nevertheless took the microphone. He sang, let’s say, idiosyncratically. The audience nevertheless gave him a huge ovation. He then headed back to his seat, accepting the congratulations, and stopped by Paul Keres’s table. Keres told him: “You should give up chess and switch to singing.” Whereupon Fischer replied: “Yes, I know, but I’m too good at chess.” Misha was very nice to Bobby and treated him humorously. Apparently, he once beat Fischer and then decided to goof around with: “Bobby! Cuckoo!” Fischer burst into tears like an infant. But Misha was the first person to say that Fischer was a real genius and a future world champion.\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',
6:'rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R',
7:'rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R',
8:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R',
9:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
10:'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
11:'rnbqkb1r/1p2pppp/p2p1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R',
12:'rnbqkb1r/1p3ppp/p2ppn2/8/2BNP3/2N5/PPP2PPP/R1BQK2R',
13:'rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/1BN5/PPP2PPP/R1BQK2R',
14:'rnbqkb1r/5ppp/p2ppn2/1p6/3NP3/1BN5/PPP2PPP/R1BQK2R',
15:'rnbqkb1r/5ppp/p2ppn2/1p6/3NPP2/1BN5/PPP3PP/R1BQK2R',
16:'rnbqkb1r/5ppp/p2ppn2/8/1p1NPP2/1BN5/PPP3PP/R1BQK2R',
17:'rnbqkb1r/5ppp/p2ppn2/8/Np1NPP2/1B6/PPP3PP/R1BQK2R',
18:'rnbqkb1r/5ppp/p2pp3/8/Np1NnP2/1B6/PPP3PP/R1BQK2R',
19:'rnbqkb1r/5ppp/p2pp3/8/Np1NnP2/1B6/PPP3PP/R1BQ1RK1',
20:'rnbqkb1r/5p1p/p2pp1p1/8/Np1NnP2/1B6/PPP3PP/R1BQ1RK1',
21:'rnbqkb1r/5p1p/p2pp1p1/5P2/Np1Nn3/1B6/PPP3PP/R1BQ1RK1',
22:'rnbqkb1r/5p1p/p2pp3/5p2/Np1Nn3/1B6/PPP3PP/R1BQ1RK1',
23:'rnbqkb1r/5p1p/p2pp3/5N2/Np2n3/1B6/PPP3PP/R1BQ1RK1',
24:'rnbqkbr1/5p1p/p2pp3/5N2/Np2n3/1B6/PPP3PP/R1BQ1RK1',
25:'rnbqkbr1/5p1p/p2pp3/3B1N2/Np2n3/8/PPP3PP/R1BQ1RK1',
26:'1nbqkbr1/r4p1p/p2pp3/3B1N2/Np2n3/8/PPP3PP/R1BQ1RK1',
27:'1nbqkbr1/r4p1p/p2pp3/5N2/Np2B3/8/PPP3PP/R1BQ1RK1',
28:'1nbqkbr1/r4p1p/p2p4/5p2/Np2B3/8/PPP3PP/R1BQ1RK1',
29:'1nbqkbr1/r4p1p/p2p4/5B2/Np6/8/PPP3PP/R1BQ1RK1',
30:'1nbqkbr1/4rp1p/p2p4/5B2/Np6/8/PPP3PP/R1BQ1RK1',
31:'1nBqkbr1/4rp1p/p2p4/8/Np6/8/PPP3PP/R1BQ1RK1',
32:'1nq1kbr1/4rp1p/p2p4/8/Np6/8/PPP3PP/R1BQ1RK1',
33:'1nq1kbr1/4rp1p/p2p4/8/Np3B2/8/PPP3PP/R2Q1RK1',
34:'1n2kbr1/4rp1p/p1qp4/8/Np3B2/8/PPP3PP/R2Q1RK1',
35:'1n2kbr1/4rp1p/p1qp4/8/Np3B2/5Q2/PPP3PP/R4RK1',
36:'1n2kbr1/4rp1p/p2p4/8/qp3B2/5Q2/PPP3PP/R4RK1',
37:'1n2kbr1/4rp1p/p2B4/8/qp6/5Q2/PPP3PP/R4RK1',
38:'1n2kbr1/4rp1p/p1qB4/8/1p6/5Q2/PPP3PP/R4RK1',
39:'1B2kbr1/4rp1p/p1q5/8/1p6/5Q2/PPP3PP/R4RK1',
40:'1B2kbr1/4rp1p/pq6/8/1p6/5Q2/PPP3PP/R4RK1',
41:'1B2kbr1/4rp1p/pq6/8/1p6/5Q2/PPP3PP/R4R1K',
42:'1q2kbr1/4rp1p/p7/8/1p6/5Q2/PPP3PP/R4R1K',
43:'1q2kbr1/4rp1p/p1Q5/8/1p6/8/PPP3PP/R4R1K',
44:'1q2kbr1/3r1p1p/p1Q5/8/1p6/8/PPP3PP/R4R1K',
45:'1q2kbr1/3r1p1p/p1Q5/8/1p6/8/PPP3PP/4RR1K',
46:'1q2k1r1/3rbp1p/p1Q5/8/1p6/8/PPP3PP/4RR1K',
47:'1q2k1r1/3rbR1p/p1Q5/8/1p6/8/PPP3PP/4R2K',
48:'1q4r1/3rbk1p/p1Q5/8/1p6/8/PPP3PP/4R2K',
49:'1q4r1/3rbk1p/p3Q3/8/1p6/8/PPP3PP/4R2K',
50:'1q3kr1/3rb2p/p3Q3/8/1p6/8/PPP3PP/4R2K',
51:'1q3kr1/3Qb2p/p7/8/1p6/8/PPP3PP/4R2K',
52:'5kr1/3Qb2p/p2q4/8/1p6/8/PPP3PP/4R2K',
53:'5kr1/1Q2b2p/p2q4/8/1p6/8/PPP3PP/4R2K',
54:'5k2/1Q2b2p/p2q2r1/8/1p6/8/PPP3PP/4R2K',
55:'5k2/1Q2b2p/p2q2r1/8/1p6/2P5/PP4PP/4R2K',
56:'5k2/1Q2b2p/3q2r1/p7/1p6/2P5/PP4PP/4R2K',
57:'2Q2k2/4b2p/3q2r1/p7/1p6/2P5/PP4PP/4R2K',
58:'2Q5/4b1kp/3q2r1/p7/1p6/2P5/PP4PP/4R2K',
59:'8/4b1kp/3q2r1/p7/1pQ5/2P5/PP4PP/4R2K',
60:'3b4/6kp/3q2r1/p7/1pQ5/2P5/PP4PP/4R2K',
61:'3b4/6kp/3q2r1/p7/1PQ5/8/PP4PP/4R2K',
62:'3b4/6kp/3q2r1/8/1pQ5/8/PP4PP/4R2K',
63:'3b4/6kp/3q2r1/8/1pQ5/6P1/PP5P/4R2K',
64:'3b4/6kp/2q3r1/8/1pQ5/6P1/PP5P/4R2K',
65:'3b4/6kp/2q3r1/8/1pQ1R3/6P1/PP5P/7K',
66:'3b4/6kp/6r1/8/1pq1R3/6P1/PP5P/7K',
67:'3b4/6kp/6r1/8/1pR5/6P1/PP5P/7K',
68:'3b4/6kp/1r6/8/1pR5/6P1/PP5P/7K',
69:'3b4/6kp/1r6/8/1pR5/6P1/PP4KP/8',
70:'3b4/7p/1r3k2/8/1pR5/6P1/PP4KP/8',
71:'3b4/7p/1r3k2/8/1pR5/5KP1/PP5P/8',
72:'3b4/7p/1r6/4k3/1pR5/5KP1/PP5P/8',
73:'3b4/7p/1r6/4k3/1pR5/4K1P1/PP5P/8',
74:'8/7p/1r6/4k1b1/1pR5/4K1P1/PP5P/8',
75:'8/7p/1r6/4k1b1/1pR5/6P1/PP2K2P/8',
76:'8/7p/1r6/3k2b1/1pR5/6P1/PP2K2P/8',
77:'8/7p/1r6/3k2b1/1pR5/3K2P1/PP5P/8',
78:'8/7p/1r3b2/3k4/1pR5/3K2P1/PP5P/8',
79:'8/7p/1r3b2/3k4/1p6/3K2P1/PPR4P/8',
80:'8/7p/1r6/3kb3/1p6/3K2P1/PPR4P/8',
81:'8/7p/1r6/3kb3/1p6/3K2P1/PP2R2P/8',
82:'8/7p/5r2/3kb3/1p6/3K2P1/PP2R2P/8',
83:'8/7p/5r2/3kb3/1p6/3K2P1/PPR4P/8',
84:'8/7p/8/3kb3/1p6/3K1rP1/PPR4P/8',
85:'8/7p/8/3kb3/1p6/5rP1/PPR1K2P/8',
86:'8/5r1p/8/3kb3/1p6/6P1/PPR1K2P/8',
87:'8/5r1p/8/3kb3/1p6/3K2P1/PPR4P/8',
88:'8/5r1p/8/3k4/1p1b4/3K2P1/PPR4P/8',
89:'8/5r1p/8/3k4/1p1b4/P2K2P1/1PR4P/8',
90:'8/5r1p/8/3k4/3b4/Pp1K2P1/1PR4P/8',
91:'2R5/5r1p/8/3k4/3b4/Pp1K2P1/1P5P/8',
92:'2R5/5r1p/8/3k4/8/Pp1K2P1/1b5P/8',
93:'3R4/5r1p/8/3k4/8/Pp1K2P1/1b5P/8',
94:'3R4/5r1p/2k5/8/8/Pp1K2P1/1b5P/8',
95:'1R6/5r1p/2k5/8/8/Pp1K2P1/1b5P/8',
96:'1R6/7p/2k5/8/8/Pp1K1rP1/1b5P/8',
97:'1R6/7p/2k5/8/2K5/Pp3rP1/1b5P/8',
98:'1R6/7p/2k5/8/2K5/Ppr3P1/1b5P/8',
99:'1R6/7p/2k5/8/1K6/Ppr3P1/1b5P/8',
100:'1R6/2k4p/8/8/1K6/Ppr3P1/1b5P/8',
101:'8/2k4p/8/1R6/1K6/Ppr3P1/1b5P/8',
102:'8/2k4p/8/1R6/1K6/Ppr3P1/7P/b7',
103:'8/2k4p/8/1R6/PK6/1pr3P1/7P/b7',
104:'8/2k4p/8/1R6/PK6/2r3P1/1p5P/b7'
},
comments:{
0:'Robert Fischer vs Mikhail Tal, Yugoslav Candidates 1959, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...c5', 3:'2.Nf3', 4:'2...d6', 5:'3.d4', 6:'3...cxd4', 7:'4.Nxd4', 8:'4...Nf6', 9:'5.Nc3', 10:'5...a6', 11:'6.Bc4', 12:'6...e6',
13:'7.Bb3', 14:'7...b5', 15:'8.f4', 16:'8...b4 8...Bb7 is the more solid main line, and it also scores better.', 17:'9.Na4', 18:'9...Nxe4', 19:'10.O-O', 20:'10...g6', 21:'11.f5! Fischer takes the bull by the horns.', 22:'11...gxf5', 23:'12.Nxf5!',
24:'12...Rg8? 12...e×f5? 13.Qd5 Ra7 14.Qd4±; 12...d5 13.Nh6 B×h6 14.B×h6 (Fischer). 14...Rg8 is the best defense.', 25:'13.Bd5', 26:'13...Ra7', 27:'14.Bxe4', 28:'14...exf5', 29:'15.Bxf5', 30:'15...Re7', 31:'16.Bxc8', 32:'16...Qxc8',
33:'17.Bf4? Fischer is too optimistic and probably thought that Tal simply cannot take the a4-knight. With the positional 17.Rf2, he could have secured a lasting advantage.', 34:'17...Qc6!', 35:'18.Qf3', 36:'18...Qxa4', 37:'19.Bxd6', 38:'19...Qc6', 39:'20.Bxb8', 40:'20...Qb6+', 41:'21.Kh1',
42:'21...Qxb8', 43:'22.Qc6+?! 22.Rae1 forces a draw, e.g., 22...Kd8 23.Qd3+ Rd7 24.Q×h7 Rg7 25.Qh4+ Kc7 26.Qf4+ Bd6 27.Qc4+ Kb7 28.Qd5+.', 44:'22...Rd7', 45:'23.Rae1+', 46:'23...Be7', 47:'24.Rxf7? Fischer exchanges too much attacking potential probably due to a miscalculation. 24.Qf6 Kd8 25.Q×f7 Re8 26.Q×h7 is necessary.', 48:'24...Kxf7', 49:'25.Qe6+', 50:'25...Kf8!',
51:'26.Qxd7', 52:'26...Qd6', 53:'27.Qb7', 54:'27...Rg6', 55:'28.c3', 56:'28...a5', 57:'29.Qc8+ 29.c×b4 is answered by 29...Q×b4 30.Qf3+ Rf6.', 58:'29...Kg7', 59:'30.Qc4', 60:'30...Bd8',
61:'31.cxb4', 62:'31...axb4', 63:'32.g3', 64:'32...Qc6+', 65:'33.Re4', 66:'33...Qxc4', 67:'34.Rxc4', 68:'34...Rb6', 69:'35.Kg2',
70:'35...Kf6', 71:'36.Kf3', 72:'36...Ke5', 73:'37.Ke3', 74:'37...Bg5+', 75:'38.Ke2', 76:'38...Kd5', 77:'39.Kd3', 78:'39...Bf6', 79:'40.Rc2? 40.b3 (Fischer) offers better drawing chances.',
80:'40...Be5', 81:'41.Re2', 82:'41...Rf6', 83:'42.Rc2', 84:'42...Rf3+', 85:'43.Ke2', 86:'43...Rf7', 87:'44.Kd3', 88:'44...Bd4', 89:'45.a3', 90:'45...b3',
91:'46.Rc8', 92:'46...Bxb2', 93:'47.Rd8+', 94:'47...Kc6', 95:'48.Rb8', 96:'48...Rf3+', 97:'49.Kc4', 98:'49...Rc3+', 99:'50.Kb4',
100:'50...Kc7', 101:'51.Rb5', 102:'51...Ba1', 103:'52.a4', 104:'52...b2 White Resigns'
}
},
{
    id: 12,
      name: 'Fischer Interview 1972',
      description:
'\n60 Minutes Interview from April 1972' +
'\n\n' +
'Mike Wallace: Winning is obviously very important to you. Now, winning for winning\'s sake is important, but do you like to beat another man?' +
'\n\n' +
'Bobby Fischer: Yeah, I do, I like to beat another man.' +
'\n\n' +
'You smile about it. Do you like to crush another man\'s ego?' +
'\n\n' +
'Uh-huh, so when they go home that night they can\'t kid themselves that they\'re so hot, you know?' +
'\n\n' +
'Do you think the Russians are pretty worried about you at this moment?' +
'\n\n' +
'Oh, they had been ever since I started playing chess.' +
'\n\n' +
'Even as a little boy?' +
'\n\n' +
'That\'s right. I remember the first thing they ever wrote about me was, you know, \'he\'s a talented player\', and they showed a game I played, and then they said, \'but all this publicity he\'s getting and all this attention can\'t fail to have a harmful effect on his personality development\'. And sure enough a few months later I was a rotten person already in their press — I was doing this, I was doing that, I was conceited, you know. Before they even knew anything about me personally. ' +
'\n\n' +
'They sting you, they get to you. ' +
'\n\n' +
'Well, they don\'t anymore, because I realized it has nothing to do with me, you know? If you were a great chess player, they\'d be saying exactly the same things about you. Maybe they\'d just tailor them a little bit to your personality or your background...' +
'\n\n' +
'This championship match between you and Spassky, is it in any sense a grudge match?' +
'\n\n' +
'In a sense. I mean not personally [about] me against Spassky, \'cause you know, I don\'t care two cents about him one way or the other, he\'s just another guy. But it\'s against the Russians and, you know, all the lies they\'ve been saying about me.' +
'\n\n' +
'Do you worry about Spassky?' +
'\n\n' +
'Not overly. I mean, he\'s a little better I think than the other Russians I\'ve taken on these years, but...' +
'\n\n' +
'You played Spassky. He\'s beaten you, but you\'ve never beaten him.' +
'\n\n' +
'Yeah, well, we\'ve only played a few games, so... The other day, I was looking through his games in the Moscow event, the Alekhine Tournament, and they were truly atrocious games. He was lost in half the games in that tournament. Really bad games on his part.' +
'\n\n' +
'Why did that happen to a man who, after all, is the champion of the world?' +
'\n\n' +
'Well, the champion of the world... First of all, I didn\'t compete, so he\'s not really much of a champion. He\'s the best they\'ve got, it\'s not a big deal.' +
'\n\n' +
'Where do you get your confidence?' +
'\n\n' +
'Well, when you\'re successful, you realize there must be something going on. Why am I so successful? There must be a reason, right? So obviously there\'s something, some natural ability, some fact is working, right?' +
'\n\n' +
'Sometimes what we\'re talking about is described as Fischer\'s arrogance. I sense that it\'s something quite different. You simply...' +
'\n\n' +
'Yeah, listen, arrogance... People have been calling me arrogant for many years, but lately they\'re not calling me arrogant. Why? \'Cause now, you know, I\'ve been winning all these matches and I\'m doing what I\'ve always said I was. So, I used to say I was the best player in the world — everyone is \'arrogant, terrible, conceited person\', but this is just an obvious fact.' +
'\n\n' +
'It\'s not just the arrogance of you saying that you\'re the best in the world, but the lights are too tough, or the temperature is too high, or arrangements aren\'t right. It\'s the difficulty of dealing with you that people are complaining about.' +
'\n\n' +
'But the thing is, everyone\'s looking at it from the organizers\' point of view. I mean, you wouldn\'t believe the kind of conditions they want us chess players to be playing in.' +
'\n\n' +
'For instance?' +
'\n\n' +
'I remember once I played in Berlin. I played a match with the best players in Berlin, you know, the American team against the Berliners, and I had guys leaning right on my head practically, smoking in my face, spectators.' +
'\n\n' +
'Is chess a tough game for the body as well as the mind?' +
'\n\n' +
'It is pretty tough, \'cause of all tension. It\'s a lot of concentration, sitting there for hour after hour, it\'s really exhausting.' +
'\n\n' +
'I think that that\'s pretty difficult for somebody who doesn\'t know the game to understand. It looks like, after all, you and I sit at a board...' +
'\n\n' +
'Well, you know, it\'s kind of like when you go to take your final exam or something. You\'re pretty tired, right? So it\'s like taking a five-hour final exam every day or something.\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR',
2:'rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR',
3:'rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR',
4:'rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR',
5:'rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R',
6:'rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/5N2/PP2PPPP/RNBQKB1R',
7:'rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/5N2/PP2PPPP/RNBQKB1R',
8:'rnbqkb1r/pp1p1ppp/5n2/2pp4/2P5/5N2/PP2PPPP/RNBQKB1R',
9:'rnbqkb1r/pp1p1ppp/5n2/2pP4/8/5N2/PP2PPPP/RNBQKB1R',
10:'rnbqkb1r/pp3ppp/3p1n2/2pP4/8/5N2/PP2PPPP/RNBQKB1R',
11:'rnbqkb1r/pp3ppp/3p1n2/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R',
12:'rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R',
13:'rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N5/PP1NPPPP/R1BQKB1R',
14:'r1bqkb1r/pp1n1p1p/3p1np1/2pP4/8/2N5/PP1NPPPP/R1BQKB1R',
15:'r1bqkb1r/pp1n1p1p/3p1np1/2pP4/4P3/2N5/PP1N1PPP/R1BQKB1R',
16:'r1bqk2r/pp1n1pbp/3p1np1/2pP4/4P3/2N5/PP1N1PPP/R1BQKB1R',
17:'r1bqk2r/pp1n1pbp/3p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQK2R',
18:'r1bq1rk1/pp1n1pbp/3p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQK2R',
19:'r1bq1rk1/pp1n1pbp/3p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQ1RK1',
20:'r1bqr1k1/pp1n1pbp/3p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQ1RK1',
21:'r1bqr1k1/pp1n1pbp/3p1np1/2pP4/4P3/2N5/PPQNBPPP/R1B2RK1',
22:'r1bqr1k1/pp1n1pbp/3p2p1/2pP3n/4P3/2N5/PPQNBPPP/R1B2RK1',
23:'r1bqr1k1/pp1n1pbp/3p2p1/2pP3B/4P3/2N5/PPQN1PPP/R1B2RK1',
24:'r1bqr1k1/pp1n1pbp/3p4/2pP3p/4P3/2N5/PPQN1PPP/R1B2RK1',
25:'r1bqr1k1/pp1n1pbp/3p4/2pP3p/2N1P3/2N5/PPQ2PPP/R1B2RK1',
26:'r1bqr1k1/pp3pbp/3p4/2pPn2p/2N1P3/2N5/PPQ2PPP/R1B2RK1',
27:'r1bqr1k1/pp3pbp/3p4/2pPn2p/4P3/2N1N3/PPQ2PPP/R1B2RK1',
28:'r1b1r1k1/pp3pbp/3p4/2pPn2p/4P2q/2N1N3/PPQ2PPP/R1B2RK1',
29:'r1b1r1k1/pp3pbp/3p4/2pPn2p/4P2q/2N1N3/PPQB1PPP/R4RK1',
30:'r1b1r1k1/pp3pbp/3p4/2pP3p/4P1nq/2N1N3/PPQB1PPP/R4RK1',
31:'r1b1r1k1/pp3pbp/3p4/2pP3p/4P1Nq/2N5/PPQB1PPP/R4RK1',
32:'r1b1r1k1/pp3pbp/3p4/2pP4/4P1pq/2N5/PPQB1PPP/R4RK1',
33:'r1b1r1k1/pp3pbp/3p4/2pP4/4PBpq/2N5/PPQ2PPP/R4RK1',
34:'r1b1r1k1/pp3pbp/3p1q2/2pP4/4PBp1/2N5/PPQ2PPP/R4RK1',
35:'r1b1r1k1/pp3pbp/3p1q2/2pP4/4PBp1/2N3P1/PPQ2P1P/R4RK1',
36:'r3r1k1/pp1b1pbp/3p1q2/2pP4/4PBp1/2N3P1/PPQ2P1P/R4RK1',
37:'r3r1k1/pp1b1pbp/3p1q2/2pP4/P3PBp1/2N3P1/1PQ2P1P/R4RK1',
38:'r3r1k1/p2b1pbp/1p1p1q2/2pP4/P3PBp1/2N3P1/1PQ2P1P/R4RK1',
39:'r3r1k1/p2b1pbp/1p1p1q2/2pP4/P3PBp1/2N3P1/1PQ2P1P/R3R1K1',
40:'r3r1k1/3b1pbp/pp1p1q2/2pP4/P3PBp1/2N3P1/1PQ2P1P/R3R1K1',
41:'r3r1k1/3b1pbp/pp1p1q2/2pP4/P3PBp1/2N3P1/1PQ1RP1P/R5K1',
42:'r3r1k1/3b1pbp/p2p1q2/1ppP4/P3PBp1/2N3P1/1PQ1RP1P/R5K1',
43:'r3r1k1/3b1pbp/p2p1q2/1ppP4/P3PBp1/2N3P1/1PQ1RP1P/4R1K1',
44:'r3r1k1/3b1pbp/p2p2q1/1ppP4/P3PBp1/2N3P1/1PQ1RP1P/4R1K1',
45:'r3r1k1/3b1pbp/p2p2q1/1ppP4/P3PBp1/1PN3P1/2Q1RP1P/4R1K1',
46:'r5k1/3brpbp/p2p2q1/1ppP4/P3PBp1/1PN3P1/2Q1RP1P/4R1K1',
47:'r5k1/3brpbp/p2p2q1/1ppP4/P3PBp1/1PNQ2P1/4RP1P/4R1K1',
48:'1r4k1/3brpbp/p2p2q1/1ppP4/P3PBp1/1PNQ2P1/4RP1P/4R1K1',
49:'1r4k1/3brpbp/p2p2q1/1PpP4/4PBp1/1PNQ2P1/4RP1P/4R1K1',
50:'1r4k1/3brpbp/3p2q1/1ppP4/4PBp1/1PNQ2P1/4RP1P/4R1K1',
51:'1r4k1/3brpbp/3p2q1/1ppP4/1P2PBp1/2NQ2P1/4RP1P/4R1K1',
52:'1r4k1/3brpbp/3p2q1/1p1P4/1Pp1PBp1/2NQ2P1/4RP1P/4R1K1',
53:'1r4k1/3brpbp/3p2q1/1p1P4/1Pp1PBp1/2N3P1/3QRP1P/4R1K1',
54:'4r1k1/3brpbp/3p2q1/1p1P4/1Pp1PBp1/2N3P1/3QRP1P/4R1K1',
55:'4r1k1/3brpbp/3p2q1/1p1P4/1Pp1PBp1/2N1R1P1/3Q1P1P/4R1K1',
56:'4r1k1/3brpb1/3p2q1/1p1P3p/1Pp1PBp1/2N1R1P1/3Q1P1P/4R1K1',
57:'4r1k1/3brpb1/3p2q1/1p1P3p/1Pp1PBp1/2N3P1/3QRP1P/4R1K1',
58:'4r3/3brpbk/3p2q1/1p1P3p/1Pp1PBp1/2N3P1/3QRP1P/4R1K1',
59:'4r3/3brpbk/3p2q1/1p1P3p/1Pp1PBp1/2N1R1P1/3Q1P1P/4R1K1',
60:'4r1k1/3brpb1/3p2q1/1p1P3p/1Pp1PBp1/2N1R1P1/3Q1P1P/4R1K1',
61:'4r1k1/3brpb1/3p2q1/1p1P3p/1Pp1PBp1/2N3P1/3QRP1P/4R1K1',
62:'4r1k1/3brp2/3p2q1/1p1P3p/1Pp1PBp1/2b3P1/3QRP1P/4R1K1',
63:'4r1k1/3brp2/3p2q1/1p1P3p/1Pp1PBp1/2Q3P1/4RP1P/4R1K1',
64:'4r1k1/3b1p2/3p2q1/1p1P3p/1Pp1rBp1/2Q3P1/4RP1P/4R1K1',
65:'4r1k1/3b1p2/3p2q1/1p1P3p/1Pp1RBp1/2Q3P1/5P1P/4R1K1',
66:'6k1/3b1p2/3p2q1/1p1P3p/1Pp1rBp1/2Q3P1/5P1P/4R1K1',
67:'6k1/3b1p2/3p2q1/1p1P3p/1Pp1RBp1/2Q3P1/5P1P/6K1',
68:'6k1/3b1p2/3p4/1p1P3p/1Pp1qBp1/2Q3P1/5P1P/6K1',
69:'6k1/3b1p2/3p3B/1p1P3p/1Pp1q1p1/2Q3P1/5P1P/6K1',
70:'6k1/3b1p2/3p2qB/1p1P3p/1Pp3p1/2Q3P1/5P1P/6K1',
71:'6k1/3b1p2/3p2q1/1p1P3p/1Pp3p1/2Q3P1/5P1P/2B3K1',
72:'6k1/3b1p2/3p4/1p1P3p/1Pp3p1/2Q3P1/5P1P/1qB3K1',
73:'6k1/3b1p2/3p4/1p1P3p/1Pp3p1/2Q3P1/5P1P/1qB2K2',
74:'6k1/5p2/3p4/1p1P1b1p/1Pp3p1/2Q3P1/5P1P/1qB2K2',
75:'6k1/5p2/3p4/1p1P1b1p/1Pp3p1/2Q3P1/4KP1P/1qB5',
76:'6k1/5p2/3p4/1p1P1b1p/1Pp1q1p1/2Q3P1/4KP1P/2B5',
77:'6k1/5p2/3p4/1p1P1b1p/1Pp1q1p1/4Q1P1/4KP1P/2B5',
78:'6k1/5p2/3p4/1p1P1b1p/1Pp3p1/4Q1P1/2q1KP1P/2B5',
79:'6k1/5p2/3p4/1p1P1b1p/1Pp3p1/6P1/2qQKP1P/2B5',
80:'6k1/5p2/3p4/1p1P1b1p/1Pp3p1/1q4P1/3QKP1P/2B5',
81:'6k1/5p2/3p4/1p1P1b1p/1PpQ2p1/1q4P1/4KP1P/2B5',
82:'6k1/5p2/3p4/1p1P3p/1PpQ2p1/1q1b2P1/4KP1P/2B5',
},
comments:{
0:'Boris Spassky – Bobby Fischer, World Championship 1972, Annotations by GM Karsten Mueller. Fischer broke through with his first win in game three, the shock of his 11th move having the desired effect. The slugfest between the two greatest players of the time was now in full swing, and the world was hanging on their every move.',
1:'1.d4', 2:'1...Nf6', 3:'2.c4', 4:'2...e6', 5:'3.Nf3', 6:'3...c5', 7:'4.d5', 8:'4...exd5', 9:'5.cxd5', 10:'5...d6', 11:'6.Nc3', 12:'6...g6',
13:'7.Nd2', 14:'7...Nbd7', 15:'8.e4', 16:'8...Bg7', 17:'9.Be2', 18:'9...O-O', 19:'10.O-O', 20:'10...Re8', 21:'11.Qc2', 22:'11...Nh5?! 11...Ne5 is the main line.',
23:'12.Bxh5', 24:'12...gxh5', 25:'13.Nc4 13.a4 Ne5 14.Nd1! as in Gligoric-Kavalek, Skopje 1972 is more critical.', 26:'13...Ne5', 27:'14.Ne3', 28:'14...Qh4', 29:'15.Bd2 15.f3!? (Byrne).', 30:'15...Ng4', 31:'16.Nxg4',
32:'16...hxg4', 33:'17.Bf4', 34:'17...Qf6', 35:'18.g3? This weakens the e4-pawn and the light squares permanently. 18.Bg3 should be tried.', 36:'18...Bd7', 37:'19.a4', 38:'19...b6', 39:'20.Rfe1', 40:'20...a6', 41:'21.Re2', 42:'21...b5!',
43:'22.Rae1', 44:'22...Qg6', 45:'23.b3', 46:'23...Re7', 47:'24.Qd3', 48:'24...Rb8', 49:'25.axb5', 50:'25...axb5', 51:'26.b4', 52:'26...c4!',
53:'27.Qd2', 54:'27...Rbe8', 55:'28.Re3', 56:'28...h5! Fischer improves his position first before he wins the e4-pawn, which in any even cannot run away; 28...B×c3? 29.Q×c3 R×e4 30.R×e4 R×e4 31.R×e4 Q×e4 allows 32.Qf6! (Byrne, Gligoric).', 57:'29.R3e2', 58:'29...Kh7', 59:'30.Re3', 60:'30...Kg8', 61:'31.R3e2', 62:'31...Bxc3',
63:'32.Qxc3', 64:'32...Rxe4', 65:'33.Rxe4', 66:'33...Rxe4', 67:'34.Rxe4', 68:'34...Qxe4', 69:'35.Bh6 35.B×d6? Q×d5 36.Bf4 Qd1+-+. Now 35.Qf6? can be met by 35...Bf5 36.Bd2 Qb1+ 37.Kg2 Qd3-+.', 70:'35...Qg6', 71:'36.Bc1',
72:'36...Qb1', 73:'37.Kf1', 74:'37...Bf5', 75:'38.Ke2', 76:'38...Qe4+', 77:'39.Qe3', 78:'39...Qc2+', 79:'40.Qd2', 80:'40...Qb3', 81:'41.Qd4? This allows Fischer to destroy White’s coordination. 41.Ke1! is the last chance, e.g., 41...Qf3 (41...c3!?) 42.Qg5+ Bg6 43.Qe3 Qh1+ 44.Kd2 Q×d5+ (Byrne) 45.Ke1, and it is not so easy to storm White’s castle. ',
82:'41...Bd3+ The sealed move. Spassky resigned at the resumption, when this move was taken from the envelope, as 42.Ke3 Qd1 just loses.',
}
},
{
    id: 13,
      name: 'A Knight was not Enough',
      description:
'\nExcerpts by Hans Ree, in his article "At the Kibbutz with Bobby" that was published at ChessCafe.com.' +
'\n\n' +
'At the kibbutz we played some blitz. In our tournament game I had collapsed as soon as Bobby had uncorked an opening novelty. Playing blitz I hoped for... well, not really revenge, but maybe one draw out of a series of games, was that too much? But no way. After a while he wanted to give me knight odds. I protested, but I had to oblige. That game he won also, and then he refused to go on. “No challenge,” he said.“Fischer is Fischer, but a knight is a knight,” said Mikhail Tal when Bobby had claimed that he could give knight odds to any woman player. But for me, a knight was not enough.' +
'\n\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
6:'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
7:'r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
8:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
9:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
10:'r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQ1RK1',
11:'r1bqkb1r/1ppp1ppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1',
12:'r1bqkb1r/2pp1ppp/p1n5/1p2p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1',
13:'r1bqkb1r/2pp1ppp/p1n5/1p2p3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1',
14:'r1bqkb1r/2p2ppp/p1n5/1p1pp3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1',
15:'r1bqkb1r/2p2ppp/p1n5/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1',
16:'r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1',
17:'r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNB2RK1',
18:'r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNB2RK1',
19:'r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNBR2K1',
20:'r2q1rk1/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNBR2K1',
21:'r2q1rk1/2p1bppp/p1n1b3/1p1pP3/2P1n3/1B3N2/PP2QPPP/RNBR2K1',
22:'r2q1rk1/2p1bppp/p1n1b3/3pP3/2p1n3/1B3N2/PP2QPPP/RNBR2K1',
23:'r2q1rk1/2p1bppp/p1n1b3/3pP3/2B1n3/5N2/PP2QPPP/RNBR2K1',
24:'r4rk1/2pqbppp/p1n1b3/3pP3/2B1n3/5N2/PP2QPPP/RNBR2K1',
25:'r4rk1/2pqbppp/p1n1b3/3pP3/2B1n3/2N2N2/PP2QPPP/R1BR2K1',
26:'r4rk1/2pqbppp/p1n1b3/3pP3/2B5/2n2N2/PP2QPPP/R1BR2K1',
27:'r4rk1/2pqbppp/p1n1b3/3pP3/2B5/2P2N2/P3QPPP/R1BR2K1',
28:'r4rk1/2pqb1pp/p1n1bp2/3pP3/2B5/2P2N2/P3QPPP/R1BR2K1',
29:'r4rk1/2pqb1pp/p1n1bP2/3p4/2B5/2P2N2/P3QPPP/R1BR2K1',
30:'r4rk1/2pq2pp/p1n1bb2/3p4/2B5/2P2N2/P3QPPP/R1BR2K1',
31:'r4rk1/2pq2pp/p1n1bb2/3p2B1/2B5/2P2N2/P3QPPP/R2R2K1',
32:'r4rk1/2pq2pp/p3bb2/n2p2B1/2B5/2P2N2/P3QPPP/R2R2K1',
33:'r4rk1/2pq2pp/p3Qb2/n2p2B1/2B5/2P2N2/P4PPP/R2R2K1',
34:'r4rk1/2p3pp/p3qb2/n2p2B1/2B5/2P2N2/P4PPP/R2R2K1',
35:'r4rk1/2p3pp/p3qb2/n2B2B1/8/2P2N2/P4PPP/R2R2K1',
36:'r4rk1/2p3pp/p4b2/n2q2B1/8/2P2N2/P4PPP/R2R2K1',
37:'r4rk1/2p3pp/p4b2/n2R2B1/8/2P2N2/P4PPP/R5K1',
38:'r4rk1/2p3pp/p7/n2R2B1/8/2b2N2/P4PPP/R5K1',
39:'r4rk1/2p3pp/p7/n2R2B1/8/2b2N2/P4PPP/2R3K1',
40:'r4rk1/2p3pp/p7/n2R2B1/1b6/5N2/P4PPP/2R3K1',
41:'r4rk1/2R3pp/p7/n2R2B1/1b6/5N2/P4PPP/6K1',
42:'2r2rk1/2R3pp/p7/n2R2B1/1b6/5N2/P4PPP/6K1',
43:'2r2rk1/R5pp/p7/n2R2B1/1b6/5N2/P4PPP/6K1',
44:'5rk1/R5pp/p7/n2R2B1/1b6/5N2/P1r2PPP/6K1',
45:'5rk1/R2R2pp/p7/n5B1/1b6/5N2/P1r2PPP/6K1',
46:'5rk1/R2R2pp/p7/n5B1/8/2b2N2/P1r2PPP/6K1',
47:'5rk1/2RR2pp/p7/n5B1/8/2b2N2/P1r2PPP/6K1',
48:'5rk1/2RR2p1/p6p/n5B1/8/2b2N2/P1r2PPP/6K1',
49:'5rk1/2RR2p1/p6p/n7/8/2b1BN2/P1r2PPP/6K1'
},
comments:{
0:'Bobby Fischer-Hans Ree, Israel 1968, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...e5', 3:'2.Nf3', 4:'2...Nc6', 5:'3.Bb5', 6:'3...a6', 7:'4.Ba4', 8:'4...Nf6', 9:'5.O-O', 10:'5...Nxe4', 11:'6.d4', 12:'6...b5',
13:'7.Bb3', 14:'7...d5', 15:'8.dxe5', 16:'8...Be6', 17:'9.Qe2', 18:'9...Be7', 19:'10.Rd1', 20:'10...O-O', 21:'11.c4', 22:'11...bxc4',
23:'12.Bxc4', 24:'12...Qd7 12...Bc5 is the main line.', 25:'13.Nc3', 26:'13...Nxc3', 27:'14.bxc3', 28:'14...f6', 29:'15.exf6', 30:'15...Bxf6', 31:'16.Bg5',
32:'16...Na5? Allowing Fischer to simplify into a clearly better ending. The prophylactic 16...Kh8 is played most often.', 33:'17.Qxe6+!', 34:'17...Qxe6', 35:'18.Bxd5', 36:'18...Qxd5', 37:'19.Rxd5', 38:'19...Bxc3', 39:'20.Rc1', 40:'20...Bb4?! 20...c6 21.Rd3 Bf6 22.Bd2 Nb7 23.R×c6 Rfc8 is more tenacious.',
41:'21.Rxc7', 42:'21...Rac8', 43:'22.Ra7', 44:'22...Rc2', 45:'23.Rdd7', 46:'23...Bc3', 47:'24.Rac7', 48:'24...h6', 49:'25.Be3'
}
},
{
    id: 14,
      name: 'Meeting Fischer by Jan Timman',
      description:
'\nExcerpt from Fischer World Champion! by Jan Timman and Max Euwe.' +
'\n\n' +
'It was not really on the cards that I would ever meet Fischer, since I entered the international chess arena just after he had retired.' +
'\n\n' +
'I did have a recurrent dream, though, that I ran into him in a nightclub, where we discussed a number of things in a friendly atmosphere. Eventually that dream came true. The day that Fischer and I met ended in a nightclub. A lot of things had happened before this time, and I would not have missed this day for all the tea in China.' +
'\n\n' +
'In the spring of 1990, Bessel Kok invited Fischer to Brussels, the city where Kok then lived and the GMA (Grandmaster Association) had its headquarters. Spassky was serving as the go-between. Fischer was to stay for a week. He had been checked into the Sheraton Hotel under the name of Bobby Brown, the title of a Frank Zappa song (which later became known as ‘Bobby Brown goes down’). On a sunny day in May, I arrived at Kok’s house around noon. Fischer arrived some hours later, accompanied by Spassky. He looked like a man in a hurry. ‘I have a hangover’, he sighed. These were the first words I had heard him say. It was about three o’clock in the afternoon, and Kok suggested we open a bottle of champagne. Fischer refused, but the host poured him a glass anyway. Kok was unrelenting in those days. Fischer radiated an incredible amount of energy, a bit like Kasparov – you more or less felt all that energy washing over you. That construction worker in Santa Monica must have had a similar experience, except that the energy was still focussed then.' +
'\n\n' +
'Now this was far less the case; Fischer’s sphere of interest had changed. He talked a lot about his chess clock, and at some point – it didn’t really take long – he took out his magnetic pocket chess set.' +
'\n\n' +
'He had bought it in Germany in 1978, and he asked me to have a look at positions he had analysed during the flight from LA to Brussels. For several hours, our only conversation was about the things he showed me on his pocket chess set. Even after we got out of the limousine to have supper, he continued to unload his conclusions while we were walking up the gravel path leading to the restaurant in Ukkel.' +
'\n\n' +
'In the restaurant he opined that Richard Réti had been an overrated player, repeating Alekhine’s despicable theories about the treacherous game in which both bishops are fianchettoed. I might have drawn his attention to his game against Filip, but this didn’t occur to me at the time. I restricted myself to observing that Réti had been an endgame composer of genius, which he accepted. He generally seemed accommodating enough if you expressed a difference of opinion. And he loved the endgame studies I showed him.' +
'\n\n' +
'It was inevitable that the conversation would touch on the Holocaust.' +
'\n\n' +
'‘It is a hoax,’ he said very softly, almost mumbling.' +
'\n\n' +
'‘But Bobby, what happened to all those people?’ I asked him. He hesitated before replying. ‘They live in Argentina, in Russia,’ he answered.' +
'\n\n' +
'He seemed to be visualizing the vast pampas of Argentina and endless steppes of Siberia populated by millions of Jews.' +
'\n\n' +
'A neo-Nazi would never have said anything like this. What it pointed at was an extremely naïve world view, just as when, 10 years later, he advocated that America be returned to the native Indians. But by that time his tone had grown a lot more grim and aggressive. His isolation and its attendant lack of correction of delusional ideas had not done his mental health any favours.' +
'\n\n' +
'After supper we had arranged to go to a nightclub, but Fischer wanted to return to the hotel first to show me his letter to the Encyclopaedia Judaica and their answer.' +
'\n\n' +
'There was another reason why he wanted to go to the nightclub at a later time. He had been there before, and at some stage they had an old-fashioned traditional act: a women in a chest that was pierced from all sides with swords. Fischer did not want to see this again. Imagine things going wrong!' +
'\n\n' +
'And so we found ourselves sitting opposite one another in the lobby of the Sheraton hotel. He observed me closely while I read his letter and the reply he had received.' +
'\n\n' +
'‘What do you think of their reaction?’ he asked.' +
'\n\n' +
'‘Well, I think it’s quite a normal reply’, I answered.' +
'\n\n' +
'No, no, I was completely wrong. There had been a long meeting about it, and the Rothschilds had been involved. Fischer maintained that the choice of words in the letter was such that it failed to acknowledge that he was not Jewish. I must say I found the idea intriguing: the Rothschilds getting together to discuss Bobby Fischer. But it is more likely that they would discuss the exquisite wine that the various scions of that famous line produced, each in their own special way.' +
'\n\n' +
'When we arrived at the club, the woman in the chest turned out to have survived her ordeal again. We stayed for a long time, and around four in the morning, Kok, Fischer and I walked back to the hotel. Kok and I were pretty tired, but Fischer seemed as sprightly as ever. ‘Is the Sheraton the tallest building in Brussels?’ he asked. These were the last words I heard him say. Kok replied in the negative.' +
'\n\n\n' +
'Here is the game Timman referred to when Fischer double fianchettoed his Bishops:\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR',
2:'rnbqkbnr/ppp1pppp/8/3p4/8/1P6/P1PPPPPP/RNBQKBNR',
3:'rnbqkbnr/ppp1pppp/8/3p4/8/1P6/PBPPPPPP/RN1QKBNR',
4:'rnbqkb1r/ppp1pppp/5n2/3p4/8/1P6/PBPPPPPP/RN1QKBNR',
5:'rnbqkb1r/ppp1pppp/5n2/3p4/8/1P3N2/PBPPPPPP/RN1QKB1R',
6:'rnbqkb1r/ppp2ppp/4pn2/3p4/8/1P3N2/PBPPPPPP/RN1QKB1R',
7:'rnbqkb1r/ppp2ppp/4pn2/3p4/8/1P3NP1/PBPPPP1P/RN1QKB1R',
8:'rnbqk2r/ppp1bppp/4pn2/3p4/8/1P3NP1/PBPPPP1P/RN1QKB1R',
9:'rnbqk2r/ppp1bppp/4pn2/3p4/8/1P3NP1/PBPPPPBP/RN1QK2R',
10:'rnbq1rk1/ppp1bppp/4pn2/3p4/8/1P3NP1/PBPPPPBP/RN1QK2R',
11:'rnbq1rk1/ppp1bppp/4pn2/3p4/8/1P3NP1/PBPPPPBP/RN1Q1RK1',
12:'rnbq1rk1/pp2bppp/4pn2/2pp4/8/1P3NP1/PBPPPPBP/RN1Q1RK1',
13:'rnbq1rk1/pp2bppp/4pn2/2pp4/2P5/1P3NP1/PB1PPPBP/RN1Q1RK1',
14:'r1bq1rk1/pp2bppp/2n1pn2/2pp4/2P5/1P3NP1/PB1PPPBP/RN1Q1RK1',
15:'r1bq1rk1/pp2bppp/2n1pn2/2pP4/8/1P3NP1/PB1PPPBP/RN1Q1RK1',
16:'r1bq1rk1/pp2bppp/2n1p3/2pn4/8/1P3NP1/PB1PPPBP/RN1Q1RK1',
17:'r1bq1rk1/pp2bppp/2n1p3/2pn4/8/1PN2NP1/PB1PPPBP/R2Q1RK1',
18:'r1bq1rk1/pp3ppp/2n1pb2/2pn4/8/1PN2NP1/PB1PPPBP/R2Q1RK1',
19:'r1bq1rk1/pp3ppp/2n1pb2/2pn4/8/1PN2NP1/PB1PPPBP/R1Q2RK1',
20:'r1bq1rk1/p4ppp/1pn1pb2/2pn4/8/1PN2NP1/PB1PPPBP/R1Q2RK1',
21:'r1bq1rk1/p4ppp/1pn1pb2/2pN4/8/1P3NP1/PB1PPPBP/R1Q2RK1',
22:'r1bq1rk1/p4ppp/1pn2b2/2pp4/8/1P3NP1/PB1PPPBP/R1Q2RK1',
23:'r1bq1rk1/p4ppp/1pn2b2/2pp4/3P4/1P3NP1/PB2PPBP/R1Q2RK1',
24:'r2q1rk1/p4ppp/bpn2b2/2pp4/3P4/1P3NP1/PB2PPBP/R1Q2RK1',
25:'r2q1rk1/p4ppp/bpn2b2/2pp4/3P4/1P3NP1/PB2PPBP/R1Q1R1K1',
26:'r2q1rk1/p4ppp/bp3b2/2pp4/3n4/1P3NP1/PB2PPBP/R1Q1R1K1',
27:'r2q1rk1/p4ppp/bp3b2/2pp4/3B4/1P3NP1/P3PPBP/R1Q1R1K1',
28:'r2q1rk1/p4ppp/bp3b2/3p4/3p4/1P3NP1/P3PPBP/R1Q1R1K1',
29:'r2q1rk1/p4ppp/bp3b2/3p4/3p4/QP3NP1/P3PPBP/R3R1K1',
30:'r2q1rk1/pb3ppp/1p3b2/3p4/3p4/QP3NP1/P3PPBP/R3R1K1',
31:'r2q1rk1/pb3ppp/1p3b2/3p4/3p4/QP3NP1/P3PPBP/3RR1K1',
32:'r2q1rk1/pb2bppp/1p6/3p4/3p4/QP3NP1/P3PPBP/3RR1K1',
33:'r2q1rk1/pb2bppp/1p6/3p4/Q2p4/1P3NP1/P3PPBP/3RR1K1',
34:'r3qrk1/pb2bppp/1p6/3p4/Q2p4/1P3NP1/P3PPBP/3RR1K1',
35:'r3qrk1/pb2bppp/1p6/3p4/3Q4/1P3NP1/P3PPBP/3RR1K1',
36:'2r1qrk1/pb2bppp/1p6/3p4/3Q4/1P3NP1/P3PPBP/3RR1K1',
37:'2r1qrk1/pb2bppp/1p6/3p4/5Q2/1P3NP1/P3PPBP/3RR1K1',
38:'2r1qrk1/pb3ppp/1p3b2/3p4/5Q2/1P3NP1/P3PPBP/3RR1K1',
39:'2r1qrk1/pb3ppp/1p3b2/3p4/3N1Q2/1P4P1/P3PPBP/3RR1K1',
40:'2r1qrk1/pb3ppp/1p6/3pb3/3N1Q2/1P4P1/P3PPBP/3RR1K1',
41:'2r1qrk1/pb3ppp/1p6/3pb3/3N4/1P2Q1P1/P3PPBP/3RR1K1',
42:'2r1qrk1/pb3p1p/1p4p1/3pb3/3N4/1P2Q1P1/P3PPBP/3RR1K1',
43:'2r1qrk1/pb3p1p/1p4p1/1N1pb3/8/1P2Q1P1/P3PPBP/3RR1K1',
44:'2r2rk1/pb3p1p/1p4p1/1q1pb3/8/1P2Q1P1/P3PPBP/3RR1K1',
45:'2r2rk1/pb3p1p/1p4p1/1q1pQ3/8/1P4P1/P3PPBP/3RR1K1',
46:'2r1r1k1/pb3p1p/1p4p1/1q1pQ3/8/1P4P1/P3PPBP/3RR1K1',
47:'2r1r1k1/pb3p1p/1p4p1/1q1p4/8/1P4P1/PQ2PPBP/3RR1K1',
48:'4r1k1/pb3p1p/1p4p1/1qrp4/8/1P4P1/PQ2PPBP/3RR1K1',
49:'4r1k1/pb3p1p/1p4p1/1qrp4/7P/1P4P1/PQ2PPB1/3RR1K1',
50:'2r3k1/pb3p1p/1p4p1/1qrp4/7P/1P4P1/PQ2PPB1/3RR1K1',
51:'2r3k1/pb3p1p/1p4p1/1qrp4/7P/1P4P1/PQ1RPPB1/4R1K1',
52:'2r3k1/pb3p1p/1p4p1/1q1p4/7P/1Pr3P1/PQ1RPPB1/4R1K1',
53:'2r3k1/pb3p1p/1p4p1/1q1p4/7P/1Pr3P1/PQ1RPPB1/3R2K1',
54:'2r3k1/pb3p1p/1p4p1/2qp4/7P/1Pr3P1/PQ1RPPB1/3R2K1',
55:'2r3k1/pb3p1p/1p4p1/2qp4/1P5P/2r3P1/PQ1RPPB1/3R2K1',
56:'2r3k1/pb2qp1p/1p4p1/3p4/1P5P/2r3P1/PQ1RPPB1/3R2K1',
57:'2r3k1/pb2qp1p/1p4p1/3p4/1P5P/2r1P1P1/PQ1R1PB1/3R2K1',
58:'2r3k1/pb2qp2/1p4p1/3p3p/1P5P/2r1P1P1/PQ1R1PB1/3R2K1',
59:'2r3k1/pb2qp2/1p4p1/3p3p/1P5P/P1r1P1P1/1Q1R1PB1/3R2K1',
60:'2r5/pb2qp1k/1p4p1/3p3p/1P5P/P1r1P1P1/1Q1R1PB1/3R2K1',
61:'2r5/pb2qp1k/1p4p1/3B3p/1P5P/P1r1P1P1/1Q1R1P2/3R2K1',
62:'2r5/p3qp1k/1p4p1/3b3p/1P5P/P1r1P1P1/1Q1R1P2/3R2K1',
63:'2r5/p3qp1k/1p4p1/3R3p/1P5P/P1r1P1P1/1Q3P2/3R2K1',
64:'2r5/p4p1k/1p4p1/3R3p/1P2q2P/P1r1P1P1/1Q3P2/3R2K1',
65:'2rR4/p4p1k/1p4p1/7p/1P2q2P/P1r1P1P1/1Q3P2/3R2K1',
66:'2rR4/p4p1k/1p4p1/7p/1P5P/P1r1PqP1/1Q3P2/3R2K1',
67:'2rR4/p4p1k/1p4p1/7p/1P5P/P1r1PqP1/1Q3P1K/3R4',
68:'3R4/p4p1k/1p4p1/7p/1Pr4P/P1r1PqP1/1Q3P1K/3R4',
69:'3R4/p2R1p1k/1p4p1/7p/1Pr4P/P1r1PqP1/1Q3P1K/8',
70:'3R4/p2R1p1k/1p6/6pp/1Pr4P/P1r1PqP1/1Q3P1K/8',
71:'5R2/p2R1p1k/1p6/6pp/1Pr4P/P1r1PqP1/1Q3P1K/8',
72:'5R2/p2R1p2/1p4k1/6pp/1Pr4P/P1r1PqP1/1Q3P1K/8',
73:'6R1/p2R1p2/1p4k1/6pp/1Pr4P/P1r1PqP1/1Q3P1K/8',
74:'6R1/p2R1p1k/1p6/6pp/1Pr4P/P1r1PqP1/1Q3P1K/8',
75:'8/p2R1p1k/1p6/6Rp/1Pr4P/P1r1PqP1/1Q3P1K/8',
76:'2r5/p2R1p1k/1p6/6Rp/1P5P/P1r1PqP1/1Q3P1K/8',
77:'2r5/p4p1k/1p6/3R2Rp/1P5P/P1r1PqP1/1Q3P1K/8',
78:'2r5/p4p2/1p5k/3R2Rp/1P5P/P1r1PqP1/1Q3P1K/8',
79:'2r5/p4p2/1p5k/5RRp/1P5P/P1r1PqP1/1Q3P1K/8',
},
comments:{
0:'Robert Fischer - Miroslav Filip Palma de Mallorca ,1970. Annotations by Jan Timman.',
1:'1.b3', 2:'1...d5', 3:'2.Bb2', 4:'2...Nf6', 5:'3.Nf3', 6:'3...e6', 7:'4.g3 The first – and last! – double fianchetto of Fischer’s career. Kasparov mentions a letter that Fischer wrote to Evans in 1963. He tells him that he is studying old opening manuals and then concludes: ‘They don’t waste time on the Catalan, Réti, King’s Indian Reversed and other rotten openings.’ Seven years later he has clearly broadened his outlook.', 8:'4...Be7', 9:'5.Bg2', 10:'5...O-O', 11:'6.O-O', 12:'6...c5',
13:'7.c4', 14:'7...Nc6', 15:'8.cxd5', 16:'8...Nxd5', 17:'9.Nc3', 18:'9...Bf6', 19:'10.Qc1', 20:'10...b6', 21:'11.Nxd5', 22:'11...exd5',
23:'12.d4', 24:'12...Ba6', 25:'13.Re1', 26:'13...Nxd4', 27:'14.Bxd4! The only way to play for an advantage. Flohr-Stoltz, Gothenburg 1931, saw 14.Nxd4 cxd4 15.Qd2 Re8 16.Bxd4 Rxe2! 17.Rxe2 Bxe2 18.Re1 Bg4, and a draw was agreed soon after.', 28:'14...cxd4', 29:'15.Qa3', 30:'15...Bb7', 31:'16.Rad1', 32:'16...Be7',
33:'17.Qa4', 34:'17...Qe8', 35:'18.Qxd4', 36:'18...Rc8', 37:'19.Qf4', 38:'19...Bf6', 39:'20.Nd4', 40:'20...Be5', 41:'21.Qe3', 42:'21...g6',
43:'22.Nb5 White has not achieved very much. If Black had now played 22…Rc5, he could almost have equalized, as he would meet 23.a4 with 23…Qe6. But Filip falls for the temptation to simplify the position, and now Fischer is in his element.', 44:'22...Qxb5', 45:'23.Qxe5', 46:'23...Rfe8', 47:'24.Qb2', 48:'24...Rc5', 49:'25.h4', 50:'25...Rec8', 51:'26.Rd2', 52:'26...Rc3',
53:'27.Red1', 54:'27...Qc5', 55:'28.b4', 56:'28...Qe7', 57:'29.e3', 58:'29...h5', 59:'30.a3 Slowly but surely White has made progress. Black decides to give up his weak d-pawn in exchange for active piece play, but Fischer counters this with impeccable technique.', 60:'30...Kh7', 61:'31.Bxd5', 62:'31...Bxd5',
63:'32.Rxd5', 64:'32...Qe4', 65:'33.Rd8', 66:'33...Qf3', 67:'34.Kh2', 68:'34...R8c4', 69:'35.R1d7', 70:'35...g5', 71:'36.Rf8', 72:'36...Kg6',
73:'37.Rg8+', 74:'37...Kh7', 75:'38.Rxg5', 76:'38...Rc8', 77:'39.Rdd5', 78:'39...Kh6', 79:'40.Rdf5 Black Resigns',
}
},
{
    id: 15,
      name: 'Voicemail from Bobby Fischer',
      description:
'\nExcerpts from an article by Lou Hays. The full article can be read in our book "Bobby Fischer: The Later Years.' +
'\n\n' +
'In 1992 I was a witness to and participant in some of the key events that led to Fischer’s decision to end his exile from chess. The standard narrative is that he needed the money and a banker in Yugoslavia put up a $5 million prize with no strings attached. But these are only the surface facts of a deeper story about Fischer’s motivations, a story I want to set straight here. The truth is, he was inspired by a teenager. Fischer was living in dire poverty early in 1992, but this had been the case for many years. Since 1972 he had made a habit of torpedoing proposed chess matches and product endorsements (“I don’t use them,” he would say) that could have brought him many millions of dollars. He had a brief change of heart early in 1992 and became willing to play chess again. This article gives an account of his thinking and activities leading up to the 1992 rematch with Boris Spassky. I met with Bobby Fischer on two occasions for a total of five days in Pasadena, California, both times in the month of April 1992. I never saw him after that, but now and then he would call me, usually to ask for help locating chess books. A friend and I provided Bobby with the funds to entertain Zita Rajcsanyi, a young Hungarian lady who, through letters and phone calls had earned his trust. Ultimately, Zita was responsible for inspiring his return to the board. Had she not come into his life when she did, he might well have died in poverty and oblivion in Los Angeles. I made a record of these events on cassette 3 tapes as they occurred. I subsequently put the tapes away and didn’t listen to them for a quarter of a century. When you get into your seventies, it becomes more important to tell a meaningful story than to bother about who will or won’t believe it. Tangible proof of my meetings with Fischer is fleeting, as he shunned photographs and autographs. His psychological state was such that I never wanted to risk losing his trust by asking for such things. He did give me a leather pocket chess set from Germany, but there is no proof it was from Fischer. I do, however, have a voice recording of Fischer leaving a message on my answering machine in June of 1992, just a month before the announcement of the 1992 Fischer – Spassky rematch. Fischer, in his inimitable voice, called to ask me to locate copies of the Chess and British Chess Magazine annuals for 1984 and 1985. He was cordial, offered to pay for the materials, and thanked me at the end of the message. Anybody can listen to this message by going to youtube.com and searching for “Voicemail from Bobby Fischer.”' +
'\n\n\n' +
'The voicemail can be found at https://www.youtube.com/watch?v=CCa15k61MLY. Here is the first game of the comeback match between Fischer and Spassky.\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
6:'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
7:'r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
8:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
9:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
10:'r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
11:'r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQR1K1',
12:'r1bqk2r/2ppbppp/p1n2n2/1p2p3/B3P3/5N2/PPPP1PPP/RNBQR1K1',
13:'r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1',
14:'r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1',
15:'r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1',
16:'r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1',
17:'r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1',
18:'rnbq1rk1/2p1bppp/p2p1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1',
19:'rnbq1rk1/2p1bppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1',
20:'r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1',
21:'r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP1N1PP1/R1BQR1K1',
22:'r2q1rk1/1bpnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP1N1PP1/R1BQR1K1',
23:'r2q1rk1/1bpnbppp/p2p1n2/1p2p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1',
24:'r2qr1k1/1bpnbppp/p2p1n2/1p2p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1',
25:'r2qr1k1/1bpnbppp/p2p1n2/1p2p3/3PP3/2P2N1P/PPB2PP1/R1BQRNK1',
26:'r2qrbk1/1bpn1ppp/p2p1n2/1p2p3/3PP3/2P2N1P/PPB2PP1/R1BQRNK1',
27:'r2qrbk1/1bpn1ppp/p2p1n2/1p2p3/3PP3/2P2NNP/PPB2PP1/R1BQR1K1',
28:'r2qrbk1/1bpn1p1p/p2p1np1/1p2p3/3PP3/2P2NNP/PPB2PP1/R1BQR1K1',
29:'r2qrbk1/1bpn1p1p/p2p1np1/1p2p1B1/3PP3/2P2NNP/PPB2PP1/R2QR1K1',
30:'r2qrbk1/1bpn1p2/p2p1npp/1p2p1B1/3PP3/2P2NNP/PPB2PP1/R2QR1K1',
31:'r2qrbk1/1bpn1p2/p2p1npp/1p2p3/3PP3/2P2NNP/PPBB1PP1/R2QR1K1',
32:'r2qr1k1/1bpn1pb1/p2p1npp/1p2p3/3PP3/2P2NNP/PPBB1PP1/R2QR1K1',
33:'r2qr1k1/1bpn1pb1/p2p1npp/1p2p3/P2PP3/2P2NNP/1PBB1PP1/R2QR1K1',
34:'r2qr1k1/1b1n1pb1/p2p1npp/1pp1p3/P2PP3/2P2NNP/1PBB1PP1/R2QR1K1',
35:'r2qr1k1/1b1n1pb1/p2p1npp/1ppPp3/P3P3/2P2NNP/1PBB1PP1/R2QR1K1',
36:'r2qr1k1/1b1n1pb1/p2p1npp/1p1Pp3/P1p1P3/2P2NNP/1PBB1PP1/R2QR1K1',
37:'r2qr1k1/1b1n1pb1/p2p1npp/1p1Pp3/PPp1P3/2P2NNP/2BB1PP1/R2QR1K1',
38:'r2qr1k1/1b1n1pbn/p2p2pp/1p1Pp3/PPp1P3/2P2NNP/2BB1PP1/R2QR1K1',
39:'r2qr1k1/1b1n1pbn/p2p2pp/1p1Pp3/PPp1P3/2P1BNNP/2B2PP1/R2QR1K1',
40:'r2qr1k1/1b1n1pbn/p2p2p1/1p1Pp2p/PPp1P3/2P1BNNP/2B2PP1/R2QR1K1',
41:'r2qr1k1/1b1n1pbn/p2p2p1/1p1Pp2p/PPp1P3/2P1BNNP/2BQ1PP1/R3R1K1',
42:'r2q1rk1/1b1n1pbn/p2p2p1/1p1Pp2p/PPp1P3/2P1BNNP/2BQ1PP1/R3R1K1',
43:'r2q1rk1/1b1n1pbn/p2p2p1/1p1Pp2p/PPp1P3/R1P1BNNP/2BQ1PP1/4R1K1',
44:'r2q1rk1/1b3pbn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/2BQ1PP1/4R1K1',
45:'r2q1rk1/1b3pbn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/2BQ1PP1/R5K1',
46:'r4rk1/1b1q1pbn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/2BQ1PP1/R5K1',
47:'r4rk1/1b1q1pbn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/R1BQ1PP1/6K1',
48:'r1r3k1/1b1q1pbn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/R1BQ1PP1/6K1',
49:'r1r3k1/1b1q1pbn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/R1B2PP1/2Q3K1',
50:'r1r2bk1/1b1q1p1n/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/R1B2PP1/2Q3K1',
51:'r1r2bk1/1b1q1p1n/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/R1B2PP1/Q5K1',
52:'r1r1qbk1/1b3p1n/p2p1np1/1p1Pp2p/PPp1P3/R1P1BNNP/R1B2PP1/Q5K1',
53:'r1r1qbk1/1b3p1n/p2p1np1/1p1Pp2p/PPp1P3/R1P1BN1P/R1B2PP1/Q4NK1',
54:'r1r1q1k1/1b2bp1n/p2p1np1/1p1Pp2p/PPp1P3/R1P1BN1P/R1B2PP1/Q4NK1',
55:'r1r1q1k1/1b2bp1n/p2p1np1/1p1Pp2p/PPp1P3/R1P1BN1P/R1BN1PP1/Q5K1',
56:'r1r1q3/1b2bpkn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BN1P/R1BN1PP1/Q5K1',
57:'r1r1q3/1b2bpkn/p2p1np1/1p1Pp2p/PPp1P3/R1P1BN1P/R1B2PP1/QN4K1',
58:'r1r1q3/1b2bpkn/p2p2p1/1p1Pp2p/PPp1n3/R1P1BN1P/R1B2PP1/QN4K1',
59:'r1r1q3/1b2bpkn/p2p2p1/1p1Pp2p/PPp1B3/R1P1BN1P/R4PP1/QN4K1',
60:'r1r1q3/1b2b1kn/p2p2p1/1p1Ppp1p/PPp1B3/R1P1BN1P/R4PP1/QN4K1',
61:'r1r1q3/1b2b1kn/p2p2p1/1p1Ppp1p/PPp5/R1P1BN1P/R1B2PP1/QN4K1',
62:'r1r1q3/4b1kn/p2p2p1/1p1bpp1p/PPp5/R1P1BN1P/R1B2PP1/QN4K1',
63:'r1r1q3/4b1kn/p2p2p1/1P1bpp1p/1Pp5/R1P1BN1P/R1B2PP1/QN4K1',
64:'r1r1q3/4b1kn/3p2p1/1p1bpp1p/1Pp5/R1P1BN1P/R1B2PP1/QN4K1',
65:'r1r1q3/R3b1kn/3p2p1/1p1bpp1p/1Pp5/2P1BN1P/R1B2PP1/QN4K1',
66:'r1r1q3/R3b2n/3p1kp1/1p1bpp1p/1Pp5/2P1BN1P/R1B2PP1/QN4K1',
67:'r1r1q3/R3b2n/3p1kp1/1p1bpp1p/1Pp5/2P1BN1P/R1BN1PP1/Q5K1',
68:'2r1q3/r3b2n/3p1kp1/1p1bpp1p/1Pp5/2P1BN1P/R1BN1PP1/Q5K1',
69:'2r1q3/R3b2n/3p1kp1/1p1bpp1p/1Pp5/2P1BN1P/2BN1PP1/Q5K1',
70:'r3q3/R3b2n/3p1kp1/1p1bpp1p/1Pp5/2P1BN1P/2BN1PP1/Q5K1',
71:'r3q3/R3b2n/3p1kp1/1p1bpp1p/1Pp3P1/2P1BN1P/2BN1P2/Q5K1',
72:'r3q3/R3b2n/3p1kp1/1p1bpp2/1Pp3p1/2P1BN1P/2BN1P2/Q5K1',
73:'r3q3/R3b2n/3p1kp1/1p1bpp2/1Pp3P1/2P1BN2/2BN1P2/Q5K1',
74:'4q3/r3b2n/3p1kp1/1p1bpp2/1Pp3P1/2P1BN2/2BN1P2/Q5K1',
75:'4q3/Q3b2n/3p1kp1/1p1bpp2/1Pp3P1/2P1BN2/2BN1P2/6K1',
76:'4q3/Q3b2n/3p1kp1/1p1bp3/1Pp2pP1/2P1BN2/2BN1P2/6K1',
77:'4q3/Q3b2n/3p1kp1/1p1bp3/1Pp2BP1/2P2N2/2BN1P2/6K1',
78:'4q3/Q3b2n/3p1kp1/1p1b4/1Pp2pP1/2P2N2/2BN1P2/6K1',
79:'4q3/Q3b2n/3p1kp1/1p1b4/1Pp2pPN/2P5/2BN1P2/6K1',
80:'4q3/Q3bb1n/3p1kp1/1p6/1Pp2pPN/2P5/2BN1P2/6K1',
81:'4q3/4bb1n/3p1kp1/1p6/1PpQ1pPN/2P5/2BN1P2/6K1',
82:'4q3/4bb1n/3pk1p1/1p6/1PpQ1pPN/2P5/2BN1P2/6K1',
83:'4q3/4bb1n/3pk1p1/1p3N2/1PpQ1pP1/2P5/2BN1P2/6K1',
84:'4qb2/5b1n/3pk1p1/1p3N2/1PpQ1pP1/2P5/2BN1P2/6K1',
85:'4qb2/5b1n/3pk1p1/1p3N2/1Pp2QP1/2P5/2BN1P2/6K1',
86:'4qb2/3k1b1n/3p2p1/1p3N2/1Pp2QP1/2P5/2BN1P2/6K1',
87:'4qb2/3k1b1n/3p2p1/1p6/1PpN1QP1/2P5/2BN1P2/6K1',
88:'5b2/3k1b1n/3p2p1/1p6/1PpN1QP1/2P5/2BN1P2/4q1K1',
89:'5b2/3k1b1n/3p2p1/1p6/1PpN1QP1/2P5/2BN1PK1/4q3',
90:'5b2/3k3n/3p2p1/1p1b4/1PpN1QP1/2P5/2BN1PK1/4q3',
91:'5b2/3k3n/3p2p1/1p1b4/1PpNBQP1/2P5/3N1PK1/4q3',
92:'5b2/3k3n/3p2p1/1p6/1PpNbQP1/2P5/3N1PK1/4q3',
93:'5b2/3k3n/3p2p1/1p6/1PpNNQP1/2P5/5PK1/4q3',
94:'8/3kb2n/3p2p1/1p6/1PpNNQP1/2P5/5PK1/4q3',
95:'8/3kb2n/3p2p1/1N6/1Pp1NQP1/2P5/5PK1/4q3',
96:'5n2/3kb3/3p2p1/1N6/1Pp1NQP1/2P5/5PK1/4q3',
97:'5n2/3kb3/3N2p1/8/1Pp1NQP1/2P5/5PK1/4q3',
98:'8/3kb3/3Nn1p1/8/1Pp1NQP1/2P5/5PK1/4q3',
99:'8/3kb3/3Nn1p1/4Q3/1Pp1N1P1/2P5/5PK1/4q3',
},
comments:{
0:'Bobby Fischer – Boris Spassky, Sveti Stefan 1992, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...e5', 3:'2.Nf3', 4:'2...Nc6', 5:'3.Bb5', 6:'3...a6', 7:'4.Ba4', 8:'4...Nf6', 9:'5.O-O', 10:'5...Be7', 11:'6.Re1', 12:'6...b5',
13:'7.Bb3', 14:'7...O-O', 15:'8.c3', 16:'8...d6', 17:'9.h3', 18:'9...Nb8', 19:'10.d4', 20:'10...Nbd7', 21:'11.Nbd2', 22:'11...Bb7', 23:'12.Bc2',
24:'12...Re8', 25:'13.Nf1', 26:'13...Bf8', 27:'14.Ng3', 28:'14...g6', 29:'15.Bg5', 30:'15...h6', 31:'16.Bd2', 32:'16...Bg7', 33:'17.a4', 34:'17...c5',
35:'18.d5', 36:'18...c4', 37:'19.b4! A strong novelty.', 38:'19...Nh7? The main line, 19...c×b3 20.B×b3 Nc5 21.c4!, is the lesser evil, as in the game Spassky has to sit and wait passively for White to build up pressure. This happens first on the queenside, but Fischer may switch to the other wing at any moment to open a second front. ', 39:'20.Be3', 40:'20...h5', 41:'21.Qd2', 42:'21...Rf8', 43:'22.Ra3', 44:'22...Ndf6',
45:'23.Rea1', 46:'23...Qd7', 47:'24.R1a2', 48:'24...Rfc8', 49:'25.Qc1', 50:'25...Bf8', 51:'26.Qa1 Fischer has installed “Alekhine’s Gun” on the a-file.', 52:'26...Qe8', 53:'27.Nf1', 54:'27...Be7',
55:'28.N1d2', 56:'28...Kg7', 57:'29.Nb1!', 58:'29...Nxe4!? A desperate try to get counterplay. After 29...Rab8 30.a×b5 a×b5 31.Ra7 Qd7 32.Na3, Black is bound hand and foot. White will sooner or later open a second front on the kingside and win.', 59:'30.Bxe4', 60:'30...f5? Exposing Black’s king, which Fischer will soon exploit. 30...Nf6 31.Nbd2 N×e4 32.N×e4 B×d5 33.Ned2± (Seirawan).', 61:'31.Bc2', 62:'31...Bxd5', 63:'32.axb5',
64:'32...axb5', 65:'33.Ra7', 66:'33...Kf6?!', 67:'34.Nbd2', 68:'34...Rxa7 34...f4? 35.Ne4+ B×e4 36.B×e4 R×a7 37.B×a7+- (Chandler).', 69:'35.Rxa7', 70:'35...Ra8', 71:'36.g4!? Fischer opens the floodgates.', 72:'36...hxg4',
73:'37.hxg4', 74:'37...Rxa7', 75:'38.Qxa7', 76:'38...f4', 77:'39.Bxf4!', 78:'39...exf4?! Spassky should try to reduce the attacking potential with 39...B×f3 40.B×e5+ d×e5 41.N×f3 Ng5. 40.Nh4 Bf7 41.Qd4+ Ke6 41...Kg5? 42.Qg7+- ', 79:'40.Nh4', 80:'40...Bf7', 81:'41.Qd4+',
82:'41...Ke6', 83:'42.Nf5!', 84:'42...Bf8', 85:'43.Qxf4', 86:'43...Kd7', 87:'44.Nd4', 88:'44...Qe1+', 89:'45.Kg2', 90:'45...Bd5+', 91:'46.Be4',
92:'46...Bxe4+', 93:'47.Nxe4', 94:'47...Be7', 95:'48.Nxb5', 96:'48...Nf8', 97:'49.Nbxd6', 98:'49...Ne6', 99:'50.Qe5 Black Resigns',
}
},
{
    id: 16,
      name: 'Interview with Ivkov',
      description:
'\nTHE LEGENDARY SERBIAN GM BORISLAV IVKOV SHARES HIS MEMORIES OF BOBBY FISCHER FANATICISM AND HARD WORK'+ '\n\n' +

'Elite Grandmaster and the first ever World Junior Chess Champion (1951), living legend Borislav Ivkov (85) played Bobby Fischer a total of ten times at classical time controls. Fischer won four games, Ivkov two, and the rest were drawn. In the early days of their rivalry “Bora” actually led 2-0 with three draws, but in 1966 Bobby won both their games at the double-round Piatigorsky Cup in Los Angeles. Yet only a year before, in the Capablanca Memorial, Ivkov had been feted in the streets of Havana as the “Hero of Cuba” – precisely because he had defeated Fischer!'+ '\n\n' +

'By Dusan Krunic (American Chess Magazine 2019)'+ '\n\n' +

'Please describe the first time you ever met with Fischer?'+ '\n\n' +

'I first got to know Bobby in 1958 when he played at the Interzonal tournament in Portoroz and qualified for the Candidates tournament at the age of fifteen. I remember him as a lanky boy with an infinite love of chess, although I had formed no particular opinions about him at that time. Our first over-the-board encounter came at Mar del Plata in 1959, where he was accompanied by his mother Regina, who was actually born in Switzerland and graduated from Medical University in Moscow.'+ '\n\n' +

'What do you remember about that first game that you played against him?'  + '\n\n' +

'Well, we played in the last round, when Najdorf and Pachman were in the lead, half a point ahead of the two of us, and also paired against each other. Of course, they made a quick draw, whereas we played with “swords drawn”! Our game was also drawn – in the final position Bobby was a piece up but I had a dangerous passed pawn... About ten days later, we played each other again in Santiago de Chile. I won that game with the black pieces, but Regina was no longer escorting Bobby as he had got angry with her for some reason.'+ '\n\n' +

'Fischer’s results in the period 1968-1972 show a clear superiority over his closest rivals. What do you think made him so dominant in those days – was it due to purely chess factors or those of a psychological nature, or a combination of both of these?'+ '\n\n' +

'Already in 1961, he was a very strong player. The level of his play in Bled that year was extremely high, he beat the Soviet players 3½ – ½ and was literally crushing everyone in those years. He was distinguished by his fanaticism but also hard work, which I only realized later. Not only did he analyze games played by his principal rivals, but he also delved deep into the past. However I might add that during the period leading up to Fischer’s conquest of the world title, the best Russian players were getting old and Boris Spassky had become exhausted by playing many tough matches in the years before Reykjavik.'+ '\n\n' +

'From your recollections, which of his rivals did Bobby respect most?'+ '\n\n' +

'He didn’t point to anyone in particular, but I learned from some Russian players that he had a special appreciation for Boleslavsky! Also for old masters like Lasker, Steinitz...'+ '\n\n' +

'What would you suggest as being Fischer’s greatest contribution to chess, purely from the aspect of the game itself?'+ '\n\n' +

'His contributions were enormous. For example, chess became headline sports news, money prizes skyrocketed, and hundreds of thousands of dollars went into world championship matches. Before Fischer, for example, Botvinnik and Smyslov played for a “dime”, as they say today, or, if I’m allowed to make a little joke, for Russian watches like “Zenit” or “Laika”.'+ '\n\n' +

'If Tarrasch is said to be “Praeceptor Germaniae” (the teacher of Germany), can we say that Fischer was “the Teacher of America”, of course purely in chess terms?'+ '\n\n' +

'Well, Tarrasch perhaps might be called that, but Bobby... I don’t think so. No one could have ever learned anything at the time from Bobby... or it was just that we were not able to understand him properly.'+ '\n\n' +

'Back in his day, Fischer talked about the “death” of classical chess. Did you agree or disagree with this viewpoint at that time? What is your present opinion on this?'+ '\n\n' +

'I never heard Fischer ever say any such thing! True, he did advocate “Fischer chess” (Fischerandom –Ed.), but I might let it be known that it wasn’t Bobby who invented this variation of chess. Twenty years before Fischer first mentioned it, Bisguier and Benko had played a match under similar rules to Fischerandom – and Bisguier had won by 3½:½!'+ '\n\n' +

'In 1992 a famous “World Championship re-match” took place in Sveti Stefan and Belgrade, with Fischer once again facing Spassky across the board. At that time was it the same Bobby Fischer you had known previously? What were the major changes you noticed in Bobby?'+ '\n\n' +

'No way! The Bobby Fischer who arrived in Yugoslavia was not even a pale shadow of his former self, who I used to know pretty well back in 1972. In that re-match with Spassky, Fischer’s only brilliant play could be seen in game 1, whereas all the other games he played at the level of a solid grandmaster, but nothing more than that.'+ '\n\n' +

'Can you please describe an experience you personally witnessed and which can be said to be characteristic of the Bobby Fischer you will always remember?'+ '\n\n' +

'That Havana tournament in 1965 always comes to mind. With three rounds to go I was in the clear lead with an “almost guaranteed” first place. I was far ahead of the chasing pack when I knocked myself out in my game against Garcia, blundering into a self-mate in one move. Then, in the last round I lost to Robatsch, who had previously always been my “regular customer”. Eventually Smyslov overtook me on the leader board, and other players too caught up with me. But it’s not only Garcia who remained in my memory. The U.S. authorities refused to give Fischer a travel permit to come to Cuba, so he had to play by telex from New York. The extra time required for transmitting moves meant he had to play each game for something like eight hours, while the rest of us in Havana played only for about five hours. So we might say he gave us three-hour time odds every day. On the other hand, I did win my game against him, thereby becoming, believe it or not – the hero of Cuba!'+ '\n\n' +

'Which anecdote about Bobby do you fondly remember? '+ '\n\n' +

'These are not anecdotes, but rather examples of tabloid journalism and even pure fiction, like his alleged statement: “There isn’t a woman player in the world I can’t give knight-odds to and still beat.” But Bobby never said that...' +
'\n\n\n' +
'This is the game that resulted in Ivkov being called the Hero of Cuba:\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
6:'r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R',
7:'r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
8:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R',
9:'r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
10:'r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1',
11:'r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQR1K1',
12:'r1bqk2r/2ppbppp/p1n2n2/1p2p3/B3P3/5N2/PPPP1PPP/RNBQR1K1',
13:'r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1',
14:'r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1',
15:'r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1',
16:'r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1',
17:'r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1',
18:'r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1',
19:'r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1',
20:'r1bq1rk1/4bppp/p2p1n2/npp1p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1',
21:'r1bq1rk1/4bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1',
22:'r1bq1rk1/3nbppp/p2p4/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1',
23:'r1bq1rk1/3nbppp/p2p4/npP1p3/4P3/2P2N1P/PPB2PP1/RNBQR1K1',
24:'r1bq1rk1/3nbppp/p7/npp1p3/4P3/2P2N1P/PPB2PP1/RNBQR1K1',
25:'r1bq1rk1/3nbppp/p7/npp1p3/4P3/2P2N1P/PPBN1PP1/R1BQR1K1',
26:'r1bq1rk1/3nb1pp/p4p2/npp1p3/4P3/2P2N1P/PPBN1PP1/R1BQR1K1',
27:'r1bq1rk1/3nb1pp/p4p2/npp1p3/4P2N/2P4P/PPBN1PP1/R1BQR1K1',
28:'r1bq1rk1/4b1pp/pn3p2/npp1p3/4P2N/2P4P/PPBN1PP1/R1BQR1K1',
29:'r1bq1rk1/4b1pp/pn3p2/npp1pN2/4P3/2P4P/PPBN1PP1/R1BQR1K1',
30:'r1bq2k1/4brpp/pn3p2/npp1pN2/4P3/2P4P/PPBN1PP1/R1BQR1K1',
31:'r1bq2k1/4Nrpp/pn3p2/npp1p3/4P3/2P4P/PPBN1PP1/R1BQR1K1',
32:'r1bq2k1/4r1pp/pn3p2/npp1p3/4P3/2P4P/PPBN1PP1/R1BQR1K1',
33:'r1bq2k1/4r1pp/pn3p2/npp1p3/4P3/2P2Q1P/PPBN1PP1/R1B1R1K1',
34:'r2q2k1/4r1pp/pn2bp2/npp1p3/4P3/2P2Q1P/PPBN1PP1/R1B1R1K1',
35:'r2q2k1/4r1pp/pn2bp2/npp1p3/4P3/2P2Q1P/PPB2PP1/R1B1RNK1',
36:'r2q2k1/3r2pp/pn2bp2/npp1p3/4P3/2P2Q1P/PPB2PP1/R1B1RNK1',
37:'r2q2k1/3r2pp/pn2bp2/npp1p3/4P3/2P1NQ1P/PPB2PP1/R1B1R1K1',
38:'r2q2k1/3r2pp/pn2bp2/np2p3/2p1P3/2P1NQ1P/PPB2PP1/R1B1R1K1',
39:'r2q2k1/3r2pp/pn2bp2/np2pN2/2p1P3/2P2Q1P/PPB2PP1/R1B1R1K1',
40:'r2q2k1/3r2pp/p3bp2/np2pN2/n1p1P3/2P2Q1P/PPB2PP1/R1B1R1K1',
41:'r2q2k1/3r2pp/p3bp2/np2pN2/B1p1P3/2P2Q1P/PP3PP1/R1B1R1K1',
42:'r2q2k1/3r2pp/p3bp2/n3pN2/p1p1P3/2P2Q1P/PP3PP1/R1B1R1K1',
43:'r2q2k1/3r2pp/p3bp2/n3pN2/p1p1P3/2P1BQ1P/PP3PP1/R3R1K1',
44:'r2q2k1/6pp/p3bp2/n3pN2/p1p1P3/2PrBQ1P/PP3PP1/R3R1K1',
45:'r2q2k1/6pp/p3bp2/n3pN2/p1p1P1Q1/2PrB2P/PP3PP1/R3R1K1',
46:'r5k1/3q2pp/p3bp2/n3pN2/p1p1P1Q1/2PrB2P/PP3PP1/R3R1K1',
47:'r5k1/3q2pp/p3bp2/n1B1pN2/p1p1P1Q1/2Pr3P/PP3PP1/R3R1K1',
48:'2r3k1/3q2pp/p3bp2/n1B1pN2/p1p1P1Q1/2Pr3P/PP3PP1/R3R1K1',
49:'2r3k1/3qB1pp/p3bp2/n3pN2/p1p1P1Q1/2Pr3P/PP3PP1/R3R1K1',
50:'2r3k1/3qB1pp/p4p2/n3pb2/p1p1P1Q1/2Pr3P/PP3PP1/R3R1K1',
51:'2r3k1/3qB1pp/p4p2/n3pQ2/p1p1P3/2Pr3P/PP3PP1/R3R1K1',
52:'2r3k1/3qB1pp/p1n2p2/4pQ2/p1p1P3/2Pr3P/PP3PP1/R3R1K1',
53:'2r3k1/3q2pp/p1n2p2/2B1pQ2/p1p1P3/2Pr3P/PP3PP1/R3R1K1',
54:'2rn2k1/3q2pp/p4p2/2B1pQ2/p1p1P3/2Pr3P/PP3PP1/R3R1K1',
55:'2rn2k1/3Q2pp/p4p2/2B1p3/p1p1P3/2Pr3P/PP3PP1/R3R1K1',
56:'2rn2k1/3r2pp/p4p2/2B1p3/p1p1P3/2P4P/PP3PP1/R3R1K1',
57:'2rn2k1/3r2pp/p4p2/2B1p3/p1p1P3/2P4P/PP3PP1/3RR1K1',
58:'2rn2k1/6pp/p4p2/2B1p3/p1p1P3/2Pr3P/PP3PP1/3RR1K1',
59:'2rn2k1/6pp/p4p2/4p3/p1p1P3/B1Pr3P/PP3PP1/3RR1K1',
60:'2r3k1/6pp/p1n2p2/4p3/p1p1P3/B1Pr3P/PP3PP1/3RR1K1',
61:'2r3k1/6pp/p1n2p2/4p3/p1p1P3/B1PR3P/PP3PP1/4R1K1',
62:'2r3k1/6pp/p1n2p2/4p3/p3P3/B1Pp3P/PP3PP1/4R1K1',
63:'2r3k1/6pp/p1n2p2/4p3/p3P3/B1Pp3P/PP3PP1/3R2K1',
64:'3r2k1/6pp/p1n2p2/4p3/p3P3/B1Pp3P/PP3PP1/3R2K1',
65:'3r2k1/6pp/p1n2p2/4p3/p3P3/B1Pp3P/PP3PP1/3R1K2',
66:'3r2k1/7p/p1n2pp1/4p3/p3P3/B1Pp3P/PP3PP1/3R1K2',
67:'3r2k1/7p/p1n2pp1/4p3/p3P1P1/B1Pp3P/PP3P2/3R1K2',
68:'3r2k1/7p/p1n3p1/4pp2/p3P1P1/B1Pp3P/PP3P2/3R1K2',
69:'3r2k1/7p/p1n3p1/4pP2/p3P3/B1Pp3P/PP3P2/3R1K2',
70:'3r2k1/7p/p1n5/4pp2/p3P3/B1Pp3P/PP3P2/3R1K2',
71:'3r2k1/7p/p1n5/4pP2/p7/B1Pp3P/PP3P2/3R1K2',
72:'3r2k1/7p/p1n5/5P2/p3p3/B1Pp3P/PP3P2/3R1K2',
73:'3r2k1/7p/p1n5/5P2/p3p3/B1Pp3P/PP3P2/3RK3',
74:'3r2k1/7p/p7/4nP2/p3p3/B1Pp3P/PP3P2/3RK3',
75:'3r2k1/7p/p7/2B1nP2/p3p3/2Pp3P/PP3P2/3RK3',
76:'3r2k1/7p/p7/2B2P2/p3p3/2Pp1n1P/PP3P2/3RK3',
77:'3r2k1/7p/p7/2B2P2/p3p3/2Pp1n1P/PP3P2/3R1K2',
78:'3r4/5k1p/p7/2B2P2/p3p3/2Pp1n1P/PP3P2/3R1K2',
79:'3r4/5k1p/p7/2B2P2/p3p3/2Pp1n1P/PP3PK1/3R4',
80:'6r1/5k1p/p7/2B2P2/p3p3/2Pp1n1P/PP3PK1/3R4',
81:'6r1/5k1p/p7/2B2P2/p3p3/2Pp1n1P/PP3P2/3R3K',
82:'8/5k1p/p7/2B2P2/p3p3/2Pp1n1P/PP3P2/3R2rK',
83:'8/5k1p/p7/2B2P2/p3p3/2Pp1n1P/PP3P2/6RK',
84:'8/5k1p/p7/2B2P2/p3p3/2Pp3P/PP3P2/6nK',
85:'8/5k1p/p7/5P2/p3p3/2PpB2P/PP3P2/6nK',
86:'8/5k1p/p7/5P2/p3p3/2PpBn1P/PP3P2/7K',
87:'8/5k1p/p7/5P2/p3p3/2PpBn1P/PP3PK1/8',
88:'8/5k1p/p7/5P2/p3p3/2P1Bn1P/PP1p1PK1/8',
89:'8/5k1p/p7/5P2/p3p3/2P2n1P/PP1B1PK1/8',
90:'8/5k1p/p7/5P2/p3p3/2P4P/PP1n1PK1/8',
91:'8/5k1p/p7/5P2/p3p3/2P3KP/PP1n1P2/8',
92:'8/7p/p4k2/5P2/p3p3/2P3KP/PP1n1P2/8',
93:'8/7p/p4k2/5P2/p3pK2/2P4P/PP1n1P2/8',
94:'8/8/p4k2/5P1p/p3pK2/2P4P/PP1n1P2/8',
95:'8/8/p4k2/5P1p/p3p3/2P1K2P/PP1n1P2/8',
96:'8/8/p4k2/5P1p/p3p3/2P1Kn1P/PP3P2/8',
97:'8/8/p4k2/5P1p/p3K3/2P2n1P/PP3P2/8',
98:'8/8/p4k2/5Pnp/p3K3/2P4P/PP3P2/8',
99:'8/8/p4k2/5Pnp/p4K2/2P4P/PP3P2/8',
100:'8/8/p4k2/5P1p/p4K2/2P4n/PP3P2/8',
101:'8/8/p4k2/5P1p/p7/2P3Kn/PP3P2/8',
102:'8/8/p4k2/5Pnp/p7/2P3K1/PP3P2/8',
103:'8/8/p4k2/5Pnp/p6K/2P5/PP3P2/8',
104:'8/8/p7/5knp/p6K/2P5/PP3P2/8',
105:'8/8/p7/5knK/p7/2P5/PP3P2/8',
106:'8/8/p7/5k1K/p3n3/2P5/PP3P2/8',
},
comments:{
0:'Robert Fischer - Borislav Ivkov, Capablanca Memorial 1965, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...e5', 3:'2.Nf3', 4:'2...Nc6', 5:'3.Bb5', 6:'3...a6', 7:'4.Ba4', 8:'4...Nf6', 9:'5.O-O', 10:'5...Be7', 11:'6.Re1', 12:'6...b5',
13:'7.Bb3', 14:'7...O-O', 15:'8.c3', 16:'8...d6', 17:'9.h3', 18:'9...Na5', 19:'10.Bc2', 20:'10...c5', 21:'11.d4', 22:'11...Nd7', 23:'12.dxc5',
24:'12...dxc5', 25:'13.Nbd2', 26:'13...f6', 27:'14.Nh4', 28:'14...Nb6', 29:'15.Nf5', 30:'15...Rf7', 31:'16.Nxe7+?! Releasing the tension too early. With 16.Qg4, White can hope for a small advantage.', 32:'16...Rxe7',
33:'17.Qf3', 34:'17...Be6', 35:'18.Nf1', 36:'18...Rd7', 37:'19.Ne3', 38:'19...c4', 39:'20.Nf5', 40:'20...Na4', 41:'21.Bxa4', 42:'21...bxa4',
43:'22.Be3', 44:'22...Rd3', 45:'23.Qg4', 46:'23...Qd7', 47:'24.Bc5', 48:'24...Rc8', 49:'25.Be7', 50:'25...Bxf5', 51:'26.Qxf5', 52:'26...Nc6',
53:'27.Bc5', 54:'27...Nd8', 55:'28.Qxd7', 56:'28...Rxd7', 57:'29.Rad1', 58:'29...Rd3!', 59:'30.Ba3', 60:'30...Nc6', 61:'31.Rxd3',
62:'31...cxd3', 63:'32.Rd1', 64:'32...Rd8', 65:'33.Kf1', 66:'33...g6', 67:'34.g4', 68:'34...f5', 69:'35.gxf5? Now it is not so easy to activate White’s king. 35.e×f5 g×f5 36.Kg2, and White is not worse.', 70:'35...gxf5', 71:'36.exf5',
72:'36...e4', 73:'37.Ke1? Running into the knight attack. After 37.b3, White can put up much better resistance, e.g., 37...Kf7 38.Ke1 Kf6 39.Kd2 a×b3 40.a×b3 Rb8 (40...K×f5 41.c4 Nd4 42.Kc3) 41.Ke3 R×b3 42.Bd6 K×f5 43.f3', 74:'37...Ne5', 75:'38.Bc5', 76:'38...Nf3+', 77:'39.Kf1', 78:'39...Kf7 Black is winning', 79:'40.Kg2', 80:'40...Rg8+', 81:'41.Kh1',
82:'41...Rg1+', 83:'42.Rxg1', 84:'42...Nxg1', 85:'43.Be3', 86:'43...Nf3', 87:'44.Kg2', 88:'44...d2', 89:'45.Bxd2', 90:'45...Nxd2',
91:'46.Kg3', 92:'46...Kf6', 93:'47.Kf4', 94:'47...h5', 95:'48.Ke3', 96:'48...Nf3', 97:'49.Kxe4', 98:'49...Ng5+', 99:'50.Kf4', 100:'50...Nxh3+',
101:'51.Kg3', 102:'51...Ng5', 103:'52.Kh4', 104:'52...Kxf5', 105:'53.Kxh5', 106:'53...Ne4 White Resigns'
}
},
{
    id: 17,
      name: 'The Red Book',
      description:
'\nFrom Stuart Rachels\' essay about chess: "The Reviled Art" from the book "Philosophy Looks at Chess":' +
'\n\n' +
'\"When Bobby Fischer was preparing to play Spassky in 1972, he studied Spassky’s games in “the red book”-a book published in German, so-called because of its cover. Back then, there were no databases, and Fischer was lucky that this book containing 353 of Spassky’s games existed and was in his possession. A friend of Fischer’s told me that you could give Bobby any number between 1 and 353, and he could tell you: all the moves to that game; the analysis of the game given in the book; and Fischer’s own improved analysis. This is the most amazing feat of memory I have ever heard attributed to a chess player. (Allen Kaufman is the friend of Fischer’s who told me about this.)\"' +
'\n\n\n' +
'Some of Fischer’s annotations, neatly handwritten in the margins of his copy of the “red book”, are fascinating. Witness the following cryptic note to the game Spassky–Suetin, Soviet Union, 1967. After 1.e4 c5 2.Nf3 Nc6 3.Nc3 e6 4.d4 cxd4 5.Nxd4 Qc7 6.Be3 a6 7.Nb3 Nf6 8.f4 Bb4 9.Bd3 Fischer has written in the margin 9. ...d5!' +
'\n\n' +
'This novel way of handling this variation where putting the Black pawn on d6 is the norm, was first employed in this exact position by Adolf Anderssen in 1877 (he played …d5 in similar Sicilians on many prior occasions), but seldom seen until the last game of the 1972 World Championship match in Reykjavik which opened 1.e4 c5 2.Nf3 e6 3.d4 cxd4 4. Nxd4 a6 5.Nc3 Nc6 6.Be3 Nf6 7.Bd3 d5.\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',
6:'rnbqkbnr/pp1p1ppp/4p3/8/3pP3/5N2/PPP2PPP/RNBQKB1R',
7:'rnbqkbnr/pp1p1ppp/4p3/8/3NP3/8/PPP2PPP/RNBQKB1R',
8:'rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/8/PPP2PPP/RNBQKB1R',
9:'rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
10:'r1bqkbnr/1p1p1ppp/p1n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R',
11:'r1bqkbnr/1p1p1ppp/p1n1p3/8/3NP3/2N1B3/PPP2PPP/R2QKB1R',
12:'r1bqkb1r/1p1p1ppp/p1n1pn2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R',
13:'r1bqkb1r/1p1p1ppp/p1n1pn2/8/3NP3/2NBB3/PPP2PPP/R2QK2R',
14:'r1bqkb1r/1p3ppp/p1n1pn2/3p4/3NP3/2NBB3/PPP2PPP/R2QK2R',
15:'r1bqkb1r/1p3ppp/p1n1pn2/3P4/3N4/2NBB3/PPP2PPP/R2QK2R',
16:'r1bqkb1r/1p3ppp/p1n2n2/3p4/3N4/2NBB3/PPP2PPP/R2QK2R',
17:'r1bqkb1r/1p3ppp/p1n2n2/3p4/3N4/2NBB3/PPP2PPP/R2Q1RK1',
18:'r1bqk2r/1p3ppp/p1nb1n2/3p4/3N4/2NBB3/PPP2PPP/R2Q1RK1',
19:'r1bqk2r/1p3ppp/p1Nb1n2/3p4/8/2NBB3/PPP2PPP/R2Q1RK1',
20:'r1bqk2r/5ppp/p1pb1n2/3p4/8/2NBB3/PPP2PPP/R2Q1RK1',
21:'r1bqk2r/5ppp/p1pb1n2/3p4/3B4/2NB4/PPP2PPP/R2Q1RK1',
22:'r1bq1rk1/5ppp/p1pb1n2/3p4/3B4/2NB4/PPP2PPP/R2Q1RK1',
23:'r1bq1rk1/5ppp/p1pb1n2/3p4/3B4/2NB1Q2/PPP2PPP/R4RK1',
24:'r2q1rk1/5ppp/p1pbbn2/3p4/3B4/2NB1Q2/PPP2PPP/R4RK1',
25:'r2q1rk1/5ppp/p1pbbn2/3p4/3B4/2NB1Q2/PPP2PPP/R3R1K1',
26:'r2q1rk1/5ppp/p2bbn2/2pp4/3B4/2NB1Q2/PPP2PPP/R3R1K1',
27:'r2q1rk1/5ppp/p2bbB2/2pp4/8/2NB1Q2/PPP2PPP/R3R1K1',
28:'r4rk1/5ppp/p2bbq2/2pp4/8/2NB1Q2/PPP2PPP/R3R1K1',
29:'r4rk1/5ppp/p2bbQ2/2pp4/8/2NB4/PPP2PPP/R3R1K1',
30:'r4rk1/5p1p/p2bbp2/2pp4/8/2NB4/PPP2PPP/R3R1K1',
31:'r4rk1/5p1p/p2bbp2/2pp4/8/2NB4/PPP2PPP/3RR1K1',
32:'r2r2k1/5p1p/p2bbp2/2pp4/8/2NB4/PPP2PPP/3RR1K1',
33:'r2r2k1/5p1p/p2bbp2/2pp4/8/2N5/PPP1BPPP/3RR1K1',
34:'1r1r2k1/5p1p/p2bbp2/2pp4/8/2N5/PPP1BPPP/3RR1K1',
35:'1r1r2k1/5p1p/p2bbp2/2pp4/8/1PN5/P1P1BPPP/3RR1K1',
36:'1r1r2k1/5p1p/p2bbp2/3p4/2p5/1PN5/P1P1BPPP/3RR1K1',
37:'1r1r2k1/5p1p/p2bbp2/3N4/2p5/1P6/P1P1BPPP/3RR1K1',
38:'1r1r2k1/5p1p/p2b1p2/3b4/2p5/1P6/P1P1BPPP/3RR1K1',
39:'1r1r2k1/5p1p/p2b1p2/3R4/2p5/1P6/P1P1BPPP/4R1K1',
40:'1r1r2k1/5p1p/p4p2/3R4/2p5/1P6/P1P1BPPb/4R1K1',
41:'1r1r2k1/5p1p/p4p2/3R4/2p5/1P6/P1P1BPPK/4R3',
42:'1r4k1/5p1p/p4p2/3r4/2p5/1P6/P1P1BPPK/4R3',
43:'1r4k1/5p1p/p4p2/3r4/2B5/1P6/P1P2PPK/4R3',
44:'1r4k1/5p1p/p4p2/8/2B5/1P6/P1Pr1PPK/4R3',
45:'1r4k1/5p1p/B4p2/8/8/1P6/P1Pr1PPK/4R3',
46:'1r4k1/5p1p/B4p2/8/8/1P6/P1r2PPK/4R3',
47:'1r4k1/5p1p/B4p2/8/8/1P6/P1r1RPPK/8',
48:'1r4k1/5p1p/B4p2/8/8/1P6/P3rPPK/8',
49:'1r4k1/5p1p/5p2/8/8/1P6/P3BPPK/8',
50:'3r2k1/5p1p/5p2/8/8/1P6/P3BPPK/8',
51:'3r2k1/5p1p/5p2/8/P7/1P6/4BPPK/8',
52:'6k1/5p1p/5p2/8/P7/1P6/3rBPPK/8',
53:'6k1/5p1p/5p2/8/P1B5/1P6/3r1PPK/8',
54:'6k1/5p1p/5p2/8/P1B5/1P6/r4PPK/8',
55:'6k1/5p1p/5p2/8/P1B5/1P4K1/r4PP1/8',
56:'5k2/5p1p/5p2/8/P1B5/1P4K1/r4PP1/8',
57:'5k2/5p1p/5p2/8/P1B5/1P3K2/r4PP1/8',
58:'8/4kp1p/5p2/8/P1B5/1P3K2/r4PP1/8',
59:'8/4kp1p/5p2/8/P1B3P1/1P3K2/r4P2/8',
60:'8/4kp1p/8/5p2/P1B3P1/1P3K2/r4P2/8',
61:'8/4kp1p/8/5P2/P1B5/1P3K2/r4P2/8',
62:'8/4k2p/5p2/5P2/P1B5/1P3K2/r4P2/8',
63:'6B1/4k2p/5p2/5P2/P7/1P3K2/r4P2/8',
64:'6B1/4k3/5p1p/5P2/P7/1P3K2/r4P2/8',
65:'6B1/4k3/5p1p/5P2/P7/1P4K1/r4P2/8',
66:'6B1/8/3k1p1p/5P2/P7/1P4K1/r4P2/8',
67:'6B1/8/3k1p1p/5P2/P7/1P3K2/r4P2/8',
68:'6B1/8/3k1p1p/5P2/P7/1P3K2/5P2/r7',
69:'6B1/8/3k1p1p/5P2/P7/1P6/5PK1/r7',
70:'6B1/8/5p1p/4kP2/P7/1P6/5PK1/r7',
71:'8/8/4Bp1p/4kP2/P7/1P6/5PK1/r7',
72:'8/8/4Bp1p/5P2/P4k2/1P6/5PK1/r7',
73:'8/3B4/5p1p/5P2/P4k2/1P6/5PK1/r7',
74:'8/3B4/5p1p/5P2/P4k2/1P6/5PK1/1r6',
75:'8/8/4Bp1p/5P2/P4k2/1P6/5PK1/1r6',
76:'8/8/4Bp1p/5P2/P4k2/1P6/1r3PK1/8',
77:'8/8/5p1p/5P2/P1B2k2/1P6/1r3PK1/8',
78:'8/8/5p1p/5P2/P1B2k2/1P6/r4PK1/8',
79:'8/8/4Bp1p/5P2/P4k2/1P6/r4PK1/8',
80:'8/8/4Bp2/5P1p/P4k2/1P6/r4PK1/8',
81:'8/3B4/5p2/5P1p/P4k2/1P6/r4PK1/8',
},
comments:{
0:'Boris Spassky - Robert Fischer, World Championship 1972, Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...c5', 3:'2.Nf3', 4:'2...e6', 5:'3.d4', 6:'3...cxd4', 7:'4.Nxd4', 8:'4...a6', 9:'5.Nc3', 10:'5...Nc6', 11:'6.Be3', 12:'6...Nf6',
13:'7.Bd3', 14:'7...d5 !? A very rarely played advance. Fischer may have been inspired by an old Anderssen game.', 15:'8.exd5', 16:'8...exd5', 17:'9.O-O', 18:'9...Bd6', 19:'10.Nxc6 10.Bf5?! 0-0 11.Bg5 Be5, and Black had no problems, Goering-Anderssen, Leipzig 1877. ', 20:'10...bxc6', 21:'11.Bd4', 22:'11...O-O',
23:'12.Qf3?! 12.Na4 is more critical as Black is fine in the resulting endgame.', 24:'12...Be6', 25:'13.Rfe1', 26:'13...c5', 27:'14.Bxf6', 28:'14...Qxf6', 29:'15.Qxf6', 30:'15...gxf6', 31:'16.Rad1',
32:'16...Rfd8', 33:'17.Be2? Putting the bishop in the way. 17.Bf1, to answer 17...c4 with 18.Ne2, is more harmonious.', 34:'17...Rab8', 35:'18.b3', 36:'18...c4! Opening lines for Black.', 37:'19.Nxd5 Spassky reacts vigorously by giving the exchange. It is difficult to suggest an alternative.', 38:'19...Bxd5', 39:'20.Rxd5', 40:'20...Bxh2+',
41:'21.Kxh2', 42:'21...Rxd5', 43:'22.Bxc4', 44:'22...Rd2', 45:'23.Bxa6', 46:'23...Rxc2', 47:'24.Re2', 48:'24...Rxe2', 49:'25.Bxe2',
50:'25...Rd8', 51:'26.a4', 52:'26...Rd2', 53:'27.Bc4', 54:'27...Ra2 After 27...R×f2, White’s a-pawn can advance: 28.a5 Kf8 29.a6 Rb2 30.Bd5 Ra2 31.Bc4, with good drawing chances.', 55:'28.Kg3', 56:'28...Kf8', 57:'29.Kf3 29.f4!? (Karpov).', 58:'29...Ke7', 59:'30.g4? Allowing Black to create a passed pawn easily; 30.g3 is more tenacious.', 60:'30...f5!',
61:'31.gxf5', 62:'31...f6', 63:'32.Bg8', 64:'32...h6', 65:'33.Kg3', 66:'33...Kd6', 67:'34.Kf3? Now Black’s king can invade. The direct route should be closed by 34.f4.', 68:'34...Ra1!', 69:'35.Kg2 35.Be6? Rg1 36.Bf7 Ke7 37.Bd5 h5 38.a5 Kd6-+', 70:'35...Ke5',
71:'36.Be6', 72:'36...Kf4', 73:'37.Bd7', 74:'37...Rb1', 75:'38.Be6', 76:'38...Rb2', 77:'39.Bc4', 78:'39...Ra2', 79:'40.Be6', 80:'40...h5',
81:'41.Bd7  The sealed move. 41.Kh3 loses as well: 41...R×f2 42.a5 Ra2 43.a6 Kg5 44.Bc4 Ra3-+; 41...Kg4 42.Bc6 h4 43.Bf3+ K×f5 44.Bc6 Kg4 45.Bf3+ Kf4 46.Bc6 Rc2 47.Bd5 Rc3 (Gligoric) 48.Bc4 h3+ 49.Kh2 Kg4 50.a5 Rc2 51.Kg1 h2+ 52.K×h2 R×f2+ 53.Kg1 Kg3-+. The game was adjourned, but analysis quickly convinced Spassky - and analysts around the world - that White could not hold the position in the face of Black’s dynamic, active advantage. When Fischer arrived on Friday, September 1 to resume the game, the announcement was made that Spassky had resigned. The chess world had a new champion. ',
}
},
{
    id: 18,
      name: 'Fischer and the Border Patrol',
      description:
'\nFischer and the Border Patrol by Dan Heisman'+
'\n\n' +
'Professor (Donald) Byrne, Fischer, and the rest of the US Olympiad team were on their way to Eastern Europe which was, of course, behind the Iron Curtain in those days. I suppose it had to be the one in Varna, Bulgaria, in 1962. The team met in central Europe (possibly Germany - it\'s been a while!) and then took the train toward their destination. They had a compartment where the US Team all travelled together.'+
'\n\n' +
'As you can surmise, this meant they had to cross at least one border by train. At a border the train stopped and was boarded by the military so that they could check everyone\s visas and passports.'+
'\n\n' +
'Byrne related that when Fischer (who in 1962 would be age 19) realized what was going on, he got up and shut the compartment door, mumbling something about "I\'m not going to let those Commies....!"'+
'\n\n' +
'The rest of the group was horrified and rushed to re-open the door to let in the heavily armed troopers. Everyone (well, except Fischer) went out of their way to be very friendly, and kind of quietly intimated "Don\'t mind our friend over there - he\'s a little eccentric..."'+
'\n\n' +
'Luckily the troopers did not make a big deal out of it and everything turned out safe for the home team (which finished 4th in that Olympiad ).' +
'\n\n' ,

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR',
4:'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR',
5:'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR',
6:'rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR',
7:'rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR',
8:'rn1qkbnr/pp2pppp/2p5/5b2/3PN3/8/PPP2PPP/R1BQKBNR',
9:'rn1qkbnr/pp2pppp/2p5/5b2/3P4/6N1/PPP2PPP/R1BQKBNR',
10:'rn1qkbnr/pp2pppp/2p3b1/8/3P4/6N1/PPP2PPP/R1BQKBNR',
11:'rn1qkbnr/pp2pppp/2p3b1/8/3P3P/6N1/PPP2PP1/R1BQKBNR',
12:'rn1qkbnr/pp2ppp1/2p3bp/8/3P3P/6N1/PPP2PP1/R1BQKBNR',
13:'rn1qkbnr/pp2ppp1/2p3bp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R',
14:'r2qkbnr/pp1nppp1/2p3bp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R',
15:'r2qkbnr/pp1nppp1/2p3bp/8/3P3P/3B1NN1/PPP2PP1/R1BQK2R',
16:'r2qkbnr/pp1nppp1/2p4p/8/3P3P/3b1NN1/PPP2PP1/R1BQK2R',
17:'r2qkbnr/pp1nppp1/2p4p/8/3P3P/3Q1NN1/PPP2PP1/R1B1K2R',
18:'r2qkbnr/pp1n1pp1/2p1p2p/8/3P3P/3Q1NN1/PPP2PP1/R1B1K2R',
19:'r2qkbnr/pp1n1pp1/2p1p2p/8/3P1B1P/3Q1NN1/PPP2PP1/R3K2R',
20:'r3kbnr/pp1n1pp1/2p1p2p/q7/3P1B1P/3Q1NN1/PPP2PP1/R3K2R',
21:'r3kbnr/pp1n1pp1/2p1p2p/q7/3P3P/3Q1NN1/PPPB1PP1/R3K2R',
22:'r3kbnr/ppqn1pp1/2p1p2p/8/3P3P/3Q1NN1/PPPB1PP1/R3K2R',
23:'r3kbnr/ppqn1pp1/2p1p2p/8/2PP3P/3Q1NN1/PP1B1PP1/R3K2R',
24:'r3kb1r/ppqn1pp1/2p1pn1p/8/2PP3P/3Q1NN1/PP1B1PP1/R3K2R',
25:'r3kb1r/ppqn1pp1/2p1pn1p/8/2PP3P/2BQ1NN1/PP3PP1/R3K2R',
26:'r3kb1r/1pqn1pp1/2p1pn1p/p7/2PP3P/2BQ1NN1/PP3PP1/R3K2R',
27:'r3kb1r/1pqn1pp1/2p1pn1p/p7/2PP3P/2BQ1NN1/PP3PP1/R4RK1',
28:'r3k2r/1pqn1pp1/2pbpn1p/p7/2PP3P/2BQ1NN1/PP3PP1/R4RK1',
29:'r3k2r/1pqn1pp1/2pbpn1p/p7/2PPN2P/2BQ1N2/PP3PP1/R4RK1',
30:'r3k2r/1pqn1pp1/2pbp2p/p7/2PPn2P/2BQ1N2/PP3PP1/R4RK1',
31:'r3k2r/1pqn1pp1/2pbp2p/p7/2PPQ2P/2B2N2/PP3PP1/R4RK1',
32:'r4rk1/1pqn1pp1/2pbp2p/p7/2PPQ2P/2B2N2/PP3PP1/R4RK1',
33:'r4rk1/1pqn1pp1/2pbp2p/p2P4/2P1Q2P/2B2N2/PP3PP1/R4RK1',
34:'r3r1k1/1pqn1pp1/2pbp2p/p2P4/2P1Q2P/2B2N2/PP3PP1/R4RK1',
35:'r3r1k1/1pqn1pp1/2Pbp2p/p7/2P1Q2P/2B2N2/PP3PP1/R4RK1',
36:'r3r1k1/2qn1pp1/2pbp2p/p7/2P1Q2P/2B2N2/PP3PP1/R4RK1',
37:'r3r1k1/2qn1pp1/2pbp2p/p7/2P1Q2P/2B2N2/PP3PP1/3R1RK1',
38:'r3rbk1/2qn1pp1/2p1p2p/p7/2P1Q2P/2B2N2/PP3PP1/3R1RK1',
39:'r3rbk1/2qn1pp1/2p1p2p/p7/2PNQ2P/2B5/PP3PP1/3R1RK1',
40:'4rbk1/2qn1pp1/r1p1p2p/p7/2PNQ2P/2B5/PP3PP1/3R1RK1',
41:'4rbk1/2qn1pp1/r1p1p2p/p4N2/2P1Q2P/2B5/PP3PP1/3R1RK1',
42:'4rbk1/2q2pp1/r1p1p2p/p1n2N2/2P1Q2P/2B5/PP3PP1/3R1RK1',
43:'4rbk1/2q2pp1/r1p1p2p/p1n2N2/2P4P/2B1Q3/PP3PP1/3R1RK1',
44:'4rbk1/2q2pp1/r1p1p2p/p4N2/n1P4P/2B1Q3/PP3PP1/3R1RK1',
45:'4rbk1/2q2pp1/r1p1p2p/p3BN2/n1P4P/4Q3/PP3PP1/3R1RK1',
46:'4rbk1/q4pp1/r1p1p2p/p3BN2/n1P4P/4Q3/PP3PP1/3R1RK1',
47:'4rbk1/q4pp1/r1p1p2N/p3B3/n1P4P/4Q3/PP3PP1/3R1RK1',
48:'4rbk1/q4p2/r1p1p2p/p3B3/n1P4P/4Q3/PP3PP1/3R1RK1',
49:'4rbk1/q4p2/r1p1p2p/p3B3/n1PR3P/4Q3/PP3PP1/5RK1',
50:'4rbk1/q7/r1p1p2p/p3Bp2/n1PR3P/4Q3/PP3PP1/5RK1',
51:'4rbk1/q7/r1p1p2p/p3Bp2/n1PR3P/4Q3/PP3PP1/3R2K1',
52:'4rbk1/q7/r1p1p2p/p1n1Bp2/2PR3P/4Q3/PP3PP1/3R2K1',
53:'3Rrbk1/q7/r1p1p2p/p1n1Bp2/2P4P/4Q3/PP3PP1/3R2K1',
54:'3Rrbk1/5q2/r1p1p2p/p1n1Bp2/2P4P/4Q3/PP3PP1/3R2K1',
55:'4Rbk1/5q2/r1p1p2p/p1n1Bp2/2P4P/4Q3/PP3PP1/3R2K1',
56:'4qbk1/8/r1p1p2p/p1n1Bp2/2P4P/4Q3/PP3PP1/3R2K1',
57:'4qbk1/8/r1p1p2p/p1n2p2/2PB3P/4Q3/PP3PP1/3R2K1',
58:'4qbk1/8/r1p1p2p/p4p2/2PBn2P/4Q3/PP3PP1/3R2K1',
59:'4qbk1/8/r1p1p2p/p4p2/2PBn2P/4QP2/PP4P1/3R2K1',
60:'4qbk1/8/r1p4p/p3pp2/2PBn2P/4QP2/PP4P1/3R2K1',
61:'4qbk1/8/r1p4p/p3pp2/2PBP2P/4Q3/PP4P1/3R2K1',
62:'4qbk1/8/r1p4p/p4p2/2PpP2P/4Q3/PP4P1/3R2K1',
63:'4qbk1/8/r1p4p/p4p2/2PpP2P/6Q1/PP4P1/3R2K1',
64:'4q1k1/6b1/r1p4p/p4p2/2PpP2P/6Q1/PP4P1/3R2K1',
65:'4q1k1/6b1/r1p4p/p4P2/2Pp3P/6Q1/PP4P1/3R2K1',
66:'6k1/6b1/r1p4p/p4P2/2Pp3P/4q1Q1/PP4P1/3R2K1',
67:'6k1/6b1/r1p4p/p4P2/2Pp3P/4Q3/PP4P1/3R2K1',
68:'6k1/6b1/r1p4p/p4P2/2P4P/4p3/PP4P1/3R2K1',
69:'3R2k1/6b1/r1p4p/p4P2/2P4P/4p3/PP4P1/6K1',
70:'3R4/5kb1/r1p4p/p4P2/2P4P/4p3/PP4P1/6K1',
71:'8/3R1kb1/r1p4p/p4P2/2P4P/4p3/PP4P1/6K1',
72:'8/3R2b1/r1p2k1p/p4P2/2P4P/4p3/PP4P1/6K1',
73:'8/3R2b1/r1p2k1p/p4P2/2P3PP/4p3/PP6/6K1',
74:'5b2/3R4/r1p2k1p/p4P2/2P3PP/4p3/PP6/6K1',
75:'5b2/3R4/r1p2k1p/p4P2/2P3PP/4p3/PP4K1/8',
76:'8/3R4/r1p2k1p/p1b2P2/2P3PP/4p3/PP4K1/8',
77:'8/7R/r1p2k1p/p1b2P2/2P3PP/4p3/PP4K1/8',
78:'8/7R/r1p4p/p1b1kP2/2P3PP/4p3/PP4K1/8',
79:'8/7R/r1p4p/p1b1kP2/2P3PP/4pK2/PP6/8',
80:'8/7R/r1p4p/p1b2P2/2Pk2PP/4pK2/PP6/8',
81:'8/8/r1p4R/p1b2P2/2Pk2PP/4pK2/PP6/8',
82:'8/8/1rp4R/p1b2P2/2Pk2PP/4pK2/PP6/8',
83:'8/8/1rp4R/p1b2P2/2Pk2PP/1P2pK2/P7/8',
84:'8/8/1rp4R/2b2P2/p1Pk2PP/1P2pK2/P7/8',
85:'8/8/1rp1R3/2b2P2/p1Pk2PP/1P2pK2/P7/8',
86:'8/8/1rp1R3/2b2P2/2Pk2PP/1p2pK2/P7/8',
87:'8/8/1rp1R3/2b2P2/2Pk2PP/1P2pK2/8/8',
88:'8/8/1rp1R3/2b2P2/2P3PP/1P1kpK2/8/8',
89:'8/8/1rp1R3/2b2PP1/2P4P/1P1kpK2/8/8',
},
comments:{
0:'Bobby Fischer vs Jan Hein Donner, Varna, Bulgaria Olympiad (1962), Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...c6', 3:'2.d4', 4:'2...d5', 5:'3.Nc3', 6:'3...dxe4', 7:'4.Nxe4', 8:'4...Bf5', 9:'5.Ng3', 10:'5...Bg6', 11:'6.h4', 12:'6...h6',
13:'7.Nf3', 14:'7...Nd7', 15:'8.Bd3', 16:'8...Bxd3', 17:'9.Qxd3', 18:'9...e6', 19:'10.Bf4', 20:'10...Qa5+', 21:'11.Bd2', 22:'11...Qc7',
23:'12.c4', 24:'12...Ngf6', 25:'13.Bc3', 26:'13...a5', 27:'14.O-O', 28:'14...Bd6', 29:'15.Ne4', 30:'15...Nxe4', 31:'16.Qxe4', 32:'16...O-O',
33:'17.d5', 34:'17...Rfe8 17...Nc5!? 18.Qd4 f5 is more active.', 35:'18.dxc6', 36:'18...bxc6', 37:'19.Rad1', 38:'19...Bf8?!', 39:'20.Nd4', 40:'20...Ra6', 41:'21.Nf5', 42:'21...Nc5',
43:'22.Qe3', 44:'22...Na4? 22...f6 is necessary to open the seventh rank for defensive purposes.', 45:'23.Be5 23.N×g7 B×g7 24.B×g7 K×g7 25.Qd4+ Kg8 26.c5 is also very strong.', 46:'23...Qa7', 47:'24.Nxh6+!!', 48:'24...gxh6', 49:'25.Rd4? 25.Qg3+ Kh7 26.h5! is very strong as Black’s f-pawn cannot move now: 26...Qe7 27.Rd4 Nc5 28.Rf4 Ra7 29.Bf6 Qd6 30.Qg4 (Dvoretsky) 30...Qd3 31.Rd1 Qc2 32.Re1 Rd7 33.Rf3 Rd3 34.Kh1 R×f3 35.g×f3 Nd7 36.Bc3+– (Meyer).', 50:'25...f5!', 51:'26.Rfd1', 52:'26...Nc5',
53:'27.Rd8', 54:'27...Qf7', 55:'28.Rxe8', 56:'28...Qxe8', 57:'29.Bd4', 58:'29...Ne4', 59:'30.f3', 60:'30...e5!', 61:'31.fxe4', 62:'31...exd4',
63:'32.Qg3+', 64:'32...Bg7', 65:'33.exf5', 66:'33...Qe3+?! 33...c5 34.Qf3 Qe5 35.Kf1 Rf6 is better technique.', 67:'34.Qxe3', 68:'34...dxe3', 69:'35.Rd8+', 70:'35...Kf7', 71:'36.Rd7+',
72:'36...Kf6', 73:'37.g4', 74:'37...Bf8', 75:'38.Kg2', 76:'38...Bc5', 77:'39.Rh7', 78:'39...Ke5', 79:'40.Kf3', 80:'40...Kd4?! 40...Rb6 41.b3 a4 is more precise as the rook should be activated as quickly as possible.', 81:'41.Rxh6?! 41.Rd7+ K×c4 42.g5 h×g5 43.h×g5 Ra8 44.g6 Bd4 and Black should win in the long run.',
82:'41...Rb6', 83:'42.b3', 84:'42...a4', 85:'43.Re6', 86:'43...axb3', 87:'44.axb3', 88:'44...Kd3', 89:'45.g5 0-1',
}
},
{
    id: 19,
      name: 'A Bishop for a Knight',
      description:
'\nInterview with Russell Kruckman'+
'\n\n' +
'Q) We hear that you knew Bobby Fischer in your youth. Can you say how that came about?'+
'\n\n' +
'A) Yes. My father, who was an artist, was getting a brochure done at his printers. He met a woman there and somehow they got talking about how much their sons loved chess. Suddenly the woman said, "You may have heard of my son. His name is Bobby Fischer." That was around 1962. Bobby would have been about nineteen and already US champion for about five years, so my father was gob-smacked. Mrs. Fischer gave my father Bobby\'s phone number and I called him up to invite him over to my parents house. I was more nervous making that phone call than I ever was to ask a girl out.'+
'\n\n' +
'To my shock he accepted. The night he came over, I had the whole Columbia chess team down. It was great. Bobby was such a character. He read everybodys palm and spoke very bluntly about everything. He told one of my friends after reading his palm, "Youre going to die young." My father and he really hit it off. My team-mates were playing five-minute chess on the floor and Bobby was pretending not to watch them. Of course, they were very excited to be playing under the eye of the Grandmaster. One of the guys made a nice sacrifice of the exchange and Bobby, who had been watching out of the corner of his eye, said, "Very good, very good. I thought you were a weakie." I thought my friend would die of bliss. Bobby explained, "I dont like to watch weak players. It ruins my game."'+
'\n\n' +
'After that we became friends and we went to chess clubs together and even to the beach. One time we were at the beach and Bobby saw a pretty girl sitting by herself. He went up to her and said, "I\'m Bobby Fischer, the great chess player." It was a good opening gambit, but she had never heard of him. Her reply made him realise she was foreign, so he asked where she was from. She said, "Holland." Bobby said, "Do you know Max Euwe?" (The Dutch former World Champion). She\'d never heard of him. Now Bobby had run out of ideas. He shrugged his shoulders and walked away.'+
'\n\n' +
'Bobby liked his friends and he liked to be admired. One night, a friend of mine and I were sitting outside the ropes while Bobby was playing Hans Berliner in the U.S. Championship. At one point, Bobby played bishop takes knight. My friend whispered to me, "Why did he do that?" since you usually didn\'t want to give a bishop up for a knight. I said, well maybe its so and so, or such and such, pointing out some positional advantages that Bobby was getting. My friend considered it for a bit and then said to me enthusiastically, "He\'s a genius!" Bobby won and after the game we went out to eat with him, and as we walked up Broadway, he turned to us and said, "You liked bishop takes knight, didn\'t you?" Hed heard it and felt appreciated.'+
'\n\n' +
'Another time, I visited Bobby at his house. He was living with his mother at an apartment in Brooklyn. He played over some games for me from the Russian publication, Schachmaty Bulletin. He saw so much so quickly that it was breathtaking. On several occasions, he went four or five moves ahead of the game and had to take back the moves because he assumed play would be along other lines. That night he showed me what he said was a refutation of the King\'s Gambit. He was about to go off to play in a tournament in Argentina where the great Spassky (not yet World Champion) would be his main rival. Bobby said he thought that if Spassky had white, he would play the King\'s Gambit against him, and then he said, "I\'ll take his pawn, hold it and win." It all happened that way with one major difference. Spassky had white, he played the King\'s Gambit, Bobby took his pawn, he held it, he established a winning position, but Boris broke through and won. Bobby was so disgusted with himself. The next time I saw him, he showed me how completely busted Spassky had been in line after line, much of it beyond my chess comprehension.'+
'\n\n' +
'Speaking of Bobby\'s grasp of the board, I saw him play speed chess at the Marshall Chess Club with Bernard Zuckerman. Zuckerman later became an IM, and was then a strong master with a reputation as a speed player. Bobby gave him five minutes and took half a minute for himself. He crushed him game after game, all the while keeping up an endless flow of chess heckling. His hand moved way faster than my eye could see.'+
'\n\n' +
'Bobby was very peculiar and certainly marched to his own drummer. He wasnt always polite. One time the Chess Federation gave him a gift of a suitcase before he went to represent the US in the Leipzig Chess Olympics. The MC called him up and made the presentation, and Bobby looked at the suitcase and said, "Its too big."'+
'\n\n' +
'He was stubborn and a bit paranoid, but underneath it all, he was very likeable. He had a kind of innocence, and I dont think he ever understood why people reacted the way they did to some of his behaviour. Bobby was certainly the greatest genius I have ever met in any area of life, outside of yoga. But I think it was his innocence that made people feel sympathy for him. I\'m very glad that he came out and played Spassky in 1992 and I hope he\'s happy in Budapest, or Japan or wherever he is. I am sad to hear he has racist obsessions, but not surprised. His thought process served him well in chess, but he didnt recognise that in life they were often vitiated by his paranoia.' +
'\n\n\n' +
'This is the game in which Bobby gives up a bishop for a knight, at move 12 and again at move 23:\n' ,

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkb1r/pppppppp/5n2/4P3/8/8/PPPP1PPP/RNBQKBNR',
4:'rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR',
5:'rnbqkb1r/pppppppp/8/3nP3/3P4/8/PPP2PPP/RNBQKBNR',
6:'rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR',
7:'rnbqkb1r/ppp1pppp/3p4/3nP3/2PP4/8/PP3PPP/RNBQKBNR',
8:'rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP4/8/PP3PPP/RNBQKBNR',
9:'rnbqkb1r/ppp1pppp/1n1P4/8/2PP4/8/PP3PPP/RNBQKBNR',
10:'rnbqkb1r/pp2pppp/1n1p4/8/2PP4/8/PP3PPP/RNBQKBNR',
11:'rnbqkb1r/pp2pppp/1n1p4/8/2PP4/2N5/PP3PPP/R1BQKBNR',
12:'rnbqkb1r/pp2pp1p/1n1p2p1/8/2PP4/2N5/PP3PPP/R1BQKBNR',
13:'rnbqkb1r/pp2pp1p/1n1p2p1/8/2PP4/2NB4/PP3PPP/R1BQK1NR',
14:'rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2NB4/PP3PPP/R1BQK1NR',
15:'rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2NB4/PP2NPPP/R1BQK2R',
16:'r1bqk2r/pp2ppbp/1nnp2p1/8/2PP4/2NB4/PP2NPPP/R1BQK2R',
17:'r1bqk2r/pp2ppbp/1nnp2p1/8/2PP4/2NBB3/PP2NPPP/R2QK2R',
18:'r1bq1rk1/pp2ppbp/1nnp2p1/8/2PP4/2NBB3/PP2NPPP/R2QK2R',
19:'r1bq1rk1/pp2ppbp/1nnp2p1/8/2PP4/2NBB3/PP2NPPP/R2Q1RK1',
20:'r1bq1rk1/pp3pbp/1nnp2p1/4p3/2PP4/2NBB3/PP2NPPP/R2Q1RK1',
21:'r1bq1rk1/pp3pbp/1nnp2p1/3Pp3/2P5/2NBB3/PP2NPPP/R2Q1RK1',
22:'r1bq1rk1/pp3pbp/1n1p2p1/3Pp3/1nP5/2NBB3/PP2NPPP/R2Q1RK1',
23:'r1bq1rk1/pp3pbp/1n1p2p1/3Pp3/1nP5/1PNBB3/P3NPPP/R2Q1RK1',
24:'r1bq1rk1/pp3pbp/1n1p2p1/3Pp3/2P5/1PNnB3/P3NPPP/R2Q1RK1',
25:'r1bq1rk1/pp3pbp/1n1p2p1/3Pp3/2P5/1PNQB3/P3NPPP/R4RK1',
26:'r1bq1rk1/pp1n1pbp/3p2p1/3Pp3/2P5/1PNQB3/P3NPPP/R4RK1',
27:'r1bq1rk1/pp1n1pbp/3p2p1/3Pp3/2P5/1PN1B3/P2QNPPP/R4RK1',
28:'r1bq1rk1/pp1n2bp/3p2p1/3Ppp2/2P5/1PN1B3/P2QNPPP/R4RK1',
29:'r1bq1rk1/pp1n2bp/3p2p1/3Ppp2/2P2P2/1PN1B3/P2QN1PP/R4RK1',
30:'r1bq1rk1/p2n2bp/1p1p2p1/3Ppp2/2P2P2/1PN1B3/P2QN1PP/R4RK1',
31:'r1bq1rk1/p2n2bp/1p1p2p1/3Ppp2/2P2P2/1PN1B3/P2QN1PP/3R1RK1',
32:'r1bq1rk1/p5bp/1p1p1np1/3Ppp2/2P2P2/1PN1B3/P2QN1PP/3R1RK1',
33:'r1bq1rk1/p5bp/1p1p1np1/3PPp2/2P5/1PN1B3/P2QN1PP/3R1RK1',
34:'r1bq1rk1/p5bp/1p3np1/3Ppp2/2P5/1PN1B3/P2QN1PP/3R1RK1',
35:'r1bq1rk1/p5bp/1p3np1/3PppB1/2P5/1PN5/P2QN1PP/3R1RK1',
36:'r2q1rk1/p2b2bp/1p3np1/3PppB1/2P5/1PN5/P2QN1PP/3R1RK1',
37:'r2q1rk1/p2b2bp/1p3np1/3PppB1/2P5/1PN5/P2QN1PP/3R1R1K',
38:'r2q2k1/p2b1rbp/1p3np1/3PppB1/2P5/1PN5/P2QN1PP/3R1R1K',
39:'r2q2k1/p2b1rbp/1p3np1/3PppB1/2P5/1PN5/P2Q2PP/3R1RNK',
40:'r4qk1/p2b1rbp/1p3np1/3PppB1/2P5/1PN5/P2Q2PP/3R1RNK',
41:'r4qk1/p2b1rbp/1p1P1np1/4ppB1/2P5/1PN5/P2Q2PP/3R1RNK',
42:'r4qk1/p4rbp/1pbP1np1/4ppB1/2P5/1PN5/P2Q2PP/3R1RNK',
43:'r4qk1/p4rbp/1pbP1np1/4ppB1/1PP5/2N5/P2Q2PP/3R1RNK',
44:'r4qk1/p4rb1/1pbP1npp/4ppB1/1PP5/2N5/P2Q2PP/3R1RNK',
45:'r4qk1/p4rb1/1pbP1Bpp/4pp2/1PP5/2N5/P2Q2PP/3R1RNK',
46:'r4qk1/p4r2/1pbP1bpp/4pp2/1PP5/2N5/P2Q2PP/3R1RNK',
47:'r4qk1/p4r2/1pbP1bpp/2P1pp2/1P6/2N5/P2Q2PP/3R1RNK',
48:'r4qk1/p4r2/2bP1bpp/2p1pp2/1P6/2N5/P2Q2PP/3R1RNK',
49:'r4qk1/p4r2/2bP1bpp/2P1pp2/8/2N5/P2Q2PP/3R1RNK',
50:'4rqk1/p4r2/2bP1bpp/2P1pp2/8/2N5/P2Q2PP/3R1RNK',
51:'4rqk1/p4r2/2bP1bpp/2PNpp2/8/8/P2Q2PP/3R1RNK',
52:'3brqk1/p4r2/2bP2pp/2PNpp2/8/8/P2Q2PP/3R1RNK',
53:'3brqk1/p4r2/2bP2pp/2PNpp2/8/8/P3Q1PP/3R1RNK',
54:'b2brqk1/p4r2/3P2pp/2PNpp2/8/8/P3Q1PP/3R1RNK',
55:'b2brqk1/p4r2/3P2pp/1QPNpp2/8/8/P5PP/3R1RNK',
56:'b2brq2/p4rk1/3P2pp/1QPNpp2/8/8/P5PP/3R1RNK',
57:'b2brq2/p4rk1/3P2pp/2PNpp2/2Q5/8/P5PP/3R1RNK',
58:'b2brq2/p4rk1/3P2pp/2PNp3/2Q2p2/8/P5PP/3R1RNK',
59:'b2brq2/p4rk1/2PP2pp/3Np3/2Q2p2/8/P5PP/3R1RNK',
60:'b2br3/p4rk1/2Pq2pp/3Np3/2Q2p2/8/P5PP/3R1RNK',
61:'b2br3/p4rk1/2Pq2pp/4p3/2Q2N2/8/P5PP/3R1RNK',
62:'b2br3/p4rk1/2q3pp/4p3/2Q2N2/8/P5PP/3R1RNK',
63:'b2br3/p4rk1/2q3pp/4p2N/2Q5/8/P5PP/3R1RNK',
64:'b2br2k/p4r2/2q3pp/4p2N/2Q5/8/P5PP/3R1RNK',
65:'b2br2k/p4r2/2Q3pp/4p2N/8/8/P5PP/3R1RNK',
66:'3br2k/p4r2/2b3pp/4p2N/8/8/P5PP/3R1RNK',
67:'3br2k/p4R2/2b3pp/4p2N/8/8/P5PP/3R2NK',
68:'3br2k/p4R2/2b4p/4p2p/8/8/P5PP/3R2NK',
69:'3br2k/p4R2/2bR3p/4p2p/8/8/P5PP/6NK',
70:'3br2k/p4R2/3R3p/4p2p/4b3/8/P5PP/6NK',
71:'3br2k/p4R2/7R/4p2p/4b3/8/P5PP/6NK',
72:'3br1k1/p4R2/7R/4p2p/4b3/8/P5PP/6NK',
73:'3br1k1/R7/7R/4p2p/4b3/8/P5PP/6NK',
74:'4r1k1/R7/7R/4p1bp/4b3/8/P5PP/6NK',
75:'4r1k1/R7/8/4p1bR/4b3/8/P5PP/6NK',
76:'4r1k1/R7/8/4p2R/4b3/4b3/P5PP/6NK',
77:'4r1k1/3R4/8/4p2R/4b3/4b3/P5PP/6NK',
78:'4r1k1/3R4/8/4p2R/3bb3/8/P5PP/6NK',
79:'4r1k1/3R4/8/4p2R/3bb3/8/P3N1PP/7K',
80:'5rk1/3R4/8/4p2R/3bb3/8/P3N1PP/7K',
81:'5rk1/3R4/8/4p1R1/3bb3/8/P3N1PP/7K',
82:'5r1k/3R4/8/4p1R1/3bb3/8/P3N1PP/7K',
83:'5r1k/3R4/8/4p1R1/3bb2P/8/P3N1P1/7K',
84:'5r1k/3R4/8/4p1R1/4b2P/8/P3N1P1/b6K',
85:'5r1k/3R4/8/4p1R1/4b2P/6N1/P5P1/b6K',
86:'b4r1k/3R4/8/4p1R1/7P/6N1/P5P1/b6K',
87:'b4r1k/8/3R4/4p1R1/7P/6N1/P5P1/b6K',
88:'b4r2/7k/3R4/4p1R1/7P/6N1/P5P1/b6K',
89:'b4r2/7k/3R4/4pNR1/7P/8/P5P1/b6K',
},
comments:{
0:'Bobby Fischer vs Hans Berliner, US Championship (1962), Annotations by GM Karsten Mueller.',
1:'1.e4', 2:'1...Nf6', 3:'2.e5', 4:'2...Nd5', 5:'3.d4', 6:'3...d6', 7:'4.c4', 8:'4...Nb6', 9:'5.exd6', 10:'5...cxd6', 11:'6.Nc3', 12:'6...g6',
13:'7.Bd3 7.Be3 is the main line.', 14:'7...Bg7', 15:'8.Nge2', 16:'8...Nc6', 17:'9.Be3 9.d5 scores better.', 18:'9...O-O', 19:'10.O-O', 20:'10...e5 10...Bg4!? is the alternative.', 21:'11.d5', 22:'11...Nb4', 23:'12.b3',
24:'12...Nxd3', 25:'13.Qxd3', 26:'13...Nd7', 27:'14.Qd2', 28:'14...f5', 29:'15.f4', 30:'15...b6', 31:'16.Rad1', 32:'16...Nf6!? Very bold and risky, as White’s queenside majority now becomes mobile. But it may be justified.', 33:'17.fxe5',
34:'17...dxe5', 35:'18.Bg5', 36:'18...Bd7', 37:'19.Kh1', 38:'19...Rf7', 39:'20.Ng1', 40:'20...Qf8', 41:'21.d6', 42:'21...Bc6', 43:'22.b4', 44:'22...h6? Berliner wastes too much time. After 22...Rc8, with the idea of 23.c5 b×c5 24.b×c5?! Nd7, Black is not worse at all.',
45:'23.Bxf6', 46:'23...Bxf6', 47:'24.c5', 48:'24...bxc5', 49:'25.bxc5', 50:'25...Re8?!', 51:'26.Nd5', 52:'26...Bd8 Berliner wants to keep his bishops, but this is very passive. However, 26...e4 27.Qe2 Rb8 28.Qc4 Kh7 29.Rb1 is also clearly better for White. ', 53:'27.Qe2', 54:'27...Ba8',
55:'28.Qb5', 56:'28...Kg7', 57:'29.Qc4', 58:'29...f4?! Allowing a petite combination, but good advice is hard to give.', 59:'30.c6', 60:'30...Qxd6', 61:'31.Nxf4!', 62:'31...Qxc6? 31...Qf8 is forced, but White remains on top after 32.R×d8 e×f4 33.Rd4 g5 34.Qc3±; 31...R×f4? 32.R×f4 Q×d1 33.Qf7++–.', 63:'32.Nh5+!', 64:'32...Kh8 32...g×h5 33.Q×f7+ Kh8 34.Rf3+–',
65:'33.Qxc6', 66:'33...Bxc6', 67:'34.Rxf7', 68:'34...gxh5', 69:'35.Rd6', 70:'35...Be4', 71:'36.Rxh6+', 72:'36...Kg8', 73:'37.Rxa7',
74:'37...Bg5', 75:'38.Rxh5', 76:'38...Be3', 77:'39.Rd7', 78:'39...Bd4', 79:'40.Ne2', 80:'40...Rf8', 81:'41.Rg5+', 82:'41...Kh8', 83:'42.h4',
84:'42...Ba1', 85:'43.Ng3', 86:'43...Ba8', 87:'44.Rd6', 88:'44...Kh7', 89:'45.Nf5 1-0',
}
},
{
    id: 20,
      name: 'I Remember Bobby',
      description:
'\nby Michael Valvo, reprinted from the Minnesota Chess Journal'+
'\n\n' +
'I can remember how shocked my opponent was in 1959 when I told him my name was Bobby Fischer. He believed me. He had to be convinced I was just joking, but it was frightening how intimidating the mention of Bobby\'s name was even then.' +
'\n\n' +
'Even though I was within a year of Bobby\'s age, I never became one of the "intimates" of Bobby\'s life. That privilege was only extended to the members of John Collins\’ personal chess club and a few others like Bernard Zuckerman and Jackie Bears. Yet, he was somehow a constant topic of conversation to such an extent that we gave him privacy. We were all Fischer groupies.' +
'\n\n' +
'I first saw him at the US Championship in 1960. He was clearly a presence that drew all eyes toward him. He had the way of noticing everything even though his eyes seemed focused downward at the board. This cat-like awareness appeared over and over again throughout the years. I dubbed it myself as the Fischer glare. That first night he stretched another of my childhood heroes, Bill Lombardy, until his position exploded. Watching him in person was different than reading about him in magazines. While reading, there always seemed to be musical accompaniment to the drama of battle. Instead, in person, an eerie silence drove home even more dramatically the superiority he had over every other player in the room. Most of the time I knew him, this aura of silence followed him everywhere. And those eyes. He could peel the skin off everything about him and see through things beyond the depth of any single person\’s intentions.' +
'\n\n' +
'Still today, I speak with some of his closest friends from time to time. None of them will breathe a word about him, even now. It is known that if Bobby ever found out this transgression of trust, the relationship would be over. The worst crime of all would be to speak to reporters, unless Bobby wanted the world to know something. He would then let you know exactly what he wanted said. Nothing more, nothing less.' +
'\n\n' +
'The most treasured experience I ever had was playing Bobby blitz chess. Speed chess or “blitz” as it’s commonly known, means a chess clock with two faces is set typically to five minutes for each side. The game can be therefore last for at most ten minutes. Each player has to make all his moves in his five minute period. If time expires, a mechanism on the clock called the flag drops and the player forfeits on “time.” Once, Bobby dropped into the New York Chess and Checker Club (aka “the Fleahouse”) on Times Square.  One of my steady customers (chess hustler term for “mark”) was interested that I play Fischer speed chess. Bobby agreed to a set match of ten games at ten dollars per game. The rate would be two minutes per side for the entire game. My customer agreed to be my backer and pay all my losses. As the games progressed, Bobby couldn’t believe how mechanically fast I was, while I couldn’t believe that he was actually thinking at that time control! He seemed to have the ability to make time slow down and calculate long variations. The final score was five wins, three draws and two losses in Bobby’s favor! And in at least two of my losses, I was ecstatic at the result. After all, a result of 0-10 was not improbable.' +
'\n\n' +
'Another experience came while working on Bobby Fischer Teaches Chess. We would meet with him occasionally and discuss the status of the project. He went over every diagram in book and wouldn’t let it be released for publication until he was satisfied. A lot of time was spent on preparing an interview for a chapter of the book, and it was disappointing that he eventually vetoed the whole idea.' +
'\n\n' +
'One day, a photograph of Bobby was necessary for the front cover. I don’t remember how I got to go along, but about five or six of us were standing in the street waiting for a cab. Quickly, Bobby opened the door of an arriving cab and shoved me inside. Then he climbed in and shut the door. Everyone seemed stunned by the rapid execution of events. He rolled down the window and said that only people who could speak CHESS could get a ride in this cab and we sped off.' +
'\n\n' +
'Next we got to the studio and Bobby introverted. He made me his instant manager for the duration of time we were there. Anybody that had anything to say to him had to do so through me. It was an amazing experience. The only thing that shocked me more was the US Championship that was held about that time. When Bobby came in, he was ushered by an entourage of about ten people. As they came toward me, I made some attempt to get out of the way, but I wanted to say hello to Bobby. He walked past me like he had never seen me before in his life.' +
'\n\n' +
'I remember Bobby dropping into the “Fleahouse” at about 1:30 in the morning. He cornered me into listening to his thoughts about one of the most complicated lines of chess, the …Qb6 variation of the Najdorf Defense. For hour after hour, he spoke spontaneously about the best ideas for both sides. I could do nothing but nod acknowledgement that I understood what he had said. His quickness and grasp of nuances were nearly beyond my ken. Finally, about four in the morning, he let me go. It was the most intense chess lesson I had ever received in my life.' +
'\n\n' +
'Recently, many people have tried to compare him to Karpov or Kasparov. He was better. I once asked former Soviet Grandmaster Anatoly Lein how he compared Fischer to Karpov. There was no comparison, as far as he was concerned. Karpov makes many mistakes. Fischer, by contrast, not only was virtually mistake free, but was the model on how to play certain types of positions. For my money, he was the greatest.' +
'\n\n' +
'Over the years, everyone has wondered if he will ever play again. I doubt it. Yasser Seirawan, America’s strongest player, has told me he was informed that it he wanted Bobby to read a letter, he had to enclose a certain amount of money. (want the rates anyone?).' +
'\n\n' +
'To speak with him on the phone, a similar condition would be imposed. I had an idea that might have brought him back into play again, but Seirawan’s comment stopped me cold. The idea was to propose a non-title match between him and Kasparov. Funding would come from directly appealing to the American public. I doubt that there is one person anywhere who wouldn’t want Bobby to come back, except maybe Bobby himself.' +
'\n\n' +
'You have to begin by realizing that money meant little to Bobby despite the fact he doesn’t currently have much. Even today, he could make millions by putting himself out a little. This he does not seem willing to do. He is a man of his own principles.' +
'\n\n' +
'Oh, yes, what about his “darker side”? His highly publicized religious antics with Armstrong. The book he wrote about spending a night in a Pasadena jail, his claim that Jews are trying to take over the world. What about them? Those personality quirks never meant anything to me. Remember, once a groupie, always a groupie.' +
'\n\n\n' +
'Here is the game Michael Valvo watched when he first saw Bobby Fischer:\n ' ,

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
4:'rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',
5:'rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',
6:'rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R',
7:'rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R',
8:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R',
9:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/5P2/PPP3PP/RNBQKB1R',
10:'r1bqkb1r/pp2pppp/2np1n2/8/3NP3/5P2/PPP3PP/RNBQKB1R',
11:'r1bqkb1r/pp2pppp/2np1n2/8/2PNP3/5P2/PP4PP/RNBQKB1R',
12:'r1bqkb1r/pp3ppp/2nppn2/8/2PNP3/5P2/PP4PP/RNBQKB1R',
13:'r1bqkb1r/pp3ppp/2nppn2/8/2PNP3/2N2P2/PP4PP/R1BQKB1R',
14:'r1bqk2r/pp2bppp/2nppn2/8/2PNP3/2N2P2/PP4PP/R1BQKB1R',
15:'r1bqk2r/pp2bppp/2nppn2/8/2PNP3/2N1BP2/PP4PP/R2QKB1R',
16:'r1bq1rk1/pp2bppp/2nppn2/8/2PNP3/2N1BP2/PP4PP/R2QKB1R',
17:'r1bq1rk1/pp2bppp/2nppn2/8/2P1P3/2N1BP2/PPN3PP/R2QKB1R',
18:'r1bq1rk1/pp2bppp/2n1pn2/3p4/2P1P3/2N1BP2/PPN3PP/R2QKB1R',
19:'r1bq1rk1/pp2bppp/2n1pn2/3P4/4P3/2N1BP2/PPN3PP/R2QKB1R',
20:'r1bq1rk1/pp2bppp/2n2n2/3p4/4P3/2N1BP2/PPN3PP/R2QKB1R',
21:'r1bq1rk1/pp2bppp/2n2n2/3N4/4P3/4BP2/PPN3PP/R2QKB1R',
22:'r1bq1rk1/pp2bppp/2n5/3n4/4P3/4BP2/PPN3PP/R2QKB1R',
23:'r1bq1rk1/pp2bppp/2n5/3Q4/4P3/4BP2/PPN3PP/R3KB1R',
24:'r1b2rk1/ppq1bppp/2n5/3Q4/4P3/4BP2/PPN3PP/R3KB1R',
25:'r1b2rk1/ppq1bppp/2n5/1Q6/4P3/4BP2/PPN3PP/R3KB1R',
26:'r4rk1/ppqbbppp/2n5/1Q6/4P3/4BP2/PPN3PP/R3KB1R',
27:'r4rk1/ppqbbppp/2n5/1Q6/4P3/4BP2/PPN3PP/2R1KB1R',
28:'r4rk1/ppqbbppp/8/1Q6/1n2P3/4BP2/PPN3PP/2R1KB1R',
29:'r4rk1/ppqbbppp/8/1Q6/1N2P3/4BP2/PP4PP/2R1KB1R',
30:'r4rk1/pp1bbppp/8/1Q6/1N2P3/4BP2/PP4PP/2q1KB1R',
31:'r4rk1/pp1bbppp/8/1Q6/1N2P3/5P2/PP4PP/2B1KB1R',
32:'r4rk1/pp2bppp/8/1b6/1N2P3/5P2/PP4PP/2B1KB1R',
33:'r4rk1/pp2bppp/8/1b1N4/4P3/5P2/PP4PP/2B1KB1R',
34:'r4rk1/pp3ppp/8/1b1N4/4P2b/5P2/PP4PP/2B1KB1R',
35:'r4rk1/pp3ppp/8/1b1N4/4P2b/5PP1/PP5P/2B1KB1R',
36:'r4rk1/pp3ppp/8/3N4/4P2b/5PP1/PP5P/2B1Kb1R',
37:'r4rk1/pp3ppp/8/3N4/4P2b/5PP1/PP5P/2B2K1R',
38:'r2b1rk1/pp3ppp/8/3N4/4P3/5PP1/PP5P/2B2K1R',
39:'r2b1rk1/pp3ppp/8/3N4/4P3/5PP1/PP1B3P/5K1R',
40:'2rb1rk1/pp3ppp/8/3N4/4P3/5PP1/PP1B3P/5K1R',
41:'2rb1rk1/pp3ppp/8/3N4/4P3/2B2PP1/PP5P/5K1R',
42:'2rb1rk1/pp4pp/8/3N1p2/4P3/2B2PP1/PP5P/5K1R',
43:'2rb1rk1/pp4pp/8/3NPp2/8/2B2PP1/PP5P/5K1R',
44:'3b1rk1/pp4pp/8/2rNPp2/8/2B2PP1/PP5P/5K1R',
45:'3b1rk1/pp4pp/8/2r1Pp2/1N6/2B2PP1/PP5P/5K1R',
46:'5rk1/pp4pp/8/b1r1Pp2/1N6/2B2PP1/PP5P/5K1R',
47:'5rk1/pp4pp/8/b1r1Pp2/1N6/P1B2PP1/1P5P/5K1R',
48:'5rk1/pp4pp/8/2r1Pp2/1b6/P1B2PP1/1P5P/5K1R',
49:'5rk1/pp4pp/8/2r1Pp2/1P6/2B2PP1/1P5P/5K1R',
50:'5rk1/pp4pp/8/3rPp2/1P6/2B2PP1/1P5P/5K1R',
51:'5rk1/pp4pp/8/3rPp2/1P6/2B2PP1/1P2K2P/7R',
52:'5r2/pp3kpp/8/3rPp2/1P6/2B2PP1/1P2K2P/7R',
53:'5r2/pp3kpp/8/3rPp2/1P5P/2B2PP1/1P2K3/7R',
54:'5r2/pp4pp/4k3/3rPp2/1P5P/2B2PP1/1P2K3/7R',
55:'5r2/pp4pp/4k3/3rPp2/1P5P/2B1KPP1/1P6/7R',
56:'2r5/pp4pp/4k3/3rPp2/1P5P/2B1KPP1/1P6/7R',
57:'2r5/pp4pp/4k3/3rPp2/1P5P/2B1KPP1/1P6/6R1',
58:'8/pp4pp/4k3/3rPp2/1Pr4P/2B1KPP1/1P6/6R1',
59:'8/pp4pp/4k3/3rPp2/1Pr4P/2B1KPP1/1P6/4R3',
60:'8/pp4pp/4k3/3rPp2/1P5P/2r1KPP1/1P6/4R3',
61:'8/pp4pp/4k3/3rPp2/1P5P/2P1KPP1/8/4R3',
62:'8/pp4pp/4k3/4rp2/1P5P/2P1KPP1/8/4R3',
63:'8/pp4pp/4k3/4rp2/1P5P/2P2PP1/3K4/4R3',
64:'8/pp4pp/4k3/5p2/1P5P/2P2PP1/3K4/4r3',
65:'8/pp4pp/4k3/5p2/1P5P/2P2PP1/8/4K3',
66:'8/pp4pp/8/3k1p2/1P5P/2P2PP1/8/4K3',
67:'8/pp4pp/8/3k1p2/1P5P/2P2PP1/3K4/8',
68:'8/pp4pp/8/5p2/1Pk4P/2P2PP1/3K4/8',
69:'8/pp4pp/8/5p1P/1Pk5/2P2PP1/3K4/8',
70:'8/p5pp/1p6/5p1P/1Pk5/2P2PP1/3K4/8',
71:'8/p5pp/1p6/5p1P/1Pk5/2P2PP1/2K5/8',
72:'8/p6p/1p6/5ppP/1Pk5/2P2PP1/2K5/8',
73:'8/p6p/1p5P/5pp1/1Pk5/2P2PP1/2K5/8',
74:'8/p6p/1p5P/6p1/1Pk2p2/2P2PP1/2K5/8',
75:'8/p6p/1p5P/6p1/1Pk2pP1/2P2P2/2K5/8',
76:'8/7p/1p5P/p5p1/1Pk2pP1/2P2P2/2K5/8',
77:'8/7p/1p5P/P5p1/2k2pP1/2P2P2/2K5/8',
78:'8/7p/7P/p5p1/2k2pP1/2P2P2/2K5/8',
79:'8/7p/7P/p5p1/2k2pP1/2P2P2/1K6/8',
80:'8/7p/7P/6p1/p1k2pP1/2P2P2/1K6/8',
81:'8/7p/7P/6p1/p1k2pP1/K1P2P2/8/8',
82:'8/7p/7P/6p1/p4pP1/K1k2P2/8/8',
83:'8/7p/7P/6p1/K4pP1/2k2P2/8/8',
84:'8/7p/7P/6p1/K2k1pP1/5P2/8/8',
85:'8/7p/7P/6p1/1K1k1pP1/5P2/8/8',
86:'8/7p/7P/6p1/1K3pP1/4kP2/8/8',
},
comments:{
0:'Lombary-Bobby Fischer, USA-ch (1960), New York. Annotations by Bobby Fischer from My 60 Memorable Games.',
1:'1.e4', 2:'1...c5', 3:'2.Nf3', 4:'2...d6', 5:'3.d4', 6:'3...cxd4', 7:'4.Nxd4', 8:'4...Nf6', 9:'5.f3 A passive non-developing move which leads to nothing. White wants to gain control of d5, establishing a Maroczy bind with c4, Nc3 etc. But after going to all that trouble he can\'t prevent ...d5 after all. Correct is that tired old move- Nc3.', 10:'5...Nc6', 11:'6.c4', 12:'6...e6',
13:'7.Nc3', 14:'7...Be7', 15:'8.Be3', 16:'8...O-O', 17:'9.Nc2', 18:'9...d5!? Reckoning that the loss of a pawn is compensated by superior development. 9...Re8 is sound but passive.', 19:'10.cxd5', 20:'10...exd5', 21:'11.Nxd5', 22:'11...Nxd5',
23:'12.Qxd5', 24:'12...Qc7', 25:'13.Qb5? Too intent on holding on to the pawn. Correct is 13. Be2 Bh4+! 14. g3 Bf6 15. 0-0 Bxb2 16. Rb1 =.', 26:'13...Bd7', 27:'14.Rc1', 28:'14...Nb4 This unexpected \'discovery\' jolts white back to reality.', 29:'15.Nxb4', 30:'15...Qxc1+', 31:'16.Bxc1',
32:'16...Bxb5', 33:'17.Nd5', 34:'17...Bh4+! The scorpion\'s sting at the tail-end of the combination.', 35:'18.g3', 36:'18...Bxf1', 37:'19.Kxf1', 38:'19...Bd8 The smoke clears. Black is an exchange ahead for a pawn. But there are still great technical difficulties. White\'s Knight is on a dominating outpost and his pawn structure is solid.', 39:'20.Bd2', 40:'20...Rc8', 41:'21.Bc3',
42:'21...f5! Weaker would be 21...Re8 because of 22.g4 blocking the King-side.', 43:'22.e5 This advance is necessary, but it undermines the support of the Knight [which can now be driven away].', 44:'22...Rc5', 45:'23.Nb4', 46:'23...Ba5', 47:'24.a3', 48:'24...Bxb4', 49:'25.axb4', 50:'25...Rd5', 51:'26.Ke2', 52:'26...Kf7',
53:'27.h4', 54:'27...Ke6', 55:'28.Ke3', 56:'28...Rc8', 57:'29.Rg1', 58:'29...Rc4 Black has steadily improved his grip, but his winning chances are still problematic, hinging mainly on sacrificing on b4 or e5 at the right moment.', 59:'30.Re1? A gross blunder. Correct is 30. Ra1 a6 31. Rg1.', 60:'30...Rxc3+! Swapping everything leads to a won King and pawn ending.', 61:'31.bxc3',
62:'31...Rxe5+', 63:'32.Kd2', 64:'32...Rxe1', 65:'33.Kxe1', 66:'33...Kd5', 67:'34.Kd2', 68:'34...Kc4', 69:'35.h5', 70:'35...b6', 71:'36.Kc2',
72:'36...g5', 73:'37.h6', 74:'37...f4', 75:'38.g4', 76:'38...a5', 77:'39.bxa5', 78:'39...bxa5', 79:'40.Kb2', 80:'40...a4', 81:'41.Ka3', 82:'41...Kxc3',
83:'42.Kxa4', 84:'42...Kd4', 85:'43.Kb4', 86:'43...Ke3',
}
},
{
    id: 21,
      name: 'Kavalek interviews Fischer',
      description:
'\nInterview with Bobby Fischer by Lubomir Kavalek' +
'\n\n' +
'January 10, 1972' +
'\n\n' +
'Grandmaster Lubomir Kavalek worked for the Voice of America in 1971-1972 shortly after immigrating to the United States in 1970. The Voice of America broadcast to foreign countries to influence public opinion regarding the United States and its people, including the Soviet Union. This interview that Kavalek did with Bobby Fischer was broadcast on the Voice of America and in parts of it, Fischer speaks directly to his fans in the Soviet Union.' +
'\n\n' +
'Q: Your match you are going to play with Boris Spassky has caused even more excitement and interest than the match Alekhine vs. Capablanca in 1927. How do you explain this extraordinary interest?' +
'\n\n' +
'Fischer: “We’ll, you know, because the Russians have been blocking me all these years, this is why I think there’s so much interest. The Russians have been putting me down for the past decade, 15 years, throwing up obstacles, cheating. Now is the moment of truth. They can’t run away anymore.”' +
'\n\n' +
'Q: You have mentioned this on a number of occasions that the Russians have been cheating against you - of course they are rather indignant about it - do you think that psychologically at this moment you want to be saying that to the audience in the Soviet Union?' +
'\n\n' +
'Fischer: “Well, I want to say what I believe, you know. And this is what I believe - that’s what I know from my experience.”' +
'\n\n' +
'Q: Last year you were pretty certain that you would beat Boris Spassky. Do you feel the same certainty right now and what do you base this on?' +
'\n\n' +
'Fischer: “Well, I’m very confident. And I know he has a plus score, and this has to be taken into account, but a lot of players have had plus scores on me, and I’ve beaten them very badly later. But you have to take a look at the overall record, which I think - in this case - is a lot more important than our personal score. First of all, I have the highest rating in the world. I\'ve always had a better international record than he had in tournaments. And you have to study the circumstances that he got his advantage, his score against me in I was playing all-out to win, because I like to win tournaments, whereas Spassky, he plays for a high place in the tournament - not necessarily for first place at all costs. So, I\'m pretty confident. I don\'t let this plus score upset me too much."'+
'\n\n' +
'Q: You seem to be in very good form at the present time. Spassky, judging from the results of the Alekhine Memorial and perhaps in other games in Canada and so-on, does not seem to be in top form. Why is it then that you seem to want the match played as late as possible, or at least you were quoted in the newspapers as saying that?'+
'\n\n' +
'Fischer: "Well, the reason is simple. First of all, Spassky, for three years has known that he is going to play a world title match. So, he has been able to pace himself so that he\'ll be in proper shape and form for the title match. I\'ve only known for the past few weeks or few months that I was going to play him for the title. So, I want to have at least some months to get in shape. He’s had several years. And he can come in as well rested as he wants to be.”'+
'\n\n' +
'Q: “Well, in connection with this, what kind of preparation are you planning if that is not a state secret?”'+
'\n\n' +
'Fischer: “Oh, just studying, getting in shape physically, keep in shape physically.'+
'\n\n' +
'Q: “How do you keep fit physically?”'+
'\n\n' +
'Fischer: “I walk a lot, do some exercises. I like to play tennis and sports.”'+
'\n\n' +
'Q: “It has been told that while playing Larsen in Denver, you used to come directly to the chess board from the tennis courts. Doesn’t tennis sort of sap your strength before a serious match like that?”'+
'\n\n' +
'Fischer: “I don’t know. It didn’t seem to.”'+
'\n\n' +
'Q: “But did you do that?”'+
'\n\n' +
'Fischer: “Yes, it’s true. I didn’t do it deliberately. I always intended to play tennis earlier, but I got up late, and they ran close together.”'+
'\n\n' +
'Q: “Some observers have noted that lately you have become a little more of an outgoing person than you used to be in previous years. Is this true, do you feel this way about yourself?”'+
'\n\n' +
'Fischer: “Yeah, I think it might be a little true, yeah.”'+
'\n\n' +
'Q: “You are leading a rather solitary life at least from the point of view of most observers. Do you think that this type of life is absolutely necessary for a professional chess master? Or do you think this is your own personal style?”'+
'\n\n' +
'Fischer: “This is my personal style, yeah, you know. Some people are party goers and what not, and I’m not. I’ve never been interested in that kind of life.”'+
'\n\n' +
'Q: “You are not married. Do you think that marriage would generally interfere with a career of a chess master?”'+
'\n\n' +
'Fischer: “It might, yeah, especially if you’re on the way up. I might get married after I take care of Spassky. But right now, I don’t think it would be good.”'+
'\n\n' +
'Q: The executive Director of the US chess Federation, Ed Edmondson, said that you generally never take time out even for illness during a match. For instance, when you played against Petrosian and you had a heavy cold you still continued playing instead of asking for a respite. Would you do the same against Spassky and doesn’t this sort of thing endanger your chances in winning? ' +
'\n\n' +
'Fischer: Taking time-out has been misused. The Russians did it during their matches when they decided to get a little rest - almost always after they lost a game - they claim to be sick. I think one should play - only in case you are so sick that you can’t physically make it. I don’t believe in timeouts every time the weather slightly changes. It’s part of chess to be in good physical condition. If you are not, you can only complain to yourself. Only in case I would be seriously ill that I would not play, I would consider to postpone the game. With Petrosian - I didn’t feel that much ill. I thought I could play and he had the advantage but then later on he slipped. I won the game but I wasn’t terribly upset about it.' +
'\n\n' +
'Q: Some people say that you have no other interest in life, or practically no other interest except for chess. We know this is not quite true. You have already mentioned that you like sports - tennis and so on. I know you like music. Edmondson said that you are a great expert in popular music or at least he was amazed at how easily you recognize the various groups and various tunes that you hear - even those of Latin America, fashionable in Argentina. What are your favorite groups?' +
'\n\n' +
'Fischer: American groups? ' +
'\n\n' +
'Q: American, British ' +
'\n\n' +
'Fischer: Well, I like in the states, I like mainly Negro groups like soul groups like what they call the \"Motown sound\", Stevie Wonder, The Four Tops, The Supremes, The Temptations, Marvin Gaye, and I like a lot of other individual singers like Joe Smith. I like the Beatles, Bob Dylan, a lot of them. Tremendous selection.' +
'\n\n' +
'Q: And your favorite tunes?' +
'\n\n' +
'Fischer: \"Yesteryou, Yesterme, Yesterday.\" Let’s see - all kinds of tunes from The Temptations, uh, \"Get Ready.\" I can tell you a few. I have to think about it a little, but I have a whole lot of favorites.' +
'\n\n' +
'Q: It’s been said that your intelligent quotient is something like 180. Is that so, is this the result of formal testing? ' +
'\n\n' +
'Fischer: I really don’t know. I kind of doubt that. It’s sounds rather incredible, but I don’t believe in those IQ test anyway. I don’t think you can put somebody\'s total capacities in a number like that, you know. It’s hard enough to do it, say, with chess. It’s a very limited field, but, uh, to say somebody’s worth so many points is ridiculous, you know. Some people are sharp in some ways, in other ways they’re pretty dumb. Who’s going to measure the important thing that should get the points, what shouldn\'t. Well, let’s say when it comes to chess, my, uh, my IQ is about 3000, but I don’t know. When it comes to other things maybe it’s down to 80, I don’t know.' +
'\n\n' +
'Q: Where does a knowledge of Russian come from? Where did you learn it? ' +
'\n\n' +
'Fischer: I studied a little bit. My mother knows some of it, so she helped me, and uh, I thought it was very important to learn it, to study the Russian chess literature. I think it’s uh, probably still the finest in the world.' +
'\n\n' +
'Q: Can you name a few books do you like? ' +
'\n\n' +
'Fischer: "Russian school of chess" by Kotov and Yudovich. You learn about all the best Russian chess players. The books on Alekhine by Panov and Kotov are very good. The books on endgames by Yuri Averbakh - the three thick endgame volumes are the best that have been published on the endgame so far.' +
'\n\n' +
'Q: Speaking of Russian chess players what is your opinion of Karpov. Have you had a chance of observing him or meeting him and generally some of the young chess players in the Soviet Union?' +
'\n\n' +
'Fischer: Well, I have to admit that I haven’t been keeping up on some of these younger Russian players that much. But just the other day I went through some of the games from the Russian student teams when they played down in Puerto Rico. They won, but I don’t know how many points. They had a big margin. I went through their games and I was amazed at this young generation of players that I hardly ever heard of are very very strong. ' +
'\n\n' +
'Q: Chess is not considered a sport in United States, but the game is becoming more popular. There are lot of young players coming up and more interest and more members in chess clubs and more participation in chess tournaments. It could be a good sign that the interest in chess is picking up in the United States.' +
'\n\n' +
'Fischer: You know, when people start to read about $100,000 prize money, I think they are going to get interested in the game. That’s the way our system works. I think it’s to a great extent people - if something doesn’t have much money in it - they kind of tend to downgrade it. When I look at golf with all the money. I have a lot of interest in it.' +
'\n\n' +
'Q: Speaking of money, I’ve seen some foreign articles which maintain that you are sort of greedy because you want a lot of money. Why do you really want to win big money prizes and make chess a sport which gives a lot of money? ' +
'\n\n' +
'Fischer: Well, I feel that if you get really good in sport, you should be properly compensated, that’s all.' +
'\n\n' +
'Q: In other words, you don’t feel that chess is an amateur sport, it’s a professional sport and when whoever is in that game has to play it for the money.' +
'\n\n' +
'Fischer: Right! ' +
'\n\n' +
'Q: Because Olympics, for instance, you know is only for amateurs.' +
'\n\n' +
'Fischer: Well, in the states, I mean, we have a lot of talented players that come up. And they see there’s no money in the game and they can maybe get by, making living, but they’re not going to go anywhere. These are ambitious and intelligent people. And naturally what happens they become engineers or something else. So, there’s got to be some money in it to keep these talented players involved. In Russia you have a just different system and if anyone shows any talent the government starts to take him over, give him all kinds of things to keep his interest up in the game.' +
'\n\n' +
'Q: What specific advice would you give to an aspiring chess professional, either in the USA or generally in the world.' +
'\n\n' +
'Fischer: I would tell them that they should study and play as much as they can. And they shouldn’t get discouraged by any setbacks. That’s about it.' +
'\n\n' +
'Q: How do you achieve what you have achieved? ' +
'\n\n' +
'Fischer: Well, I think it’s kind of a gift, but I study like a tremendous amount of literature. And I continue studying. There’s so much stuff coming out. If you want to study chess, there’s no problem. There are just thousands and thousands of games being published practically every month.' +
'\n\n' +
'Q: Isn’t it overpowering though when you do too much studying? Of chess theory and so on? Doesn’t really affect you in some way? ' +
'\n\n' +
'Fischer: Well, right. You have to be selective. You can’t go through it all. I just look through what I feel is important to me.' +
'\n\n' +
'Q: How many hours a day, let’s say, during the preparation for a match, like just the one with Spassky - how many hours do you devote to study?' +
'\n\n' +
'Fischer: I don’t have any schedule. Just you know, kind of haphazard thing.' +
'\n\n' +
'Q: Well, but roughly. I mean do you work four hours, six hours?' +
'\n\n' +
'Fischer: I don’t know - several hours. It’s hard to say. ' +
'\n\n' +
'Q: You have a acquired a rather large fan base in the Soviet Union. is there anything that you would like to tell them? ' +
'\n\n' +
'Fischer: Yes I’d like to say hello to all my fans in the Soviet Union. I know I have a lot of fans in spite of some of the slanted things they have written about me. I get a lot of letters and a lot of telegrams from the Soviet Union.' +
'\n\n' +
'Q: From individuals? ' +
'\n\n' +
'Fischer: Individuals, yeah! Wishing me luck and telling me that I must be the next world champion and that kind of thing. Well, I would just like to say hello to them and tell them I intend to try my best to make the next match interesting so they don’t feel disappointed. Like the last few Petrosian-Spassky matches were not particularly exciting. You know, the players were mainly interested in the score, in the result. They didn’t particularly care about their chess audience. They didn’t wanna take any chances, but I intend to give my fans in Russia and around the room world something to dig their teeth into.' +
'\n\n' +
'Q: You think that the match itself is going to be exciting for the quality of the games? ' +
'\n\n' +
'Fischer: Right, I think it will be.' +
'\n\n' +
'Q: What would change for you if you do become real champion, as we hope you will?' +
'\n\n' +
'Fischer: Well, a lot of money. There seems to be an awful lot of money coming my way. That’s basically about it!' +
'\n\n' +
'Q: Well, then what would you do? Would you continue living the same way you do now? Working hard: studying? Practicing? Playing a lot of games and tournaments?' +
'\n\n' +
'Fischer: Yeah but I intend - after I get the title - I can be a little bit more exclusive, pick my own tournaments and matches in this kind of thing.' +
'\n\n' +
'Q: Thank you very much, Robert. ' +
'\n\n' +
'Fischer: A pleasure!' +
'\n\n\n' +
'This is the first game of Fischer\'s from the Interzonal which started him on the path to the World Championship:\n',

diagrams:{

0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',

1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',

2:'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR',

3:'rnbqkbnr/pp1ppppp/2p5/8/4P3/3P4/PPP2PPP/RNBQKBNR',

4:'rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P4/PPP2PPP/RNBQKBNR',

5:'rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR',

6:'rnbqkbnr/pp2pp1p/2p3p1/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR',

7:'rnbqkbnr/pp2pp1p/2p3p1/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R',

8:'rnbqk1nr/pp2ppbp/2p3p1/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R',

9:'rnbqk1nr/pp2ppbp/2p3p1/3p4/4P3/3P1NP1/PPPN1P1P/R1BQKB1R',

10:'rnbqk1nr/pp3pbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1P1P/R1BQKB1R',

11:'rnbqk1nr/pp3pbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQK2R',

12:'rnbqk2r/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQK2R',

13:'rnbqk2r/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1',

14:'rnbq1rk1/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1',

15:'rnbq1rk1/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQR1K1',

16:'rnbq1rk1/pp2npbp/2p3p1/4p3/3pP3/3P1NP1/PPPN1PBP/R1BQR1K1',

17:'rnbq1rk1/pp2npbp/2p3p1/4p3/P2pP3/3P1NP1/1PPN1PBP/R1BQR1K1',

18:'rnbq1rk1/pp2npbp/6p1/2p1p3/P2pP3/3P1NP1/1PPN1PBP/R1BQR1K1',

19:'rnbq1rk1/pp2npbp/6p1/2p1p3/P1NpP3/3P1NP1/1PP2PBP/R1BQR1K1',

20:'r1bq1rk1/pp2npbp/2n3p1/2p1p3/P1NpP3/3P1NP1/1PP2PBP/R1BQR1K1',

21:'r1bq1rk1/pp2npbp/2n3p1/2p1p3/P1NpP3/2PP1NP1/1P3PBP/R1BQR1K1',

22:'r2q1rk1/pp2npbp/2n1b1p1/2p1p3/P1NpP3/2PP1NP1/1P3PBP/R1BQR1K1',

23:'r2q1rk1/pp2npbp/2n1b1p1/2p1p3/P1NPP3/3P1NP1/1P3PBP/R1BQR1K1',

24:'r2q1rk1/pp2npbp/2n3p1/2p1p3/P1bPP3/3P1NP1/1P3PBP/R1BQR1K1',

25:'r2q1rk1/pp2npbp/2n3p1/2p1p3/P1PPP3/5NP1/1P3PBP/R1BQR1K1',

26:'r2q1rk1/pp2npbp/2n3p1/2p5/P1PpP3/5NP1/1P3PBP/R1BQR1K1',

27:'r2q1rk1/pp2npbp/2n3p1/2p1P3/P1Pp4/5NP1/1P3PBP/R1BQR1K1',

28:'r4rk1/pp1qnpbp/2n3p1/2p1P3/P1Pp4/5NP1/1P3PBP/R1BQR1K1',

29:'r4rk1/pp1qnpbp/2n3p1/2p1P3/P1Pp3P/5NP1/1P3PB1/R1BQR1K1',

30:'r4rk1/pp1qnpbp/2n3p1/2p1P3/P1P4P/3p1NP1/1P3PB1/R1BQR1K1',

31:'r4rk1/pp1qnpbp/2n3p1/2p1P3/P1P4P/3p1NP1/1P1B1PB1/R2QR1K1',

32:'3r1rk1/pp1qnpbp/2n3p1/2p1P3/P1P4P/3p1NP1/1P1B1PB1/R2QR1K1',

33:'3r1rk1/pp1qnpbp/2n3p1/2p1P3/P1P4P/2Bp1NP1/1P3PB1/R2QR1K1',

34:'3r1rk1/pp1qnpbp/6p1/2p1P3/PnP4P/2Bp1NP1/1P3PB1/R2QR1K1',

35:'3r1rk1/pp1qnpbp/6p1/2p1P3/PnPN3P/2Bp2P1/1P3PB1/R2QR1K1',

36:'3rr1k1/pp1qnpbp/6p1/2p1P3/PnPN3P/2Bp2P1/1P3PB1/R2QR1K1',

37:'3rr1k1/pp1qnpbp/4P1p1/2p5/PnPN3P/2Bp2P1/1P3PB1/R2QR1K1',

38:'3rr1k1/pp1qn1bp/4p1p1/2p5/PnPN3P/2Bp2P1/1P3PB1/R2QR1K1',

39:'3rr1k1/pp1qn1bp/4N1p1/2p5/PnP4P/2Bp2P1/1P3PB1/R2QR1K1',

40:'3rr1k1/pp1qn2p/4N1p1/2p5/PnP4P/2bp2P1/1P3PB1/R2QR1K1',

41:'3rr1k1/pp1qn2p/4N1p1/2p5/PnP4P/2Pp2P1/5PB1/R2QR1K1',

42:'3rr1k1/pp1qn2p/4N1p1/2p5/P1P4P/2Pp2P1/2n2PB1/R2QR1K1',

43:'3Nr1k1/pp1qn2p/6p1/2p5/P1P4P/2Pp2P1/2n2PB1/R2QR1K1',

44:'3r2k1/pp1qn2p/6p1/2p5/P1P4P/2Pp2P1/2n2PB1/R2QR1K1',

45:'3r2k1/pp1qn2p/6p1/2p5/P1P4P/2Pp2P1/2nQ1PB1/R3R1K1',

46:'3r2k1/pp1qn2p/6p1/2p5/P1P4P/2Pp2P1/3Q1PB1/n3R1K1',

47:'3r2k1/pp1qn2p/6p1/2p5/P1P4P/2Pp2P1/3Q1PB1/R5K1',

48:'3r4/pp1qn1kp/6p1/2p5/P1P4P/2Pp2P1/3Q1PB1/R5K1',

49:'3r4/pp1qn1kp/6p1/2p5/P1P4P/2Pp2P1/3Q1PB1/4R1K1',

50:'3r2n1/pp1q2kp/6p1/2p5/P1P4P/2Pp2P1/3Q1PB1/4R1K1',

51:'3r2n1/pp1q2kp/6p1/2pB4/P1P4P/2Pp2P1/3Q1P2/4R1K1',

52:'3r2n1/pp4kp/6p1/2pB4/q1P4P/2Pp2P1/3Q1P2/4R1K1',

53:'3r2n1/pp4kp/6p1/2pB4/q1P4P/2PQ2P1/5P2/4R1K1',

54:'4r1n1/pp4kp/6p1/2pB4/q1P4P/2PQ2P1/5P2/4R1K1',

55:'4R1n1/pp4kp/6p1/2pB4/q1P4P/2PQ2P1/5P2/6K1',

56:'4q1n1/pp4kp/6p1/2pB4/2P4P/2PQ2P1/5P2/6K1',

57:'4q1n1/pB4kp/6p1/2p5/2P4P/2PQ2P1/5P2/6K1',

58:'4q3/pB4kp/5np1/2p5/2P4P/2PQ2P1/5P2/6K1',

59:'4q3/pB4kp/3Q1np1/2p5/2P4P/2P3P1/5P2/6K1',

60:'8/pB1q2kp/3Q1np1/2p5/2P4P/2P3P1/5P2/6K1',

61:'8/pB1q2kp/Q4np1/2p5/2P4P/2P3P1/5P2/6K1',

62:'8/pB3qkp/Q4np1/2p5/2P4P/2P3P1/5P2/6K1',

63:'8/QB3qkp/5np1/2p5/2P4P/2P3P1/5P2/6K1',

64:'8/QB3qkp/6p1/2p5/2P1n2P/2P3P1/5P2/6K1',

65:'8/QB3qkp/6p1/2p5/2P1n2P/2P2PP1/8/6K1',

66:'8/QB3qkp/3n2p1/2p5/2P4P/2P2PP1/8/6K1',

67:'8/1B3qkp/3n2p1/2Q5/2P4P/2P2PP1/8/6K1',

68:'8/1n3qkp/6p1/2Q5/2P4P/2P2PP1/8/6K1',

69:'8/1n3qkp/6p1/8/2PQ3P/2P2PP1/8/6K1',

70:'6k1/1n3q1p/6p1/8/2PQ3P/2P2PP1/8/6K1',

71:'6k1/1n3q1p/6p1/8/2PQ3P/2P2PP1/5K2/8',

72:'6k1/1n2q2p/6p1/8/2PQ3P/2P2PP1/5K2/8',

73:'6k1/1n2q2p/6p1/3Q4/2P4P/2P2PP1/5K2/8',

74:'5k2/1n2q2p/6p1/3Q4/2P4P/2P2PP1/5K2/8',

75:'5k2/1n2q2p/6p1/3Q3P/2P5/2P2PP1/5K2/8',

76:'5k2/1n2q2p/8/3Q3p/2P5/2P2PP1/5K2/8',

77:'5k2/1n2q2p/8/7Q/2P5/2P2PP1/5K2/8',

78:'5k2/4q2p/8/2n4Q/2P5/2P2PP1/5K2/8',

79:'5k2/4q2p/8/2nQ4/2P5/2P2PP1/5K2/8',

80:'8/4q1kp/8/2nQ4/2P5/2P2PP1/5K2/8',

81:'8/4q1kp/8/2n5/2PQ4/2P2PP1/5K2/8',

82:'8/4qk1p/8/2n5/2PQ4/2P2PP1/5K2/8',

83:'8/4qk1p/8/2nQ4/2P5/2P2PP1/5K2/8',

84:'8/4q1kp/8/2nQ4/2P5/2P2PP1/5K2/8',

85:'8/4q1kp/8/2n5/2PQ4/2P2PP1/5K2/8',

86:'8/4qk1p/8/2n5/2PQ4/2P2PP1/5K2/8',

87:'8/4qk1p/8/2nQ4/2P5/2P2PP1/5K2/8',

},

comments:{

0:'Robert Fischer - Robert Huebner, Palma de Mallorca Interzonal 1970. Annotations by GM Jan Timman',
1:'1.e4', 2:'1...c6', 3:'2.d3 It is remarkable how restrained Fischer often reacted to the Caro Kann. It should be noted that the fully-fledged attacker Velimirovic also played this move.', 4:'2...d5', 5:'3.Nd2', 6:'3...g6', 7:'4.Ngf3', 8:'4...Bg7', 9:'5.g3', 10:'5...e5', 11:'6.Bg2', 12:'6...Ne7',
13:'7.O-O', 14:'7...O-O', 15:'8.Re1', 16:'8...d4 Shortly before, in Siegen, Hort had played 8...Nd7 against Fischer, who reacted with 9.b3. But the double fianchetto is not very good. The reply 9...d4, also played by Hort, is stronger here. However, in reply to 10.Bb2 Black should continue simply 10...c5 (instead of Hort’s move 10...b5). After 11.c3 Nc6, Black can look to the future with confidence; he has an excellent King’s Indian with reversed colours. Hübner rejected 8...Nd7 because he thought 9.c3 was a strong answer. This indeed looks better since White gets much more influence in the centre. Eight years later, Velimirovic played this way against Matulovic in Belgrade, and obtained an excellent victory.', 17:'9.a4 In Velimirovic-Ciric, Belgrade 1963, White attacked the centre directly with 9.c3, and after 9...c5 10.cxd4 cxd4 increased his range of influence on the queenside with 11.b4. Now, Black should have reacted with 11...Be6, after which the position is approximately balanced, but he played 11...b5, surrendering several important squares. White continued with 12.Nb3 and later won the game.', 18:'9...c5', 19:'10.Nc4', 20:'10...Nbc6', 21:'11.c3', 22:'11...Be6', 23:'12.cxd4',
24:'12...Bxc4 Strategically, this exchange is justified, but Black could have waited with it. After 12...cxd4, the play can develop as follows: 13.Bd2 Nc8 (13...a5 came into consideration too) 14.b4 Nd6 15.Nxd6 Qxd6 16.Ng5 Bd7 17.b5 Nb4 18.Qb3 a5, with a tough fight and chances for both sides.', 25:'13.dxc4', 26:'13...exd4', 27:'14.e5', 28:'14...Qd7', 29:'15.h4 A thematic push. The alternative was 15.Bd2, but probably Fischer wanted to reserve the choice of square to develop the bishop to.', 30:'15...d3 Hübner was afraid of a white initiative on the kingside, and for this reason sought direct counterplay in the centre. Probably, it would have been better to try to maximally increase his sphere of influence on the kingside with 15...Rae8. After 16.Bf4 h6, the position is dynamically balanced.', 31:'16.Bd2', 32:'16...Rad8', 33:'17.Bc3 A natural move, but 17.Ra3 also came into consideration, in order to have the possibility of taking aim at the black d-pawn.',
34:'17...Nb4 A sharp, somewhat risky sortie. The alternative 17...Nf5 was to be preferred, to keep sufficient influence in the centre.', 35:'18.Nd4 Fischer rightly wants to aim for the e5-e6 thrust, but it was more accurate to do this with 18.Ng5, since White doesn’t have to fear the knight invasion on c2. Black is in trouble, as becomes clear in the following lines: A) 18...Nc2 19.e6 fxe6 20.Bxg7 Kxg7 21.Nxe6+ Kg8 22.Nxf8 Kxf8 (after 22...Rxf8 23.Qd2 Rf6 24.Rad1Nxe1 25.Rxe1 Rd6 26.b3, Black will eventually lose his d-pawn, for which he gets insufficient compensation) 23.Qd2 Nxa1 24.Rxa1 Qd4 25.Re1 Nf5 26.Re4 Qd6 27.h5, and White has the initiative; B) 18...Qc7 19.e6 f5 20.Nf7 Nc2 21.Nxd8 Rxd8 22.Qd2, and also here White is better. ', 36:'18...Rfe8 Giving White what he wants after all. Later, Hübner gave two stronger alternatives. First, the slightly surprising but strategically justified 18...Nec6, with the intention to meet 19.Nxc6 with 19...bxc6. The doubled pawn is not weak, since Black controls a lot of important squares. The position is balanced. The restrained 18...Qc8 was another good possibility, to prevent the further march of the white e-pawn. There could have followed 19.Qd2 Rfe8 20.h5, and now Black has the surprising finesse 20...Na2!, yielding him equality.', 37:'19.e6', 38:'19...fxe6', 39:'20.Nxe6', 40:'20...Bxc3', 41:'21.bxc3', 42:'21...Nc2',
43:'22.Nxd8', 44:'22...Rxd8', 45:'23.Qd2', 46:'23...Nxa1', 47:'24.Rxa1 The complications are over, and White’s advantage is beyond doubt. The black d-pawn cannot be maintained in the long run, and White’s supremacy on the kingside is strong. In addition, the bishop is slightly stronger than the knight.', 48:'24...Kg7', 49:'25.Re1', 50:'25...Ng8? Black wants to manoeuvre his knight to f6, but this is time consuming. Probably, 25...b6 was a slightly better defence. Hübner feared 26.Bh3 during the game, but then 26...Nf5 is an adequate defence. The best way for White to continue his initiative is with 26.h5, and now the play can become sharp. After 26...Ng8 27.Re5 Re8 28.Rd5 Qg4, White has two options: 29.Bf1 (29. a5 Re7 (the alternative 29...Qe2 is dangerous, due to 30.Qf4) 30.axb6 axb6 31.Bf1 Qxc4 32.Rxd3 Qe6, and Black’s position is tenable) 29...Nf6 30.h6+ Kg8 31.Rxd3 Ne4 32.Qc1 Qf5, and Black has some compensation for the pawn.', 51:'26.Bd5',
52:'26...Qxa4', 53:'27.Qxd3', 54:'27...Re8', 55:'28.Rxe8', 56:'28...Qxe8', 57:'29.Bxb7', 58:'29...Nf6 Hübner indicates that 29...Qe7 was stronger, to keep the white queen from d6. However, the difference with the text move is not large, since the white queen can penetrate by a roundabout route. After 30.Bf3 Nf6 31.Qb1 Qc7 32.Qb5, Black has the option of 32...a5, which gives him slightly better chances of counterplay in principle.', 59:'30.Qd6', 60:'30...Qd7',
61:'31.Qa6', 62:'31...Qf7', 63:'32.Qxa7? Until this moment Fischer had only used 70 minutes, and he also played the text move quickly. Hübner wittily writes, ‘Fischer gobbled up the unprotected pawn just as quickly as he had done his sandwich.’ Perhaps Fischer played so quickly because Hübner was in serious time-trouble. Whatever the case may be, the text move is a curious mistake. White could have strengthened his position without any problem with 32.Bf3 or 32.Kg2. It’s hard to say how large White’s winning chances would have been in that case; Hübner doesn’t dare to give a decisive answer to this. In any case, it is clear that White can strengthen his position undisturbed, while Black has to watch passively.', 64:'32...Ne4! Of course; Black wins the bishop. Fischer’s mistake is curious, especially because in general he had a clear preference for bishops above knights – and here in fact he just blunders his bishop.', 65:'33.f3', 66:'33...Nd6', 67:'34.Qxc5', 68:'34...Nxb7', 69:'35.Qd4+', 70:'35...Kg8',
71:'36.Kf2 With three pawns for the piece, White is not in any danger of losing, but he doesn’t have any winning chances either.', 72:'36...Qe7', 73:'37.Qd5+', 74:'37...Kf8', 75:'38.h5', 76:'38...gxh5', 77:'39.Qxh5', 78:'39...Nc5', 79:'40.Qd5', 80:'40...Kg7',
81:'41.Qd4+', 82:'41...Kf7', 83:'42.Qd5+', 84:'42...Kg7', 85:'43.Qd4+', 86:'43...Kf7', 87:'44.Qd5+ There was no post-mortem. As a rule, Fischer wasn’t willing to engage in one when the result of the game was disappointing for him.',

}
},
{
    id: 22,
      name: 'Botvinnik on his Game with Fischer',
      description:
'\nRiddles in the Game and Analysis' +
'\n\n' +
'by Mikhail Botvinnik' +
'\n\n' +
'I had only one opportunity to meet Robert Fischer over the board. This was at the XV Chess Olympiad in Varna 1962. There was an effort by the Leyden Chess Society of the Netherlands to organize a training match between us some 7 years later, but these efforts were unsuccessful. ' +
'\n\n\n' +
'Botvinnik\'s analysis starts on Black\'s 42nd move.\n',

diagrams:{

0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',

1:'rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR',

2:'rnbqkbnr/pppppp1p/6p1/8/2P5/8/PP1PPPPP/RNBQKBNR',

3:'rnbqkbnr/pppppp1p/6p1/8/2PP4/8/PP2PPPP/RNBQKBNR',

4:'rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR',

5:'rnbqkb1r/pppppp1p/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR',

6:'rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR',

7:'rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',

8:'rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',

9:'rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/1QN2N2/PP2PPPP/R1B1KB1R',

10:'rnbqk2r/ppp1ppbp/5np1/8/2pP4/1QN2N2/PP2PPPP/R1B1KB1R',

11:'rnbqk2r/ppp1ppbp/5np1/8/2QP4/2N2N2/PP2PPPP/R1B1KB1R',

12:'rnbq1rk1/ppp1ppbp/5np1/8/2QP4/2N2N2/PP2PPPP/R1B1KB1R',

13:'rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R',

14:'rn1q1rk1/ppp1ppbp/5np1/8/2QPP1b1/2N2N2/PP3PPP/R1B1KB1R',

15:'rn1q1rk1/ppp1ppbp/5np1/8/2QPP1b1/2N1BN2/PP3PPP/R3KB1R',

16:'rn1q1rk1/pppnppbp/6p1/8/2QPP1b1/2N1BN2/PP3PPP/R3KB1R',

17:'rn1q1rk1/pppnppbp/6p1/8/2QPP1b1/2N1BN2/PP2BPPP/R3K2R',

18:'r2q1rk1/pppnppbp/2n3p1/8/2QPP1b1/2N1BN2/PP2BPPP/R3K2R',

19:'r2q1rk1/pppnppbp/2n3p1/8/2QPP1b1/2N1BN2/PP2BPPP/3RK2R',

20:'r2q1rk1/ppp1ppbp/1nn3p1/8/2QPP1b1/2N1BN2/PP2BPPP/3RK2R',

21:'r2q1rk1/ppp1ppbp/1nn3p1/2Q5/3PP1b1/2N1BN2/PP2BPPP/3RK2R',

22:'r4rk1/ppp1ppbp/1nnq2p1/2Q5/3PP1b1/2N1BN2/PP2BPPP/3RK2R',

23:'r4rk1/ppp1ppbp/1nnq2p1/2Q5/3PP1b1/2N1BN1P/PP2BPP1/3RK2R',

24:'r4rk1/ppp1ppbp/1nnq2p1/2Q5/3PP3/2N1Bb1P/PP2BPP1/3RK2R',

25:'r4rk1/ppp1ppbp/1nnq2p1/2Q5/3PP3/2N1BP1P/PP2BP2/3RK2R',

26:'r2r2k1/ppp1ppbp/1nnq2p1/2Q5/3PP3/2N1BP1P/PP2BP2/3RK2R',

27:'r2r2k1/ppp1ppbp/1nnq2p1/2QP4/4P3/2N1BP1P/PP2BP2/3RK2R',

28:'r2r2k1/ppp1ppbp/1n1q2p1/2QPn3/4P3/2N1BP1P/PP2BP2/3RK2R',

29:'r2r2k1/ppp1ppbp/1n1q2p1/1NQPn3/4P3/4BP1P/PP2BP2/3RK2R',

30:'r2r2k1/ppp1ppbp/1n3qp1/1NQPn3/4P3/4BP1P/PP2BP2/3RK2R',

31:'r2r2k1/ppp1ppbp/1n3qp1/1NQPn3/4PP2/4B2P/PP2BP2/3RK2R',

32:'r2r2k1/pppnppbp/1n3qp1/1NQP4/4PP2/4B2P/PP2BP2/3RK2R',

33:'r2r2k1/pppnppbp/1n3qp1/1NQPP3/5P2/4B2P/PP2BP2/3RK2R',

34:'r2r2k1/pppnppbp/1n4p1/1NQPP3/5q2/4B2P/PP2BP2/3RK2R',

35:'r2r2k1/pppnppbp/1n4p1/1NQPP3/5B2/7P/PP2BP2/3RK2R',

36:'r2r2k1/ppp1ppbp/1n4p1/1NnPP3/5B2/7P/PP2BP2/3RK2R',

37:'r2r2k1/ppN1ppbp/1n4p1/2nPP3/5B2/7P/PP2BP2/3RK2R',

38:'2rr2k1/ppN1ppbp/1n4p1/2nPP3/5B2/7P/PP2BP2/3RK2R',

39:'2rr2k1/ppN1ppbp/1n1P2p1/2n1P3/5B2/7P/PP2BP2/3RK2R',

40:'2rr2k1/ppN2pbp/1n1p2p1/2n1P3/5B2/7P/PP2BP2/3RK2R',

41:'2rr2k1/ppN2pbp/1n1P2p1/2n5/5B2/7P/PP2BP2/3RK2R',

42:'2rr2k1/ppN2p1p/1n1P2p1/2n5/5B2/7P/Pb2BP2/3RK2R',

43:'2rr2k1/ppN2p1p/1n1P2p1/2n5/5B2/7P/Pb2BP2/3R1RK1',

44:'2rr2k1/ppNn1p1p/3P2p1/2n5/5B2/7P/Pb2BP2/3R1RK1',

45:'2rr2k1/ppNn1p1p/3P2p1/2nR4/5B2/7P/Pb2BP2/5RK1',

46:'2rr2k1/p1Nn1p1p/1p1P2p1/2nR4/5B2/7P/Pb2BP2/5RK1',

47:'2rr2k1/p1Nn1p1p/1p1P2p1/2nR4/5B2/5B1P/Pb3P2/5RK1',

48:'2rr2k1/p1Nn1p1p/1p1Pn1p1/3R4/5B2/5B1P/Pb3P2/5RK1',

49:'2rr2k1/p2n1p1p/1p1PN1p1/3R4/5B2/5B1P/Pb3P2/5RK1',

50:'2rr2k1/p2n3p/1p1Pp1p1/3R4/5B2/5B1P/Pb3P2/5RK1',

51:'2rr2k1/p2n3p/1p1Pp1p1/8/5B2/3R1B1P/Pb3P2/5RK1',

52:'2rr2k1/p6p/1p1Pp1p1/2n5/5B2/3R1B1P/Pb3P2/5RK1',

53:'2rr2k1/p6p/1p1Pp1p1/2n5/5B2/4RB1P/Pb3P2/5RK1',

54:'2rr2k1/p6p/1p1P2p1/2n1p3/5B2/4RB1P/Pb3P2/5RK1',

55:'2rr2k1/p6p/1p1P2p1/2n1B3/8/4RB1P/Pb3P2/5RK1',

56:'2rr2k1/p6p/1p1P2p1/2n1b3/8/4RB1P/P4P2/5RK1',

57:'2rr2k1/p6p/1p1P2p1/2n1R3/8/5B1P/P4P2/5RK1',

58:'2r3k1/p6p/1p1r2p1/2n1R3/8/5B1P/P4P2/5RK1',

59:'2r3k1/p3R2p/1p1r2p1/2n5/8/5B1P/P4P2/5RK1',

60:'2r3k1/p2rR2p/1p4p1/2n5/8/5B1P/P4P2/5RK1',

61:'2r3k1/p2R3p/1p4p1/2n5/8/5B1P/P4P2/5RK1',

62:'2r3k1/p2n3p/1p4p1/8/8/5B1P/P4P2/5RK1',

63:'2r3k1/p2n3p/1p4p1/8/6B1/7P/P4P2/5RK1',

64:'6k1/p1rn3p/1p4p1/8/6B1/7P/P4P2/5RK1',

65:'6k1/p1rn3p/1p4p1/8/6B1/7P/P4P2/4R1K1',

66:'8/p1rn1k1p/1p4p1/8/6B1/7P/P4P2/4R1K1',

67:'8/p1rn1k1p/1p4p1/8/6B1/7P/P4PK1/4R3',

68:'8/p1r2k1p/1p4p1/2n5/6B1/7P/P4PK1/4R3',

69:'8/p1r2k1p/1p4p1/2n5/6B1/4R2P/P4PK1/8',

70:'8/p3rk1p/1p4p1/2n5/6B1/4R2P/P4PK1/8',

71:'8/p3rk1p/1p4p1/2n5/6B1/5R1P/P4PK1/8',

72:'8/p3r1kp/1p4p1/2n5/6B1/5R1P/P4PK1/8',

73:'8/p3r1kp/1p4p1/2n5/6B1/2R4P/P4PK1/8',

74:'8/p5kp/1p4p1/2n5/4r1B1/2R4P/P4PK1/8',

75:'8/p5kp/1p4p1/2n5/4r3/2R4P/P4PK1/3B4',

76:'8/p5kp/1p4p1/2n5/3r4/2R4P/P4PK1/3B4',

77:'8/p5kp/1p4p1/2n5/3r4/2R4P/P1B2PK1/8',

78:'8/p6p/1p3kp1/2n5/3r4/2R4P/P1B2PK1/8',

79:'8/p6p/1p3kp1/2n5/3r4/2R2K1P/P1B2P2/8',

80:'8/p6p/1p4p1/2n3k1/3r4/2R2K1P/P1B2P2/8',

81:'8/p6p/1p4p1/2n3k1/3r4/2R3KP/P1B2P2/8',

82:'8/p6p/1p4p1/6k1/3rn3/2R3KP/P1B2P2/8',

83:'8/p6p/1p4p1/6k1/3rB3/2R3KP/P4P2/8',

84:'8/p6p/1p4p1/6k1/4r3/2R3KP/P4P2/8',

85:'8/p6p/1p4p1/6k1/4r3/R5KP/P4P2/8',

86:'8/p3r2p/1p4p1/6k1/8/R5KP/P4P2/8',

87:'8/p3r2p/1p4p1/6k1/8/5RKP/P4P2/8',

88:'8/p1r4p/1p4p1/6k1/8/5RKP/P4P2/8',

89:'8/p1r4p/1p4p1/6k1/P7/5RKP/5P2/8',

90:'8/p6p/1p4p1/2r3k1/P7/5RKP/5P2/8',

91:'8/p4R1p/1p4p1/2r3k1/P7/6KP/5P2/8',

92:'8/p4R1p/1p4p1/r5k1/P7/6KP/5P2/8',

93:'8/p6R/1p4p1/r5k1/P7/6KP/5P2/8',

94:'8/p6R/1p4p1/6k1/r7/6KP/5P2/8',

95:'8/p6R/1p4p1/6k1/r6P/6K1/5P2/8',

96:'8/p6R/1p4p1/5k2/r6P/6K1/5P2/8',

97:'8/p4R2/1p4p1/5k2/r6P/6K1/5P2/8',

98:'8/p4R2/1p4p1/4k3/r6P/6K1/5P2/8',

99:'8/p5R1/1p4p1/4k3/r6P/6K1/5P2/8',

100:'8/p5R1/1p4p1/4k3/7P/6K1/5P2/r7',

101:'8/p5R1/1p4p1/4k3/7P/5K2/5P2/r7',

102:'8/p5R1/6p1/1p2k3/7P/5K2/5P2/r7',

103:'8/p5R1/6p1/1p2k2P/8/5K2/5P2/r7',

104:'8/p5R1/6p1/1p2k2P/8/r4K2/5P2/8',

105:'8/p5R1/6p1/1p2k2P/8/r7/5PK1/8',

106:'8/p5R1/8/1p2k2p/8/r7/5PK1/8',

107:'8/p7/8/1p2k1Rp/8/r7/5PK1/8',

108:'8/p7/3k4/1p4Rp/8/r7/5PK1/8',

109:'8/p7/3k4/1R5p/8/r7/5PK1/8',

110:'8/p7/3k4/1R6/7p/r7/5PK1/8',

111:'8/p7/3k4/1R6/5P1p/r7/6K1/8',

112:'8/p7/2k5/1R6/5P1p/r7/6K1/8',

113:'1R6/p7/2k5/8/5P1p/r7/6K1/8',

114:'1R6/p7/2k5/8/5P2/r6p/6K1/8',

115:'1R6/p7/2k5/8/5P2/r6p/7K/8',

116:'1R6/8/2k5/p7/5P2/r6p/7K/8',

117:'1R6/8/2k5/p4P2/8/r6p/7K/8',

118:'1R6/2k5/8/p4P2/8/r6p/7K/8',

119:'8/2k5/8/pR3P2/8/r6p/7K/8',

120:'8/8/3k4/pR3P2/8/r6p/7K/8',

121:'8/8/3k1P2/pR6/8/r6p/7K/8',

122:'8/8/4kP2/pR6/8/r6p/7K/8',

123:'8/8/1R2kP2/p7/8/r6p/7K/8',

124:'8/5k2/1R3P2/p7/8/r6p/7K/8',

125:'8/5k2/R4P2/p7/8/r6p/7K/8',

126:'8/8/R4Pk1/p7/8/r6p/7K/8',

127:'8/8/2R2Pk1/p7/8/r6p/7K/8',

128:'8/8/2R2Pk1/8/p7/r6p/7K/8',

129:'8/8/R4Pk1/8/p7/r6p/7K/8',

130:'8/5k2/R4P2/8/p7/r6p/7K/8',

131:'8/5k2/2R2P2/8/p7/r6p/7K/8',

132:'8/5k2/2R2P2/8/p7/3r3p/7K/8',

133:'8/5k2/R4P2/8/p7/3r3p/7K/8',

134:'8/5k2/R4P2/8/8/p2r3p/7K/8',

135:'8/5k2/R4P2/8/8/p2r3p/8/6K1',

},

comments:{

0:'Botvinnik-Fischer, Varna Olympiad 1962.',

1:'1.c4', 2:'1...g6', 3:'2.d4', 4:'2...Nf6', 5:'3.Nc3', 6:'3...d5', 7:'4.Nf3', 8:'4...Bg7', 9:'5.Qb3', 10:'5...dxc4', 11:'6.Qxc4',

12:'6...O-O', 13:'7.e4', 14:'7...Bg4', 15:'8.Be3', 16:'8...Nfd7', 17:'9.Be2', 18:'9...Nc6', 19:'10.Rd1', 20:'10...Nb6', 21:'11.Qc5', 22:'11...Qd6',

23:'12.h3', 24:'12...Bxf3', 25:'13.gxf3', 26:'13...Rfd8', 27:'14.d5', 28:'14...Ne5', 29:'15.Nb5', 30:'15...Qf6', 31:'16.f4', 32:'16...Ned7',

33:'17.e5', 34:'17...Qxf4', 35:'18.Bxf4', 36:'18...Nxc5', 37:'19.Nxc7', 38:'19...Rac8', 39:'20.d6', 40:'20...exd6', 41:'21.exd6',

42:'21...Bxb2', 43:'22.O-O', 44:'22...Nbd7', 45:'23.Rd5', 46:'23...b6', 47:'24.Bf3', 48:'24...Ne6', 49:'25.Nxe6', 50:'25...fxe6', 51:'26.Rd3',

52:'26...Nc5', 53:'27.Re3', 54:'27...e5', 55:'28.Bxe5', 56:'28...Bxe5', 57:'29.Rxe5', 58:'29...Rxd6', 59:'30.Re7', 60:'30...Rd7',

61:'31.Rxd7', 62:'31...Nxd7', 63:'32.Bg4', 64:'32...Rc7', 65:'33.Re1', 66:'33...Kf7', 67:'34.Kg2', 68:'34...Nc5', 69:'35.Re3', 70:'35...Re7',

71:'36.Rf3+', 72:'36...Kg7', 73:'37.Rc3', 74:'37...Re4', 75:'38.Bd1', 76:'38...Rd4', 77:'39.Bc2', 78:'39...Kf6', 79:'40.Kf3', 80:'40...Kg5',

81:'41.Kg3', 82:'41...Ne4+', 83:'42.Bxe4', 84:'42...Rxe4 Although the game and now gone 42 moves, play continued. I was in no hurry to adjourn, since I considered over-the-board play in such a position would give me more chances than I would get after adjournment analysis. And Fischer\'s whole being radiated amazement that White would continue to resist in such a \"hopeless\" position. Clearly, he was out to show both the Olympiad participants and the spectators that such a position requires no analysis. But let’s see how the game went.', 85:'43.Ra3 From the continuation - and with a glance at the following diagram – it is clear that the immediate 43.Rc7 was correct, without fear of the reply 43...Ra4. The reader will soon see, however, that finding such a difficult decision over the board was practically impossible. But now Fischer is the first to suffer from his decision not to adjourn and analyze the position: he passes up the winning line 43...a5, and on 44.Rb3, 43...Rb4. The whole problem lies in the fact that the pawn ending after 45.Rxb4 axb4 46.f4+ K55 47.Kf3 Ke6 48.Ke4 Kd6 49.Kd4 b5 is lost; and if White declines the exchange of rooks, Black also wins the rook endgame.', 86:'43...Re7', 87:'44.Rf3', 88:'44...Rc7 On 44...Kh6 followed by 45...Kg7 White would have to find some other way to save himself; perhaps he could not.', 89:'45.a4 Now the session was at an end, and Fischer had to seal a move. After dinner the nights analysis began, one of the longest of my experience. I was not worried by the continuation 45...Rc4 because of the immediate 46.a5 bxa5 (or 46...b5 47.Rf7) 47.Rf7 a6 48.h4+ Kh6 49.Rd7 with a draw. Nor is 45...Kh6 46.Rd3 Rc5 47.h4 Ra5 48.Rd4 dangerous for White. But what is White to do after 45...Rc5? The future look grim indeed, until Geller found a unique counter plan for White. When he left, late at night, I had only to work out the fine points of his discovery.', 90:'45...Rc5 So our work on just this move will not be wasted after all.',

91:'46.Rf7', 92:'46...Ra5 46.Rc7 Ra4 would lead to basically the same sort of position. But what was the point of our analysis?', 93:'47.Rxh7!! "I overlooked this defense", Fischer was to write later. There is nothing surprising in this, since the decision to get my opponent two connected passed pawns seems paradoxical, to say the least. That it is possible springs from the fact that the advance of these pawns will weaken the square b6. Then the Black king can be chased away from the g6 pawn, the pawn can be taken, and White will have two passed pawns on the kingside.', 94:'47...Rxa4', 95:'48.h4+', 96:'48...Kf5 The thematic variation, which serves as the concrete expression of the preceding commentary, would look like this: 48...Kf6 49.Rb7 Ra5 50.Kg4 b5 51.f4 a6 52.Rb6+ Kf7 53. Rb7+, and White draws.', 97:'49.Rf7+', 98:'49...Ke5', 99:'50.Rg7', 100:'50...Ra1',

101:'51.Kf3 What can Black do here? We have already seen that nothing useful can be gotten from 51...Kf6 52.Rb7. Had Fischer examined the adjourned position carefully, he would undoubtedly have reached this position and selected 51...Kd4, which is the most unpleasant continuation for a White. Sure of victory, however, he slept soundly that night - as his American teammates informed me after the adjournment. One can perhaps afford to sleep with other endgames, but not with rooks!', 102:'51...b5 For this continuation, I found a sufficient answer near morning.', 103:'52.h5! The surprising thing about this move is that, instead of taking the undefended g-pawn, White temporary sacrifices one of his own. Fischer acknowledges that he overlooked this reply when he played 51...b5 – a rare occurrence in the career of the future World Champion. By the way: at this point I was no longer able to contain myself – I went to our team captain, Lev Abramov, and said one word to him: "Draw". Imagine our amazement when we found out later that Fischer had at that moment filed a protest with the Deputy Arbiter, L.Bonevoy, that "Botvinnick was taking advice during the game"!', 104:'52...Ra3+', 105:'53.Kg2', 106:'53...gxh5', 107:'54.Rg5+', 108:'54...Kd6', 109:'55.Rxb5', 110:'55...h4',

111:'56.f4', 112:'56...Kc6 The reader should not be surprised that play drags on so in a radically drawn endgame. There are players who find it hard to readjust their thinking after an unexpected turn of events.', 113:'57.Rb8', 114:'57...h3+', 115:'58.Kh2', 116:'58...a5', 117:'59.f5', 118:'59...Kc7', 119:'60.Rb5', 120:'60...Kd6',

121:'61.f6', 122:'61...Ke6', 123:'62.Rb6+', 124:'62...Kf7', 125:'63.Ra6 Here is where Black ought to offer the draw. For I, being a pawn down, cannot, according to the unwritten rules of chess, be the one to make the offer.', 126:'63...Kg6', 127:'64.Rc6', 128:'64...a4', 129:'65.Ra6', 130:'65...Kf7',

131:'66.Rc6', 132:'66...Rd3', 133:'67.Ra6', 134:'67...a3', 135:'68.Kg1 Only now did Fischer, his face White as a sheet, shake my hand and left the playing hall, with tears in his eyes. Our battle over this game did not end here, however. The main thing was whether or not Black could have won after 51...Kd4. After 52.Rxg6 Black starts pushing pawns: 52...b5 53.h5 b4 54.h6 b3 (a theoretical draw results from 54...Rh1 55.Kg2 Rh5 56.Ra6 b3 5.Rxa7 Rxh6 58.Rb7 Kc4 59.Kf3). Now White will check the opposing king. Since he does not wish to allow Black\'s Rook on the b-file, he will have to take up an inferior position: 55.Rg4+ Kc5 56.Rg5+ Kc6 (56...Kb4 57.Rg7 b2 58.h7 Rh1 59.Rxa7) 57.Rg6+ Kb7 58.Rg7+ Ka6 59.Rg6+ Ka5 60. Rg5+ Ka4 61.Rg4+ Ka3. Now 62.Rh4 b2 63.h7 b1=Q 64.h8=Q is forced. My evaluation of the position was as follows: "Black cannot win, since his rook is shut in by his king". Fischer continued this analysis: 64...Qb3+ 65.Ke2 Qd1+ 66.Ke3 Rb1 and after the additional moves 67.Qf8+ Ka2 concluded that "White king will be unable to shelter from the fatal avalanche of checks". There are two errors in this, first of all, as I discovered, after 68.Qc5 White has a sufficient defense. This was later worked out in detail by Master A.Kremenetsky in Shakhmaty v SSSR No 2, 1977. Gary Kasparov, then only 13, but now known to all as an International Grandmaster, found an elegant drawing line: 67.Rc4! Rb3+ 68.Rc3 Qe1+ 69.Kd3 Qf1+ 70.Kd2 (70 Ke3? Qh3+) 70...Qxf2+ 71.Kd3. This appears to be the final word in the lengthy disputes connected with this game. It gave rise to some head-turning riddles, during play and especially in analysis.',

}
},
{
    id: 23,
      name: 'Fischer at the 1957 US Open',
      description:
'\nFischer at the 1957 US Open' +
'\n\n' +
'by Jerome Hanken' +
'\n\n' +
'I first met Bobby Fischer in Cleveland, Ohio, at the United States Open chess championship in the summer of 1957. He was somewhat small for his 14 years of age, but even then, he possessed the confidence and tenacity which were later to characterize his approach to life, as well as to chess. I had just completed two rather futile years as a graduate student at the University of Kansas and was returning to my native Ohio to teach High School. It was during this summer that the game of chess had become almost an obsession to me. Having learned the game only the year before, I immediately plunged into the icy waters of tournament play only to be battered and beaten about in a rather unpromising manner. However, persistence, at the expense of my graduate work, had brought me to the point where I was becoming an almost competent tournament player.  \n\n'+

'Perhaps it was the fact that I was a schoolteacher which made it so easy for me to relate to the rather taciturn and closemouthed young Bobby at the time. He was always surrounded by other young players and older chess masters with whom he continually indulged in so-called “rapid transit” or five-minute chess. The stream of New York toned invective which passes back and forth between the players in such matches is familiar to all serious chess buffs, but it was my first introduction to it. “Patzer!” or “Bread” were two of the nicer epithets applied by Fischer to his usually hapless opponents. Bobby’s “rapid transit” chess has always been almost superior to his tournament play. His amazing quick insight and fantastic physical responses have placed him in a class by himself in this form of chess as well as tournament play. \n\n'+

'At the time, there was very little, other than chess, which I found in common with Bobby. He expressed rather negative feelings about teachers in general, but never went into this in any detail. During this tournament, my first United States Open and Bobby’s first major victory in a national chess tournament, the jealousy and rancor which Bobby had aroused in his fellow players was already becoming evident. A strange incident occurred during that tournament which I recall very vividly. Bobby came down to the tournament room one day with a noticeable black eye. He refused to talk about it with anyone, but, later on, I heard that he had been the object of some considerable teasing among his peers (Authors – this was the incident with Gil Ramerez related earlier in this book). Bobby was being sponsored at Cleveland because of his victory in the United States Junior which came the month before and he was housed with other young players in a special hotel suite. The story was, that one of the young men had been mercilessly annoying Bobby and that, in a fit of rage, Bobby had sunk his teeth into the boy’s arm. He refused to let go and the other boy was finally forced to punch him in the eye in order to reclaim his somewhat chewed up arm. There were no further reports of anyone seriously teasing or bothering Bobby Fischer.  ' +
'\n\n',

diagrams:{

0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',

1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',

2:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',

3:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',

4:'rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',

5:'rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',

6:'rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R',

7:'rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R',

8:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R',

9:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',

10:'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',

11:'rnbqkb1r/1p2pppp/p2p1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R',

12:'rnbqkb1r/1p3ppp/p2ppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R',

13:'rnbqkb1r/1p3ppp/p2ppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R',

14:'rnbqkb1r/1p3pp1/p2ppn1p/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R',

15:'rnbqkb1r/1p3pp1/p2ppn1p/8/3NP3/2N1B3/PPPQ1PPP/R3KB1R',

16:'rnbqkb1r/1p3pp1/p2pp2p/8/3NP1n1/2N1B3/PPPQ1PPP/R3KB1R',

17:'rnbqkb1r/1p3pp1/p2pp2p/8/4P1n1/1NN1B3/PPPQ1PPP/R3KB1R',

18:'rnbqkb1r/1p3pp1/p2pp2p/8/4P3/1NN1n3/PPPQ1PPP/R3KB1R',

19:'rnbqkb1r/1p3pp1/p2pp2p/8/4P3/1NN1Q3/PPP2PPP/R3KB1R',

20:'r1bqkb1r/1p3pp1/p1npp2p/8/4P3/1NN1Q3/PPP2PPP/R3KB1R',

21:'r1bqkb1r/1p3pp1/p1npp2p/8/4P3/1NN1Q3/PPP1BPPP/R3K2R',

22:'r1bqk2r/1p2bpp1/p1npp2p/8/4P3/1NN1Q3/PPP1BPPP/R3K2R',

23:'r1bqk2r/1p2bpp1/p1npp2p/8/4P3/1NN1Q3/PPP1BPPP/R4RK1',

24:'r1bq1rk1/1p2bpp1/p1npp2p/8/4P3/1NN1Q3/PPP1BPPP/R4RK1',

25:'r1bq1rk1/1p2bpp1/p1npp2p/8/4P3/1NN1Q3/PPP1BPPP/3R1RK1',

26:'r1bq1rk1/4bpp1/p1npp2p/1p6/4P3/1NN1Q3/PPP1BPPP/3R1RK1',

27:'r1bq1rk1/4bpp1/p1npp2p/1p6/4PP2/1NN1Q3/PPP1B1PP/3R1RK1',

28:'r2q1rk1/3bbpp1/p1npp2p/1p6/4PP2/1NN1Q3/PPP1B1PP/3R1RK1',

29:'r2q1rk1/3bbpp1/p1npp2p/1p6/4PP2/1NN1QB2/PPP3PP/3R1RK1',

30:'r2q1rk1/3bbpp1/p2pp2p/np6/4PP2/1NN1QB2/PPP3PP/3R1RK1',

31:'r2q1rk1/3bbpp1/p2pp2p/np6/4PP2/1NN1Q3/PPP1B1PP/3R1RK1',

32:'r2q1rk1/3bbpp1/p2pp2p/1p6/2n1PP2/1NN1Q3/PPP1B1PP/3R1RK1',

33:'r2q1rk1/3bbpp1/p2pp2p/1p6/2B1PP2/1NN1Q3/PPP3PP/3R1RK1',

34:'r2q1rk1/3bbpp1/p2pp2p/8/2p1PP2/1NN1Q3/PPP3PP/3R1RK1',

35:'r2q1rk1/3bbpp1/p2pp2p/8/2p1PP2/2N1Q3/PPPN2PP/3R1RK1',

36:'r4rk1/2qbbpp1/p2pp2p/8/2p1PP2/2N1Q3/PPPN2PP/3R1RK1',

37:'r4rk1/2qbbpp1/p2pp2p/8/2p1PP2/2N1Q3/PPPN2PP/3R1R1K',

38:'r1r3k1/2qbbpp1/p2pp2p/8/2p1PP2/2N1Q3/PPPN2PP/3R1R1K',

39:'r1r3k1/2qbbpp1/p2pp2p/8/2p1PP2/2N1QN2/PPP3PP/3R1R1K',

40:'1rr3k1/2qbbpp1/p2pp2p/8/2p1PP2/2N1QN2/PPP3PP/3R1R1K',

41:'1rr3k1/2qbbpp1/p2pp2p/8/2p1PP2/2N1QN2/PPP3PP/1R3R1K',

42:'1rr3k1/2qbbpp1/3pp2p/p7/2p1PP2/2N1QN2/PPP3PP/1R3R1K',

43:'1rr3k1/2qbbpp1/3pp2p/p4P2/2p1P3/2N1QN2/PPP3PP/1R3R1K',

44:'1rr3k1/2qbbpp1/3pp2p/5P2/p1p1P3/2N1QN2/PPP3PP/1R3R1K',

45:'1rr3k1/2qbbpp1/3pP2p/8/p1p1P3/2N1QN2/PPP3PP/1R3R1K',

46:'1rr3k1/2qbb1p1/3pp2p/8/p1p1P3/2N1QN2/PPP3PP/1R3R1K',

47:'1rr3k1/2qbb1p1/3pp2p/8/p1p1P3/P1N1QN2/1PP3PP/1R3R1K',

48:'1rr3k1/3bb1p1/3pp2p/2q5/p1p1P3/P1N1QN2/1PP3PP/1R3R1K',

49:'1rr3k1/3bb1p1/3pp2p/2Q5/p1p1P3/P1N2N2/1PP3PP/1R3R1K',

50:'1r4k1/3bb1p1/3pp2p/2r5/p1p1P3/P1N2N2/1PP3PP/1R3R1K',

51:'1r4k1/3bb1p1/3pp2p/2r5/p1p1P3/P4N2/NPP3PP/1R3R1K',

52:'1r4k1/3bb1p1/3pp2p/1r6/p1p1P3/P4N2/NPP3PP/1R3R1K',

53:'1r4k1/3bb1p1/3pp2p/1r6/pNp1P3/P4N2/1PP3PP/1R3R1K',

54:'1r4k1/3bb1p1/3pp2p/1r6/pN2P3/P1p2N2/1PP3PP/1R3R1K',

55:'1r4k1/3bb1p1/3pp2p/1r6/pN1NP3/P1p5/1PP3PP/1R3R1K',

56:'1r4k1/3bb1p1/3pp2p/2r5/pN1NP3/P1p5/1PP3PP/1R3R1K',

57:'1r4k1/3bb1p1/N2pp2p/2r5/p2NP3/P1p5/1PP3PP/1R3R1K',

58:'6k1/3bb1p1/N2pp2p/2r5/p2NP3/P1p5/1rP3PP/1R3R1K',

59:'6k1/3bb1p1/3pp2p/2N5/p2NP3/P1p5/1rP3PP/1R3R1K',

60:'6k1/3bb1p1/4p2p/2p5/p2NP3/P1p5/1rP3PP/1R3R1K',

61:'6k1/3bb1p1/4p2p/2p5/p3P3/P1p2N2/1rP3PP/1R3R1K',

62:'6k1/3bb1p1/4p2p/8/p1p1P3/P1p2N2/1rP3PP/1R3R1K',

63:'6k1/3bb1p1/4p2p/4N3/p1p1P3/P1p5/1rP3PP/1R3R1K',

64:'6k1/4b1p1/4p2p/1b2N3/p1p1P3/P1p5/1rP3PP/1R3R1K',

65:'6k1/4b1p1/4p2p/1b2N3/p1p1P3/P1p5/1RP3PP/5R1K',

66:'6k1/4b1p1/4p2p/1b2N3/p1p1P3/P7/1pP3PP/5R1K',

67:'6k1/4b1p1/4p2p/1b2N3/p1p1P3/P1P5/1p4PP/5R1K',

68:'6k1/6p1/4pb1p/1b2N3/p1p1P3/P1P5/1p4PP/5R1K',

69:'6k1/6p1/4pb1p/1b2N3/p1p1P3/P1P5/1p4PP/1R5K',

70:'6k1/6p1/4p2p/1b2b3/p1p1P3/P1P5/1p4PP/1R5K',

71:'6k1/6p1/4p2p/1b2b3/p1p1P3/P1P5/1R4PP/7K',

72:'4b1k1/6p1/4p2p/4b3/p1p1P3/P1P5/1R4PP/7K',

73:'4b1k1/6p1/4p2p/4b3/pRp1P3/P1P5/6PP/7K',

74:'4b1k1/6p1/4p2p/8/pRp1P3/P1b5/6PP/7K',

75:'4b1k1/6p1/4p2p/8/p1R1P3/P1b5/6PP/7K',

76:'4b1k1/6p1/4p2p/8/p1R1P3/P7/1b4PP/7K',

77:'4b1k1/6p1/4p2p/8/pR2P3/P7/1b4PP/7K',

78:'4b1k1/6p1/4p2p/8/pR2P3/b7/6PP/7K',

79:'4b1k1/6p1/1R2p2p/8/p3P3/b7/6PP/7K',

80:'4b3/5kp1/1R2p2p/8/p3P3/b7/6PP/7K',

81:'4b3/1R3kp1/4p2p/8/p3P3/b7/6PP/7K',

82:'4b3/1R2bkp1/4p2p/8/p3P3/8/6PP/7K',

83:'4b3/1R2bkp1/4p2p/4P3/p7/8/6PP/7K',

84:'4b3/1R2bkp1/4p2p/4P3/8/p7/6PP/7K',

85:'4b3/1R2bkp1/4p2p/4P3/8/p7/6PP/6K1',

86:'8/1R2bkp1/2b1p2p/4P3/8/p7/6PP/6K1',

87:'8/R3bkp1/2b1p2p/4P3/8/p7/6PP/6K1',

88:'8/R3bkp1/4p2p/3bP3/8/p7/6PP/6K1',

89:'8/R3bkp1/4p2p/3bP3/8/p7/6PP/5K2',

90:'8/R3bkp1/4p2p/3bP3/8/8/p5PP/5K2',

91:'8/R3bkp1/4p2p/3bP3/8/8/p3K1PP/8',

92:'8/R3b1p1/4p1kp/3bP3/8/8/p3K1PP/8',

93:'8/R3b1p1/4p1kp/3bP3/6P1/8/p3K2P/8',

94:'8/R5p1/4p1kp/2bbP3/6P1/8/p3K2P/8',

95:'8/6p1/4p1kp/R1bbP3/6P1/8/p3K2P/8',

96:'8/6p1/4p1kp/R2bP3/3b2P1/8/p3K2P/8',

},

comments:{

0:'Nash-Fischer, US Open 1957. Annotations by NM Dan Scoones.',

1:'1.e4', 2:'1...c5', 3:'2.Nf3', 4:'2...d6', 5:'3.d4', 6:'3...cxd4', 7:'4.Nxd4', 8:'4...Nf6', 9:'5.Nc3', 10:'5...a6', 11:'6.Bg5', 12:'6...e6',

13:'7.Qd2', 14:'7...h6', 15:'8.Be3', 16:'8...Ng4', 17:'9.Nb3', 18:'9...Nxe3', 19:'10.Qxe3', 20:'10...Nc6', 21:'11.Be2', 22:'11...Be7',

23:'12.O-O', 24: '12...O-O', 25:'13.Rad1', 26:'13...b5', 27:'14.f4', 28:'14...Bd7', 29:'15.Bf3', 30:'15...Na5', 31:'16.Be2', 32:'16...Nc4',

33:'17.Bxc4', 34:'17...bxc4', 35:'18.Nd2', 36:'18...Qc7', 37:'19.Kh1', 38:'19...Rfc8', 39:'20.Nf3', 40:'20...Rab8', 41:'21.Rb1', 42:'21...a5',

43:'22.f5', 44:'22...a4', 45:'23.fxe6', 46: '23...fxe6', 47:'24.a3', 48:'24...Qc5', 49:'25.Qxc5', 50:'25...Rxc5', 51:'26.Na2 In trying to cope with Fischer\'s favourite Sicilian Najdorf, Edmund Nash has had to make a few concessions, one of them being the bishop pair. He now has the challenge of defending his pawns on b2 and e4, and to this end he has just played 26.Na2 with the obvious idea of 27.c3 followed by 28.Nb4. Fischer is ready with a sharp response.', 52:'26...Rcb5!! This merits two exclamation marks because Fischer has calculated the subsequent complicated variations with considerable depth – and accuracy. His line is much stronger than 26...c3 27.Nxc3 Bf6 28.e5!? dxe5 29.Rfc1, when White still has some defensive chances.',

53:'27.Nb4', 54:'27...c3!', 55:'28.Nd4', 56:'28...Rc5!', 57:'29.Na6 White is pretty well forced to accept Black\'s exchange sacrifice. He would lose in straightforward fashion after 29.bxc3 Rf8 30.Rxf8+ Bxf8 31.Ne2 Rc4 32.e5 dxe5 33.Nd3 Bd6 34.Rb6 Bxa3 35.Nxe5 Re4 36.Nxd7 Rxe2, etc.', 58:'29...Rxb2', 59:'30.Nxc5', 60:'30...dxc5', 61:'31.Nf3', 62:'31...c4',

63:'32.Ne5?! In his book Bobby Fischer (Russell 2009), Dr. Karsten Müller recommends the stronger defence 32.Rbd1!? Bc6 33.Rfe1 Bxa3 34.Rd8+ Kh7 35.Rc8 Bd7. Now there are two main lines: A. 36.Rd8!? (trying for counterplay) 36...Bb5 37.Nd4 Be7 38.Ra8 a3 39.Nxb5 Rxb5 40.g3 Rb2 41.Re2 a2 42.Kg2 Bg5 43.h4 Bd2 44.h5 Rxc2 45.Rf2 Rb2 46.Rff8 (White has worked up a dangerous counterattack, but Black can neutralise it with an accurate defensive manoeuvre) 46...Bf4+! 47.Kf3 Bb8! 48.Rfxb8 Rxb8 49.Rxa2 g6 50.g4 Kg7 51.Kf4 gxh5 52.gxh5 Kf6 53.e5+ Ke7 54.Ke4 (54.Ra7+? Ke8 55.Ra2 Rb2 and wins) 54...Rb2 55.Ra7+ Kd8 56.Ra3 Re2+ 57.Kd4 (57.Kf3 Rh2! 58.Kg3 Rd2 59.Rxc3 Rd3+! 60.Rxd3+ cxd3 61.Kf3 d2 62.Ke2 d1Q+ 63.Kxd1 Kd7 and wins) 57...c2 58.Ra1 Kd7 59.Kxc4 Rxe5 and Black is winning easily. B. 36.Rxc4 (trying for simplification) 36...Rxc2 37.Rc7 Be8 38.Rc8 Bg6 39.Ra1 Be7 40.Rc7 (40.Rxa4 loses immediately to 40...Rc1+ 41.Ng1 Bg5, etc.) 40...Bd6 41.Rc4 a3 42.e5 Bb8 43.Ne1 Rf2 44.Nf3 a2 45.Rxc3 Rb2 46.Rcc1 Be4 47.Re1 Bd5 48.h3 Kg6 49.Rg1 Ba7 50.Rgd1 Bxf3 51.gxf3 Kg5 52.h4+ Kf4 53.Rd3 Bc5 54.Rf1 Bb4 55.Ra1 Rb1+ 56.Rd1 Rxd1+ 57.Rxd1 Bc3 followed by ...a1Q and wins. The conclusion is that White can put up much stronger resistance with Muller\'s 32.Rbd1, but it does not appear to save the game if Black plays accurately.', 64:'32...Bb5! After this Black is winning without much difficulty. ', 65:'33.Rxb2', 66:'33...cxb2', 67:'34.c3', 68:'34...Bf6 Here the computer finds a much faster win with the non-standard shot 34...Bb4!?, but in the hurlyburly of tournament play, safety is often preferable to beauty.', 69:'35.Rb1', 70:'35...Bxe5', 71:'36.Rxb2', 72:'36...Be8',

73:'37.Rb4', 74:'37...Bxc3', 75:'38.Rxc4', 76:'38...Bb2', 77:'39.Rb4', 78:'39...Bxa3', 79:'40.Rb6', 80:'40...Kf7', 81:'41.Rb7+',

82:'41...Be7', 83:'42.e5', 84:'42...a3', 85:'43.Kg1', 86:'43...Bc6', 87:'44.Ra7', 88:'44...Bd5', 89:'45.Kf1', 90:'45...a2', 91:'46.Ke2', 92:'46...Kg6',

93:'47.g4', 94:'47...Bc5', 95:'48.Ra5', 96:'48...Bd4 0-1 This game was played just a few weeks after Bobby Fischer\'s famous victory over Donald Byrne in the 1956 Rosenwald tournament. In my opinion it is just as impressive as the so-called “Game of the Century.”',

}
},
{
    id: 24,
      name: 'Fischer at a 1964 Washington, DC Simul',
      description:
'\nBobby Fischer by Larry Kaufman (from his book Chess Board Options - A Memoir of Players, Games, and Engines)' +
'\n\n' +
'I first met Bobby Fischer in 1964, when he came to Washington D.C. to give a lecture and play a 70+ board simul. According to the Chessmetrics website, Fischer was already the best player in the world for most of that year, whereas I had only about a 2000 rating and was little known outside the D.C. area. Several players rated above me played in the simul, and I would have played, but I judged that I would learn more from watching Fischer play 70 games than from playing one myself. This might seem odd now with all games instantly available from every significant event on the internet, but I knew that if I didn’t watch those games, I would never see most of them. Also the fee ($14, I think, about like $100 now) was a consideration, but if I could have seen the other games later I would have gone for it. I think I made the right decision, because although it would be nice to be able to talk about my game with Fischer (I never did get to play against him), I really did learn a lot from watching and became a master within two years.  \n\n'+

'Fischer’s lecture was on his drawn Olympiad game with Botvinnik, which he insisted he should have won at various points, perhaps not always correctly with computer hindsight. In the simul I observed a few things of interest. In one game he played a high school friend of mine by the name of Danny Collins, which was notable in that after twenty moves or so he managed to put Danny into a rare full-board Zugzwang; with all the pieces and pawns on the board and no direct threats to him, Danny had only suicidal moves available and lost. Fischer asked for the game score, which was published in Chess Life several decades later. An unusually large number of games featured the Caro-Kann (probably players thought it was the best chance to draw vs. Fischer).' +
'\n\n',

diagrams:{

0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',

1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',

2:'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR',

3:'rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR',

4:'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR',

5:'rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR',

6:'rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR',

7:'rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR',

8:'rn1qkbnr/pp2pppp/2p5/5b2/3PN3/8/PPP2PPP/R1BQKBNR',

9:'rn1qkbnr/pp2pppp/2p5/2N2b2/3P4/8/PPP2PPP/R1BQKBNR',

10:'rn2kbnr/ppq1pppp/2p5/2N2b2/3P4/8/PPP2PPP/R1BQKBNR',

11:'rn2kbnr/ppq1pppp/2p5/2N2b2/3P4/3B4/PPP2PPP/R1BQK1NR',

12:'rn2kbnr/ppq1pppp/2p5/2N5/3P4/3b4/PPP2PPP/R1BQK1NR',

13:'rn2kbnr/ppq1pppp/2p5/8/3P4/3N4/PPP2PPP/R1BQK1NR',

14:'r3kbnr/ppqnpppp/2p5/8/3P4/3N4/PPP2PPP/R1BQK1NR',

15:'r3kbnr/ppqnpppp/2p5/8/3P1B2/3N4/PPP2PPP/R2QK1NR',

16:'r3kbnr/pp1npppp/1qp5/8/3P1B2/3N4/PPP2PPP/R2QK1NR',

17:'r3kbnr/pp1npppp/1qp5/8/3P1B2/3N1N2/PPP2PPP/R2QK2R',

18:'r3kbnr/pp1np1pp/1qp2p2/8/3P1B2/3N1N2/PPP2PPP/R2QK2R',

19:'r3kbnr/pp1np1pp/1qp2p2/8/3P1B2/3N1N2/PPP2PPP/R2Q1RK1',

20:'2kr1bnr/pp1np1pp/1qp2p2/8/3P1B2/3N1N2/PPP2PPP/R2Q1RK1',

21:'2kr1bnr/pp1np1pp/1qp2p2/8/P2P1B2/3N1N2/1PP2PPP/R2Q1RK1',

22:'2k1rbnr/pp1np1pp/1qp2p2/8/P2P1B2/3N1N2/1PP2PPP/R2Q1RK1',

23:'2k1rbnr/pp1np1pp/1qp2p2/P7/3P1B2/3N1N2/1PP2PPP/R2Q1RK1',

24:'2kqrbnr/pp1np1pp/2p2p2/P7/3P1B2/3N1N2/1PP2PPP/R2Q1RK1',

25:'2kqrbnr/pp1np1pp/2p2p2/P7/3P1B2/3N1N2/1PP2PPP/R2QR1K1',

26:'2kqrbnr/pp1np2p/2p2p2/P5p1/3P1B2/3N1N2/1PP2PPP/R2QR1K1',

27:'2kqrbnr/pp1np2p/2p2p2/P5p1/3P4/3N1NB1/1PP2PPP/R2QR1K1',

28:'2kqrbnr/pp1np3/2p2p2/P5pp/3P4/3N1NB1/1PP2PPP/R2QR1K1',

29:'2kqrbnr/pp1np3/2p2p2/P5pp/3P3P/3N1NB1/1PP2PP1/R2QR1K1',

30:'2kqrbnr/pp1np3/2p2p2/P6p/3P2pP/3N1NB1/1PP2PP1/R2QR1K1',

31:'2kqrbnr/pp1np3/2p2p2/P6p/3P2pP/3N2B1/1PPN1PP1/R2QR1K1',

32:'2kqrb1r/pp1np3/2p2p1n/P6p/3P2pP/3N2B1/1PPN1PP1/R2QR1K1',

33:'2kqrb1r/pp1np3/2p2p1n/P6p/2NP2pP/3N2B1/1PP2PP1/R2QR1K1',

34:'2kqrb1r/pp1np3/2p2p2/P4n1p/2NP2pP/3N2B1/1PP2PP1/R2QR1K1',

35:'2kqrb1r/pp1np3/P1p2p2/5n1p/2NP2pP/3N2B1/1PP2PP1/R2QR1K1',

36:'2kqrb1r/p2np3/P1p2p2/1p3n1p/2NP2pP/3N2B1/1PP2PP1/R2QR1K1',

37:'2kqrb1r/p2np3/P1p2p2/Np3n1p/3P2pP/3N2B1/1PP2PP1/R2QR1K1',

38:'2k1rb1r/p2np3/Pqp2p2/Np3n1p/3P2pP/3N2B1/1PP2PP1/R2QR1K1',

39:'2k1rb1r/p2np3/Pqp2p2/NpN2n1p/3P2pP/6B1/1PP2PP1/R2QR1K1',

40:'2k1rb1r/p2np3/Pqp2p2/NpN4p/3P2pP/6n1/1PP2PP1/R2QR1K1',

41:'2k1rb1r/p2np3/Pqp1Rp2/NpN4p/3P2pP/6n1/1PP2PP1/R2Q2K1',

42:'1nk1rb1r/p3p3/Pqp1Rp2/NpN4p/3P2pP/6n1/1PP2PP1/R2Q2K1',

43:'1nk1rb1r/p3p3/Pqp1Rp2/NpN4p/3P2pP/6P1/1PP3P1/R2Q2K1',

44:'1nkr1b1r/p3p3/Pqp1Rp2/NpN4p/3P2pP/6P1/1PP3P1/R2Q2K1',

45:'1nkr1b1r/p3p3/Pqp1Rp2/NpN4p/3P2pP/2P3P1/1P4P1/R2Q2K1',

46:'1nk2b1r/p3p3/PqprRp2/NpN4p/3P2pP/2P3P1/1P4P1/R2Q2K1',

47:'1nk2b1r/p3p3/PqprRp2/NpN4p/3P2pP/2P3P1/1P2Q1P1/R5K1',

48:'1nk2b1r/p3p3/Pqp1rp2/NpN4p/3P2pP/2P3P1/1P2Q1P1/R5K1',

49:'1nk2b1r/p3p3/Pqp1Qp2/NpN4p/3P2pP/2P3P1/1P4P1/R5K1',

50:'1n3b1r/p1k1p3/Pqp1Qp2/NpN4p/3P2pP/2P3P1/1P4P1/R5K1',

51:'1n3b1r/p1k1p3/Pqp1Qp2/NpN4p/1P1P2pP/2P3P1/6P1/R5K1',

52:'1n3b2/p1k1p3/Pqp1Qp1r/NpN4p/1P1P2pP/2P3P1/6P1/R5K1',

53:'1n3bQ1/p1k1p3/Pqp2p1r/NpN4p/1P1P2pP/2P3P1/6P1/R5K1',

54:'5bQ1/p1k1p3/nqp2p1r/NpN4p/1P1P2pP/2P3P1/6P1/R5K1',

55:'5Q2/p1k1p3/nqp2p1r/NpN4p/1P1P2pP/2P3P1/6P1/R5K1',

56:'5Q2/p1k1p2r/nqp2p2/NpN4p/1P1P2pP/2P3P1/6P1/R5K1',

57:'5Q2/p1k1p2r/nqN2p2/1pN4p/1P1P2pP/2P3P1/6P1/R5K1',

58:'5Q2/p1k1p2r/1qN2p2/1pn4p/1P1P2pP/2P3P1/6P1/R5K1',

59:'5Q2/p1k1p2r/1qN2p2/1pP4p/3P2pP/2P3P1/6P1/R5K1',

60:'5Q2/p1k1p2r/2q2p2/1pP4p/3P2pP/2P3P1/6P1/R5K1',

61:'5Q2/R1k1p2r/2q2p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

62:'5Q2/Rqk1p2r/5p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

63:'5Q2/1Rk1p2r/5p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

64:'5Q2/1k2p2r/5p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

65:'6Q1/1k2p2r/5p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

66:'6Q1/1k2p3/5p1r/1pP4p/3P2pP/2P3P1/6P1/6K1',

67:'8/1k2p1Q1/5p1r/1pP4p/3P2pP/2P3P1/6P1/6K1',

68:'7r/1k2p1Q1/5p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

69:'7Q/1k2p3/5p2/1pP4p/3P2pP/2P3P1/6P1/6K1',

70:'7Q/1k6/5p2/1pP1p2p/3P2pP/2P3P1/6P1/6K1',

71:'7Q/1k6/5p2/1pPPp2p/6pP/2P3P1/6P1/6K1',

72:'7Q/1k6/5p2/1pPP3p/4p1pP/2P3P1/6P1/6K1',

73:'8/1k6/5Q2/1pPP3p/4p1pP/2P3P1/6P1/6K1',

74:'8/1k6/5Q2/1pPP3p/6pP/2P1p1P1/6P1/6K1',

75:'8/1k6/1Q6/1pPP3p/6pP/2P1p1P1/6P1/6K1',

76:'k7/8/1Q6/1pPP3p/6pP/2P1p1P1/6P1/6K1',

77:'k7/8/1QP5/1p1P3p/6pP/2P1p1P1/6P1/6K1',

78:'k7/8/1QP5/1p1P3p/6pP/2P3P1/4p1P1/6K1',

79:'k7/1Q6/2P5/1p1P3p/6pP/2P3P1/4p1P1/6K1',

},

comments:{
0:'Robert James Fischer-Daniel Collins, Simul Washington, D.C. 1964.',
1:'1.e4', 2:'1...c6', 3:'2.d4', 4:'2...d5', 5:'3.Nc3', 6:'3...dxe4', 7:'4.Nxe4', 8:'4...Bf5', 9:'5.Nc5 An unusual move first played by the ever inventive David Bronstein. Fischer wrote this about it in his book "My 60 Memorable Games": On tour (1964) I experimented with the weird 5.Nc5!?. Most of my opponents countered with 5...e5 6.Nxb7 Qxd4 (if 6...Qb6 7.Nc5 Bxc5 8.dxc5 Qxc5 9.c3 White\'s better. Fischer-Petrosian, five-minute game, Bled 1961); 7.Qxd4 exd4 8.Bd3 with the better ending. Some replied with 5...b6 6.Na6 Nxa6 7.Bxa6 Qd5! Still others played 5...Qc7 6.Bd3 Bxd3 7.Nxd3 e6. White has more space, but only experience can tell whether he has the edge; however, the Knight on d3 discourages the normal freeing maneuver ...c5 and/or ...e5. At least it\'s something to break the monotony.', 10:'5...Qc7 IM Jovanka Houska gives in her book, "Opening Repertoire: The Caro-Kann" recommended 5...Nd7 6.Nxb7 Qc7 7.Nc5 Nxc5 8.dxc5 Rd8!', 11:'6.Bd3',
12:'5...Bxd3', 13:'7.Nxd3', 14:'7...Nd7', 15:'8.Bf4', 16:'8...Qb6', 17:'9.Nf3', 18:'9...f6?? This is quite a bad move that one might think that Black accidentally touched his f-pawn and was forced to move it. 9...Ngf6 10.0–0 e6 11.c3 ended in a quick quick draw in Nikolenko-Burmakin, Moscow 2009.', 19:'10.O-O', 20:'10...O-O-O', 21:'11.a4', 22:'11...Re8',
23:'12.a5', 24:'12...Qd8', 25:'13.Re1', 26:'13...g5', 27:'14.Bg3', 28:'14...h5', 29:'15.h4', 30:'15...g4', 31:'16.Nd2 Even stronger was 16.Re6!.', 32:'16...Nh6', 33:'17.Nc4',
34:'17...Nf5', 35:'18.a6', 36:'18...b5', 37:'19.Na5', 38:'19...Qb6 Black should have tried to get his pieces out with 19...e5, which wouldn\'t have been possible had 17.Re6!, clamping down on the e-pawn, been played.', 39:'20.Nc5', 40:'20...Nxg3', 41:'21.Re6', 42:'21...Nb8', 43:'22.fxg3',
44:'22...Rd8', 45:'23.c3', 46:'23...Rd6', 47:'24.Qe2', 48:'24...Rxe6', 49:'25.Qxe6+', 50:'25...Kc7', 51:'26.b4! This is the rare middlegame zugzwang that Kaufman was referring to. Black is defenseless against 27.Qf7 and 28.Ne6+ but being forced to move makes it even worse.', 52:'26...Rh6', 53:'27.Qg8',
54:'27...Nxa6', 55:'28.Qxf8', 56:'28...Rh7', 57:'29.Nxc6', 58:'29...Nxc5', 59:'30.bxc5', 60:'30...Qxc6', 61:'31.Rxa7+', 62:'31...Qb7',
63:'32.Rxb7+', 64:'32...Kxb7', 65:'33.Qg8', 66:'33...Rh6', 67:'34.Qg7', 68:'34...Rh8', 69:'35.Qxh8', 70:'35...e5', 71:'36.d5', 72:'36...e4',
73:'37.Qxf6', 74:'37...e3', 75:'38.Qb6+', 76:'38...Ka8', 77:'39.c6', 78:'39...e2', 79:'40.Qb7 Black Resigns',
}
},
{
    id: 25,
      name: 'Fischer Wants Light',
      description:
      'From the book Life at Play: A Chess Memoir by Lubomir Kavalek'+
'\nOur hotel, Sousse Palace, with its beach, pool, sailboat, donkey, and camel, was fun, but the biggest attraction was Bobby Fischer. After a five-year hiatus, he had decided to join the contest for the world title again. There were 23 of us vying for six qualifying spots. The winners would meet in individual matches to prevent the dealings of the tournament mafias. To avoid a repeat of Curaçao 1962, where the Soviets had played as a team against Fischer, the pairings were designed to have players from the same country meet in the first few rounds.\n'+

'My game with Fischer was scheduled for the sixth round and I was looking forward to it. Nobody from our post-war generation had had a chance to play him yet. We kept running into Bobby in the hotel frequently because his room was between Hort’s and mine. The walls were thin, and Bobby was an evening person who liked to listen to music late into the night. Hort was bothered and wanted revenge. He would turn up the radio’s Arabic music station full blast and go downstairs to breakfast. It turned out that Bobby was a sound sleeper and never noticed.\n'+

'We played on Sunday, October 22, and the auditorium was full. Bobby came late, as was his habit. We shook hands and started. The opening was the Poisoned Pawn Variation of the Najdorf Sicilian. I could see that when I selected the sharpest, most analyzed continuation, Bobby got antsy. He got up and requested our table be moved to another spot with better lighting. There was no problem with the light. Was he just trying to break my concentration? I didn’t care where we sat, so the organizers moved our table. Bobby was still unhappy, however, and requested additional lamps. We sat surrounded by illumination and I felt like I was being interrogated.\n'+

'During this phase of the game, it was important to come up with something unexpected, and Fischer attacked my most active piece, a knight, with his pawn. He assumed I would exchange it and that would give him control over the dark squares. He kept glancing at me and looked pleased. He was two pawns up and pushing me back from the center. I calculated that retreating with the knight led nowhere and considered sacrificing it to complete my development. Bobby had only two heavy pieces in play so far and his queen was stuck at the edge of the board. He had already taken two poisoned pawns; was he going to take my knight as well?\n'+

'My position reached the fight or flight stage. I was fighting for survival and decided to let the knight be, moving my king to safety. Bobby took the knight and created a pawn triangle – usually a weak formation, but his triangle controlled six important squares.\n'+

'I don’t look at my opponents much during games, but this time I could not resist. Bobby did not look happy. He had overlooked an attacking opportunity, and his position now looked precarious for a change. In the end he put my queen in a deadly pin, but with a pretty rook accordion on the seventh rank I could draw by perpetual check. It was a short but rich game with many intrigues behind the curtain. Bent Larsen wrote that my knight sacrifice was psychologically justifiable, but one could assume that Bobby had not analyzed it. The knight sacrifice in this variation became something of a fad and Garry Kasparov later said our game had influenced the development of this variation for many years to come.\n'+

'I was happy with the outcome, and my father and I went for a walk on the beach afterwards. Suddenly I saw my afternoon opponent waving at me from across the street. I walked over and Bobby took out his pocket chess set, showing me how he could have won. We were standing under a streetlamp and I could barely see the pieces, but he never noticed. The analytical variation he showed me could be refuted with an exchange sacrifice, but Bobby was on the right track. With a little tweaking, Black could have won.\n'+

'Bobby was playing brilliantly, and nobody could have foreseen that in a mere ten days we would be playing without him. In addition to his lighting complaints, he made it clear that he did not like being photographed during games, and protested the schedule, which had him playing five games in five days. The organizers ignored his verbal protests, so Bobby simply did not show up for his game against Aivars Gipslis, forfeited, and announced that he was leaving.\n'+

'His next game was supposed to be against Sammy Reshevsky, who was already walking around with visions of an easy point, when Fischer stormed into the playing hall seven minutes before he would have forfeited again. He sat down to play, and after 28 moves, Reshevsky resigned.\n'+

'Fischer then beat Robert Byrne but did not show up against Hort and lost another point. He was commuting between Sousse and the capital Tunis, making promises and threats in turn. The Soviets had enough at this point and announced that unless his antics ceased and the organizers stopped making concessions to him, they would all leave. The organizers had great support in the chief referee Jaroslav Šajtar, and Bobby finally said that he would accept the two forfeits and play his next game, which was supposed to be against Larsen.\n'+

'As it happened, it was the organizers and Šajtar who prevented him from continuing. They gave him twenty minutes to appear for the game, knowing full well that Bobby was 140 kilometers away in Tunis and there was no way for him to make it. The following day he flew home. He had been totally dominant in the tournament, winning seven out of ten games, with three draws. His goodbye message was clear - let the patzers fight it out among themselves.'+
'\n',

diagrams:{

0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',

1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',

2:'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR',

3:'rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',

4:'rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R',

5:'rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R',

6:'rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R',

7:'rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R',

8:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R',

9:'rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',

10:'rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R',

11:'rnbqkb1r/1p2pppp/p2p1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R',

12:'rnbqkb1r/1p3ppp/p2ppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R',

13:'rnbqkb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R',

14:'rnb1kb1r/1p3ppp/pq1ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R',

15:'rnb1kb1r/1p3ppp/pq1ppn2/6B1/3NPP2/2N5/PPPQ2PP/R3KB1R',

16:'rnb1kb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PqPQ2PP/R3KB1R',

17:'rnb1kb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PqPQ2PP/1R2KB1R',

18:'rnb1kb1r/1p3ppp/p2ppn2/6B1/3NPP2/q1N5/P1PQ2PP/1R2KB1R',

19:'rnb1kb1r/1p3ppp/p2ppn2/5PB1/3NP3/q1N5/P1PQ2PP/1R2KB1R',

20:'r1b1kb1r/1p3ppp/p1nppn2/5PB1/3NP3/q1N5/P1PQ2PP/1R2KB1R',

21:'r1b1kb1r/1p3ppp/p1npPn2/6B1/3NP3/q1N5/P1PQ2PP/1R2KB1R',

22:'r1b1kb1r/1p4pp/p1nppn2/6B1/3NP3/q1N5/P1PQ2PP/1R2KB1R',

23:'r1b1kb1r/1p4pp/p1Nppn2/6B1/4P3/q1N5/P1PQ2PP/1R2KB1R',

24:'r1b1kb1r/6pp/p1pppn2/6B1/4P3/q1N5/P1PQ2PP/1R2KB1R',

25:'r1b1kb1r/6pp/p1pppn2/4P1B1/8/q1N5/P1PQ2PP/1R2KB1R',

26:'r1b1kb1r/6pp/p1p1pn2/4p1B1/8/q1N5/P1PQ2PP/1R2KB1R',

27:'r1b1kb1r/6pp/p1p1pB2/4p3/8/q1N5/P1PQ2PP/1R2KB1R',

28:'r1b1kb1r/7p/p1p1pp2/4p3/8/q1N5/P1PQ2PP/1R2KB1R',

29:'r1b1kb1r/7p/p1p1pp2/4p3/4N3/q7/P1PQ2PP/1R2KB1R',

30:'r1b1k2r/4b2p/p1p1pp2/4p3/4N3/q7/P1PQ2PP/1R2KB1R',

31:'r1b1k2r/4b2p/p1p1pp2/4p3/4N3/q7/P1PQB1PP/1R2K2R',

32:'r1b1k2r/4b3/p1p1pp2/4p2p/4N3/q7/P1PQB1PP/1R2K2R',

33:'r1b1k2r/4b3/p1p1pp2/4p2p/2P1N3/q7/P2QB1PP/1R2K2R',

34:'r1b1k2r/4b3/p1p1p3/4pp1p/2P1N3/q7/P2QB1PP/1R2K2R',

35:'r1b1k2r/4b3/p1p1p3/4pp1p/2P1N3/qR6/P2QB1PP/4K2R',

36:'r1b1k2r/4b3/p1p1p3/4pp1p/q1P1N3/1R6/P2QB1PP/4K2R',

37:'r1b1k2r/4b3/p1p1p3/4pp1p/q1P1N3/1R6/P2QB1PP/5RK1',

38:'r1b1k2r/4b3/p1p1p3/4p2p/q1P1p3/1R6/P2QB1PP/5RK1',

39:'r1b1k2r/4b3/p1p1p3/4p2p/q1P1p3/1RQ5/P3B1PP/5RK1',

40:'r1b1k2r/4b3/p1p1p3/4p2p/2P1p3/1RQ5/q3B1PP/5RK1',

41:'r1b1k2r/4b3/p1p1p3/4p2p/2P1p3/1RQ5/q5PP/3B1RK1',

42:'r1b1kr2/4b3/p1p1p3/4p2p/2P1p3/1RQ5/q5PP/3B1RK1',

43:'r1b1kr2/4b3/p1p1p3/4p2B/2P1p3/1RQ5/q5PP/5RK1',

44:'r1bk1r2/4b3/p1p1p3/4p2B/2P1p3/1RQ5/q5PP/5RK1',

45:'r1bk1r2/4b3/p1p1p3/4p2B/2P1p3/1RQ5/q5PP/3R2K1',

46:'r2k1r2/3bb3/p1p1p3/4p2B/2P1p3/1RQ5/q5PP/3R2K1',

47:'r2k1r2/3bb3/p1p1p3/4p2B/2P1p3/1R2Q3/q5PP/3R2K1',

48:'r2k1r2/3bb3/p1p1p3/q3p2B/2P1p3/1R2Q3/6PP/3R2K1',

49:'r2k1r2/1R1bb3/p1p1p3/q3p2B/2P1p3/4Q3/6PP/3R2K1',

50:'r2k1r2/1R1b4/p1p1p3/q1b1p2B/2P1p3/4Q3/6PP/3R2K1',

51:'r2k1r2/1R1R4/p1p1p3/q1b1p2B/2P1p3/4Q3/6PP/6K1',

52:'r1k2r2/1R1R4/p1p1p3/q1b1p2B/2P1p3/4Q3/6PP/6K1',

53:'r1k2r2/1RR5/p1p1p3/q1b1p2B/2P1p3/4Q3/6PP/6K1',

54:'r2k1r2/1RR5/p1p1p3/q1b1p2B/2P1p3/4Q3/6PP/6K1',

55:'r2k1r2/1R1R4/p1p1p3/q1b1p2B/2P1p3/4Q3/6PP/6K1',

},

comments:{

0:'Lubomir Kavalek-Bobby Fischer, Sousse 1967.',

1:'1.e4', 2:'1...c5', 3:'2.Nf3', 4:'2...d6', 5:'3.d4', 6:'3...cxd4', 7:'4.Nxd4', 8:'4...Nf6', 9:'5.Nc3', 10:'5...a6', 11:'6.Bg5', 12:'6...e6',

13:'7.f4', 14:'7...Qb6', 15:'8.Qd2', 16:'8...Qxb2', 17:'9.Rb1', 18:'9...Qa3', 19:'10.f5', 20:'10...Nc6', 21:'11.fxe6', 22:'11...fxe6',

23:'12.Nxc6', 24:'12...bxc6', 25:'13.e5', 26:'13...dxe5', 27:'14.Bxf6', 28:'14...gxf6', 29:'15.Ne4', 30:'15...Be7', 31:'16.Be2', 32:'16...h5',

33:'17.c4', 34:'17...f5', 35:'18.Rb3', 36:'18...Qa4', 37:'19.O-O? Likely this is too risky. 19.Nd6+ B×d6 20.Q×d6 Qa5+ 21.Kf2 would have been equal.', 38:'19...fxe4', 39:'20.Qc3?! 20.Kh1!? offered better chances, but would not have been quite sufficient. ', 40:'20...Qxa2', 41:'21.Bd1', 42:'21...Rf8? Here is where Fischer missed his chance. He should have first given check with 21...Bc5+ 22.Kh1 and then played 23...Rf8. Black is winning after 23.B×h5+ Kd8 24.Rd1+ Bd7 as now 25.Rb7 can be met by 25...Bd4.',

43:'22.Bxh5+', 44:'22...Kd8', 45:'23.Rd1+', 46:'23...Bd7', 47:'24.Qe3', 48:'24...Qa5', 49:'25.Rb7', 50:'25...Bc5', 51:'26.Rdxd7+',

52:'26...Kc8', 53:'27.Rdc7+', 54:'27...Kd8', 55:'28.Rd7+ Draw',
}
},
{
    id: 26,
      name: 'Fischer 1972 Interview after the Match',
      description:
      'Fischer Interview with Svetozar Gligoric after the Match\n'+ 
'Gligoric: I wish to congratulate you, Bobby, very sincerely on your success. You have opened a new chapter in the history of chess. Just this morning the president of FIDE, Dr. Max Euwe, expressed the opinion that you are the best player he ever met in his life-and I am of the same opinion. This was my first opportunity to watch your play closely, because I had previously always been involved with my own play too during competition. But this was the first time I watched you playing and could notice every detail in your play, and I was really amazed at how strong you were. That is my sincere opinion. I would like to ask the first question: Are you pleased with the match and how it all went? \n'+
 
'Fischer: I\'d first of all like to thank you for your comments. I\'m pleased with the outcome; yes, pleased. \n'+ 
 
'Gligoric: Are you pleased with your play, I mean? \n'+
 
'Fischer: Yes, I\'m pretty pleased, I mean. under the circumstances, .. considering all the pressure I was under and everything.\n'+ 
 
'Gligoric: I am glad that Spassky gave some resistance in the second half of the match. How did you accept it? \n'+
 
'Fischer: He played very well in the second half. I really felt under pressure in the last games, except in the last game I felt good. But for about six or seven games in a row I was under pressure every game, it was terrible. \n'+ 
 
'Gligoric: That\'s true. As I wrote, it was a terrible change, but I think it was normal because I thought you had put such a lot of energy into the first half. I mean, you somehow had to exhaust your weapons for a while. And then the 21st game was a miracle to me because of the way you handled the opening. I liked it very much indeed; it was something quite new.\n'+ 
 
'Fischer: Well, not so new to tell you the truth. I found the idea .. I was looking in Anderssen\'s book you know. It\'s the way they used to play the pawns, too, in the old days, with pawn to Queen four. They used to play this Bishop to King three and Bishop to Queen three ... \n'+
 
'Gligoric: I see ... \n'+
 
'Fischer: I saw it in many games, this isolated pawn. It\'s nothing ...\n'+ 
 
'Gligoric: I realized it immediately when I saw the position on the board. I want to ask you: Do you know that as World Champion you are a member of the FIDE Central Committee? \n'+
 
'Fischer: Oh, is that right? I haven\'t thought about it.  \n'+
 
'Gligoric: Yes, you are a member of the Central Committee now. Will you have any suggestions for the future system of world championship competition, do you know?\n'+  
 
'Fischer: I don\'t know. I really shouldn\'t say anything too definitely, you know, because I\'ll keep my options. I want to play a lot of chess and I like to play matches. I want to play a lot of matches, you know; the money is there. It\'s a question of money, not a question of waiting three years-it\'s a long time, a very long time.\n'+  
 
'Gligoric: May I confirm\' the opinion you expressed before: would you have another match with Spassky?  \n'+
 
'Fischer: Definitely, yes. Definitely if the money is there, we are going to have a return match, there\'s no question ... .\n'+ 
 
'Gligoric: Can I ask him about what he thinks? \n'+
 
'Fischer: You can ask him, yes. You know, the Russians made me wait a very long time; you know, dishonestly and everything. But I don\'t intend to do the same thing. But it\'s not a personal thing between me and the Russian players. I like them-it\'s a question, you know, with the Russian government. It wasn\'t the players really, they had no choice. \n'+
 
'Gligoric: I understand. \n'+
 
'Fischer: So I\'m not against them ... \n'+
 
'Gligoric: What are your next plans? Have you decided what you are going to do with the Olympiad and maybe some other competitions? \n'+
 
'Fischer: I don\'t know. I\'m interested in playing. I\'m not very tired, to tell you the truth, but I thought I\'d be tired. \n'+
 
'Gligoric: You don\'t look tired. \n'+
 
'Fischer: I feel bored, I want to get into action.  \n'+
 
'Gligoric: Do you know anything about the Olympiad and the players in it? \n'+
 
'Fischer: I don\'t know, I have to talk with somebody. I haven\'t heard anything.\n'+ 
 
'Gligoric: I see. And will you play any other tournament after the Olympiad later on? \n'+
 
'Fischer: I don\'t know. I haven\'t accepted anything. \n'+
 
'Gligoric: And will you accept any new offers in the United States, I mean, to appear in public? There were some doubts.\n'+ 
 
'Fischer: No, I want to play. I\'m not interested in making some kind of spectacle of myself. I\'m interested in serious chess, you know. \n'+

'This is one of the games that deeply impressed everybody. Even Boris Spassky stood and applauded when the game ended.'+
'\n',

diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/4p3/8/2P5/8/PP1PPPPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/4p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R',
4:'rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R',
5:'rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R',
6:'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R',
7:'rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',
8:'rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',
9:'rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R',
10:'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R',
11:'rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R',
12:'rnbq1rk1/ppp1bpp1/4pn1p/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R',
13:'rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R',
14:'rnbq1rk1/p1p1bpp1/1p2pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R',
15:'rnbq1rk1/p1p1bpp1/1p2pn1p/3P4/3P3B/2N1PN2/PP3PPP/R2QKB1R',
16:'rnbq1rk1/p1p1bpp1/1p2p2p/3n4/3P3B/2N1PN2/PP3PPP/R2QKB1R',
17:'rnbq1rk1/p1p1Bpp1/1p2p2p/3n4/3P4/2N1PN2/PP3PPP/R2QKB1R',
18:'rnb2rk1/p1p1qpp1/1p2p2p/3n4/3P4/2N1PN2/PP3PPP/R2QKB1R',
19:'rnb2rk1/p1p1qpp1/1p2p2p/3N4/3P4/4PN2/PP3PPP/R2QKB1R',
20:'rnb2rk1/p1p1qpp1/1p5p/3p4/3P4/4PN2/PP3PPP/R2QKB1R',
21:'rnb2rk1/p1p1qpp1/1p5p/3p4/3P4/4PN2/PP3PPP/2RQKB1R',
22:'rn3rk1/p1p1qpp1/1p2b2p/3p4/3P4/4PN2/PP3PPP/2RQKB1R',
23:'rn3rk1/p1p1qpp1/1p2b2p/3p4/Q2P4/4PN2/PP3PPP/2R1KB1R',
24:'rn3rk1/p3qpp1/1p2b2p/2pp4/Q2P4/4PN2/PP3PPP/2R1KB1R',
25:'rn3rk1/p3qpp1/1p2b2p/2pp4/3P4/Q3PN2/PP3PPP/2R1KB1R',
26:'rnr3k1/p3qpp1/1p2b2p/2pp4/3P4/Q3PN2/PP3PPP/2R1KB1R',
27:'rnr3k1/p3qpp1/1p2b2p/1Bpp4/3P4/Q3PN2/PP3PPP/2R1K2R',
28:'rnr3k1/4qpp1/pp2b2p/1Bpp4/3P4/Q3PN2/PP3PPP/2R1K2R',
29:'rnr3k1/4qpp1/pp2b2p/1BPp4/8/Q3PN2/PP3PPP/2R1K2R',
30:'rnr3k1/4qpp1/p3b2p/1Bpp4/8/Q3PN2/PP3PPP/2R1K2R',
31:'rnr3k1/4qpp1/p3b2p/1Bpp4/8/Q3PN2/PP3PPP/2R2RK1',
32:'1nr3k1/r3qpp1/p3b2p/1Bpp4/8/Q3PN2/PP3PPP/2R2RK1',
33:'1nr3k1/r3qpp1/p3b2p/2pp4/8/Q3PN2/PP2BPPP/2R2RK1',
34:'2r3k1/r2nqpp1/p3b2p/2pp4/8/Q3PN2/PP2BPPP/2R2RK1',
35:'2r3k1/r2nqpp1/p3b2p/2pp4/3N4/Q3P3/PP2BPPP/2R2RK1',
36:'2r2qk1/r2n1pp1/p3b2p/2pp4/3N4/Q3P3/PP2BPPP/2R2RK1',
37:'2r2qk1/r2n1pp1/p3N2p/2pp4/8/Q3P3/PP2BPPP/2R2RK1',
38:'2r2qk1/r2n2p1/p3p2p/2pp4/8/Q3P3/PP2BPPP/2R2RK1',
39:'2r2qk1/r2n2p1/p3p2p/2pp4/4P3/Q7/PP2BPPP/2R2RK1',
40:'2r2qk1/r2n2p1/p3p2p/2p5/3pP3/Q7/PP2BPPP/2R2RK1',
41:'2r2qk1/r2n2p1/p3p2p/2p5/3pPP2/Q7/PP2B1PP/2R2RK1',
42:'2r3k1/r2nq1p1/p3p2p/2p5/3pPP2/Q7/PP2B1PP/2R2RK1',
43:'2r3k1/r2nq1p1/p3p2p/2p1P3/3p1P2/Q7/PP2B1PP/2R2RK1',
44:'1r4k1/r2nq1p1/p3p2p/2p1P3/3p1P2/Q7/PP2B1PP/2R2RK1',
45:'1r4k1/r2nq1p1/p3p2p/2p1P3/2Bp1P2/Q7/PP4PP/2R2RK1',
46:'1r5k/r2nq1p1/p3p2p/2p1P3/2Bp1P2/Q7/PP4PP/2R2RK1',
47:'1r5k/r2nq1p1/p3p2p/2p1P3/2Bp1P2/7Q/PP4PP/2R2RK1',
48:'1r3n1k/r3q1p1/p3p2p/2p1P3/2Bp1P2/7Q/PP4PP/2R2RK1',
49:'1r3n1k/r3q1p1/p3p2p/2p1P3/2Bp1P2/1P5Q/P5PP/2R2RK1',
50:'1r3n1k/r3q1p1/4p2p/p1p1P3/2Bp1P2/1P5Q/P5PP/2R2RK1',
51:'1r3n1k/r3q1p1/4p2p/p1p1PP2/2Bp4/1P5Q/P5PP/2R2RK1',
52:'1r3n1k/r3q1p1/7p/p1p1Pp2/2Bp4/1P5Q/P5PP/2R2RK1',
53:'1r3n1k/r3q1p1/7p/p1p1PR2/2Bp4/1P5Q/P5PP/2R3K1',
54:'1r5k/r3q1pn/7p/p1p1PR2/2Bp4/1P5Q/P5PP/2R3K1',
55:'1r5k/r3q1pn/7p/p1p1PR2/2Bp4/1P5Q/P5PP/5RK1',
56:'1r1q3k/r5pn/7p/p1p1PR2/2Bp4/1P5Q/P5PP/5RK1',
57:'1r1q3k/r5pn/7p/p1p1PR2/2Bp4/1P4Q1/P5PP/5RK1',
58:'1r1q3k/4r1pn/7p/p1p1PR2/2Bp4/1P4Q1/P5PP/5RK1',
59:'1r1q3k/4r1pn/7p/p1p1PR2/2Bp3P/1P4Q1/P5P1/5RK1',
60:'3q3k/1r2r1pn/7p/p1p1PR2/2Bp3P/1P4Q1/P5P1/5RK1',
61:'3q3k/1r2r1pn/4P2p/p1p2R2/2Bp3P/1P4Q1/P5P1/5RK1',
62:'3q3k/2r1r1pn/4P2p/p1p2R2/2Bp3P/1P4Q1/P5P1/5RK1',
63:'3q3k/2r1r1pn/4P2p/p1p1QR2/2Bp3P/1P6/P5P1/5RK1',
64:'4q2k/2r1r1pn/4P2p/p1p1QR2/2Bp3P/1P6/P5P1/5RK1',
65:'4q2k/2r1r1pn/4P2p/p1p1QR2/P1Bp3P/1P6/6P1/5RK1',
66:'3q3k/2r1r1pn/4P2p/p1p1QR2/P1Bp3P/1P6/6P1/5RK1',
67:'3q3k/2r1r1pn/4P2p/p1p1QR2/P1Bp3P/1P6/5RP1/6K1',
68:'4q2k/2r1r1pn/4P2p/p1p1QR2/P1Bp3P/1P6/5RP1/6K1',
69:'4q2k/2r1r1pn/4P2p/p1p1QR2/P1Bp3P/1P3R2/6P1/6K1',
70:'3q3k/2r1r1pn/4P2p/p1p1QR2/P1Bp3P/1P3R2/6P1/6K1',
71:'3q3k/2r1r1pn/4P2p/p1p1QR2/P2p3P/1P1B1R2/6P1/6K1',
72:'4q2k/2r1r1pn/4P2p/p1p1QR2/P2p3P/1P1B1R2/6P1/6K1',
73:'4q2k/2r1r1pn/4P2p/p1p2R2/P2pQ2P/1P1B1R2/6P1/6K1',
74:'4q2k/2r1r1p1/4Pn1p/p1p2R2/P2pQ2P/1P1B1R2/6P1/6K1',
75:'4q2k/2r1r1p1/4PR1p/p1p5/P2pQ2P/1P1B1R2/6P1/6K1',
76:'4q2k/2r1r3/4Pp1p/p1p5/P2pQ2P/1P1B1R2/6P1/6K1',
77:'4q2k/2r1r3/4PR1p/p1p5/P2pQ2P/1P1B4/6P1/6K1',
78:'4q1k1/2r1r3/4PR1p/p1p5/P2pQ2P/1P1B4/6P1/6K1',
79:'4q1k1/2r1r3/4PR1p/p1p5/P1BpQ2P/1P6/6P1/6K1',
80:'4q2k/2r1r3/4PR1p/p1p5/P1BpQ2P/1P6/6P1/6K1',
81:'4q2k/2r1r3/4PR1p/p1p5/P1Bp1Q1P/1P6/6P1/6K1',
},
comments:{
0:'Fischer-Spassky, World Championship 1972, Annotations by GM Karsten Mueller.',
1:'1.c4', 2:'1...e6', 3:'2.Nf3', 4:'2...d5', 5:'3.d4', 6:'3...Nf6', 7:'4.Nc3', 8:'4...Be7', 9:'5.Bg5', 10:'5...O-O', 11:'6.e3', 12:'6...h6',
13:'7.Bh4', 14:'7...b6', 15:'8.cxd5 White has tried many moves here, including 8.Bd3, 8.Rc1, 8.Be2 and 8.Qb3.', 16:'8...Nxd5', 17:'9.Bxe7', 18:'9...Qxe7', 19:'10.Nxd5', 20:'10...exd5', 21:'11.Rc1', 22:'11...Be6',
23:'12.Qa4', 24:'12...c5', 25:'13.Qa3', 26:'13...Rc8', 27:'14.Bb5', 28:'14...a6 Not bad, but Black has a more venomous option: 14...Qb7!? 15.d×c5 b×c5 16.R×c5 R×c5 17.Q×c5 Na6 18.B×a6 Q×a6 19.Qa3 Qc4 with dangerous compensation, as in Timman-Geller, Hilversum 1973.', 29:'15.dxc5', 30:'15...bxc5', 31:'16.O-O', 32:'16...Ra7',
33:'17.Be2', 34:'17...Nd7', 35:'18.Nd4', 36:'18...Qf8?! 18...Nf6 is more active, and after 19.Nb3 Black even has Kasparov’s surprising 19...Rac7!, with counterplay.', 37:'19.Nxe6', 38:'19...fxe6', 39:'20.e4!', 40:'20...d4? Conceding a lot of light squares to White. It is better to fight for them with 20...c4 (Tal) 21.Qh3 Rc6 22.b3 Nb6 (Kasparov).', 41:'21.f4', 42:'21...Qe7',
43:'22.e5', 44:'22...Rb8?! 22...Nb6 poses much greater problems for White. One sample line runs 23.Qd3 Nd5 24.Qe4 Qf7 25.f5 Ne3 26.f×e6 Q×e6 27.Bd3 Rf7 28.Qh7+ Kf8 29.R×f7+ Q×f7 30.Bc4± (Kasparov).', 45:'23.Bc4', 46:'23...Kh8', 47:'24.Qh3', 48:'24...Nf8?! Passive defense cannot disturb White. Tal’s suggestion, 24...R×b2!?, should have been tried, although White remains on top after 25.B×e6 Rab7 26.Rce1 (Kasparov).', 49:'25.b3', 50:'25...a5', 51:'26.f5! The decisive opening of lines for White’s attack.', 52:'26...exf5',
53:'27.Rxf5', 54:'27...Nh7', 55:'28.Rcf1', 56:'28...Qd8', 57:'29.Qg3', 58:'29...Re7', 59:'30.h4', 60:'30...Rbb7', 61:'31.e6', 62:'31...Rbc7',
63:'32.Qe5', 64:'32...Qe8', 65:'33.a4', 66:'33...Qd8', 67:'34.R1f2', 68:'34...Qe8', 69:'35.R2f3', 70:'35...Qd8', 71:'36.Bd3', 72:'36...Qe8',
73:'37.Qe4', 74:'37...Nf6', 75:'38.Rxf6', 76:'38...gxf6', 77:'39.Rxf6', 78:'39...Kg8', 79:'40.Bc4', 80:'40...Kh8', 81:'41.Qf4 1-0',
}
},
{
  id: 27,
    name: 'Spassky on Fischer',
    description:
    'From the Introduction by Vladimir Kramnik to the book Spassky’s Best Games.\n'+ 
'Boris is a man of a broad soul, absolutely not petty. This can be judged at least by the same 1972 match with Fischer. It is clear that Spassky could just have refused to continue the match. If he had packed up and left, no one would have blamed him for disrupting the match. To be honest, Fischer behaved in a very ugly way, both before the start and during the match. Most of all, breadth of the soul is needed in order to forgive this. Spassky did not hold any grudge against him.\n'+ 
'I am absolutely sure that it was not a matter of money, as evil tongues claim. Surely Boris believed that for some higher reason this battle should not be interrupted. The main reason, I think, was admiration for the genius of Fischer.\n'+ 
'Spassky knew Fischer very well, both as a person and as a chess player. He understood very well that Fischer was not behaving like that on purpose, but that he had mental problems. I guess he admired Fischer’s genius and that must have prevented him from winning the match. Excessive respect does not help; this is not exactly what is required of you when you play a World Championship match. Boris and I did not talk about this topic, but I am sure that this was his main motivation. He understood that Fischer was unique. And not to let him play a match (or you can read it like this: not to let him become a world champion) would have been a crime against chess. Boris is one of those people for whom these things are not empty words. I’m sure he wouldn’t have forgiven himself if he hadn’t given Fischer a chance.'+
'\n\nI will add an annotated game here soon.\n',

diagrams:{0:''},
    comments:{0:''}
}
];
